export default {
  // 文化类
  cultureList: [
    // {// 2026 周晓强
    //   title: '',
    //   img: '',
    //   linkTo: "/instanceItem?type=culture&num=38",
    //   details: {
    //     top: {
    //       title: '',
    //       img: ''
    //     },
    //     lunbo: {
    //       title: ['<strong></strong>',
    //         '',
    //         '',
    //         ''
    //       ],

    //       img: ['',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         ''
    //       ]

    //     },
    //     bottom: {
    //       title: ['<strong></strong>',
    //         '',
    //         '',
    //         ''
    //       ],
    //       img: ['',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         '',
    //         ''
    //       ]
    //     }
    //   }
    // },


    {// 20260705 周晓强
      title: '展陈空间｜构建叙事场景，塑造沉浸观感',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724313-66171501-659c-4495-b9ee-bbd49d63559a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=65",
      details: {
        top: {
          title: '展陈空间｜构建叙事场景，塑造沉浸观感',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724313-66171501-659c-4495-b9ee-bbd49d63559a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶坚持一展一方案的定制化设计，以空间叙事+沉浸式多媒体交互，打造主题清晰、动线合理的一体化交付精品展陈空间。',
          ],

          img: []

        },
        bottom: {
          title: [''
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724285-834a0675-3120-494b-873b-51e8b1199349.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724276-3978b4b7-171c-4b13-9cdf-dd52f51dafa3.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260704 周晓强
      title: '街道站点｜激活城市末梢，赋能基层服务',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692313-63088663-2bdf-49f2-bca1-492cfa83d5cc.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=63",
      details: {
        top: {
          title: '街道站点｜激活城市末梢，赋能基层服务',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692313-63088663-2bdf-49f2-bca1-492cfa83d5cc.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶依托众多基层点位落地实操经验，为北站街道量身打造第一综合网格工作站、党群服务中心。',
          ],

          img: []

        },
        bottom: {
          title: ['第一综合网格工作站以“多格合一”为抓手，合理规划动线、功能、展示，服务等合理化布局及样式展示；党群服务中心集基础党务、图书阅览、健身运动、艺术互动、儿童活动等功能于一体，秉承“开放式、集约化、共享性”的理念，利用技术赋能、创新呈现，大力探索党建宣传及教育新形势。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692297-aaf75fd1-6ee6-4293-8e8a-84fed9f557fe.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260703 周晓强
      title: '主题公园｜融汇人文景致，助力技能传承',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387643147-7ab8b129-5843-445a-9dbf-fd1aade50384.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=62",
      details: {
        top: {
          title: '主题公园｜融汇人文景致，助力技能传承',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387643147-7ab8b129-5843-445a-9dbf-fd1aade50384.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶为上海闵行职业技术学院建造的技能公园，以"传承匠心淬炼卓越"为核心主题，通过空间叙事与景观艺术，展现人类技能文明的演进脉络与工匠精神的永恒价值。',
          ],

          img: []

        },
        bottom: {
          title: ['园区以"技能之路"为游览主线，串联起技能启蒙、锤炼、升华与沉淀的全过程，打造一座兼具教育性、互动性与艺术性的沉浸式文化体验空间。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636853-e86df25e-ee96-4d09-a182-c9cd047347ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636651-290c4ec9-5354-467b-bc1b-f57c834a05cc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387635839-b312a7e1-39d1-40d4-abfa-2e5d9b39946b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387636261-a3fd6d77-c5f0-4248-9238-1ccb774bee6d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636970-848b66c8-4bf8-4294-bec2-804a3d22ba58.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20260702 周晓强
      title: '党政阵地｜筑牢红色根基，夯实思想堡垒',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587156-c24be6fa-e54f-4da6-bc71-3dc3543dec21.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=61",
      details: {
        top: {
          title: '党政阵地｜筑牢红色根基，夯实思想堡垒',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587156-c24be6fa-e54f-4da6-bc71-3dc3543dec21.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托成熟的一体化空间交付能力，叁昶团队凭借丰富的党政类标杆落地项目落地经验，定制化打造特色党政阵地。',
          ],

          img: []

        },
        bottom: {
          title: [''
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587221-4d459cbd-3b0a-4b85-854a-adde9c1a5a57.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587193-0c7303ce-a544-42c4-9370-1cb623d64441.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260701 周晓强
      title: '文化建设｜雕琢空间肌理，沉淀人文底蕴',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531508-d61b63f9-bc3d-4c88-9153-b17b4c65a518.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=60",
      details: {
        top: {
          title: '文化建设｜雕琢空间肌理，沉淀人文底蕴',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531508-d61b63f9-bc3d-4c88-9153-b17b4c65a518.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托大量高水准落地项目的持续淬炼，叁昶团队以定制化设计为起点，沉浸式体验为语言，一体化交付为承诺，形成了以文化空间建设为核心、多元场景协同拓展的业务格局。',
          ],

          img: []

        },
        bottom: {
          title: ['从轻量化局部改造到综合性展馆建设，叁昶业务全面覆盖立体化文化建设。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531609-8d47c24c-e035-4975-ada7-2eb00ecf0f4c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387533717-d04a407c-4850-4eb4-92d5-f08b004615bc.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531565-237d45b1-b35a-446f-a056-69f0c81c868c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531555-614a7f2b-c423-4392-955e-0cb8de2d909c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532534-d860f3df-462d-4deb-8db2-aeed81bc01ba.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532631-ed3adc46-5537-4087-8ae9-c7c76fa2fdef.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532827-89fa85ff-6622-4d2d-b3c1-315ad8dbcf0a.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260612 周晓强
      title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473780077-fe10b024-2b3a-4335-808d-3bbe7bb7b13e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473780077-fe10b024-2b3a-4335-808d-3bbe7bb7b13e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['6月12日，由教育部组织，由中国建筑集团有限公司、同济大学、上海城建职业学院三方牵头，汇聚60家企业、普通高校、职业院校参与的国家城市更新行业产教融合共同体在上海成立。本次会议主视觉设计、活动策划保障、背景视频、内外场搭建、全套物料均由叁昶团队全权负责。'
          ],

          img: []

        },
        bottom: {
          title: ['团队以专业的服务标准，深度参与本次会议的主视觉设计、环节策划，负责内外场搭建保障及全套物料制作，圆满呈现60位共同体代表同台参与的国家城市更新行业产教融合共同体启动仪式、32家校企合作单位签约等重磅环节，收获主办方及参会嘉宾的高度认可。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473789664-8a955025-903c-4a59-9404-82e9dbd2d8bd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473789646-92298138-9d4c-4734-82b6-4060ddeed147.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473792210-7342267c-5bf2-440e-84d8-df89ffc1dd18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20260516 周晓强
      title: '叁昶护航 | 以青春之名，驰骋技能赛场！',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473525293-a6392b37-3111-4185-a0f1-16c78e87915b.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航 | 以青春之名，驰骋技能赛场！',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473525293-a6392b37-3111-4185-a0f1-16c78e87915b.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['近日，第十五届上海市大学生机械工程创新大赛暨第十二届全国大学生机械创新设计大赛上海赛区预赛在上海理工大学圆满落幕。',
            '本次大赛以“灵巧智能，美好生活”为主题，设“特定水产品初加工机械”“高性能仿生蝴蝶”“叶菜洁净化处理包装一体化机械”三个赛道，鼓励学生通过创新设计与智能技术的融合，为相关产业发展提供更便捷、更智能的技术解决方案。来自上海交通大学、同济大学等17所高校的179支参赛队伍同台竞技，参赛师生近800人。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536486-e7b67087-889d-4e1c-97fe-f07fc298a5a6.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536882-90feb5d7-c06d-4558-ac7b-da63bb6da767.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536588-5f0e2185-ae8b-4f36-b230-6a8b56e5ef55.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶深度参与本次大赛的<strong>策划筹备、赛区搭建、开闭幕式、现场保障、全套物料及环境布置</strong>，受获一致认可和好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555294-1d635c84-0da2-4a94-80e7-cfe2fd36d2e9.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555297-3cd9b550-eb45-41da-9206-6cb25cbfae9b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555300-f3b58a32-8972-462c-8ec9-f70308bc92dd.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555018-17f58006-c14e-45e5-bddf-39a869af92d8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555247-cd715778-dc3c-4fa2-95c2-3d1cfc9b2f9c.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260516 周晓强
      title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473269779-28299cf0-1a0d-4566-89c1-db92afc2adc5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473269779-28299cf0-1a0d-4566-89c1-db92afc2adc5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，“匠心筑梦，人人出彩”——2026年上海职业教育活动月启动仪式暨上海市中等职业学校第九届“璀璨星光”校园文化节开幕式在上海信息技术学校举行。上海市教育委员会副主任赵震出席。',
            '此次活动月启动暨“璀璨星光”校园文化节开幕，集展示、观摩体验活动等为一体，叁昶深度参与本次活动的策划筹备、视频制作、原创节目、视觉舞美及环境布置，受获一致认可和好评。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281757-9565f1ea-4c51-4bcc-936f-e9b9fe950159.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281640-64b1d3c9-877b-4770-bf66-76754a2f304a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281604-bddc38e9-3614-4588-b936-c9fe40f96db1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281847-ce2bf24c-d1ea-44ea-aa48-aef95214fc3e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281588-3a2e0506-8288-4c57-993b-10e80937f202.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473282834-4d9b9d68-05ac-4583-8442-3a81d18e2f62.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473283095-b419e9f9-da8f-428d-af2d-6293dac65ded.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473283201-ef545ba2-079d-4efc-b84c-514e8248e60b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20260328 周晓强
      title: '叁昶助力 | 城建职院召开“重服务、强贡献”职业教育综合改革推进大会',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472956149-3a5848d1-4e74-42f6-a72e-80eeb7b0f9dc.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶助力 | 城建职院召开“重服务、强贡献”职业教育综合改革推进大会',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472956149-3a5848d1-4e74-42f6-a72e-80eeb7b0f9dc.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['3月28日上海城建职业学院“重服务、强贡献”职业教育综合改革推进大会在奉贤校区顺利召开。中国职业技术教育学会会长、教育部原副部长鲁昕，上海市教委副主任、总督学刘玉祥出席会议。城建职院校领导班子、教职工及各界嘉宾300余人参会，共商职教高质量发展大计。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969011-9ad35665-6b92-4286-9645-1e982688bd3c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969306-cd1f1ab0-68d6-413e-b628-b18a067ce299.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969090-f5e41471-7ce0-4c1d-8709-9b1c35a7b898.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969158-1a4c74a5-1fc6-4c8d-b6cf-5eef93a513b2.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [
            '叁昶深度参与本次大会的<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置</strong>，收获一致认可和好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472992483-3878f458-e9c1-4631-a816-27e70c579132.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472992479-3e1a96aa-bf0b-46d1-a983-29b299ff91f4.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260211 周晓强
      title: '汇骐骥腾辉颂硕果，仁心筑梦启新程  | 叁昶助力国妇婴2026年春节迎新表彰大会暨职工文化艺术节开幕式圆满完成！',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415580988-966e3923-c26f-4771-ab62-9187960c53c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '汇骐骥腾辉颂硕果，仁心筑梦启新程  | 叁昶助力国妇婴2026年春节迎新表彰大会暨职工文化艺术节开幕式圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415580988-966e3923-c26f-4771-ab62-9187960c53c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2月11日下午，“骐骥腾辉颂硕果，仁心筑梦启新程——2026年春节迎新表彰大会暨职工文化艺术节开幕式”在国妇婴徐汇院区报告厅举行，医院党政领导班子成员、获奖职工代表一百余人欢聚一堂，表彰先进典型、共话发展成果，同时开启 2026 职工艺术文化节新篇章，共迎丙午马年的到来。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592229-9f215ee2-15f7-4b77-92d3-961045ab81aa.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592269-13974adc-1efe-4ce7-8e23-add6df5d84d3.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592414-063f0cdd-7b4e-450a-8b15-3fe8d3912b8d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592403-c76af084-9a89-4877-958a-d0c795350fab.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592358-de67058f-e50f-49bf-9542-87be6cdaaea6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415593307-5459631d-f2a3-4495-a7ee-a41c113103ee.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415593552-7a02dcdd-9077-4fe5-9637-1dae5603eea5.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['整场活动在<strong>《来嘛过新年》</strong>激动人心的律动中拉开帷幕；现场播放的视频<strong>《逐光而行・共护新生》</strong>，生动再现了过去一年里，全体国妇婴人在守护新生命、关爱妇幼健康道路上砥砺前行留下的足迹；<strong>改编歌曲《一路同行着》、手舞《苍穹唤》、企鹅舞《高雅人士》、女声合唱团的《Try Everything》</strong>，以及尾声领导们的<strong>新春贺曲《步步高》</strong>更将现场氛围推向高潮。',
            '本次活动<strong>策划方案、舞美呈现、原创节目、视频制作、视觉画面及氛围布置</strong>均由叁昶设计、落地并全程保障，将众多精彩纷呈的多元形式贯穿始终。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604666-c3b7bf78-b758-45c8-be83-07021651e65b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604616-aaec9aec-104d-480d-80a2-65d1825783e4.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604662-698a5a60-91db-4a34-813a-f77663364f13.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604534-d033d5b3-b0f0-4913-b4b4-471792ccdb4b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604712-ae032dc7-bb85-4582-a791-dab903f76b20.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415605484-c07915a6-e7c4-4c05-8f1e-e9ff8fab7c2b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415605685-c2703d7d-a56f-4f2e-a347-28c2e3bf8633.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20251223 周晓强
      title: '焕新升级 | 叁昶助力“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”圆满开幕！',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415193622-30065df3-4cde-4154-9d8b-5cffcc8214a9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '焕新升级 | 叁昶助力“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”圆满开幕！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415193622-30065df3-4cde-4154-9d8b-5cffcc8214a9.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['12月23日下午，“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”正式启幕。市区相关领导、企业代表、职教专家及区域内四所中职校师生、中小学嘉宾齐聚现场。',
            '叁昶深度参与本次活动的<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置</strong>，收获一致认可和好评。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206257-2f421f87-b484-4fb5-b651-42ad6e14acbf.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206321-5dce8df8-a9f0-4bb1-8248-e0762f1c7240.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206337-d6b8b60c-3638-4635-8414-a0d3d71e95e1.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206377-6909e4ef-0604-48be-88f5-13568c20baef.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206291-022a8a8d-33f5-4908-b2bc-cd257bda88c3.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207121-cbcbb637-c459-4012-a8c1-0b68c2ba96ff.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207352-b294c603-cfc8-4b3d-acee-0f1013f3a003.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207320-ee4ba408-fc68-433a-ac8d-30294709af4d.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['此次“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”，集展示、赛事、互动体验为一体。开场表演“AI舞动 智享汇创”呈现人机共融，瞬间点燃全场；情景讲述环节中设置了现场连线，将匠心传承搬上舞台；核心环节徐汇区中职生AI创新设计大赛总决赛，亮点十足；此外启动环节、互动问答、专家点评及尾声合唱环节等多元环节，兼具科技感、教育性与观赏性，全方位展现徐汇中职学子的人工智能创新风采。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221512-dd754bfe-3b76-4ed9-ae0b-01c285eccdc6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221497-44fa171c-ca3f-4a97-a425-990190136615.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221538-775bfb1e-9684-43dc-b1ae-a8d1eceaa59e.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221538-e3108321-2d1f-47d2-ba11-25ac3018ee8b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221664-7d191bab-c2f7-44b5-b590-90b44f609ca6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415222546-7e58c379-34e3-4f71-83ae-ed03f9726c4b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415222676-3fb14947-5965-4932-94be-2753ed69d492.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20251214 周晓强
      title: '首秀即样板，出手必出彩 | 叁昶保障中国基础教育国际论坛圆满举办！',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414738867-3a3608f9-0dd2-49df-98c3-23b01163f764.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '首秀即样板，出手必出彩 | 叁昶保障中国基础教育国际论坛圆满举办！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414738867-3a3608f9-0dd2-49df-98c3-23b01163f764.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2025年12月13日-14日，中国基础教育国际论坛（CICBE 2025）于上海举行。论坛由中国教育学会、北京外国语大学、上海师范大学、上海市嘉定区人民政府共同主办，主题为“人工智能发展与教育教学变革——机遇与挑战”。教育部党组成员、副部长任友群视频致辞'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414753527-022108d1-69c9-4931-b223-fdb402ef16b9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414753798-e8197048-eb4d-4fc4-8f4f-e30575eacd43.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754039-ca450dcc-fc00-41d4-8b0f-0384a09919c2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754151-366b41b1-2cad-473e-bf35-cbddd26269e8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754090-14e25f13-be3d-4ea6-b14d-be45b3e7d6c2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414755007-7ccd1633-c5fc-41b0-bbc5-9dad8ded8e42.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414756549-8f5ec144-b3bf-4d28-9130-9a57517392b8.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶公司以专业化、智能化、国际化的服务标准，深度参与本次论坛LOGO、主视觉、会务手册、参会证、指引等视觉设计，开场、致辞、启动等各环节视频制作及内外场策展和环境布置，结合全自动升降演讲台与全自动签约机器人实现数字化呈现，圆满完成主论坛及五大平行分论坛的策划设计和服务保障。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414777463-80d61a7d-f2b6-4ce3-8608-964379decc9d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414778836-c3939950-4b03-4baa-8e15-e1072d6faab5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414777964-8f877d0d-684e-4d6b-afcd-e6664128d77d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414777779-5911dc88-ee91-4d19-af7d-fcd9e68eb6f8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414778527-2e4c9e6a-37ad-4eb1-a139-ea349ddf5322.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414779613-0f79e4b6-7e1a-4e8e-9782-be822d94bff5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414779493-d6431c5b-655b-4269-8aba-b3f10bf4ea1b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414779862-93969c5f-26b8-4137-a97b-da59f7c29f9f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414780231-8cc52162-9ae4-41cc-9aa7-8d0fca89218b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414780198-cbf08c79-2bd8-4929-b315-5496a14bc299.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20251015 周晓强
      title: '华东师大成立创新研究院！叁昶助力“国家队”携手“主力军”！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283938049-a9c18707-7e33-4815-8412-55d05fee7612.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=59",
      details: {
        top: {
          title: '华东师大成立创新研究院！叁昶助力“国家队”携手“主力军”！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283938049-a9c18707-7e33-4815-8412-55d05fee7612.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月15日，国家心理健康和精神卫生防治中心（以下简称“国家心理健康中心”）与华东师范大学联合成立的心理健康数治创新研究院在华师大普陀校区举行成立大会。叁昶圆满完成本次大会的策划设计并全程参与保障。',
            '国家心理健康中心主任、党委书记付强，华东师大党委书记梅兵上台致辞，并与国家心理健康中心副主任王钢，上海市教育委员会副主任王浩，上海市卫生健康委员会医政处副处长孙明明，长宁区卫生健康工作党委书记江平，普陀区卫生健康工作党委书记邓海巨，闵行区卫生健康工作党委书记赵艳，华东师大心理与认知科学学院院长周晓林共同为心理健康数治创新研究院揭牌。华东师大党委常委、副校长程静主持大会。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761283953872-3b3d6385-bd41-4839-8ef5-e476d87dcc3a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951702-609c80e6-abeb-452a-9073-6621fdff8b06.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951729-a55f637e-3043-47af-9b2e-f4d2de00967c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951818-bc8f3d64-2983-4aa2-9f02-3600800b3639.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951783-e63f96eb-7167-42b6-8924-945a1576e1cb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283952897-9f463259-7351-4ca0-becc-a4c2462a7b8c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953106-3742b639-2a62-4adc-bc78-b8801b0cbc9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953019-2f6c5e36-ebdd-4f75-a00f-4d38c278217b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953055-4c13586f-016c-45c5-98ab-ce3d803a27c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283954027-da8a71b6-2d79-4181-ac49-529cfcaa7e10.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['会上还进行了心理健康数治创新研究院聘任仪式、心理健康促进数治实验室博士后工作站”揭牌仪式，并发布研究院建设方案及12个首批重点研究项目。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283959966-483aa167-a356-4da1-8d5d-fd1d270e8b7d.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250922 周晓强
      title: '梦想启海上 技能赋未来 | 叁昶助力上海第48届世赛倒计时一周年活动完美呈现！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283862197-7b4efb63-4dda-4c7c-8a53-533977e82185.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=58",
      details: {
        top: {
          title: '梦想启海上 技能赋未来 | 叁昶助力上海第48届世赛倒计时一周年活动完美呈现！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283862197-7b4efb63-4dda-4c7c-8a53-533977e82185.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['9月22日，上海第48届世界技能大赛倒计时一周年活动，在上海展览中心友谊会堂隆重举行。世界技能大赛是最高层级的世界性职业技能赛事，每两年举办一届，代表了各领域职业技能发展的世界先进水平。',
            '<strong>人力资源社会保障部党组成员、副部长，世赛组委会副主任颜清辉与上海市委常委、副市长，世赛组委会副主任陈杰</strong>共同为上海第48届世界技能大赛事务执行局揭牌。上海市人力资源社会保障局党组书记、局长，第48届世赛组委会秘书长杨佳瑛出席并致辞。世界技能组织首席执行官大卫·霍伊向倒计时一周年活动发来视频致辞。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283877863-5ff56c25-eac1-4c44-bf83-92cd4e4052eb.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283877881-f6382264-f8e2-4d70-8eca-04493c90a0fb.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878136-291a32c2-869b-4978-aced-b8cebba8a0e9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878287-10390167-3c68-4335-922a-3fc8feef8dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878894-36633c0f-1571-47d1-81b7-d694c075f38e.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283879027-c9f585e8-8abc-47f9-893e-f19675b8dceb.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [
            '以技能之光点亮全球盛会，本次<strong>活动策划、舞美设计、原创节目、作词编曲、视频制作、内外场环境视觉布置</strong>均由叁昶公司策划、设计、落地和全程保障。',
            '活动现场，<strong>蛟龙号接旗仪式、志愿者招募启动、四大国家战略赞助商服务发布、技能梦想大使亮相等环节</strong>亮点纷呈，叁昶在保证议程环节创新、创意的同时，用专业能力确保每一个环节高效衔接、完美呈现。',
            '由叁昶编曲作词，创排的原创节目中，更有<strong>智能机器人</strong>和技能代表们以独特的方式，诠释新时代技能潮涌，并于节目最后展示了<strong>现场绘制的世赛logo</strong>。',
            '围绕“技能蓝海”、“心中山海”、“照亮星海”、“热情上海”，现场也邀请到了世赛选手代表及专家分享技能故事以各自的视角，采用<strong>现场讲述和场外直拍</strong>的形式，表达对技能的赤诚热爱，共同抒发一年后对世赛成功举办的憧憬与期待。',
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889166-bd517375-fb17-4137-8b96-685819651e8c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889078-deeeb705-d376-4edc-9fd0-56ef706ee119.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889112-f3698572-b0a6-4185-8d25-74ceeedf9b3d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889077-1694571e-f736-4ddf-a00c-8effae9bda12.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889064-94399d2d-7e65-46e2-a125-a66a18a89cec.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889829-0e7a752b-f6b0-464f-8d17-fb997948ce35.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761283890118-ec81a667-ef77-4f6f-abb4-4a4952b8db86.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250830 周晓强
      title: '南模校园焕新记：从篮球风云到人文角落，叁昶打造现代化育人多元场景',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550397646-dfaa20eb-b16f-4f9d-8ef3-b4ec1c6195c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=57",
      details: {
        top: {
          title: '南模校园焕新记：从篮球风云到人文角落，叁昶打造现代化育人多元场景',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550397646-dfaa20eb-b16f-4f9d-8ef3-b4ec1c6195c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司赋能校园文化建设，为南洋模范中学进行校园文化升级。从展现南模篮球风采、记录校园活力的<strong>南模篮球风云录</strong>，到展示南模<strong>篮球发展历史、体现南模体育精神</strong>的场景营造；从涵养艺术气质的<strong>音乐空间</strong>、浸润书香的<strong>阅读空间</strong>，到串联校园动线的创意<strong>楼梯间</strong>，再到聚焦科技教育的<strong>机器人实验室</strong>空间优化，每一处均深度融合“功能性”与“人文气息”。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410320-73146fd5-13bb-4dec-9218-d2f56e48e37f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550409020-76ddd63f-17ae-43ae-ada5-3cbc34698a01.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410965-cbf14f77-7750-4742-8d63-2e0883783dab.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410851-dd250918-62a4-4336-9d4b-0d0d7d63b020.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550409051-a49d8c53-d6e1-46a6-bb66-a0b0b3aa6ce0.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550412964-648f351a-d647-454b-9037-6dc80a572cd6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['叁昶通过场景化、个性化的精神窗口打造，不仅满足师生多样化使用需求，更让校园成为承载成长记忆、激发探索热情的现代化育人载体，助力南洋模范中学构建独具特色的校园文化新生态。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550417983-67e52b20-bfdb-49c4-b0aa-53ab6efb8dd8.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550418229-94ff52c8-1e1c-48c8-b3cf-aa2a82cf0296.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550418383-44e67629-343f-463b-9aa2-3c9ea9c85886.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250726 周晓强
      title: '叁昶出品 必出精品！非遗文化长廊、学生活动中心项目获得一致好评！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174543-c6e149f0-ac1a-4233-aff5-c5d778471869.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=56",
      details: {
        top: {
          title: '叁昶出品 必出精品！非遗文化长廊、学生活动中心项目获得一致好评！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174543-c6e149f0-ac1a-4233-aff5-c5d778471869.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['为更好地展示中华传统建筑文化，实现展览互动、教学等功能，叁昶为某校量身定制的非遗文化长廊将长廊分为序、中国优秀传统建筑文化历史、建筑思想与人文情怀、建筑艺术、建筑技术五个版块。',
            '各版块通过展墙、图文展板、模型实物、互动道具等多种形式、多角度形象生动的打造可观、可感、可触的沉浸式互动体验，展示出中国传统建筑文化的魅力，发挥了“中国传统建筑文化实践体验基地”中华优秀传统文化传承作用，强化文化育人功能。',
            '此外，现已投入使用的学生活动中心装备了先进的电子显示屏和综合控制系统，这些设备促进了学校双创教育课程的有效开展和项目研讨的活动。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174276-b899c69d-dc78-4e29-900c-71d2cce9986b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175162-3acd6179-e40f-4d3c-9046-03770e984daa.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175958-5817e8ff-4e97-4bd0-852c-64d12f4f5576.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175532-40acf3a9-7bd7-4c8d-8815-d573eb30777e.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550176253-d6bfc292-5fbf-48ad-aa10-9e45e423314d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550178781-26a64257-1dc1-4fdf-9bbc-e585b499e35b.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250624 周晓强
      title: '技能造就美好未来 | 叁昶保障上海市第二届职业技能大赛圆满落幕！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237281236-5411be05-6a74-473e-940f-ab94a56574aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=55",
      details: {
        top: {
          title: '技能造就美好未来 | 叁昶保障上海市第二届职业技能大赛圆满落幕！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237281236-5411be05-6a74-473e-940f-ab94a56574aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['<strong>6月24日，</strong>以“技能造就美好未来"为主题的上海市第二届职业技能大赛在青浦区东方绿舟剧场荣耀闭幕。上海市职业技能大赛是本市规格最高、规模最大、项目最多的综合性职业技能竞赛。本届大赛共吸引全市16个代表队共1367名参赛选手同台竞技。',
            '市政府副秘书长张英出席活动并宣布大赛闭幕。市人力资源和社会保障局党组书记、局长杨佳瑛，青浦区委副书记、区长金晓明，市人力资源和社会保障局副局长谭友林，青浦区政府党组成员陈锡琦，闵行区副区长杨辛，团市委副书记唐志宇等出席闭幕式。',
            '叁昶深度参与本次<strong>大赛闭幕式、LOGO、主视觉、吉祥物、回顾视频及内外场策展和环境布置，</strong>圆满完成本届大赛<strong>开闭幕式的策划设计和全程保障，</strong>获得了各方好评。',
            '闭幕式由<strong>“荣耀加冕·梦想新程”和“荣耀之星·闪耀蓝毯”</strong>两部分组成，通过<strong>获奖选手蓝毯秀、大赛精彩回顾视频片、冠军选手荣耀时刻等环节，</strong>充分展示技能青年奋勇争先、勇攀高峰的精神风貌。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951228-d9e86551-1118-4d78-99c2-26d0c98aa635.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951199-9fb8d043-cbe5-4152-9ed5-8da65b90b4ae.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951203-1fa8f7be-a046-421e-a47f-f363e7deda42.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951173-7c386ed4-8205-4694-98e3-05bcb1ae7284.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406951981-26c57a6d-2d63-44e3-b2e4-fcc6c38bdc5c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952563-ddc296d3-7add-4f0b-998f-3664d4e85cc9.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952831-6eaaed8f-aeda-46b6-beff-7e8d998739a3.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952779-7e9e717c-e03d-4099-9975-dca4d374f6e8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952701-7fd7a3b6-5932-48de-bdcb-90c4c8e48763.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406954319-bbffee86-f4b5-4dc2-b050-dd50c7916d35.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406953910-2717bdc0-42c3-407f-bdbb-24cae1f3f4ec.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [
            '值得一提的是荣耀蓝毯环节打破传统红毯的刻板印象，以技能蓝为基调，打造宛如全明星般的<strong>蓝毯秀场。99个赛项的322位获奖选手</strong>在授奖后，依次沿着闪耀着技能之光的蓝毯大道在欢呼与掌声中问鼎桂冠，依次登上属于他们的荣耀之台，展示专属于技能人的独特魅力。',
            '以实力镌刻品质高度，叁昶以 “追求卓越，精益求精” 的硬核执行力精研策划、匠心锻造精品，昶赢未来，叁昶乘势而上！',
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327058-f047f547-5559-4a99-8d65-aaf7a2e7a81d.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327054-3db1179d-9306-48e6-a8f8-a1bad5ce02ac.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237327637-1e469c44-35a1-450e-a485-eaf6965e200b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237328153-e042bbb4-1281-4350-8ee4-cdf2b525b859.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327147-5b84a4a3-6ef6-4ec3-ab13-d7d508e57eb1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237328405-b8ef53c2-1dc2-489a-a6ae-c124c5b10da0.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237328060-385f63bc-64f2-4c38-b98b-58c697cf40c2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237328260-34f98248-b42e-4027-840d-002995c942f1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250530 周晓强
      title: '毕业快乐！叁昶再次为上海七宝德怀特高级中学学生毕业典礼划上圆满句点。',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333956107-893635c3-5a92-4084-a91c-4abb46da9ddd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=54",
      details: {
        top: {
          title: '毕业快乐！叁昶再次为上海七宝德怀特高级中学学生毕业典礼划上圆满句点。',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333956107-893635c3-5a92-4084-a91c-4abb46da9ddd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月30日，上海七宝德怀特高级中学2025届学生毕业典礼如期而至。在这个离别与温情交织的时刻，七德理事会、监事会、全体中外教师、毕业生亲友约700余人，一起见证G12学子亲手为有笑有泪有成长有梦想的三年高中校园生活画下圆满的句点。',
            '继去年七德十周年校庆暨毕业典礼圆满落地后，本次毕业典礼<strong>策划方案、舞美呈现、节目指导、视频制作、视觉设计</strong>依旧由叁昶策划并全程保障，现场进行实时转播并双语同步翻译。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979166-f99be61c-204a-43e4-8d46-f819b5e12fae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979111-c2b36bc1-d667-4335-ac86-d0cf14bc2394.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979353-4c0d63a4-ca35-41c2-8ede-43c3a92324fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979117-b7a35765-51da-4031-942f-381dda490e9f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979158-e1f4372d-c163-48bf-b1ed-874bad4259ba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980177-a679e1b3-c35b-485c-9fad-a8e41603db14.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980352-4d25c812-de05-4bc2-a9e2-98dbd73c4923.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980432-a6716acc-7f3c-490a-994b-425d707fcb0b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]

        },
        bottom: {
          title: ['以毕业生入场仪式开场，庆典在说唱、合唱和乐团演奏中正式拉开帷幕。除发言环节、毕业电影、学生捐赠、颁发毕业证书及奖学金等众多精彩纷呈的多元形式贯穿始终，呈现了在一片中西融合的教育土壤中，来自不同文化背景的教师群体能全面地滋养学生的认知与理想。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013872-c853df6c-577a-4f44-8af6-b09e57fcd9bb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013887-d0e3cf7d-c7f2-4f34-b6c5-5feec427ece0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753334014748-796c4723-c57e-48fc-85ac-26d48bd018f2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013884-fb560db1-b442-46b7-8e5d-b59751fcdf35.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013957-87fff558-4373-4d4d-85b0-d5b014cc1555.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334014927-c1c8246d-07d3-4295-8ac4-24b29905a835.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]
        }
      }
    },
    {// 20250516 周晓强
      title: '育”见AI，智启未来 | 叁昶公司助力2025年第22届上海教育博览会！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911690-6c8e85ce-b411-496e-8a40-6f288ed3f73a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=53",
      details: {
        top: {
          title: '育”见AI，智启未来 | 叁昶公司助力2025年第22届上海教育博览会！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911690-6c8e85ce-b411-496e-8a40-6f288ed3f73a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，2025第二十二届上海教育博览会在上海展览中心正式开幕，本次展会的主题为“‘育’见AI，智启未来”。5月16日-18日为线下展，众多教育单位现场集中展示，展区分为市级展区、长三角教育一体化发展展区、“AI+教育”特色主题展区、区域教育展区等，全方位、多视角展示上海乃至长三角地区人工智能赋能教育高质量发展，构建以人为本的创新教育生态，打造全国领先的人工智能创新策源地。同期线上开展至6月底。',
            '叁昶公司设计打造的展馆齐齐亮相本次教博会，紧扣AI教育，融入诸多创新理念，全方位展示 AI 赋能教育的多元成果与无限可能，引领大家共同迈向智慧教育的未来。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911471-89ca3166-44e9-472f-9a84-59e129499d7e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911521-b155021d-636f-46e8-b4de-7a775200052b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911661-be0e4b6e-fd4e-44e8-bc70-d0cd042e9481.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911649-14d9cf29-a37b-4c99-837d-791f770d9db0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549912673-67caa09d-1a36-4bc2-a020-6c2ca7b1ef71.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549912776-269dbc99-e4c9-4e6c-9307-8db82c79eb00.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250516 周晓强
      title: '叁昶助力2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛圆满开赛！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333878552-27bfa5ce-ba92-4228-957f-012de9e06c18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=52",
      details: {
        top: {
          title: '叁昶助力2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛圆满开赛！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333878552-27bfa5ce-ba92-4228-957f-012de9e06c18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛（简称“星光大赛”）开赛式在上海市信息管理学校举行。',
            '市教育发展基金会理事长王荣华，市教卫工作党委副书记、市教委主任周亚明，市教委副主任赵震，市教育发展基金会副理事长蒋红，徐汇区副区长王志华，及职业教育活动月相关参与单位、大赛组委会成员单位、各区教育局、行业企业、职业院校代表约200人参加了本次活动。',
            '叁昶深度参与本次开赛式<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置，</strong>受获一致认可和好评。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894671-e83d54ef-58ba-4e44-8beb-6ddc03ebf465.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894787-36115932-be92-40aa-af25-f005c9766b9e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894488-0dc1e281-fa8a-4df3-8697-6666b9285785.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894810-8eb0836d-32f8-4a5e-b69e-bfb332501190.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894694-eb73cc40-ddb7-4065-a58b-1b4a6bba207a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333895648-bf85af6c-172e-46b2-a561-6d018b03f43f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333895701-7cd03c8c-b025-41ec-806b-d4abd41594b1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['此次活动月启动仪式暨星光大赛开赛式，集大赛、展示、观摩体验活动等为一体，<strong>开场视频《技能筑梦 成就未来》、情景讲述《星光点亮梦想》 、舞蹈《流光》世校赛金牌作品、师生合唱：《梦启海上》，以及对企业家、校长的星光纪实采访环节，</strong>均为<strong>叁昶原创出品，</strong>折射出制度供给更加充分、条件保障更加有力、产教融合更加深入的上海职业教育发展新成果。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333919774-eec706b3-1118-40ff-b57c-666676db12fa.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333919847-0244192a-c5c9-499b-86ba-f002cdc3b1c2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333920113-2298aae3-1981-44d9-a513-a114f0039266.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333920307-1fe5dee7-5ddc-44b7-997f-5f6e90fe8091.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20250328 周晓强
      title: '赋能红色新动力，叁昶打造的党群活动中心让人眼前一亮！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627796-e01036bc-06af-4e5f-8cd9-c521675eb64f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=51",
      details: {
        top: {
          title: '赋能红色新动力，叁昶打造的党群活动中心让人眼前一亮！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627796-e01036bc-06af-4e5f-8cd9-c521675eb64f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为三中院打造的党建活动中心，以“党建引领法制，科技赋能司法”为核心理念，建设了集“智慧化、交互式、文化融合”于一体的现代化党建活动中心，结合特有文化设计特色，助推数智转型，实现多功能需要。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627698-7a830625-ce21-4e28-90ff-06f9ef38248f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549628030-9fb74bf9-51c6-4414-afef-98ecf69367cc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627977-e9140fce-6ff9-4c1d-befa-36e356ab4b06.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250323 周晓强
      title: '追求卓越，再出精品！叁昶助力上海市第二届职业技能大赛盛大开幕！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237094630-28eb72cc-7db5-455c-ae60-3f04b0944a40.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=50",
      details: {
        top: {
          title: '追求卓越，再出精品！叁昶助力上海市第二届职业技能大赛盛大开幕！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237094630-28eb72cc-7db5-455c-ae60-3f04b0944a40.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['3月23日，以“技能造就美好未来”为主题的上海市第二届职业技能大赛开幕式于国家会展中心（上海）举行。',
            '继叁昶助力首届上海市职业技能大赛开闭幕打造完美样板后，时隔两年叁昶再次深度参与，完美助力第二届大赛盛大开幕。',
            '上海市职业技能大赛作为本市<strong>规格最高、规模最大、项目最多</strong>的综合性职业技能竞赛，参照世赛、国赛办赛模式，共设置101个比赛项目，采用“主赛区+分赛区”协同办赛机制，将吸引16支区代表队，近千名选手同台竞技，通过技能展示、技能体验等模块，打造<strong>“可观、可感、可参与”</strong>的技能嘉年华。',
            '本次大赛<strong>开幕式、LOGO、主视觉、吉祥物、宣传片及内外场策展和环境布置</strong>均由叁昶策划设计并全程保障，开幕式现场还有<strong>宇树机器人</strong>和观众进行惊喜互动。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237116079-284c0812-285d-44a4-8205-f3da198a1bba.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237115512-ccc9bf76-2c21-4f05-981e-81354578f7b6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237115538-cc6f5bf8-04e1-43b1-bcb8-dd5e10b3784a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237118274-47d1c55f-c79e-40a4-aa7a-0cac42bfbf31.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237118373-82400cc6-beff-4379-a5b8-272f635755fc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237119501-7166726f-8e29-42c4-87c6-0c9513380498.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237119248-843c0500-2c74-4b80-ac3e-5cb765fb4595.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237120979-de50efe9-2a78-417a-bb24-5974859dcd4c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237122998-ee650e98-a274-483f-9b21-05348597be45.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237123214-13103954-6799-4479-a633-52c543b250fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['<strong>开幕式：吹响以赛强技“集结号”</strong>',
            '上海市副市长陈杰宣布大赛开幕。市政府副秘书长庄木弟，人力资源社会保障部职业能力建设司二级巡视员张达分别致辞。市人力资源社会保障局党组书记、局长杨佳瑛，青浦区副区长倪向军，大赛组委会成员单位及各区相关负责同志参加大赛开幕式。',
            '开幕式上，与会嘉宾观看了大赛宣传片，16个区参赛代表入场，选手代表、裁判员代表分别宣读比赛誓词。',
            '<strong>青浦馆：聚焦技能成才“大检阅”</strong>',
            '叁昶团队着力打造的“青浦馆”，聚焦技能与产业的融合发展，围绕三大核心产业集群，融入<strong>科技元素、青浦元素</strong>，通过精心的设计策划，全方位展现青浦在科技创新、技能人才培养和主导产业发展等方面取得的突出成效。',
            '<strong>氛围布置：以斑斓文化展现工匠力量</strong>',
            '全场氛围布置是提升大赛体验的关键环节。通过内外场氛围布置，营造出浓厚的大赛氛围。在入口、通道以及公共区域，都能看到醒目的大赛标志和宣传标语，让每一位进入赛场的人都能感受到大赛的热烈气氛。',
            '<strong>视觉设计：赋予品牌符号崭新定义</strong>',
            '主KV颜色采用<strong>技能蓝、数智蓝</strong>为背景主色，延续了“技能造就美好未来”的大赛主题，整体设计以斑斓文化展现蓬勃工匠力量、以深厚底蕴展现多元城市风貌，<strong>赋予了一以贯之的大赛品牌符号崭新定义，</strong>引领技能人才进入新时代职业发展快车道。',
            '大赛吉祥物名为<strong>“小青果”，</strong>“青” 取自本次技能大赛的举办地青浦，“果”吉祥物的整体形状像一颗果实，也象征着技能大赛的选手，所铸就的闪耀成果。',
            '简约、隆重、振奋、激扬，叁昶以“追求卓越，精益求精”的强大执行力，精心策划、全力打造精品，昶赢未来，叁昶正当时！',],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237149616-d65e52bc-cca6-4efe-afc7-8aba6404d287.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237148745-894850e0-a179-43a0-bd22-505f71cad191.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237151105-66a330e4-ae8e-4260-9260-c36805bd8aa6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237149000-1557be30-a3c5-48eb-9519-960c7f832d67.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237148772-0168cecc-87e4-4821-b0e7-70bdcc1a154e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237151907-e2883b48-3f30-4c72-9c09-a540305cb49d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237153623-165ddeb3-e14c-47e0-a496-e1b9bcc07b51.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237150450-cfc7d767-cd2f-4c0b-984d-35cc3827d6cc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237150955-b5088a61-59f2-425e-b8e9-df4e17a46b6c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250315 周晓强
      title: '叁昶公司打造的院史墙、院内文化顺利落成！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334718-ddfeb2ae-53cf-416d-a0a3-5d3dd79200e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=49",
      details: {
        top: {
          title: '叁昶公司打造的院史墙、院内文化顺利落成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334718-ddfeb2ae-53cf-416d-a0a3-5d3dd79200e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为市二院独家定制的院史墙，以“江河归流，共济致远”为设计主题，通过河流动态汇聚的创意形式，生动呈现由四所机构逐步融合、共筑新生的历程，寓意“多元汇聚、同心同行”的办院精神。',
            '院内文化设计上，除院内装置外，独具匠心的剪影贴画艺术墙成为文化亮点，叁昶团队以剪影贴画艺术生动呈现医院特色科室与医者故事，将传统艺术与医学人文深度融合。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334541-891363a3-1a29-40ed-aa5d-e6742c1ab371.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334788-e900182d-b307-4cf9-9c39-2e2b83eb354b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334755-d8b59c25-6b90-4dcd-bdd3-d4d1a55c9441.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334662-f5c7b111-6cc0-4f03-a812-15e8eeecdc2f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549335834-88c39ee5-a6ca-42f6-baba-b14f43be18ce.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250315 周晓强
      title: '传承百年医脉，开启奋进新征程 | 叁昶助力上海市第二人民医院恢复冠名！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333766295-75cf1dd2-6f9f-4cfb-b2ec-7365f16ed130.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=48",
      details: {
        top: {
          title: '传承百年医脉，开启奋进新征程 | 叁昶助力上海市第二人民医院恢复冠名！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333766295-75cf1dd2-6f9f-4cfb-b2ec-7365f16ed130.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['3月15日，上海交通大学医学院附属第九人民医院黄浦分院举办“恢复上海市第二人民医院冠名”揭牌仪式暨大型义诊活动。上海市卫健委主任闻大翔、黄浦区委书记杲云出席仪式并讲话。黄浦区委副书记、区长徐惠丽，区人大常委会主任韩顺芳，区政协主席陈志奇等出席仪式。叁昶<strong>全程参与揭牌仪式的策划及圆满落地，并保障外场氛围布置及义诊活动顺利开展。</strong>'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785971-060df819-1376-4d14-a5ef-db94e45f1a59.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785980-3e9a7f20-4fdc-4306-906a-9427bcf25115.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785988-acda70df-631b-4aed-bf75-73bf12a3346c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333786120-e85757cc-20c7-4bf6-a734-62f2d6555026.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333786076-62d067bc-e254-435e-8c91-e61f46922e78.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787022-38050a49-dac9-46ce-be4b-3d9c7e06f09a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787251-da49f3f0-d133-4852-9685-03026f8d5ca3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787243-740d37bd-f474-4632-a7f9-e51fc2661575.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787204-147b5e04-1b3c-4042-9c57-a93cc820c5ee.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787451-ba786b1a-59bc-4cc8-a26d-8f4ca696eaf6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333788028-c6f6d464-8387-4d83-bf72-c9119ca4ba8b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',


          ]

        },
        bottom: {
          title: ['启动仪式融合了<strong>颁奖、清单发布、讲述发言，</strong>并实现了<strong>内场装置与外场大楼红绸</strong>同步启动揭牌，壮观非凡。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827109-7607d806-7e75-45e9-9ca3-930fbb57011e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827128-41849194-8f0d-4584-842e-134e3b19bb1a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827131-2bbec929-e98a-4fb6-b7b4-4c92541f7fe0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827131-b5007f8d-1a13-4c9b-980b-33229a05da78.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827175-a8af83bd-fadd-49a3-8898-a4be7c8be50e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828186-97874268-395b-47f5-9f9b-5bcf681c63ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828282-0c388cec-ae18-49b8-a2bc-f06fdfffd8dc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828253-5a3f0a94-1bc9-4c38-be23-0f6479c76c51.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1']
        }
      }
    },
    {// 20250120 周晓强
      title: '聚力共创新征程，同心齐进耀未来 | 叁昶助力国妇婴2024年度表彰暨2025年迎春会圆满完成！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333682960-c5dd338a-fc77-4de3-88c8-ed4f6fe31b84.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=47",
      details: {
        top: {
          title: '聚力共创新征程，同心齐进耀未来 | 叁昶助力国妇婴2024年度表彰暨2025年迎春会圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333682960-c5dd338a-fc77-4de3-88c8-ed4f6fe31b84.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['1月20日，“聚力共创新征程，同心齐进耀未来——2024年度表彰暨2025年迎春会”在国妇婴徐汇院区举行，医院党政领导班子成员、获奖职工代表一百余人齐聚一堂，展望美好未来，共迎蛇年新春。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698992-e551f8dd-232e-4e7c-a412-02aefc2e633d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698978-bf64c87d-27fd-43ae-8ed1-8ad851222172.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698942-406c97f9-c284-446f-89a4-8d383f851ba5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333699056-f2ac526f-4070-4a83-8c3a-83ef9e20f580.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333699005-458781d2-a33a-4370-b1cf-dba7d2b88524.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700021-f84fa2b4-aaab-42da-923d-9c4a9bb0b257.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700087-fc82122c-ff0d-4028-bcba-61b725f952c9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700096-7c87578e-d99b-400e-9735-27af48230148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700206-6a993f5f-4fce-41c2-8dc6-dfc5bbe95d48.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]

        },
        bottom: {
          title: ['整场活动在<strong>《鼓舞新春》</strong>激动人心的律动中拉开帷幕；<strong>音乐沙画《守护生命，砥砺前行》</strong>用一幅幅流动的画面回顾展示了2024年医院的重点工作成效；<strong>情景朗诵《爱在奉献，爱在国妇婴》</strong>以仁心、奉献、守护、新生交融讲述；以及<strong>歌曲《红旗飘飘》和《火花当燃》</strong>环节，分别进行了太极拳展示以及《真心英雄》、《只此青绿》、《APT》等歌舞展示；活动最后，在<strong>合唱《我奋斗我幸福》</strong>的高潮部分，8位院领导也步入台上一展歌喉，并送上新春的祝福，将现场气氛推向高潮。',
            '本次活动<strong>策划方案、舞美呈现、原创节目、视频制作、视觉画面及氛围布置</strong>均由叁昶设计、落地并全程保障，将鼓舞、沙画、朗诵、歌曲、表彰等众多精彩纷呈的多元形式贯穿始终。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716978-29f1dffd-66ec-470a-832b-797b4471b39c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716986-775a5d3c-6e64-4e4a-88f7-14d55574535a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717042-04da9e09-c442-41a6-a5fd-7b4d5da64279.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716948-f7ca72b6-3f46-4bfe-abcf-68eda1a9e859.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716971-61fdde49-60e5-480e-a721-3d9ddddfbc5b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717660-b166638a-1811-4a13-9b84-ad212e82d34a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717977-c7fd1cac-2235-4f5a-ab86-43f7a07f1ae1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20241210 周晓强
      title: '以墙为纸，叁昶为胸科医院绘就温暖底色！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548739806-7863a06a-ccaa-47f0-b0ff-e9f165e495b5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=46",
      details: {
        top: {
          title: '以墙为纸，叁昶为胸科医院绘就温暖底色！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548739806-7863a06a-ccaa-47f0-b0ff-e9f165e495b5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶通过特色的文化设计推进上海市胸科医院医院内涵式发展，用文化软实力涵养医院高质量发展的“动力源”。'],
          img: []

        },
        bottom: {
          title: ['本次项目设计结合专业特色，配色延用了医院品牌色调，与整体相统一。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548746841-92ecdc2c-85e7-489b-ad3a-f10ea5290d28.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548746928-2c11acb2-4240-480e-93dd-6445ec687855.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241206 周晓强
      title: '同创耀辉煌 共建创荣光 |  叁昶助力2024年虹桥机场同创共建年会圆满呈现!',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413314824-be65b8cf-ab3e-4dde-8f6b-c72a825b47e4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=45",
      details: {
        top: {
          title: '同创耀辉煌 共建创荣光 |  叁昶助力2024年虹桥机场同创共建年会圆满呈现!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413314824-be65b8cf-ab3e-4dde-8f6b-c72a825b47e4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['12月6日，“同创耀辉煌 共建创荣光”2024年机场同创共建年会于虹桥源盛大举行，现场欢笑不断，热闹非凡。叁昶深度参与本次开赛式<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置，</strong>受获一致认可和好评。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329506-e81e3f07-e1a6-4cf7-97ed-703f49a5ed49.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329306-fc101ce8-b4d3-4387-9f04-84eb31d75691.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329525-82d6e1a3-f694-4066-b28a-e594326f333f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329524-5c2bc8a2-c355-41e3-8f78-0605676a0a65.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329397-504d273f-d0fd-415e-aea7-92103bdd46e1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330529-37dfba72-9af4-4381-afe5-3ea2fa24b8f6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330515-c586e0c7-342a-49de-97ca-a0db8c812bc4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330682-dc246828-da5a-49a4-9c99-9a221ec52655.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330757-1914d13d-4dd6-48bd-b93c-960a6750cc4e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330806-4d54a340-09f9-4767-a99c-2027050a196b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413331601-2d7449c6-7f1e-4d9d-ada5-a3cf17f43eef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['现场设置了茶歇供宾客享用，年会内容集<strong>开场鼓舞、回顾视频、情景讲述、表彰仪式、颁奖词、知识问答、抽奖环节、合唱等</strong>多元形式构成，均为叁昶原创打造。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341847-8da0f006-4ffe-4f05-9e14-6cc5fc8d908f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341873-4bd46a22-121e-46c1-8e2e-c1e0bcf09356.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341836-4b704a73-e721-417c-b6fd-e14ff9c180bf.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341862-90a7cb59-4f93-40c8-a1df-ef9657efa47a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341963-efa0507b-0410-4e75-b218-72aff6ccbe36.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413343128-5d40c5c4-1f66-4606-9e49-6291b03b6b7c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20241203 周晓强
      title: '智享汇创 | 2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会圆满举办!',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412895744-d4dc35ce-a9af-4776-aba7-9f9cc6316934.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=44",
      details: {
        top: {
          title: '智享汇创 | 2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会圆满举办!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412895744-d4dc35ce-a9af-4776-aba7-9f9cc6316934.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['12月3日，以“智享汇创”为主题的2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会在漕河泾开发区会议中心举行。',
            '徐汇区教育工作党委书记姚黎红，市教委职教处四级调研员谢俊，区教育局副局长、徐汇职教集团常务副理事长林琛，虹梅街道党工委副书记王晶，区科委副主任虞蔚，以及区域中职校的校领导们出席活动。<strong>叁昶策划设计并全程保障活动落地及环境布置。</strong>'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909822-bb5bff5f-2e23-4495-8d9c-0dec3cc6bf6d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909567-936d351a-77cb-40b6-968c-e90fa8535790.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909698-353283f3-1374-4294-af4e-548c8356b464.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909501-ee49e6c6-0462-4a6d-b5d1-3cfd7314aae4.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909516-5909418d-cb1f-41c0-afe2-c198aa6374c7.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910365-0bebc930-3da9-4cbf-a3bb-a5f0cac1cdba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910588-5c5a84a3-9637-4e59-8be0-ff43a662c3e7.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910730-a4cd3687-806b-4f0c-969a-e45e48f534c9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412911391-91095281-3c14-43b2-be02-535ef42a6519.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412911192-df5cb9e4-cd33-4acc-8347-b1f961f9127a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['发布会以叁昶原创的科技舞蹈“时光穿梭”及开场视频拉开序幕，除1位真人主持外，本次活动还制作了<strong>5位数字主持人</strong>。现场项目成果发布围绕<strong>【未来工厂】、【创意工坊】、【时空穿越】、【数智生活】四个应用场景，以数智展示、珠宝走秀、路演示范、专家点评等多重形式，</strong>展开一系列精彩纷呈的展示与分享。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924045-ef128c45-3acd-4cc0-97cd-def56ea1293d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924040-d92652dd-7a9e-43c6-aab2-e13ec0aeceda.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924045-b4ea33fe-2236-4000-8db4-0058ee3c195c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412923993-9e7109ba-07f0-4e51-8e8c-a768ae6130f5.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924732-fc95a28c-c687-4288-b290-f204c157ca42.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924928-964d96f8-2965-4196-bfc0-3440288c6799.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412925690-dba3f9e1-d34b-4083-9c69-5ec63ba69a2c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412925786-8b939143-c98b-40c5-8ed1-e2544db4539e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20241114 周晓强
      title: '上海市劳动和社会保障学会成立40周年暨学会高质量发展大会圆满召开！',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753410803645-49541e45-1ae7-4b91-8272-82a5c618cf09.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=43",
      details: {
        top: {
          title: '上海市劳动和社会保障学会成立40周年暨学会高质量发展大会圆满召开！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753410803645-49541e45-1ae7-4b91-8272-82a5c618cf09.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2024年11月14日上午，上海市劳动和社会保障学会成立40周年暨学会高质量发展大会在上海展览中心友谊会堂三楼会议厅召开。',
            '国务院参事室特约研究员、中国劳动学会会长、人力资源和社会保障部原党组副书记、副部长杨志明，上海市政协第十二届委员会副主席、上海市拥军优属基金会理事长周太彤，第十四届全国政协委员、中国劳动和社会保障科学研究院院长莫荣，上海市人力资源和社会保障局党组书记、局长杨佳瑛，上海市社会科学界联合会党组书记、专职副主席王为松，上海市劳动和社会保障学会会长张岚以及学会老会长张剑萍等领导出席会议。',
            '来自上海市社联、上海市人社局、市兄弟学（协）会相关部门负责人，学会副会长、常务理事、理事、监事，各专业委员会、分会、区劳动保障学（协）会、直属会员单位代表320余人参加会议。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813662-9307e174-2205-4b92-b44f-44c789867e1a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813867-5df3367f-79e5-4d87-9df8-a820e48c5cee.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813907-df24290b-b097-43d2-a56e-07d46f3bcb4c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813949-867b7d9c-a95d-470e-a22a-d395ccf3f367.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813937-a674ad9b-c6ef-411d-82a0-49b71ecf611f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814637-d0a80673-f78f-461e-a979-1f4339808723.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410815046-132df6bf-3d3b-4f25-a609-f7ea48213b70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814807-adc9cbe0-25cc-4111-a769-70e6a505bfa0.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814814-4f4e97b4-65b4-4229-8ca3-3d5fb70598b2.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶深度参与本次大会策划筹备、视频制作、原创节目、视觉舞美及环境布置，暖场视频、40周年视频均为叁昶原创。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410831025-a4a4de21-de94-4c99-a424-c1a2636261fd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410831101-87bef03e-3340-45f2-b2d1-54181f5190b9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410830993-da531ee0-ab50-4c9f-997a-ade63ce1b773.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20241031 周晓强
      title: '京津冀沪+交通职业教育集团联盟2025年工作推进会在上海召开！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409570207-2066a119-a414-4f85-8b63-33f2dc099dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=42",
      details: {
        top: {
          title: '京津冀沪+交通职业教育集团联盟2025年工作推进会在上海召开！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409570207-2066a119-a414-4f85-8b63-33f2dc099dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月31日，京津冀沪+交通职业教育集团联盟（以下简称“联盟”）专项研讨会在上海举行。本次研讨会主题为“交通助力人民城市，人才筑基新质生产力”。',
            '同济大学城市风险管理研究院院长、市交通委原党组书记、主任孙建平，市交通委二级巡视员孙林骏，市教委二级巡视员、职教处处长马建超，公共交通产教融合共同体（上海交通物流职教集团）理事长蔡军，联盟名誉主席靳和连、鲍贤俊、李怡民，以及联盟成员单位、观察员单位、兄弟院校和公共交通产教融合共同体（上海交通物流职教集团）成员单位领导、专家、代表共70余人参与了本次研讨会。上海交通职业技术学院党委书记徐刚、校长董晓峰分别主持了开幕式和主旨报告。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589696-2073ae35-ebfe-4f02-b98b-37410419bfb5.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589628-73ae6b93-a1b3-46b6-ab90-29a383a4c3d6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589810-3aafa1cc-66fc-4194-8ee5-9c7cffce0d28.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589786-c3f46b96-382d-4198-8826-f740dfec5c3d.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589835-4d5d714b-894d-4745-ac11-f07937dd1605.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590475-0e59b83c-b85b-43d7-86ec-7fd1b08e9122.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590499-563fd4a4-40dc-48b3-ae42-bae9fec095ba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590510-68ac0583-4fd6-4281-b770-51477d12734a.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['本次活动由开幕式、主旨报告和互动沙龙环节组成，整体<strong>流程策划、环境布置、视觉设计、落地执行</strong>均由叁昶团队精心负责，保障了京津冀沪+交通职业教育集团联盟2025年工作推进会圆满结束，受到主办方高度好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602087-f240d765-3e7f-45e2-b5d6-a07777ea811a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602134-f18ed61f-875e-4ffc-b6f3-56735e34c779.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602027-01e1de57-e2cc-43c1-8bdc-2c40dda7f382.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602040-d4ad9f8e-9154-4dc6-b180-6671731e85aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20241028 周晓强
      title: '腾飞十五载 沪港向未来 |  叁昶助力沪港公司成立十五周年庆祝主题活动顺利举行!',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408889186-0dab08e4-ad26-4a8f-bf95-7c803a9e8a1e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=41",
      details: {
        top: {
          title: '腾飞十五载 沪港向未来 |  叁昶助力沪港公司成立十五周年庆祝主题活动顺利举行!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408889186-0dab08e4-ad26-4a8f-bf95-7c803a9e8a1e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月28日，“腾飞十五载 沪港向未来”虹桥机场沪港公司十五周年纪念主题活动于沪港机场管理（上海）有限公司举行。',
            '桥机场党委书记、董事长李政佳，虹桥机场党委副书记、总经理朱传武，虹桥公司工会主席沈小玲，沪港公司常务副总经理李浩峰莅临出席，沪港公司领导及各部门负责人、员工代表、杭州萧山机场代表共同见证。',
            '活动随着叁昶原创开场视频正式开启，定制款印制员工姓名的彩虹奖杯、定制款十五周年生日蛋糕及抽奖环节将活动的气氛一次次推向高潮。',
            '本次活动还准备了精美的茶歇供宾客享用，整体流程策划、环境布置、视觉设计、落地执行均由叁昶团队精心负责。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901145-0aee01a3-24ed-44a5-ab4e-78700834bd14.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901189-09f78fde-a39e-460b-a5ad-5421564084f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901115-2c864376-3b2f-4ad0-aa38-fd2a0252f895.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901299-211c5838-2ac8-4bfd-ba13-f86ae1852599.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901321-39c22f10-3ae0-4e83-a9dd-fb478df5fa6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408902254-6a7231f2-c376-49ce-956a-2a6c8488cbeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408902470-023fad80-1829-4528-9b01-3b1ef2226697.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241024 周晓强
      title: '它来了！叁昶打造了一座可读可玩可探的校园科普馆！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595053-923f6605-b8d0-4323-af71-dea938cf5afd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=40",
      details: {
        top: {
          title: '它来了！叁昶打造了一座可读可玩可探的校园科普馆！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595053-923f6605-b8d0-4323-af71-dea938cf5afd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: [],
          img: []

        },
        bottom: {
          title: ['叁昶对上海市环境学校科普馆的教学环境、信息系统管理等方面全面数字化，构建具有多功能性，集互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595118-55c93697-d89f-4520-9854-44df9a6a6f28.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595155-e33797a2-f3a8-4487-9b2a-16466693de35.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240929 周晓强
      title: '百年门户 畅享虹桥 | 叁昶助力上海虹桥机场服务品牌圆满发布！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753407992515-b2a58261-bbf2-4023-b5be-6e8dfa1f74ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=39",
      details: {
        top: {
          title: '百年门户 畅享虹桥 | 叁昶助力上海虹桥机场服务品牌圆满发布！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753407992515-b2a58261-bbf2-4023-b5be-6e8dfa1f74ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['9月29日，上海虹桥机场在2号航站楼举办“虹桥服务”品牌发布会，民航华东地区管理局党委书记姜春水，机场协会理事长王瑞萍，机场集团总裁冯昕，东航集团副总经理万庆朝，机场公安分局副局长刘民，虹桥机场公司、虹桥机场海关、虹桥边检站、上海质科院、市市场监管局机场分局、市质协领导出席发布仪式。',
            '本次活动策划方案、舞美呈现、节目指导、视频制作、视觉及装置均由叁昶设计、落地并全程保障，以原创沙画发布视频、原创情景剧、独唱合唱等多重形式内本次活动进行丰富。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003727-7b610cfb-c1b7-43c1-801f-3e3e151b27e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003625-120bc4c9-8954-4240-9cf7-17147b1ea279.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003784-524fb515-b5ee-4ddc-852b-12750bb04f88.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003860-87588e62-9937-4fbe-842f-df32dd5f9ec3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240928 周晓强
      title: '见贤思齐！嘉定一中文化墙：青春榜样，薪火相传',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548405501-53569c73-905d-4fb1-b9b6-4f2514f6b769.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '见贤思齐！嘉定一中文化墙：青春榜样，薪火相传',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548405501-53569c73-905d-4fb1-b9b6-4f2514f6b769.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: [],
          img: []

        },
        bottom: {
          title: ['叁昶公司设计的嘉定一中文化墙正式亮相校园。当青春的奋斗故事被定格，当优秀的成长轨迹成为风景，这一面面承载着荣耀与希望的文化墙，不仅是对优秀学子的致敬，更是以 “看得见的榜样”，叁昶为每一位莘莘学子搭建起的精神桥梁。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548402778-75af9edc-78ab-4d6f-add6-9636d876b2b3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548402812-592bf11f-8702-4261-8b62-c27a330d4ea9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240920 周晓强
      title: '叁昶助力人工智能产业领域基础性技能人才培养试点项目启动仪式圆满完成！',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753333623361-25ce86d7-4cb0-4b2e-b36a-49ac1f1f5f3c.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=37",
      details: {
        top: {
          title: '叁昶助力人工智能产业领域基础性技能人才培养试点项目启动仪式圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753333623361-25ce86d7-4cb0-4b2e-b36a-49ac1f1f5f3c.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['9月20日，人工智能产业领域基础性技能人才培养试点项目启动仪式于上海南湖职业技术学院5G会议中心隆重举行。上海市人力资源和社会保障局党组成员、副局长谭友林、上海市经济和信息化委员会副主任张宏韬、虹口区副区长章维共同启动人工智能产业领域基础性技能人才培养试点项目。上海南湖职业技术学院副院长周一峰主持。',
            '活动中观看了试点项目介绍视频并在最后的启动仪式环节全息智能启动球自主移动至舞台中央，叁昶策划设计并全力保障活动圆满结束。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633047-3d90a09c-b07b-4acb-a07b-72891d96bfd8.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633104-e1c7d5b4-ad20-4446-acb8-d3a41c36b2ed.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633048-dc6fc19c-636a-421e-967f-64b57ad6ef29.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633142-d43a0561-88cb-4e93-9a9e-032c1b3e126b.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240912 周晓强
      title: '叁昶以设计承精神，规划吴孟超院士精神教育基地设计方案',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264369-a44a7e50-3c15-4945-9a65-46ab908bd0e6.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=36",
      details: {
        top: {
          title: '叁昶以设计承精神，规划吴孟超院士精神教育基地设计方案',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264369-a44a7e50-3c15-4945-9a65-46ab908bd0e6.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶公司为海军军医大学第三附属医院（上海东方肝胆外科医院）规划的吴孟超院士精神教育基地设计方案，以“叙事性空间+沉浸式体验”为核心设计逻辑，将吴孟超精神融入每一处细节，实现“见空间即见精神”的效果，让参观者直观感受“一生为医”的坚守。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264302-30637d4e-6214-4e63-92f7-67140fddbdce.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264750-40e91a70-592e-4a3a-a089-763653e58791.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264367-afdb9911-e935-4d05-b62d-34117dd7758c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264395-01d18af9-8891-48be-af09-f79f43312423.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548266538-70466d59-a28e-4cda-9752-12108dafb9ea.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240902 周晓强
      title: '创新引领 人文赋能！叁昶打造的这一党群服务中心焕新亮相',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804619-8701e214-ee89-4ae3-a126-37991768b562.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '创新引领 人文赋能！叁昶打造的这一党群服务中心焕新亮相',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804619-8701e214-ee89-4ae3-a126-37991768b562.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶团队为北站街道量身定制的<strong>党群服务中心</strong>充分结合区域特点及绿色建筑的要求，秉承“开放式、集约化、共享性”的理念，利用技术赋能、创新呈现，大力探索党建宣传及教育新形势。',
            '中心集<strong>基础党务、图书阅览、健身运动、艺术互动、儿童活动</strong>等功能于一体，引领观众参与互动，给人以强烈的震撼。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804509-1c4a4bb0-4940-423e-8b8f-88077c7862e5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804203-5c0a6943-ad85-4389-a105-b9e4272ba512.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804309-6e5430e1-9ff8-40e1-ad3e-1c465c254f7f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532803955-86d1d35c-3f2a-427c-b30e-a782332cf77a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532807086-0b7e02c4-5df7-4d02-b27b-33acca21ba92.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '向善向美向未来 | 叁昶助力上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼圆满呈现！',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082826021-028cf065-d78f-49a8-8f4e-5b99224997fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1500%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=34",
      details: {
        top: {
          title: '向善向美向未来 | 叁昶助力上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼圆满呈现！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082826021-028cf065-d78f-49a8-8f4e-5b99224997fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1500%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['6月2日，上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼顺利举行，现场<strong>超1000人共同见证</strong>。',
            '贵州省高级人民法院原院长、闵行区原区委书记孙潮，上海市人民政府副秘书长赵祝平，上海市教育学会会长、上海市教育委员会原副主任尹后庆，上海市政协科技和教育委员会常务副主任、闵行区原副区长杨德妹，上海市教育委员会副主任王浩等领导莅临出席。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082841807-5eecf882-29ab-48f3-a324-43e93e194b6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082840331-a4736664-e798-4a6a-8290-e21a28ec1e00.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082837821-646cc9d6-381a-4f74-8d3e-184a697800c7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082838911-b9d4f116-7c95-49bc-b4e7-a2267595ca11.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1056%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082838803-3b1bf4d4-b69b-4911-b07a-5fde04d4b65c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1043%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082826021-028cf065-d78f-49a8-8f4e-5b99224997fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1500%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['本次活动<strong>策划方案、舞美呈现、节目指导、视频制作、视觉及装置</strong>均由叁昶设计、落地并全程保障，实现了<strong>现场转播及双语同步翻译</strong>。',
            '以七德十年大事记和毕业生入场仪式开场，伴随着民乐团与爵士乐团  庆典正式拉开帷幕。除<strong>学生职业发展项目基地发布、颁发毕业证书及奖学金等环节外</strong>，庆典将<strong>汇演、音乐剧、情景讲述、表彰</strong>等众多精彩纷呈的多元形式贯穿始终呈现了风华正茂、神采卓越的七德风貌。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082857656-38c7544f-51cc-4b5e-b4ff-36cd34879c65.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1019%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082856668-43a8eb07-8aa4-4b6c-a9ab-7eeaaeec0b6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859907-1e2321bf-fa39-4293-b2db-34d572d78191.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859682-ba86004d-9e4b-4e46-b4d4-62134aacd30b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_993%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082857284-2c7089ec-b5a6-4eae-bbfa-9d7317cee534.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859894-c96be186-8442-424f-8a82-f2a63fbeecfa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1038%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082863373-1d032e31-bfbf-4d7f-8973-3d2bf40566c4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082865587-9e702cf7-df82-495b-a2fe-e93cef2f6827.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1046%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '慧心逐梦 创享未来 | 叁昶助力上海市材料工程学校第四届“慧之创”材料双创节启动',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082762951-9944cf67-bb6a-4f43-be7d-5abc65f66275.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=33",
      details: {
        top: {
          title: '慧心逐梦 创享未来 | 叁昶助力上海市材料工程学校第四届“慧之创”材料双创节启动',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082762951-9944cf67-bb6a-4f43-be7d-5abc65f66275.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['5月28日，“慧心逐梦 · 创享未来”第四届“慧之创”材料双创节于上海市材料工程学校大礼堂举行。围绕学校“慧·竹”文化，叁昶公司进行了“慧之创”全案策划及设计制作，展现活动有激、比赛有绩、宣传有迹的双创特色。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772841-edbbbf9c-f4f6-41d2-b341-be241cf22fa2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772794-3872971b-7aa8-4daf-82cc-d85f9f7c07b2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772704-9b794a4e-2936-45ee-9ca8-c1d367b2cafe.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773021-ac3edd65-68a1-4792-b864-1321c264404b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773104-55ba2d0f-bec0-4e27-a6e6-f4df24e32d10.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773618-d9fb7196-3bdf-4400-87db-f87da8c857d3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773277-c157be22-f554-45f3-a6a0-bde22c0bbd7c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773447-b2aba9b8-2b73-4b32-974e-e606f54ad586.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['在活动内容设计中，叁昶团队深度挖掘学校双创元素进行节目创作，通过<strong>视频回顾、路演展示+导师点评、故事分享、音乐剧</strong>等多种内容形式， 呈现丰富、立体的双创活力；在仪式环节设计中，叁昶团队在传统模式中进行了道具和形式的创新，实现了领导和<strong>AI虚拟人</strong>同台进行活动内容的发布。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082785965-3d2a6722-a53f-480a-9d8a-4a7b2ab7a603.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082785857-56bb822b-7c7c-4edf-88b1-ea27bcecb9dc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082786316-3568d0d7-0f61-47ee-94e9-67182d2cc2d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082786003-ac9e4b44-02d7-4c01-8f75-44d81f979e3f.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '上海新型高职联合马克思主义学院揭牌',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082669043-68781396-3a8c-4f41-b491-19f42cf8bd9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1768%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=32",
      details: {
        top: {
          title: '上海新型高职联合马克思主义学院揭牌',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082669043-68781396-3a8c-4f41-b491-19f42cf8bd9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1768%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['4月30日上午，上海南湖职业技术学院、上海科创职业技术学院、上海闵行职业技术学院、上海现代化工职业学院、上海建设管理职业技术学院五所新型高职在上海南湖职业技术学院举行上海新型高职联合马克思主义学院成立仪式。市教卫工作党委书记沈炜、虹口区委书记李谦出席仪式并讲话，共同为上海新型高职联合马克思主义学院揭牌。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082683240-2c7f3b37-f5e7-4380-87a1-ce5feb07eb34.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082685038-602b57c8-069a-4169-9a6d-b4b899f9dba2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082682255-484c2a6b-a552-42f6-8951-7904d0dbebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1541%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082682147-91544232-8f87-4e62-b44f-5ab5b8160079.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1642%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082677451-6109f4a1-8514-4fa8-a11a-81dba5249ed3.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['会上，市教卫工作党委书记沈炜、虹口区委书记李谦为上海新型高职联合马克思主义学院揭牌；五所新型高职共同签署《上海新型高职联合马克思主义学院合作备忘录》，为上海新型高职联合马克思主义学院特聘专家颁发了聘书，并举办了专家微报告。',
            '本次活动的<strong>策划、视觉设计及内外场布置</strong>均由叁昶公司落地和全程保障。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082700736-0b295855-aff8-486e-85ba-6a36023b586c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1764%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082703888-c0daa1d6-405e-4399-bd1a-884c00b30ad7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082697659-eded4ad1-ce19-4fde-8001-4113397b9e12.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '同一本书，不同的世界 | 叁昶助力上海市基础教育读书行动交流展示活动暨“阅‘嘉’行动”启动仪式举行',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082591835-2e2ca3ce-b87e-438a-b337-42d612dec4d9.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=31",
      details: {
        top: {
          title: '同一本书，不同的世界 | 叁昶助力上海市基础教育读书行动交流展示活动暨“阅‘嘉’行动”启动仪式举行',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082591835-2e2ca3ce-b87e-438a-b337-42d612dec4d9.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['4月22日下午，在第29个世界读书日来临之际，“同一本书、不同的世界”——2024年上海市基础教育读书行动交流展示活动暨嘉定区“阅‘嘉’行动”启动仪式在嘉定区图书馆举行。上海市教育委员会副主任杨振峰、嘉定区副区长汤东英、嘉定区政协副主席陈宾等出席活动。叁昶<strong>全程参与策划并保障</strong>活动的顺利落地。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605563-f830fd1e-cf0c-411f-aa00-b5398610e91c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605514-20870648-cd52-4d2e-af29-9dce76e379c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605438-0499ec0c-da3f-48b9-9b96-2a647b9f9b40.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605387-4eb12fc4-5481-4de9-8cb7-d0f5d14f4d7f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605595-6f0fb7de-8183-43bb-9daf-1135f6b369a7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605707-a3874e18-b30c-495f-8825-a35f25efebb5.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['本次活动由上海市教委、嘉定区政府和区政协共同主办，嘉定区教育局、区文旅局、区政协文化文史和学习委共同承办。',
            '市教委相关处室，嘉定区相关委办局，上海市教师教育学院（市教委教研室）和市教委中小学图工委相关负责同志，各区教育局分管局长、教育学院院长和基教科科长，以及嘉定区相关部门的负责同志和全区校长、园长等近500人参加活动，共同见证了“阅‘嘉’行动”及“孔庙讲堂”的启动。嘉定区的师生进行了<strong>诗乐表演、阅读讨论会、情景剧、教师微研修、脱口秀、国学分享会</strong>等多样形式的表演。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/webp/38716037/1718082620289-f436304a-9b4a-4dbb-abc9-3cf2214d5ed4.webp',
            'https://cdn.nlark.com/yuque/0/2024/webp/38716037/1718082620390-2a564e32-df0d-4458-8375-523923d9006f.webp'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区比赛圆满结束',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082489062-82f60f2e-39e8-47bc-acee-360cf431a70b.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=30",
      details: {
        top: {
          title: '第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区比赛圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082489062-82f60f2e-39e8-47bc-acee-360cf431a70b.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2024年3月20日，叁昶助力为期两天的第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区的管道与制暖、抹灰与隔墙系统、砌筑三个比赛项目圆满完赛。',
            '第47届世界技能大赛集中考核（上海赛区）龙吴路分赛区由中华人民共和国人力资源和社会保障部主办，上海市人力资源和社会保障局承办，上海市建筑工程学校提供龙吴路分赛区场地及技术支持。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082505936-9fb95676-b763-46b7-9687-f56fc8e0cd1c.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082510195-72195352-6830-49c8-a25e-3089afbb28c1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082511752-a51d5796-a080-49cb-b3d9-aab0f596dfb2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082509161-3e7d7fd9-23da-4e55-968c-be5334fb4941.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082508675-6e200b32-1317-4b71-add5-f861200d3728.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['赛场<strong>环境布置、内外宣传、赛务用品、赛务手册、花絮拍摄、赛程拍摄及后期制作</strong>均由叁昶公司<strong>策划、设计制作、布置并保障</strong>。',
            '据悉，第47届世界技能大赛将于今年9月在法国里昂举办。为积极备战第47届世界技能大赛，人社部在上海、河南、广东等3个赛区组织开展集中考核工作，并决出代表我国出征第47届世赛的正选选手和备选选手。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082537953-7439e36d-b97f-41e4-934f-20c24a3246ac.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1295%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082536754-8762642b-17ea-4711-9515-fcca4b689ac4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082533718-5b0fd8f3-c12a-4083-b3c4-0c3ce64b350c.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082537585-ae014995-1178-4716-aebe-70f8a78492bc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1311%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '叁昶全力保障浦东机场飞行区模拟驾驶培训基地启用仪式圆满结束',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082191486-03687ee4-6885-41d2-a38d-c209f73f2120.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1587%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=29",
      details: {
        top: {
          title: '叁昶全力保障浦东机场飞行区模拟驾驶培训基地启用仪式圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082191486-03687ee4-6885-41d2-a38d-c209f73f2120.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1587%2Climit_0'
        },
        lunbo: {
          title: ['2024年2月6日，浦东机场“飞行区模拟驾驶培训基地启用仪式”顺利举行。上海机场 (集团) 有限公司总裁冯昕出席并致辞。叁昶<strong>策划设计并全力保障</strong>活动圆满结束。',
            '活动中观看了《浦东机场飞行区模拟驾驶培训系统介绍》短片并进行了方向盘模型交付仪式及飞行区模拟驾驶培训基地启用仪式。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082326688-2d063ec7-be93-4e15-b4a7-6ecf61ea6856.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082324879-7d9583ef-28d9-4fb9-abe6-524c5eefa949.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082325813-e268be32-d849-4d4f-838e-8a0960319dd6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082324970-4ead4f6b-262a-434a-848f-25bd7e93887c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {}
      }
    },
    {// 2024-6-11 周晓强
      title: '叁昶保障第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展！',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077771263-0b146d55-1f10-4eec-bfae-6a4666f5f90c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1053%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=28",
      details: {
        top: {
          title: '叁昶保障第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077771263-0b146d55-1f10-4eec-bfae-6a4666f5f90c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1053%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2024年1月6日，由上海中华职教社联合市人社局、市教委共同主办的第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会在上海南湖职业技术学院举行。',
            '上海市副市长、市职教社主任解冬出席并讲话。市政府副秘书长王平，虹口区委书记李谦，市中华职教社副主任、浦东新区人大常委会副主任李国华，市中华职教社副主任、上海体育大学党委副书记、校长毛丽娟，市中华职教社副主任丁光宏，市中华职教社副主任、市教委副主任孙真荣，市就业促进中心主任周国良，虹口区委常委、统战部部长郑宏，市中华职教社副主任叶才福、丁祖昱等领导出席活动。市职教社常务副主任、市政府参事胡卫主持活动。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077786285-52215da7-9bcf-4e83-aa4c-0276c84255c4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077783714-240b845c-1226-492a-89bd-3710dc120f18.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077785153-bb478ed8-a024-4b2b-a931-b899955a92e8.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077788168-a7b5e89b-6a4a-45c1-b24a-488e9a6fd974.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077784035-73100227-b9e6-4a3d-a92b-5e498811ce73.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077788122-28514be3-f07b-4368-bcba-d3135771d98f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1047%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['本次<strong>活动议程、内外场视觉、视频制作、环境布置、图片直播</strong>均由叁昶团队精心负责，保障了第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展， 受到主办方高度好评。',
            '活动内场除领导讲话汇报、颁奖表彰、表演、赛旗交接等环节，叁昶助力上海中华职业教育社“上海市虹口区产教联合体-创新研究基地”顺利启动。活动外场设有“职技匠心·沪创未来”职业技能成果主题展，现场展示了蜡染、传统香道制作技艺、葫芦雕刻等非遗项目，以及智能新能源汽车5G+XR虚拟仿真等新兴技术。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077816057-053aa441-d7a0-4d7a-8eae-88715a1df0c5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077810915-e1580eed-b6af-4f1b-8c78-d29132985cf1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1050%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077810638-097aa79f-7e76-4f8c-8130-98458fe193dc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077811346-772c209e-8380-4c29-bdce-bdd120a3237a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077812134-c56accb3-a10e-4b4a-bc6c-b13570237809.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077813587-b102fb67-7972-4ba3-8e54-6b276986e506.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '创新创业|叁昶助力徐汇职业教育集团举行区中等职业学校学生“双创节”',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077441215-08015ceb-8cdc-4224-89f5-10ddf7309683.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=27",
      details: {
        top: {
          title: '创新创业|叁昶助力徐汇职业教育集团举行区中等职业学校学生“双创节”',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077441215-08015ceb-8cdc-4224-89f5-10ddf7309683.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2024年1月5日，2023年徐汇区中等职业学校学生创新创业节在上海市信息管理学校顺利举行。',
            '徐汇区教育局副局长、徐汇职教集团常务副理事长林琛，市教委教育技术装备中心党总支书记周齐佩，上海市学生事务中心副主任王涛，市教委职业教育处四级调研员谢俊，徐汇区人力资源和社会保障局局长彭燕及区域中职校领导，部分企业负责人参加活动。叁昶策划设计并全程保障内外场活动及环境布置。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077505290-ad878361-eee3-4d79-a83d-884170b0da11.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1047%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077504457-36002808-5e57-4226-b335-60cf16a08193.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1057%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077504982-a7679ae2-cf6a-4ce4-b5f9-b99199489303.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1041%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077503091-23ac3479-758f-4389-a268-ce1b4ad186da.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1028%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077510220-6f33d830-5104-42ac-8fb4-60ca867184df.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['活动分为<strong>“双创”舞台秀和“双创”成果展示市集</strong>两个部分。',
            '双创”舞台秀由<strong>暖场直播、舞龙、走秀、舞蹈、路演示范、成长故事分享</strong>等多元形式构成，活动中举行了区中职创新创业导师聘任仪式、区创新创业共同体成立揭牌仪式。',
            '双创”成果展示市集设置了<strong>蓝毯区、打卡</strong>区及来自徐汇区中职校15个创客创业成果转化展示展位构成的<strong>市集区</strong>。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077529196-97a07946-e6bd-43b5-9624-95d31ecb6b02.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528481-2bd93690-9229-49b7-af38-06b1256991a1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528591-7cc454b3-94d3-449d-81e9-dabf575b7110.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528853-2befcbc0-42bf-49d6-b0d4-798af68bc6a2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077531316-6c017cbd-d8fb-41c8-aad3-69142709f3b8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077532160-44506d7b-a269-40da-8fc7-4a30e1afe2ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077534222-365d5824-93e4-4d96-8bc7-c00b17d43c43.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077529414-1375fda1-6b0d-41f4-9134-33c017752d6c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077535065-7ceea8f5-3a9d-40b8-ad6f-26977ae550b4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077534200-cfea83a0-9600-46ab-b7d1-b569cc379e52.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240526 周晓强
      title: '科学引领未来，教育助力强国 | 2024第二十一届上海教育博览会盛大举办！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590090-120233fe-ec63-42f4-a4fe-7045f356cd38.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=26",
      details: {
        top: {
          title: '科学引领未来，教育助力强国 | 2024第二十一届上海教育博览会盛大举办！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590090-120233fe-ec63-42f4-a4fe-7045f356cd38.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月24日-5月26日，2024第二十一届上海教育博览会在上海展览中心盛大举办，本届教博会由中共上海市教育卫生工作委员会、上海市教育委员会指导，上海教育报刊总社主办，以“科学引领未来，教育助力强国”为主题，将继续采用线上、线下相结合的方式进行。其中，5月24日-26日为线下展，线上展同期开展并将持续至6月底。',
            '展区分为市级展区、长三角融合发展主题展区、科学教育特色主题展区、高等教育展区、区域教育展区、职业教育展区以及相关企业展区等。',
            '叁昶公司设计打造的展馆齐齐亮相本次教博会。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590567-f3ec63bb-c154-4e71-a7c1-1a7628e01760.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590324-71af0360-3456-4ed6-9fb3-96b8bcd31a01.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590892-4dbf6e8d-63dc-4f70-95ec-31175dbbde8e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532591131-30c5ae9e-bcf2-47ae-aec3-d9756a31986d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532592153-13d71c3a-2def-42fe-a593-eff6eae273fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532592006-fd591531-2de5-4abf-97d5-da00557688ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240320 周晓强
      title: '新时代廉洁教育新高地——河滨清风新时代e+廉洁主题公园',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239557-23c21251-c674-4207-8ccd-cc7a9e3e113a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=25",
      details: {
        top: {
          title: '新时代廉洁教育新高地——河滨清风新时代e+廉洁主题公园',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239557-23c21251-c674-4207-8ccd-cc7a9e3e113a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶将河滨清风新时代e+ 廉洁主题公园巧妙融合了彭浦镇白遗桥滨河绿地的自然风光与深厚的廉洁文化底蕴，通过家训长凳、清风长廊、竹编莲花、投影廉灯、网上廉洁文化展馆等廉洁文化元素，带领游园者聆听古代清廉典故的低语，感受先贤们高风亮节的精神风范，以此打造出一处寓教于乐、润心无声的新时代廉洁教育新高地。叁昶将河滨清风新时代e+ 廉洁主题公园巧妙融合了彭浦镇白遗桥滨河绿地的自然风光与深厚的廉洁文化底蕴，通过家训长凳、清风长廊、竹编莲花、投影廉灯、网上廉洁文化展馆等廉洁文化元素，带领游园者聆听古代清廉典故的低语，感受先贤们高风亮节的精神风范，以此打造出一处寓教于乐、润心无声的新时代廉洁教育新高地。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239592-24d286b1-7cfd-40ae-b9e6-986ec4aace4a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532238616-a52fa9f4-89e6-49af-adcf-9f45517a0a40.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239064-3feb7aa5-5ba3-4cfd-bfe2-4baa557d69f1.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532238458-93eea65e-8fd8-4761-a7f6-65b4e48fef2f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532241456-e5867139-22c5-429f-b23b-bb2afeb3efd1.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532241595-fe3cf71b-4207-485d-b3a6-6323b58e8193.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532242765-5db4acec-e044-4bf1-9665-2c81d8f3dd21.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20231230 周晓强
      title: '叁昶出品 | 仁济医院户外文化景观：医脉相承，人文共生',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024374-425090f8-b398-42b3-8f69-623ea0d27cff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=24",
      details: {
        top: {
          title: '叁昶出品 | 仁济医院户外文化景观：医脉相承，人文共生',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024374-425090f8-b398-42b3-8f69-623ea0d27cff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为仁济医院打造的户外文化景观项目，以“医脉相承，人文共生”为主题，将医疗文化、科技创新与自然生态深度融合，塑造了一座兼具疗愈功能与人文关怀的艺术空间。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024293-bcc2a34c-3e89-4802-913c-a875e642523d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024293-bcc2a34c-3e89-4802-913c-a875e642523d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024487-cf94e20f-5879-496e-bd16-0af5365613e5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024251-6232f6ce-e273-44f3-85b7-a4fe4e9c6ef1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20230830 周晓强
      title: '探秘上海现代化工职业学院学生活动中心：五层空间的活力密码',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531845376-a2a4d76e-efce-4e42-afe5-1d74f0ed071c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=23",
      details: {
        top: {
          title: '探秘上海现代化工职业学院学生活动中心：五层空间的活力密码',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531845376-a2a4d76e-efce-4e42-afe5-1d74f0ed071c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['作为上海现代化工职业学院校园文化建设的核心载体，叁昶倾力打造的学生活动中心，通过“图标+ 五层空间” 的一体化设计，构建起兼具功能性与文化感的学生专属场域。',
            '空间设计上，五层区域层层递进、各有侧重：直观呈现 “一楼一主题、一步一文化”的建设成果，为学校师生与外界提供了解项目的便捷窗口，也为校园文化赋能学生成长注入持久动力。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761531854840-fc6cf471-edd0-4e32-9db3-89dd8b1b4a53.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531853809-4fab051b-1abf-46ff-9094-6a499841f9ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531853835-01deee0f-c1fc-4299-98e0-cd2c8d13fc5d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531854018-8f6730db-da4c-4d8b-b15a-37fc92b7f1b4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {
      title: '【传承、创新】叁昶倾力打造！二大会址·中国共产党党章学习厅喜迎开放活动',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228745183-7431d509-3959-4eb1-8813-840492bc7d7a.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=22",
      details: {
        top: {
          title: '【传承、创新】叁昶倾力打造！二大会址·中国共产党党章学习厅喜迎开放活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228745183-7431d509-3959-4eb1-8813-840492bc7d7a.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0'
        },
        lunbo: {
          title: ['12月2日下午，<strong>市委书记陈吉宁</strong>来到位于老成都北路的<strong>中共二大会址纪念馆</strong>。陈吉宁瞻仰了中共二大会议旧址，在一件件文物史料前驻足凝视、听取讲解。他说，<strong>上海是党的诞生地</strong>、初心始发地和伟大建党精神孕育地，也是<strong>首部党章诞生地</strong>。要把学习党章作为学习贯彻党的二十大精神的重要内容，<strong>常学常新、笃信笃行</strong>，做<strong>学习贯彻党章的忠实践行者</strong>，大力弘扬伟大建党精神，坚定理想信念，强化使命担当，团结一心奋进新征程、展现新气象。要在<strong>党史研究、展陈创新、社会教育</strong>等方面下更大功夫，吸引更多人走进纪念馆，了解党的历史，接受精神洗礼，更加自觉<strong>传承红色基因、赓续红色血脉</strong>。',
            '2022年11月27日，<strong>叁昶设计建立</strong>的中共二大会址纪念馆举行了开放活动“<strong>永远的旗帜——中国共产党党章学习厅</strong>”。<strong>市委常委、市委宣传部部长赵嘉鸣</strong>出席活动，为中国共产党党章学习厅开放揭幕。<strong>叁昶公司顾问王志卫先生</strong>，以及来自机关、企事业单位的<strong>30余名党员</strong>也来到活动现场，共同见证党章学习厅的全新开放揭幕。', '当天，活动以党章学习流动教室巡讲正式开始。活动现场，中共二大会址纪念馆被纳入静安区“<strong>学思践悟新思想</strong>”现场教学点，获授牌。中共二大会址纪念馆将依托叁昶设计建成的党章学习厅等阵地，开展<strong>全方位</strong>教学资源深度发掘，充分发挥其作为现场教学点的教育培训的<strong>载体作用</strong>、成果展示的<strong>窗口作用</strong>、示范引领的<strong>样板作用</strong>、调查研究的<strong>平台作用</strong>，为深入学习习近平新时代中国特色社会主义思想和推动党员教育走深走实提供有力支持。', '<strong>中共二大会址纪念馆</strong>依托叁昶设计建成的党章学习厅，意味着叁昶设计的党章学习厅得到了区政府的<strong>高度认可</strong>，也说明叁昶的精心设计不负众望。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727883-3a40033a-9bcd-4bbc-b505-cb06ccce6026.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727914-920fa2c8-77ad-434c-965d-17641d492672.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727929-b345bfec-ef91-420d-b2ff-8f1e1e4b0f0e.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727881-6d5d2744-0698-4b5c-95cc-e1bc4acca12f.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727879-9969b28b-3824-4113-8a60-867c74da0bdc.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728487-1eec03c4-82e1-4e36-ad92-ef7a40f4ef36.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728752-33e6b3a4-e776-4308-9b8b-a3692c477cbf.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728835-babfb2c1-ee51-4bd6-bf15-5e000e5800b4.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]

        },
        bottom: {
          title: ['展厅内共展示了<strong>19部党章</strong>，详细地罗列了每一部的背景和细节；在“<strong>党章集锦</strong>”墙上，收集了<strong>77本</strong>各个时期不同版本的党章。公司采用了<strong>最先进</strong>的施工技术、<strong>最精湛</strong>的匠心工艺、<strong>最精细</strong>的工程管理，展陈设计精心用心、精雕细琢，并落实到每处细节、每个环节，进一步突出主题、凸显特色，充分彰显<strong>建党光辉历程</strong>和<strong>伟大建党精神</strong>，充分展示中国共产党人的精神家园。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737784-12ce1e09-fde5-439e-b768-ad9c9be97c80.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737780-b6550c0a-ccf3-498e-b5e1-0952aef42acd.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737769-6e2a78cc-ddf6-4595-89cb-0ca01fa9bd72.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737803-cbb0250b-d09e-408d-8479-5465a041f5c4.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {// 2021-11-8，阮弘宇，
      title: '七易七迁十突破，赓续传承向未来丨叁昶设计打造的上海电子信息职业技术学院校史馆圆满完成',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598948855-cf7d76e9-dfe9-4d80-9272-c2803a9ab421.jpeg',
      linkTo: "/instanceItem?type=culture&num=21",
      details: {
        top: {
          title: '七易七迁十突破，赓续传承向未来丨叁昶设计打造的上海电子信息职业技术学院校史馆圆满完成',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598948855-cf7d76e9-dfe9-4d80-9272-c2803a9ab421.jpeg'
        },
        lunbo: {
          title: ["序厅以“画卷”打开的形式，娓娓道来学院悠久的历史与文化。",

            "展馆内容分为“艰苦创业”、“漫漫求索”、“转型升级”、“创新发展”四大板块，正厅四大板块以各时代校门变迁为主题，采用新中式风格，整体搭配棕色系展开，体现出历史的厚重与沧桑，在视觉上给人以沉浸式的感受。",

            "整体平面布局以“匠”字为格局，结合传统中式窗花与现代发光灯牌的运用，在体现历史感的同时，融入现代科技元素，形成历史感与科技感的结合与对比，营造整体环境氛围。"],

          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598974973-50a99340-b5a7-430c-adae-dba6575c3c76.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598981538-824a20a7-2323-4014-9d79-8c661c59039b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598984938-b985ad31-86f9-4d78-b5bd-6c9311d9d377.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598998796-d2f4f034-fbc5-4190-af7f-139a99d398cd.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
          ]

        },
        bottom: {
          title: [
            "学院领导对我们的设计十分认可，也正是因此在我们后续主导进入施工阶段时，领导们给予了我们充分的信任，在我们工程部与设计部的充分协作下，最终圆满完成本次校史馆的设计建设工作。",

            "新学年开启的时间渐渐临近，上海电子信息职业技术学院校史馆静静等待着归来的师生和新入学的孩子，它将会给他们讲述一个怎么样的学校故事？让我们一起期待吧！",

            " 与此同时，越来越多的校园文化项目也在学园公司设计与工程团队的努力下持续落地，成为让师生真正看得见，摸得着的文化景观。关注我们，你将有机会感受这一系列校园的文化之美。"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599026290-1f0c9a1c-fc0e-493f-9c34-d4ec9aa20f84.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599034045-a76d3a50-0284-4605-8869-3509c5120ae0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599042585-baac3101-dfcd-489b-ae0f-2018bc6ae3f0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599032120-3f710c7c-c728-42f5-99f9-bf90ae180772.jpeg'
          ]
        }
      }
    },
    {// 2021-11-8，阮弘宇，
      title: '【大战7.8.9奋战100天】叁昶公司召开公司重大项目总结会暨第四季度全员大会',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479050715-80fa1472-d4ee-4367-a8a9-376581ed06d6.jpeg',
      linkTo: "/instanceItem?type=culture&num=20",
      details: {
        top: {
          title: '【大战7.8.9奋战100天】叁昶公司召开公司重大项目总结会暨第四季度全员大会',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479050823-8694314a-3bca-4e7b-9a94-1a052cecaa9a.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ["从<strong>1921到2021</strong>,时间<strong>跨越百年</strong>, 我们党从建党之初只有<strong>50多名中共党员</strong>到如今拥有<strong>9000多万名党员</strong>的<strong>世界第一大执政党</strong>。其中的奋斗历程，值得我们不断学习、时刻铭记！会后，<strong>叁昶全体员工</strong>乘着大巴来到了<strong>中共一大会址纪念馆</strong>，我们怀着喜悦与激动的心情，在<strong>党旗前合影</strong>。在这个特别的日子里，留下了我们最特别的纪念。",

            "  <strong>中共一大会址</strong>展陈共分为序厅“<strong>历史选择 伟大起点</strong>”、第一部分“<strong>前仆后继 救亡图存</strong>”、第二部分“<strong>民众觉醒主义抉择</strong>”、第三部分“<strong>早期组织 星火初燃</strong>”、第四部分“<strong>开天辟地 日出东方</strong>”、第五部分“<strong>砥砺前行光辉历程</strong>”和尾厅“<strong>不忘初心 牢记使命 永远奋斗</strong>” 7个板块，生动展现了<strong>中国共产党的诞生、壮大历程</strong>，聚焦建党初期中国共产党在上海的革命实践。通过几个主题板块的参观，我们对<strong>中国共产党</strong>成立的艰难历程及中共一大的召开有了更加深刻的学习体会。在共产党早期成员的带领下，在工人阶级的勇敢斗争中，我们才有了今天的新中国。",

            "<strong>中国共产党</strong>的成立，是<strong>近代中国社会进步</strong>、革命发展的客观要求和必然结果，是历史的选择，是人民的选择。共产党的成立之路深深地打动了我们，指引我们在今后的工作上更加<strong>严格要求自己，不怕艰难困苦</strong>，努力向着目标奋进。",

            " 参观了<strong>一大会址纪念馆</strong>，并观看了之后，我们每个人都<strong>深受鼓舞、感触颇深</strong>。大家表示，无论面对什么挑战，无论面对什么困难，都要<strong>秉持初心</strong>，立足本职岗位，尽心尽力履职尽责，为党和国家的事业、为企业发展贡献自己的一份力量。在随后的活动中，我们各抒己见，结合当日的团建成果和公司的发展现状，表达了自己的看法并参与了分享朋友圈集赞活动。",

            " 任何前进的道路都是曲折的，需要一个团队的<strong>共同努力、坚持不懈</strong>，但是只要心在一起，力往一处使，一定会取得进步。这也是我们此次团建最大的收获。通过此次大会，我们坚定了自己的信念，在今后的工作中，我们一定秉承<strong>叁昶</strong>的“<strong>更高、更快、更强、更团结</strong>”的精神，坚持信念，团结一致，为着我们共同的目标而努力奋斗！"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009763-9eef6469-cb1f-4b10-8158-7287c97c7b24.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009771-851bc1f2-460f-41b9-a850-a70b329339a0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009775-461f94db-cfbd-4b51-b071-a7fca2b58e62.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009968-503da458-5f2e-48ca-984c-e5498752bdef.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009767-2b627526-822c-477e-b33d-c77439e8e555.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017369-cceb29d1-1788-4343-9f7a-a31f70b6e331.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017395-4441a5b3-6186-4de1-b3ce-cc9e77fb58a1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017412-3e3e1b0b-8c30-4e38-8540-ab3269b3dd17.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017400-c3209e12-c18f-43b8-9fd3-c64c10b92d68.jpeg'
          ]

        },
        bottom: {
          title: [
            " 秋高气爽，丹桂飘香，<strong>叁昶公司</strong>召开<strong>公司重大项目总结会暨第四季度全员大会</strong>，公司领导、各部门负责人、项目经理、项目合作伙伴及有关人员参会。会议由<strong>公司常务副总曹鸣浩</strong>主持。",

            "<strong>公司顾问王志卫</strong>就今年各项工作的圆满完成做出<strong>五点总结</strong>：一是要<strong>加强人才储备</strong>；二是要<strong>加强管理流程</strong>；三是要<strong>加强绩效考核</strong>；四是要<strong>加强质量监督</strong>；五是要<strong>加强团结合作</strong>。最后指出，在未来，我们要向着<strong>更高、更快、更强、更团结</strong>的精神全力以赴，在拼搏奋斗中实现企业、个人发展的双赢！",

            " <strong>公司常务副总曹鸣浩</strong>总结公司第三季度项目突显了<strong> “高、大、广” </strong>的特点，即<strong>层次高、规模大、涉及广</strong>。公司5个业务部门，5个综合保障部门，第三季度合计完成工作任务<strong>178项</strong>，其中业务部门完成90项，综合保障部门完成88项，确保了第三季度工作的顺利完成。",

            " <strong>公司副总吴小波</strong>说大战“789”、奋战“100天”各项计划工作，在各部门的密切配合下，顺利完成阶段性目标；要做到“<strong>有计划、有组织、有落实</strong>”的整体规划，以完成各项目顺利“<strong>闭环</strong>”交付为目的，做好“第四季度”完美收官。",

            " <strong>设计总监林晟</strong>通过今年各项目锻炼，对自己有了更深次发展，对设计思路有了更明确的方向，在今后的工作中做到<strong>加强专业学习，提高设计水平与服务质量</strong>，做到有效沟通，积极配合，共同协作完成设计任务。"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031724-93226f1a-eb7b-4217-86d9-5e918447a19d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031753-7c15ded4-4639-448a-a325-a5ebb7e56c25.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031763-0ec7c566-140d-4712-96e3-f99fe26c9268.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035863-e980589d-a5b0-4dba-9de1-fca19c9c616f.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035901-35208230-5060-49ce-952b-72070751ea06.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035870-7364c487-df28-4045-bef9-a44706452478.jpeg'
          ]
        }
      }
    },
    {// 2021-8-2，阮弘宇，
      title: '30多个暑期项目全面启动！“烟花”刚过叁昶刮起“小旋风”',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480678504-772a8ea2-7f76-4fc3-89d6-eb7ee7b9e4b5.jpeg',
      linkTo: "/instanceItem?type=culture&num=19",
      details: {
        top: {
          title: '30多个暑期项目全面启动！“烟花”刚过叁昶刮起“小旋风”',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480678541-684950bc-f1b9-4c3b-bfac-213a58ea9bc4.jpeg'
        },
        lunbo: {
          title: ['<strong>战酷暑</strong>，不忘初心敢干事，<strong>抢时间</strong>，践行使命干成事。<strong>叁昶公司</strong>在今年暑期对<strong>三十多所学校</strong>分别进行了<strong>智慧校园的设计施工，智慧教室设计和改造，校园文化景观的设计制作</strong>等，<strong>叁昶公司</strong>对每个项目的<strong>安全性、稳定性、美观性</strong>以及<strong>创新性</strong>等方面始终保持着最高要求。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480652041-19499901-e7b9-4698-a5a8-dc8ab85f08c3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480652030-d2e6f327-e279-4494-a51f-de8bd2dec9a5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480652044-3064efeb-b153-4a6c-9c1b-8495cb81d6a0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480652057-c2880ac5-8531-46d8-93e8-d04473187a77.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480652073-afcf27e1-9d00-4523-8a49-5da4fa7dda6e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480658320-dda278af-8ebb-42ac-800e-368a9d2257ac.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480658319-714210f3-7fbe-4737-a9aa-6c9d7b14dcda.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480658325-4bb5c555-c012-4f3e-8aa2-5832474ddf0e.jpeg'
          ]

        },
        bottom: {
          title: ['为确保施工质量及效果，<strong>叁昶</strong>小伙伴<strong>冒高温、战酷暑</strong>，从设计、施工到验收进行<strong>全过程把关</strong>。面对施工中出现的突发情况，与施工人员共同研究解决，充分协调调度好工程之间的衔接过程，<strong>抢时间、保质量</strong>，为暑期各项目的<strong>顺利完成</strong>创造有利条件。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480667998-5ecaff80-4f8d-4d51-9e13-f7cff49486c1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480668013-418619d7-a907-4897-9360-90bebdea23e5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480668019-badce34c-1908-408b-9111-43c4d0e166fc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661480668055-90adee73-0724-481b-b055-5f5e180409cf.jpeg',
          ]
        }
      }
    },
    {// 2021-7-15，阮弘宇，
      title: '奋斗百年路 启航新征程。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481015325-f03553fb-21a9-4e9a-9c42-a08519ad7842.jpeg',
      linkTo: "/instanceItem?type=culture&num=18",
      details: {
        top: {
          title: '叁昶塑经典、铸精品,打造歌声里的党史。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481015326-fbd3ae23-8b49-4f0d-8cff-870d452d0411.jpeg'
        },
        lunbo: {
          title: [],
          img: [
          ]
        },
        bottom: {
          title: ['7月1日，庆祝<strong>中国共产党成立100周年大会</strong>在北京天安门广场隆重举行。<strong>习近平总书记</strong>在大会上指出，“<strong>一百年来，中国共产党弘扬伟大建党精神，在长期奋斗中构建起中国共产党人的精神谱系，锤炼出鲜明的政治品格。历史川流不息，精神代代相传。我们要继续弘扬光荣传统、赓续红色血脉，永远把伟大建党精神继承下去、发扬光大！</strong>”',
            '今天公司员工<strong>自觉组织</strong>收看<strong>建党百年庆祝大会直播</strong>，以此加强引导公司青年人学习和感受<strong>中国共产党成立100周年</strong>的丰功伟绩，努力工作，用实际行动<strong>献礼百年华诞。</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481007904-15ee17dc-3cb8-44f7-bfee-67b2b67e4906.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481007918-810420d4-fc49-47c8-80fb-09a98b2aee17.jpeg',
          ]
        }
      }
    },
    {// 2021-7-15，阮弘宇，
      title: '叁昶打造上海戏剧学院党建服务中心（莲花路校区）献礼建党百年。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481220226-27777d66-b6a6-423b-96a6-11f3af862ba9.jpeg',
      linkTo: "/instanceItem?type=culture&num=17",
      details: {
        top: {
          title: '叁昶打造上海戏剧学院党建服务中心（莲花路校区）献礼建党百年。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219834-a7739936-d275-4731-b5c9-0d6cb4d84983.jpeg'
        },
        lunbo: {
          title: ['<strong>叁昶</strong>秉持<strong>“塑经典、铸精品”</strong>的理念，出色的完成了<strong>上海戏剧学院党建服务中心（莲花路校区）</strong>的建设，以此来庆祝伟大的<strong>中国共产党百年诞辰。</strong>',
            ' 我们精心设计的整个党建服务中心展现了<strong>五大版块：“开天辟地”、“改天换地”、“翻天覆地”、“惊天动地”，“艺路前行”</strong>。既令展厅的展示效果<strong>有叙事、有重点、有层次</strong>;也高度契合了“<strong>紧密团结在党的周围、一切以党的领导为中心”</strong>的这一党建主旨，点燃参观者心中最炙热的<strong>红色情怀</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218149-bd815f9e-53e7-4930-9627-e22a189cd706.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218203-87ae17f5-4a61-4405-9b0e-dc734f805329.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218147-8f6a387d-1703-4379-b07a-04abf08d8c15.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218164-e74f486a-e165-4db6-b701-5763d70fe44a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218170-44710789-0a4f-480c-91f1-cefba7b50810.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218734-c2bd317e-41bf-4dd7-9148-4e9e15d27ac5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218822-9bf8ad97-f9d3-4449-a4b8-933b02789458.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481218908-2b01bd32-6541-48d0-a90b-860b321a5bc7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219062-53d83845-f3b4-4870-955b-8f1cdfae6f4d.jpeg',
          ]
        },
        bottom: {
          title: ['<strong>叁昶公司</strong>设计建设的<strong>上海市戏剧学院（莲花路校区）党建服务中心</strong>2021年7月1日正式启用。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219200-8eae6400-5b0a-46e1-bbb6-425ad79445e5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219673-da49902f-2a91-45ce-9aa7-bd56f1cb9b3e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219841-8aa3b44b-d5a0-42a6-b576-b88f6e11641f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481219784-8e36274b-df54-4672-90a9-72544f747dd6.jpeg'
          ]
        }
      }
    },
    {// 2021-7-15，阮弘宇，
      title: '叁昶塑经典、铸精品,打造歌声里的党史。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481638317-7d4210ce-2dd1-473f-96ae-0bb89e96ec93.jpeg',
      linkTo: "/instanceItem?type=culture&num=16",
      details: {
        top: {
          title: '叁昶塑经典、铸精品,打造歌声里的党史。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481638356-dc3e2ded-f373-4eaf-afc4-70e3f2a2f3a1.jpeg',
        },
        lunbo: {
          title: ['<strong>叁昶</strong>秉持<strong>“塑经典、铸精品”</strong>的理念，出色的完成了<strong>上海交通大学“歌声里的党史”</strong>文化长廊的建设，以此来庆祝伟大的<strong>中国共产党百年诞辰</strong>。', '在庆祝<strong>中国共产党成立100周年</strong>之际，我们团队为<strong>上海交通大学</strong>建造的<strong>“歌声里的党史”</strong>文化长廊，用十多首红色歌曲来赞颂我们伟大的党<strong>百年奋斗史</strong>，让广大师生了解并学习我们丰富的<strong>革命精神</strong>。学习党史，我们可以创新更多适合青年学子的形式和方法。我们的党在这一百年里，就是<strong>唱着歌曲，凝心聚力，展现精神</strong>，一步一个台阶，从一个胜利走向一个胜利，不断创造奇迹和辉煌！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481619814-8b1545f5-29f7-410b-907e-5950dd2527b1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481619820-4a541f6a-4fff-4c71-b88f-75534058c746.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481619837-5e5ebd1e-d6a4-4c9b-b40b-9b08edb2bec3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481619837-5e5ebd1e-d6a4-4c9b-b40b-9b08edb2bec3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481619865-5d948538-0197-4fae-b314-49e60b879985.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481620439-22874ba4-3e47-4bbd-aa3a-08cdae9f007a.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>叁昶</strong>设计的“<strong>歌声里的党史</strong>”文化长廊以党在百年奋斗历程中形成的<strong>伟大精神为轴线</strong>，串联重要史实，用<strong>红色音乐文化解读精神内涵</strong>，通过手机扫码唱享红歌，激励师生从党的<strong>光辉历史中汲取红色力量</strong>，筑牢信念之基，赓续<strong>共产党人精神血脉</strong>。亮点：跟着音乐学党史，弘扬爱党爱国主义精神，为<strong>上海交通大学</strong>设计建成<strong>看得见，听得到，学得会</strong>的校园音乐文化墙，提升教育水平。<strong>叁昶公司</strong>设计建设的<strong>上海市交通大学“歌声里的党史</strong>”文化长廊于2021年7月1日正式启用。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481629664-a3540cb8-0607-478a-8f84-48553bbea6b8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481629679-d6aba965-3ed0-4afc-8314-d85c15720d09.jpeg'
          ]
        }
      }
    },
    {// 2021-3-25，阮弘宇，
      title: '叁昶为您策展教博会，打造有你们红色基因的“学习党史”大课堂。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481864499-d616bd75-54ef-47fa-9221-9cfcc77fd0b6.jpeg',
      linkTo: "/instanceItem?type=culture&num=15",
      details: {
        top: {
          title: '叁昶为您策展教博会，打造有你们红色基因的“学习党史”大课堂。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481864494-d370e38d-4c57-47bd-9c02-bbf254eb9ed0.jpeg?x-oss-process=image%2Fresize%2Cw_386%2Climit_0'
        },
        lunbo: {
          title: ['2021年3月24日下午，<strong>“信仰的力量，教育的梦想”</strong>2021<strong>第十八届上海教育博览会启动工作会</strong>在上海教育报刊总社隆重举行。<strong>叁昶公司顾问王志卫</strong>应邀<strong>出席</strong>此次启动工作大会。', '2017—2019年，<strong>公司连续三年</strong>参与上海市教育博览会现场展示，帮助<strong>近三十家学校</strong>进行策划、<strong>布展一体化服务</strong>，以各<strong>学校文化、专业特色</strong>为策划核心，融入<strong>VR、AR、3D、虚拟远程互动</strong>等先进技术手段，<strong>传统</strong>与<strong>现代、文化</strong>与<strong>专业</strong>融为一体的设计理念，设计展位得到<strong>主办方、参观者</strong>和<strong>社会各界高度关注</strong>，帮助许多参展单位评为<strong>“教博会十佳展台”</strong>。', '<strong>公司顾问王志卫先生在第十二届、十三届、十四届教育博览会上接受电视台采访。</strong>'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481811770-28d3c236-f266-4de5-b418-024137e3c9fe.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481811764-f04e88e5-f3ba-4227-8d3f-24e85df75324.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481811781-0cbcad3a-92a7-43a9-ac27-a14966731ebd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481811803-96387eeb-1edb-4665-9f82-6ed4cca74dfa.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481811818-f28a36b0-7ea6-4d5a-b1cc-dc9e117eaa0f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812385-6be52050-dc01-4c7c-9ac5-fb3fb977815f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812338-54457fa1-33e2-469e-9b46-7d9b68a90ab5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812636-335ac58c-a925-4394-bad2-86193438e41b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812849-9cf5cc93-843c-4ec4-9e37-f9afb4ef5d5d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812737-fd377979-bd9f-4cb6-a615-4cdbbc218a1c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481812906-627209be-40a8-481d-8ed3-c9cf6b983102.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>叁昶公司</strong>精心设计实施的<strong>“党史党性教育馆”</strong>成为了<strong>“四史”</strong>教育“网红”打卡地。先后有<strong>市委党史研究室主任、市委党校领导、闵行区委书记、各单位领导</strong>带队到现场进行考察学习。', '<strong>叁昶公司</strong>在现代<strong>数字化</strong>展示技术“加持”下，让<strong>红色文化创意</strong>的展现在观众面前，以<strong>红色文化</strong>资源渗透每一个角落，成为进行<strong>党的历史知识教育、培育革命奋斗精神、加强思想政治教育</strong>的重要形式，在<strong>中国共产党建党100周年</strong>之际，让我们一起，了解<strong>革命历史</strong>，学习革命先辈<strong>不畏牺牲、不懈奋斗</strong>的精神。为实现<strong>中华民族</strong>伟大复兴中国梦，努力奋斗！'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481826091-558333bc-ca1b-47d6-a2f4-285b300cf22a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481826140-6d9a27bc-df93-4250-8d49-530f9e22065b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481826117-781fbbe1-05e7-4c9c-a2b8-6ed26fa65daa.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661481826135-1771f1f3-b6e4-47aa-ad91-8036e2a9d127.jpeg'
          ]
        }
      }
    },
    {// 2021-3-22，阮弘宇，
      title: '叁昶打造红色文化系列品牌丨献礼建党百年传递信仰力量',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482184051-36db52b9-7556-4a4f-99fa-63eaab9053bb.jpeg',
      linkTo: "/instanceItem?type=culture&num=14",
      details: {
        top: {
          title: '叁昶打造红色文化系列品牌丨献礼建党百年传递信仰力量',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482184163-040328a8-9110-40ad-9b96-0e9e26f056c6.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['2021年2月20日上午，<strong>党史学习教育动员大会</strong>在北京召开。<strong>习近平总书记</strong>出席会议并发表重要讲话，在社会各界特别是党员干部中引发热烈反响。<strong>“在庆祝我们党百年华诞的重大时刻，在‘两个一百年’奋斗目标历史交汇的关键节点，在全党集中开展党史学习教育，正当其时，十分必要。”</strong>', '党史馆是<strong>学习党史、了解党史</strong>、开展爱国主义教育的重要阵地，也是充分发挥党史<strong>“以史为鉴、资政育人”</strong>的重要平台。<strong>叁昶公司</strong>精心设计的<strong>“党史党性教育馆”</strong>因地制宜将全馆布局设计为<strong>五大版块</strong>，分别为<strong>“开天辟地”、“红色征程”、“奠基伟业”、“改革开放”、“中华复兴”</strong>等内容，全景展示了<strong>党史、新中国史、改革开放史</strong>和<strong>社会主义发展史</strong>。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482166574-7f6404cd-4696-4f50-9fbc-8adea57f5cc5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482166609-8473cc3e-3dab-4610-bbf2-a0934ea946b1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482166590-88ddad82-96d4-407a-894f-bf8ae0b02bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482166587-50229397-9caa-4662-8e6e-8a1c3e82370f.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>叁昶公司</strong>精心设计实施的<strong>“党史党性教育馆”</strong>成为了<strong>“四史”</strong>教育“网红”打卡地。先后有<strong>市委党史研究室主任、市委党校领导、闵行区委书记、各单位领导</strong>带队到现场进行考察学习。', '<strong>叁昶公司</strong>在现代<strong>数字化</strong>展示技术“加持”下，让<strong>红色文化创意</strong>的展现在观众面前，以<strong>红色文化</strong>资源渗透每一个角落，成为进行<strong>党的历史知识教育、培育革命奋斗精神、加强思想政治教育</strong>的重要形式，在<strong>中国共产党建党100周年</strong>之际，让我们一起，了解<strong>革命历史</strong>，学习革命先辈<strong>不畏牺牲、不懈奋斗</strong>的精神。为实现<strong>中华民族</strong>伟大复兴中国梦，努力奋斗！'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482176099-405ee7cb-6a89-461c-80e1-6caf89abde11.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482176258-cced1f31-35cc-4374-a456-bf952d75a465.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482176136-a2893784-5b7a-4471-bd5a-917c48f942fb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482176159-a72e508a-e5ce-43ff-875d-17a30f8bdb7d.jpeg',
          ]
        }
      }
    },
    {// 2021-3-1，amanda，阮弘宇，
      title: '2021春风行动，直播“带岗”来袭！更有公司元宵福利，你心动了吗？',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482340049-c98afbbc-1e67-4954-a71b-b3ebf606c6c2.jpeg',
      linkTo: "/instanceItem?type=culture&num=13",
      details: {
        top: {
          title: '2021春风行动，直播“带岗”来袭！更有公司元宵福利，你心动了吗？',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482340043-8aebd152-ad76-44f0-b7fd-787bf4001bcd.jpeg'
        },
        lunbo: {
          title: '牛年<strong>春节长假</strong>已经过去，有工作的小伙伴都已<strong>开工返岗</strong>，正在<strong>找工作</strong>的小伙伴们也<strong>别慌</strong>，<strong>叁昶</strong>登录<strong>2021年春风行动</strong>，“<strong>职业蓄能，创想西门</strong>”网络<strong>>直播招聘会</strong>，别人带货我们<strong>带人</strong>，公司提供诸多岗位“<strong>职</strong>”<strong>等你来</strong>。2021年2月25日19:00点整，在#<strong>微博直播台</strong>#<strong>青年报的微博直播</strong>#平台直播，<strong>在家</strong>看直播<strong>就能找工作</strong>。',
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482326204-90e84de0-a323-458d-bf32-92d804ce0bed.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482326212-9e920462-1cc3-4087-b359-fd81223fdc0a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482326217-6d2f6cb9-2d03-48e6-85ba-f8456e55a398.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482326220-107f90e4-3a4a-4a00-9400-f504d6a66bc7.jpeg'
          ]
        },
        bottom: {
          title: '圆圆的<strong>月亮</strong>，圆圆的<strong>汤圆</strong>，圆圆的<strong>祝福</strong>，圆圆的<strong>梦想</strong>。元宵节嘛，总要遵循“<strong>圆圆style</strong>”。元宵佳节到来之际，<strong>叁昶公司</strong>的员工们都感受到公司<strong>满满的关爱</strong>，一份精心挑选的<strong>精美礼品</strong>、美味可口的汤圆，不仅体现了公司对员工<strong>细致入微的关怀</strong>，更传递了<strong>叁昶公司</strong>一直倡导的<strong>关心、关爱</strong>员工的文化理念。',
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482333115-c92b8a4b-63cf-49f9-9be9-2b215b020873.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482333195-42c953b0-078e-488b-a2a7-0a8e9a2d54ed.jpeg'
          ]
        }
      }
    },
    {// 2021-2-22，amanda，阮弘宇，
      title: '新年工作第一天，致敬奋斗路上的你',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482506860-990d369b-0c28-4ae2-8f33-b29c4669924f.jpeg',
      linkTo: "/instanceItem?type=culture&num=12",
      details: {
        top: {
          title: '新年工作第一天，致敬奋斗路上的你',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482506817-02e37039-5d51-467c-b92d-9432e277ced0.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['<strong>新春开门红~牛转乾坤~开业大吉</strong> 2020，我们<strong>披荆斩棘</strong>，<strong>辉煌收官</strong>，2021，我们<strong>勇往直前，创造更加灿烂的辉煌！</strong>开年上班第一天，新的征程已<strong>拉开序幕，上海叁昶文化科技有限公司</strong>站在新起点上，<strong>坚守岗位，不忘初心，迎风起航</strong>，为广大客户提供<strong>最优质</strong>的服务，以<strong>最具饱满</strong>的精神姿态，<strong>昂首阔步</strong>迈入新的一年。<strong>平凡铸就伟大，英雄来自人民</strong>，每个人都了不起，征途漫漫，<strong>唯有奋斗</strong>。我们通过奋斗，披荆斩棘，走过了万水千山，我们还要继续奋斗，勇往直前，创造<strong>更加灿烂的辉煌！</strong>', '叁昶公司在新的一年里<strong>员工语录</strong>上墙了，看到小伙伴们的<strong>内心告白</strong>，从中感受到了他们<strong>执著的人生追求。</strong>'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468026-1a41d17f-9a89-4931-9b7a-51a71fdd764d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482467993-09732e46-2c69-4241-929d-868cd13263e6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482467997-454d48d0-ff6a-4500-960f-67e925c5dd2c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468004-f13b3b9c-2764-4740-8e17-712967480dc7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468015-29f63162-863d-46f1-bc1e-dab8d886f8cb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468735-44000336-a71b-41e1-b504-7a26a8e5c75c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468771-51a11c54-8db5-4624-a797-da1d334cffeb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482468899-51d1177b-4e4f-4036-87ab-392a0cdf0d53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482469175-68e3f804-8640-4941-907c-f25dfd56e052.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482469184-5e7aac45-1575-4f13-99a6-a2b5be0f1f92.jpeg',
          ]
        },
        bottom: {
          title: [],
          img: [
          ]
        }
      }
    },
    {// 2021-2-7，amanda，阮弘宇，
      title: '比“红包”更令人期待的是叁昶的“offer”',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482765398-d6929a80-8f25-4a61-9c3a-2479b04dcd47.jpeg',
      linkTo: "/instanceItem?type=culture&num=11",
      details: {
        top: {
          title: '比“红包”更令人期待的是叁昶的“offer”',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482765409-725490ba-ffa6-4e75-9044-62f3399bf710.jpeg'
        },
        lunbo: {
          title: ['<strong>上海叁昶文化科技有限公司</strong>成立于2017年5月，四年来在市场经济的大潮中，<strong>坚定信念、找准定位、奋力拼搏</strong?>，在各位<strong>合作伙伴</strong>的<strong>帮助</strong>下，业务范围也<strong>不断扩大</strong>，目前已发展为以<strong>信息产业为主导</strong>，集<strong>信息化系统集成服务、软件和信息技术服务、设计和文化创意服务、智能化技术推广服务、大数据信息运营服务</strong>为一体的<strong>文化科技公司</strong>，公司致力于为用户提供<strong>完整的产品</strong>与服务体验，这就是叁昶公司。这是一个“<strong>有文化、有内涵的团队企业</strong>”，就差一个可爱的你，加入我们一起<strong>创造梦想</strong>，让你们来看看我们团队做的<strong>部分经典案例</strong>了解公司。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482726321-a4b949f8-b6af-41d7-9c28-26dad6b6c389.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482726279-c5dd838c-bf7d-48d6-b019-25ab01166af9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482726313-3ec66b97-32e5-492e-a6ea-d9184579220c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482726282-a2977dec-8e0d-4808-8c4f-2b144a2a8d47.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482726284-7ce89bd8-76d1-4660-bd65-2de495fa6136.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482727059-b7c20abd-98e9-4291-87fb-f36499ebc25d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482727108-ea0cc6b6-7129-4fbd-b2a9-051abc1854dc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482727125-a7c821c5-fe5f-48be-b742-a6d3e635aaaf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482727493-fe16ae1e-0582-406a-872b-0199462bfc88.jpeg'
          ]
        },
        bottom: {
          title: ['岗位众多，“<strong>职</strong>”等你来。牛年就要找一个这样<strong>牛气的工作！！</strong>我们期待各位的加入。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482736641-82e7b9eb-e2a3-40cf-9234-8ba12af041b2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482736679-c5733eb5-ed13-4955-84b0-b35621599d38.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482736689-1bd25f93-c64e-4b69-b62f-53c3ceeb3a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482736700-67a93d48-8d1b-4e3f-9757-61b26e1e382c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482736677-1a4e6d2f-1246-438f-a914-3ed69b6659f8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661482737375-c881d16d-55a8-45a1-af5c-4beca4815a52.jpeg',
          ]
        }
      }
    },
    {// 近期活动类 2020-11-19，amanda，阮弘宇，从近期活动移动过来的
      title: '没有完不成的任务！公司开展第四季度内训《执行力建设》课程培训',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483086746-0266ba24-8dc1-438b-9aed-03d7707311f0.jpeg',
      linkTo: "/instanceItem?type=culture&num=10",
      details: {
        top: {
          title: '没有完不成的任务！公司开展第四季度内训《执行力建设》课程培训',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483086757-aca0c7fb-2c51-489a-9630-b260d12c737b.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0',
        },
        lunbo: {
          title: ['为提高公司员工<b>执行力</b>，打造<b>高效、有竞争力</b>的公司团队，11月15日下午，在叁昶公司总部开展<b>第四季度内训《执行力建设》课程培训</b>，公司领导、中层干部以及全体员工和实习生<b>共40余人</b>参加培训。培训由<b>叁昶公司顾问、清华大学特聘讲师王志卫先生</b>主讲。', '课程上，<b>王志卫先生</b>结合自身多年实践经验与案例，从<b>如何成为优秀的执行者、摆正作为执行者的角色位置、执行不力的表现及原因、如何提升执行力四大层面，</b>并结合团队<b>高效凝聚力</b>就如何<b>打造和提升执行力</b>进行了精彩的授课。', '课程中<b>王志卫先生</b>以诙谐睿智的语言、大量生动的案例，理论联系实际，引导大家<b>从内因出发，从细节做起，构筑强有力的执行力</b>。相信通过本次培训，伙伴们能够<b>高效运行执行力</b>，提升工作效率，强化过程管理意识，不断开创工作新局面。', ' <b>领导者做正确的事，执行者正确的做事！——王志卫先生</b>'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483072844-07573bb5-10bb-4ba1-aa9d-5be542afe5c1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483072936-652969c0-ccf5-4d62-a45c-50c163a4d290.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483072823-a51e1884-38f1-472c-b56d-e1ec0a57ba34.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483072834-e0df7748-b701-40cd-a51d-ce10166c4e2d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483072841-c24e53d8-3655-471b-a95b-0f617905c2b6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483073151-cdc7fb4a-06dc-4b25-80cf-c1af727cdfef.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483073244-21d3a3c9-8766-4a4e-b2d6-3e597b12ceb5.jpeg',
          ]
        },
        bottom: {
          title: ['通过本次培训，员工们<b>真正意识到</b>各项工作均应<b>以结果为导向</b>，带头成为<b>执行力强的领导者</b>，培养和锻造一支<b>素质优良</b>、<b>作风过硬</b>的公司队伍，进而带动形成一个<b>高效执行的团队</b>。我们相信，只要有一支高效执行力团队，<b>叁昶一定会办成让所有客户满意的好公司！</b>'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483079491-583ca49b-e192-412f-8bba-5fc575e8a7c0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661483079516-3d71f59c-eed9-4149-b783-3e98db3a8967.jpeg'
          ]
        }
      }
    },
    {// 近期活动类 2020-11-10，amanda，阮弘宇，从近期活动移动过来的
      title: '【秋招】“职等你来”与叁昶，共精彩',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484240593-6c7a41f9-b78a-4942-9093-dccf89ef8a26.jpeg',
      linkTo: "/instanceItem?type=culture&num=9",
      details: {
        top: {
          title: '【秋招】“职等你来”与叁昶，共精彩',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484240711-c06d298d-fd2f-4c6d-98a4-b5a17d318ede.jpeg'
        },
        lunbo: {
          title: ['上海叁昶文化科技有限公司<b>需求多多</b>，<b>岗位丰富</b>，还在犹豫的你，别等待啦！近期我司根据实际情况为<b>多所高校</b>学子们提供了相应的<b>就业机会</b>，由于招聘的岗位涉及<b>信息化</b>，<b>多媒体等板块</b>，岗位新颖，成功吸引了<b>广大学子们</b>前面咨询竞聘。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484223965-6146aaab-ab80-4b65-8fb8-e926d4e9b48b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484223988-4a0250d8-8e73-4c66-a022-3a08317d0b5c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484223988-ef6e7e21-9891-4751-917c-1bf8046e4cf2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484223995-79c2a22b-62fb-4494-8a1b-c77df595830d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484223992-9a64ad6e-caac-4e2b-aff2-d35cffc76f56.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484224511-7c6ce142-35b7-4be4-b1c8-3e01acdef995.jpeg'
          ]
        },
        bottom: {
          title: ['叁昶公司围绕<b>科技</b>、<b>教育</b>、<b>文化</b>、<b>咨询</b>、<b>服务</b>等五大类领域，提供多样化的<b>产品和服务</b>，一个<b>值得信任的公司</b>，关键看是否有一个<b>值得信任的工作团队</b>。<b>叁昶文化科技有限公司</b>就是这样一家有着<b>核心引领</b>、<b>成熟团队</b>，可提供多元化服务的公司。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484231544-b568a0bf-135f-425e-970f-3b73368be60d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484231586-5503f0f8-3c2e-48c1-a106-5d07dd166b47.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484231593-15942fcd-2537-4cb3-8719-8b31328d4cb0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661484231610-9942be89-12c4-4b7a-b7c7-532cf900e352.jpeg'
          ]
        }
      }
    },
    {//2020-06-02,amanda，龙明发
      title: '叁昶为纪念五四运动，特为青年同志们开展五四青年节座谈会以及团建活动',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490124168-761597cb-863d-4642-8ab2-fadaea8ce628.jpeg',
      linkTo: "/instanceItem?type=culture&num=7",
      details: {
        top: {
          title: '叁昶为纪念五四运动，特为青年同志们开展五四青年节座谈会以及团建活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490124248-d27e5f34-2f5f-462e-b617-53954222cc68.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['叁昶公司负责人<b>曹鸣浩</b>与青年座谈交流：他引用毛主席诗词中的“<b>自信人生二百年，会当水击三千里</b>”，赞美青春、鼓舞青年、砥砺前进，同时要求公司青年员工要学习和传承“爱国、进步、民主、科学”为主要内容的伟大五四精神，让理想信念在创业奋斗中升华，让青春在创新创造中闪光！ 座谈会上公司青年们代表纷纷进行发言', '他们表示：<b>奋斗是青春最靓丽的底色</b>。疫情当下，要学习医护人员身先士卒的无私奉献精神，要珍惜韶华、不负青春，努力学习掌握科学知识，提高内在素质，锤炼过硬本领，要用自己更出色的工作给客户带来更多的产品和更好客户体验。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490109880-c8a82e45-b164-4934-9980-d1442832f887.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490109887-b0985aa2-7554-493a-a81b-18163da7e644.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490109895-435cfead-7670-47d7-89ae-c274f434fa52.jpeg',

          ]
        },
        bottom: {
          title: ['叁昶公司努力搭建青年成长成才平台，做青年员工的<b>“知心人”、“热心人”、“引路人”</b>。相信“奋斗”不只是响亮的口号，而是要在做好每一件小事、完成每一项任务、履行每一项职责中见精神。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490116619-7be01398-c3bc-47ab-96e0-5306124b9373.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490116614-a71a7372-1a49-4541-b37f-ffda26d6464c.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0'
          ]
        }
      }
    },
    {//2020-01-08
      title: '让每一面墙壁都会说话，使每一个角落都能育人——叁昶公司校园文化建设项目巡礼',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490247201-a3b26df1-fda8-4245-897c-b9a8e272fa67.jpeg',
      linkTo: "/instanceItem?type=culture&num=6",
      details: {
        top: {
          title: '让每一面墙壁都会说话，使每一个角落都能育人——叁昶公司校园文化建设项目巡礼',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490247211-6777ae8d-d1aa-4770-ba88-97cdd4809177.jpeg'
        },
        lunbo: {
          title: ['2019年11月，教育部办公厅下发关于加强和改进新时代中等职业学校德育工作的意见中提到：“各地各校要高度重视学校文化建设，做好文化育人顶层设计，凝练校训、校风、教风、学风，构建凸显地域文化色、突出专业办学特点以及学校优良传统的精神文化体系。重视校园人文环境和自然环境的整体规划与建设，完善校园文化设备设施。”  校园文化是学校精神文明、校园特色的核心之一，是利用校园所有空间去陶冶感染学生，是一幅有主题的画，是一首无声的诗，但情深意切，融入了知识、教育、艺术性于一体，达到“润物无声”的教育目的。叁昶公司致力于学校校园文化服务活动，以锦薄之力为推动国家职业教育作出贡献。2019年暑期叁昶为上海市杨浦职业技术学校、上海市材料工程学校、上海市商业学校、上海电子工业学校等职业学校打造属于自己学校特色的校园文化，使学校中每一面墙壁都会说话，每一个角落都能育人。上图为部分案例展示。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490240353-6073c62d-ccb7-401e-9ace-3ede5f11ad53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490240362-f2d3de7a-1e05-4edb-b5bd-66b1e8a9d7c9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490240353-fe9dfd96-5ae4-48a8-90ad-a8fa62d39d9c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490240409-0fc11989-20cf-48ba-ba40-0d33aac44964.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490240386-a51e9cf9-311d-4e08-b108-9dc412b8e1f9.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490241033-ebbd1cc0-57ac-4510-be0c-c67f3d15ab1f.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490241051-d3c7fb65-de92-4277-89e7-e6aebdcf6906.jpeg',

          ]
        },
        bottom: {
          title: [],
          img: [

          ]
        }
      }
    },
    {//2019-12-25
      title: '响应市政府号召，助力推进“美丽街区”建设活动',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490442450-306e8c8a-dbce-4bca-87c6-e64a2c5c7ea4.jpeg',
      linkTo: "/instanceItem?type=culture&num=5",
      details: {
        top: {
          title: '响应市政府号召，助力推进“美丽街区”建设活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490442494-c43c50bf-1f47-4ae0-be19-fa0149fd06fc.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['上海市委副书记、市长应勇12月主持召开市政府常务会议，会议中提出：持续推进“美丽街区”建设，进一步提升市容环境品质。叁昶公司也积极响应，成为推进“美丽街区”建设项目的一部分。在此展示公司“通河路东侧（呼玛路至呼兰路）文化风采墙建设”项目中的建设景观。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490413245-3fab0f0d-53d5-47da-ae32-2d5731fffd6f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490413248-e199c654-6eec-44e7-8fae-7954af75d3b0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490413247-84472d79-d451-4e8f-8926-0a1e032593e0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490413254-76a29cb9-2a0e-484a-927e-729794a7333e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490413248-d7264679-3f09-4dcd-86c4-3fc7a6518883.jpeg'
          ]
        },
        bottom: {
          title: '',
          img: [

          ]
        }
      }
    },
    {//2019-11-27
      title: '“金牌学校”——上海市杨浦职业学校校园文化建设项目圆满完成',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490565241-c702881d-a11b-4db3-b9a3-eb5f5f0ff28f.jpeg',
      linkTo: "/instanceItem?type=culture&num=4",
      details: {
        top: {
          title: '“金牌学校”——上海市杨浦职业学校校园文化建设项目圆满完成',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490565255-aa83538e-e23d-4861-a67c-9a10dbeaccb3.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['校园文化建设是学校可持续发展的动力，是学校综合办学水平的重要表现，也是学校个性魅力和办学特色的体现，更是学校培养适应新时代要求的高素质技能人才的内在需要。为了改善学校设施，打造“校园建设营造整体美、绿色植物营造环境美、大国工匠营造职业美、人际和谐营造文明美”的校园文化建设需求，叁昶承接建设杨浦职校校园文化环境布置工程项目。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544060-dc5d3cde-4537-4412-8e9b-dbb88a8d8988.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544097-94a92601-cf27-4ea4-9722-00325265cd97.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544092-0aa8ca28-ac5c-4365-914b-e97ab40b589c.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544090-bd7b202a-f327-4809-849f-599efb020b98.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544059-453f8651-8529-4dea-aae9-ab065f4303cb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544553-541e9813-2705-4e01-a67c-b8cbb5824dc5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544667-1e00a417-1938-4ce0-9461-41488da257a6.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490544852-2da961e3-a2d0-4d05-a868-3bc2ad5beb07.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490545015-69e76b45-2701-438f-b663-fbc87e8e0d5e.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490545055-b1507126-a479-4632-8ad9-f97852f4351c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490545357-e990b0eb-4eb6-4811-916b-ffc846692b46.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490545460-3abfe41d-d9ab-443b-a6b6-ac5505f77cc3.jpeg',
          ]
        },
        bottom: {
          title: ['上海市杨浦职业技术学校是国家级重点中等职业学校、上海市中等职业教育改革发展特色示范学校。第45届世界技能大赛中，学校选手徐澳门凭借精湛的技术技能和优秀的职业素养，一举多得车身修理项目金牌。这是杨浦职校继获得第43届银牌、第44届金牌后，再次夺金。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490553484-0f9414d2-2d88-42f3-a4a0-4b996c5496d5.jpeg'
          ]
        }
      }
    },
    {
      title: '展示中职风采的社团文化节十周年展演',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490732291-06490a8b-058e-4c71-9f94-18c0919288ef.jpeg',
      linkTo: "/instanceItem?type=culture&num=3",
      details: {
        top: {
          title: '展示中职风采的社团文化节十周年展演',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490732314-dcb9847a-45b0-407b-a21c-81d0d50af02d.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: '为展现中职校学生精神风貌，2018年11月17日、24日，由上海市教委主办、我司承办哎东方绿舟、世纪广场举行“青春放歌——上海市中等职业学校学生校园文化社团展示”活动',
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490717644-d07ae3d9-9ff8-431e-b6ff-a8ce8c2181ce.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490717657-6619463d-4c50-4d59-ab63-cbe1605831ab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490717669-212e73fc-1827-48df-b802-ebdef2d8e603.jpeg',

          ]
        },
        bottom: {
          title: '通过本次青春放歌上海中等职业学校校园文化社团展示与交流，进一步拓展了学生的专业知识，提高了综合素养，得到各方一致好评！',
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490724867-16eee200-2cae-4ca9-8349-12b3bcbee970.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490724881-3c482064-ebc2-40e8-ac4e-68cbc169d456.jpeg',

          ]
        }
      }
    },
    {
      title: '2019上海市“全国科普日”活动启动仪式',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490879482-bcc4ea76-beb3-4eae-8238-21abb76bdf3d.jpeg',
      linkTo: "/instanceItem?type=culture&num=2",
      details: {
        top: {
          title: '2019上海市“全国科普日”活动启动仪式',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490879517-a21f1303-bc5a-4835-94f9-91ae518eab5b.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['公司参与策划了“礼赞共和国、智慧新生活”2019上海市“全国科普日”活动启动仪式暨闵行区科普嘉年华顺利开幕启动仪式活动现场亮点频出，秉承市区联动和贴近市民的理念，仪式通过科普网全程进行视频直播，长三角一区三市（上海闵行、江苏苏州、浙江嘉兴、安徽芜湖）科协在启动仪式上首次签署备忘录，将推动四地共同举办高水平学术交流、探索建设长三角“大科普”生态圈、拓展长三角科技人才服务等活动。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490860583-9d305c0a-9dad-4ac4-aadc-395c68bf6ad0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490860564-bd3db37c-bf38-406e-af93-531006123e6a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490869079-dd7facb9-0c35-4b3c-b00c-b9aec252c9cd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490869089-21c5e928-f7bf-4cbe-af6e-8d4e8cac1497.jpeg'
          ]
        },
        bottom: {
          title: ['科普不仅有温度，它更有热度。9月等申城科普热情高涨、科学热度不断攀升，全民关注、全程参与，上海市“全国科普日”公司陪你一起玩转科学，助推公民科学素质的进一步提升，助力上海加快建设具有全球影响力的科创中心。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490873102-75db796a-0cc8-4683-a97f-d35b69411c2a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490873113-1f2a2ffb-dd92-4308-85b2-b310b8f76fbd.jpeg'
          ]
        }
      }
    },
    {
      title: '璀璨全国的第45届世技赛全国选拔赛开幕式',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491002090-54ced0fc-0f60-4c22-a140-c20a98df00d7.jpeg',
      linkTo: "/instanceItem?type=culture&num=1",
      details: {
        top: {
          title: '璀璨全国的第45届世技赛全国选拔赛开幕式',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491002125-862bd659-2aeb-4a43-a678-2495204ad56d.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['公司承接2018年中国技能大赛——第45届世界技能大赛全国选拔赛开幕式；6月12日晚，在国家会展中心虹馆成功举行 上海市委书记李强宣布大赛开幕。人社部部长张纪南，上海市委副书记、市长应勇，世界技能组织主席西蒙·巴特利分别致辞。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490987432-4cf39596-661c-43a3-978b-4e003f35255f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490987424-4467d59a-2c9e-4163-81df-4f8899338939.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490987460-933301f6-157f-4954-bea0-ffd6fdaf0a90.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490987443-be524045-20c7-4a0b-942e-464601dd4524.jpeg'
          ]
        },
        bottom: {
          title: ['整场活动有“燃点”、有“萌点”、有“泪点”、有“亮点”、有“焦点”、又一次吹响了新青年、新技能、新梦想的号角，掀起了技能中国的热浪。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490987443-be524045-20c7-4a0b-942e-464601dd4524.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661490995210-3bc3fa4a-9221-4012-a3c5-6831b9fab6d9.jpeg',
          ]
        }
      }
    },
  ],
  // 教育类
  educationList: [
    {// 20250611   周晓强
      title: '以“叁昶标准”打造中职诊改复核服务标杆！',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761284190048-a79256eb-0a63-447a-aba0-710b81dbbf43.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '以“叁昶标准”打造中职诊改复核服务标杆！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761284190048-a79256eb-0a63-447a-aba0-710b81dbbf43.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['6月11日，2025年度叁昶服务的上海中职学校诊改复核现场服务保障工作圆满结束，叁昶公司开发的整改平台为五所学校提供重要支持，凭借“专业团队+标准流程+数据赋能”三位一体保障体系，<strong>五校复核结论全部为“有效”，服务满意度全部为“很满意”，</strong>整体服务工作赢得了所有学校的高度赞誉。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223446-7ef3db5e-32b2-4be1-a371-8bcd548437ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223817-f241b929-e523-4f2e-912a-d2d5bbeb2aef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223595-2b1a9569-d568-4a8f-a12c-29e4f6d5d6ff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284224437-6eef15ba-cc8c-4f57-b73e-700ff29bb2f5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 2024-6-21 周晓强
      title: '合作交流 携手共进 | 上海大学新闻传播学院学生赴叁昶公司参观学习',
      time: '2024-06-20',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941197575-9834a857-c21f-4fac-8a1f-149b63e729e3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=30",
      details: {
        top: {
          title: '合作交流 携手共进 | 上海大学新闻传播学院学生赴叁昶公司参观学习',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941197575-9834a857-c21f-4fac-8a1f-149b63e729e3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2024年6月20日下午，上海大学新闻传播学院的同学们走出校园，前往学院人才培养实习基地——上海叁昶文化科技有限公司进行参观学习。<strong></strong>。',
            '叁昶公司顾问、上海大学新闻传播学院创新创业导师王志卫对学院师生一行的到来表示欢迎，并与同学们讲述了从“战场”、“官场”再到“商场”一路走来的叁昶故事。',
            '同时，王校长结合了同学们的专业特色，分享、解读了叁昶在<strong>科技、文化、教育、咨询、服务五大领域业务板块的丰厚案例</strong>，并基于个人丰厚经历经验为同学们提供了中肯的<strong>择业就业建议</strong>。',
            '互动环节中，同学们积极发言，就<strong>职业发展路径、工作机会等</strong>方面进行了提问，展开了深入交流，王校长一一进行解答。通过王校长的解答，同学们对行业未来趋势及企业发展获得了更清晰的认识。',
            '在叁昶公司常务副总曹鸣浩的引导下，同学们还参观了公司企业文化墙、心语分享区，对叁昶文化有了更为直观的了解。',
            '作为一家<strong>有着核心引领，可提供多元化产品和服务</strong>的公司，此次参观学习是叁昶公司和上海大学新闻传播学院的友好交流合作的延续。参观学习的最后，王校长也对同学们加入叁昶进行实习工作表示欢迎。',
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941213028-05926486-718d-4c74-bf34-f2356196cc5a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941213449-72fbf607-cd4b-4c56-b4cc-c7e66107b42f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941211343-e2ebf26b-1346-41df-97d7-b52396fbdeb3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941214209-b55ddf03-2ba1-4c4b-bccd-02eedc079801.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941214828-02fafe6f-1543-42df-8a75-a15b79d915f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {}
      }
    },
    {//2020-06-02 amanda,龙明发
      title: '【合作交流 携手共进】叁昶与上海大学新闻传播学院共同签署合作协议',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221359960-bf3aa42e-52c2-4543-9d72-f4a4293e5362.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=education&num=9",
      details: {
        top: {
          title: '【合作交流 携手共进】叁昶与上海大学新闻传播学院共同签署合作协议',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221359960-bf3aa42e-52c2-4543-9d72-f4a4293e5362.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2022年11月17日上午，<strong>叁昶公司</strong>与<strong>上海大学新闻传播学院</strong>在上海大学智能媒体创新实验中心开展了<strong>合作交流会</strong>。此次参会成员有上海叁昶文化科技有限<strong>公司顾问王志卫先生</strong>，上海大学<strong>对外联络处副处长彭明霞</strong>、上海大学<strong>新闻传播学院院长严三九</strong>、上海大学新闻传播学院<strong>党委副书记兼副院长王智君</strong>、上海大学新闻传播学院<strong>二位副院长牛盼强和周宇豪</strong>。',
            '本次合作交流会上，叁昶公司和上海大学新闻传播学院共同完成了<strong>四大事件</strong>。一是，叁昶公司和上海大学共同<strong>签署了合作协议</strong>；二是，双方就人才培养共同完成了<strong>揭牌仪式</strong>；三是，叁昶公司作为捐赠方，为上海大学新闻传播学院<strong>捐赠了十万元作为人才培养经费</strong>；四是，上海大学新闻传播学院聘请叁昶公司顾问王志卫先生为<strong>学生导师</strong>。', '这四大事件的顺利完成，标志着叁昶公司和上海大学新闻传播学院的友好交流合作进入<strong>更高阶段</strong>，也意味着双方将就此展开<strong>更深远</strong>的合作交流。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344394-9d139439-447d-447d-b930-9459d3b1c8a1.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344365-d1d9edcf-301a-41bb-bf28-858799c3c0e8.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344381-d7aed800-7f8e-47d8-bf3c-26ae51e342ad.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344458-9c7c9c45-9d62-4d61-a93c-063118d15617.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344359-88834d9c-84da-42b0-9583-884c0af21f62.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344965-101b69a3-132c-4e3d-a750-7bc6a2d7421e.png'
          ]
        },
        bottom: {
          title: ['会上，叁昶公司顾问王志卫先生为大家带来了其精心准备的课程<strong>《执行力：优质保量完成任务的金钥匙》</strong>。王志卫先生结合其个人事迹，分享了他22年的军旅生活、一路走来的点滴、事业上取得的成就，这些都离不开他<strong>贯彻到底的执行力</strong>。',
            '他结合自己以往的经历经验、所见所闻、所思所想，从“<strong>执行不力的表现及原因</strong>”、“<strong>摆正角色和位置</strong>”、“<strong>明确优秀的标准</strong>”和“<strong>努力进阶提能力</strong>”四个方面，讲述了如何提高执行力成为更好的自己。', '此次合作交流会，叁昶公司和上海大学新闻传播学院建立了<strong>深远的友好合作关系</strong>，学生们也从王志卫先生分享的课程中获得关于执行力的启发，会议取得了圆满成功。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221352601-2c99ba3a-4f79-4699-b487-eda92f5a87c2.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221352634-64b11c46-2f1f-4cca-9ef3-a476c48244e8.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {//2020-06-02 amanda,龙明发
      title: '叁昶策划制作上海市学生线上职业体验日30s宣传片',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491298088-c3b13ca7-6c82-483a-a99c-551ab617ec9b.jpeg',
      linkTo: "/instanceItem?type=education&num=8",
      details: {
        top: {
          title: '叁昶策划制作上海市学生线上职业体验日30s宣传片',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491298137-5e7f1c80-1ddb-4dcd-90f1-66f207ebcb2a.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['疫情当前，叁昶公司策划的宣传片以一个创意十足的<strong>“云”平台</strong>，让大家在这里继续当小工程师、小设计师、小园艺师……', '这是上海市职业教育的一大品牌；这是每年超过十万人次职业体验的盛宴；这是公司连续三年为上海市学生职业体验打造“宣传片”。这部宣传片<strong>将登录全市地铁、楼宇等媒体播放。本次宣传片的主题：《遇见未来的自己》</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491289182-b64d3d31-1857-4652-a342-3f8071663c63.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491289192-5dd1f903-cfe2-4482-8ae4-a84d06b654d3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491289184-b4565baa-92d7-4c2a-875b-cb8522bc35b5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491289189-5d31b885-8096-4589-9141-cc949eabc814.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491289196-cd8c27e7-a0eb-4a8a-9ed6-a9b67a9f127c.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0'
          ]
        },
        bottom: {
          title: '',
          img: []
        }
      }
    },
    {//教育类//2019-11-26//2020-06-02
      title: '大众创业，万众创新——叁昶为推进“国家战略”助力',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491505990-0af28834-4428-4db5-864c-d2d04db110e2.jpeg',
      linkTo: "/instanceItem?type=education&num=7",
      details: {
        top: {
          title: '大众创业，万众创新——叁昶为推进“国家战略”助力',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491506005-4db0fd03-0f56-4f4d-8242-27a43c873935.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['公司承办上海市学生事务中心的中职校创新创业指导师培训项目于上周圆满结束。为进一步贯彻国家“大众创业、万众创新”精神，进一步落实市教委 2016 年职业教育工作精神进一步加强中职校创新创业教育师资队伍建设，各中职校就业指导老师参加此次培训，提升创新创业指导能力。上海市学生事务中心副主任周红星、就业服务部副部长章骏参加开班仪式。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494312-983dc4d6-cd13-4dec-9a74-5b5a1156e9d0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494303-6a6d22a7-9deb-4f89-b2c6-67331553b3f8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494303-975749b3-35d1-465d-a64b-835286b09f55.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494311-4c3d3c9f-fced-46c9-bd89-5f549edb7313.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494311-8361b9ef-80fb-4e6e-95bf-8575853e44a9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491494758-3d1af48a-e43b-4838-9e69-5a4d90540078.jpeg'
          ]
        },
        bottom: {
          title: ['通过本次对中职学校老师进行创新创业基础知识和能力培训，弥补中职校创新创业专业师资力量的“空白”，更好满足职业学校青年学生创新创业需求，为创新创业“大潮”提供可持续的后备力量。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491500147-ab86e6e4-9fde-4aec-ac28-cc29e760ab34.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491500154-11a74013-e2ea-4af1-8c74-41e2e338e36f.jpeg',

          ]
        }
      }
    },
    {//2020-01-08
      title: '上海市中职校“校园文化建设”培训项目报名工作火热进行中!',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491637247-7149622c-101d-4d91-9546-75198e300139.jpeg',
      linkTo: "/instanceItem?type=education&num=6",
      details: {
        top: {
          title: '上海市中职校“校园文化建设”培训项目报名工作火热进行中!',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491637269-d5d9683f-2a4b-4948-8632-c54b3e66efc4.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['2019年，叁昶公司再次承接由上海市教育委员会教育技术装备中心主办的上海市中职校“校园文化建设”培训项目活动。校园文化作为学校教育的重要组成部分，必然要紧跟时代发展的脚步，凸显新时代特色。习近平同志在十九大中明确指出“传承和弘扬中国优秀传统文化”，这也是新时代的重要命题。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491630460-a5f79c18-88b6-4b8e-ad15-414477e50886.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491630450-a80a4ff9-3df5-4ec7-9255-b535db437b63.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491630463-e8df4147-f10d-46cc-b646-1c4e751323bc.jpeg?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491630467-aa7f7600-d8fa-4983-8fb0-61f2b7a78f36.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491630452-aceb5a6f-ba27-4436-b004-22a0ca81edec.jpeg',
          ]
        },
        bottom: {
          title: '',
          img: []
        }
      }
    },
    {//2020-01-08
      title: '“挑战未来职场 放飞青春梦想”——2019年上海市房地产学校职业指导与服务系列活动',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491759912-52cacd72-9070-4b27-a382-3581e63f86a8.jpeg',
      linkTo: "/instanceItem?type=education&num=5",
      details: {
        top: {
          title: '“挑战未来职场 放飞青春梦想”——2019年上海市房地产学校职业指导与服务系列活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491759923-f5c61a47-2272-499e-9d63-bcf7be2ad8a4.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['2019年12月10日下午，由叁昶承办的上海市房地产学校“2019年职业指导与服务系列活动模拟面试大赛”决赛，在上海市房地产学校多功能厅展开激烈决逐。通过措施提升职业指导的针对性和就业服务的有效性一直是我们职业指导工作的目标。为提升学生们的职场竞争力，让大家真切的感受到求职面试的实况和氛围，了解不同职位所学的基本素质，做好职业规划，决赛在同学们的热情期待中拉开帷幕。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491746908-2c6b0f47-091f-49ad-ba8b-1886867763d3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491746894-d7d575d9-15ef-448e-bcd4-53f984212252.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491746910-2f9b7fc0-d1f2-4130-a9d0-85aa81d462e8.jpeg'
          ]
        },
        bottom: {
          title: ['今后，我们将会持续将职业指导能力提升计划进行、完善下去，我们也会根据校方不同需求提供更加适配的服务方案，期待更多合作！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491752483-85a4b87c-11d5-4f21-accc-18fa9d161360.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491752406-bc00692f-56bc-4669-9da9-d45fa734aff0.jpeg'
          ]
        }
      }
    },
    {//2019-12-25
      title: '上海海关2019年全面深度融合全员培训',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491893444-774c8717-1b7a-4718-a72c-0912845fa0fb.jpeg',
      linkTo: "/instanceItem?type=education&num=4",
      details: {
        top: {
          title: '上海海关2019年全面深度融合全员培训',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491893450-874109e8-ed5d-4f9d-aaa5-a0ca85e9f0aa.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['以习近平新时代中国特色社会主义思想为指导，围绕习近平新时代中国特色社会主义思想、政治能力、业务能力、执法能力4个模块内容，着眼“五关”建设和新海关队伍、业务全面深度融合，全面提升广大关员的政治能力、业务能力和执法能力，着力培养本职领域精通、相关领域熟悉、全领域了解的复合型人才。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491880184-0089c249-509e-4e7e-9813-9bd74afb2f0e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491880267-a20c190b-3aa2-412f-bd13-fb1b44ec644d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491880194-de843acc-8c76-4de7-99ba-544b287cc903.jpeg'
          ]
        },
        bottom: {
          title: ['本项目结束后，学员预期会在思政方面、业务方面、组织纪律方面、团队意识方面产生提升，由于本次培训涉及人员规模大，人数众多，覆盖面广泛，对于广大关员整体素质提高也可以起到积极推进的作用。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491886077-bdcd7421-8913-407f-a0c2-42f352026635.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491886085-23f0afcb-92f1-4639-a120-15fa254fc747.jpeg'
          ]
        }
      }
    },
    {
      title: '中国电子科技集团第23研究所领导干部培训',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491995452-1a661590-b57a-44ba-a17b-182d56eb72d2.jpeg',
      linkTo: "/instanceItem?type=education&num=3",
      details: {
        top: {
          title: '中国电子科技集团第23研究所领导干部培训',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491995470-b65faf32-990f-4116-a704-134a57685006.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['为深入贯彻习近平新时代中国特色社会主义思想、培养高素质专业化青年科技干部，公司承接并策划了2019年上半年中国电子科技集团第23研究所领导干部培训'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491984905-8c772a52-e245-472c-817b-0368fa68bda5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491984898-aa3657ba-aeaf-499c-a01c-0841e0275299.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661491984903-cd18cfda-887d-4b56-8200-e463e08b6237.jpeg',
          ]
        },
        bottom: {
          title: ['培训计划分为三大部分——优秀团队塑造、战略规划训练以及团队精神淬炼。通过设计课程授课与素质拓展活动结合的培训方式，提高学员的培训兴趣以及接收效果，并获得了一致好评。'],
          img: []
        }
      }
    },
    {
      title: '上海市工商外国语学校礼仪培训课程',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492109156-bbc0e36d-5d62-4231-9073-56652f8b0fd7.jpeg',
      linkTo: "/instanceItem?type=education&num=2",
      details: {
        top: {
          title: '上海市工商外国语学校礼仪培训课程',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492109213-1dd28c36-ae57-4714-a2f2-eacb5b0d5d40.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['为适应高校需求，公司承办了上海市工商外国语学校礼仪培训课程。通过礼仪教育，让学生掌握文明礼仪知识，内化讲文明礼仪的意识，规范举止言行，形成良好的行为习惯，把礼仪规范牢记在心里，表现在学习、生活的各个细节中，懂得自尊自爱、尊重他人、友好相处，为个人全面发展和学校提升文化品位奠定基础。'],
          img: []
        },
        bottom: {
          title: ['通过本次培训，弘扬中华民族优秀文化，继承优良传统美德，使学生成为彬彬有礼的博雅少年，成为文明社会中闪亮的一员。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492100585-bfd7e210-46c0-447d-ae73-24cd5bdf8e9a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492100571-65094767-27ef-4a18-bf53-ad5d164ba17d.jpeg'
          ]
        }
      }
    },
    {
      title: '上海市中等职业学校创新创业指导师培训',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492212745-7a6b2117-43b7-4cac-8ebb-ddd126ba4f00.jpeg',
      linkTo: "/instanceItem?type=education&num=1",
      details: {
        top: {
          title: '上海市中等职业学校创新创业指导师培训',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492212999-056a5111-00fd-4015-80a6-d9c6345ee594.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['2018～2019年由上海市学生事务中心主办、我司承办上海市中等职业学校创新创业指导师培训'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492184642-29a78c64-6c64-49d3-a679-d606dddb5b24.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492184655-ff3be351-5892-48e1-bbee-19030b6869a7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492184671-765586f8-a9a8-4b26-b218-a672b84a5db9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492184683-8d5141e8-a2f1-4aa4-974b-d78bea45118a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492184687-bc27243f-e911-4814-8321-e47b2a9796bf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492185275-be8b4220-f1d6-4747-a8f9-844785ecbaba.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492185367-6d362398-cb38-4fa3-b015-06a360aad83d.jpeg'
          ]
        },
        bottom: {
          title: ['本次培训经设计，科学合理地将理论与实践相结合、线上与线下相呼应，设置培训课程分为理论篇、走访篇、实战篇，邀请沪上创新创业专家现场授课，参观企业、学校和创业实训基地，并模拟实战、素质拓展，进一步拓展了中职校教师的专业知识，提高了综合素养，得到各方一致好评！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492192893-29131eb5-43eb-4f72-b594-abc83a6367b3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661492192905-fd66cb2d-28e2-4d42-9f83-717b11bb28bf.jpeg'
          ]
        }
      }
    },
  ],
  // 科技类
  technologyList: [
    {// 20260630 周晓强
      title: 'AI赋能｜叁昶 12 大诊改功能模块全新上线',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387164126-a751c65c-d915-4803-a7e6-22e8a1c42148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=39",
      details: {
        top: {
          title: 'AI赋能｜叁昶 12 大诊改功能模块全新上线',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387164126-a751c65c-d915-4803-a7e6-22e8a1c42148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['针对当前上海中职诊改复核标准持续更新，院校普遍存在多套数据重复填报、台账繁杂、质量监测缺乏可视化工具、迎检溯源难等痛点。叁昶<strong>全新上线12大诊改功能模块</strong>，打造AI赋能、数据互通的一体化诊改平台。',
          ],

          img: []

        },
        bottom: {
          title: ['整套升级模块<strong>对标全国人才培养状态库，打通国市校三级数据链路，配备双版本数据底座</strong>，适配不同院校需求，同时<strong>集成五层AI智能画像与五大业务管理模块</strong>，精准匹配上海中职诊改复核要求，支持院校按需灵活选配。',
            '未来叁昶将持续迭代智能化、标准化诊改工具，助力院校深化内涵建设，推动职业教育高质量发展。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387172226-78972200-83df-4358-b4b7-e12cda1310a5.png?x-oss-process=image%2Fformat%2Cwebp']
        }
      }
    },
    {// 20260625 周晓强
      title: '智慧操场 | 打造可感知、可量化的实践成果',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474741391-005dfb1f-b9e4-4928-8028-5970da9d0669.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧操场 | 打造可感知、可量化的实践成果',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474741391-005dfb1f-b9e4-4928-8028-5970da9d0669.png?x-oss-process=image%2Fformat%2Cwebp '
        },
        lunbo: {
          title: ['通过物联网摄像头+人工智能运动视觉算法，叁昶将机器视觉与体育教育深度融合，实现中小学、普通高中体育教学、自主锻炼、标准化体质测试等全场景使用需求，解决体育教学、测试信息化资源缺乏等难题。'
          ],

          img: []

        },
        bottom: {
          title: ['目前叁昶团队已成功助力20余项校园智慧操场及体测室的智能化建设及升级。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474750804-00fdd3d2-5c44-47a9-85b2-08610b1dfff4.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474750849-69d0c141-e4e8-43d4-98e2-918967aadec2.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260624 周晓强
      title: '智慧教室 | 以科技助力焕新 以智慧赋能课堂',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474489801-0ce335dc-305d-4437-a48f-cb24bd78b8b6.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧教室 | 以科技助力焕新 以智慧赋能课堂',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474489801-0ce335dc-305d-4437-a48f-cb24bd78b8b6.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['多年来，叁昶始终专注于数字化升级与文化空间营造的双轮驱动，构建起从方案策划、技术研发、工程实施到售后运维的完整服务闭环。'
          ],

          img: []

        },
        bottom: {
          title: ['运用文化+科技，艺术+技术的理念，叁昶团队通过对设备的全面升级与功能优化，将原有教室改造为满足现代化教学需求的智慧教室，以适配新的功能定位，提升教学体验与管理效率。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500596-193b03ac-8387-4188-a329-7aabe3cfae5f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500555-7084d858-7998-41d1-8eb2-5594f9bae64a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500545-0e094e5e-e2a5-41d0-b136-bed76d17cc97.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500573-1b6cf01d-edd8-4eef-abb8-0075700d6e5c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500610-1e0fd43e-f0eb-4c6a-80c7-e8fd7f1b9826.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474501456-dc641153-3545-4654-94fd-79de0f557775.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260623 周晓强
      title: '智慧报告厅 | 以境育学 焕发教育新活力',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474301619-148c472f-0e4a-4b4f-9dcb-747c42b8f64a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧报告厅 | 以境育学 焕发教育新活力',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474301619-148c472f-0e4a-4b4f-9dcb-747c42b8f64a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托数字化软硬件集成，叁昶致力于打造集“智慧化、多功能、沉浸式”于一体的现代化报告厅，构建集约便捷、特色鲜明的智慧空间。'
          ],

          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296718-4781b133-ee9b-4bf6-8568-e8ff75f5b50d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296781-5dfab54a-24d5-48c9-a905-3189b439cf99.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296645-2c8c1d7f-f9a5-4da3-8536-ddfcae76ae4d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296779-a64c6f2d-8005-49a1-811e-80c21b7ea033.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260622 周晓强
      title: '智慧研学空间 | 助推数智升级 践行一体化服务',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474078570-275dedb5-cb72-4d17-bf54-922b14de927f.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧研学空间 | 助推数智升级 践行一体化服务',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474078570-275dedb5-cb72-4d17-bf54-922b14de927f.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['以沉浸式体验与环境智能交互为核心，叁昶团队通过对物理空间的立体化视觉重构与多维交互能力的深度融合，构建一个能全方位激发感知、促进情境化认知与协作探究的沉浸式智慧研学空间。'
          ],

          img: []

        },
        bottom: {
          title: ['从规划落地，到部署运维，叁昶团队以全生命周期服务为支撑，全面赋能硬件升级与服务增效。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087849-136e295a-23b1-4906-935a-09405172bb42.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087823-c6a306de-5158-4d73-b27a-b4ec1f2d9189.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474088118-dba67e9d-120e-4c70-a45e-6cc270cf391b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087941-d6c8e4c5-4a5c-46c8-a50d-0de1dada128a.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250708 周晓强
      title: '打造集“科研、会议、展示”于一体的智能化多功能报告厅！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761635032284-7958dea0-ec2b-42e1-8f7f-e67102fcbdad.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '打造集“科研、会议、展示”于一体的智能化多功能报告厅！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761635032284-7958dea0-ec2b-42e1-8f7f-e67102fcbdad.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为长征医院打造的智慧教室及公共空间，以“智慧教育、科技教学”为核心理念，打造集“科研、会议、展示”于一体的智能化多功能报告厅。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250516 周晓强
      title: '构建高效教学空间，叁昶助力打造现代化教学新场景',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547656-d4fe4c73-09df-42bb-acca-ead87b3ec314.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '构建高效教学空间，叁昶助力打造现代化教学新场景',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547656-d4fe4c73-09df-42bb-acca-ead87b3ec314.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶公司为上海理工大学第三教学楼打造了47 间教室及 1 间智慧教室监控中心。其中 35 人智慧教室7间、50人智慧教室3间、67人智慧教室4间、76人智慧教室4间、92人智慧教室3间、112人智慧教室24间、165人智慧教室2间。同时所有教室门禁及公共区域安防监控系统一并纳入建设。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547517-29b88192-9fd7-4bad-a89b-99753f6d6fb7.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547559-41c47395-98b1-4701-a2ff-208fc4734438.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634549300-ad08432f-397c-49ed-b4e4-7b8bd136ce60.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250507 周晓强
      title: '双空间升级焕新：叁昶打造多功能会议新空间！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415201-2b1676c3-4d48-42fe-8b46-4c467a9c3f70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '双空间升级焕新：叁昶打造多功能会议新空间！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415201-2b1676c3-4d48-42fe-8b46-4c467a9c3f70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶升级改造的上海交通大学智慧教室项目，涵盖一间容纳20人的小型会议室和一间可容纳116人的多功能会议室。',
            '小型会议室可满足日常20人以下的小规模内部会议，并提供多媒体音视频展示功能。而多功能会议室则可适应多样化的会议与活动需求，配备先进的显示系统、远程会议系统、中央控制系统和专业音响系统。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415250-bebc2a80-7781-47b3-94f7-40a05b5343f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415108-2151eb99-bb06-4f52-a8c9-4127e3f8698f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250416 周晓强
      title: '艺术与智慧共生！叁昶赋能审美教学，打造“课演一体”空间',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244176-78ecfe1d-b2e7-42bc-bc9e-199cd88cebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '艺术与智慧共生！叁昶赋能审美教学，打造“课演一体”空间',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244176-78ecfe1d-b2e7-42bc-bc9e-199cd88cebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['智慧赋能艺术，创新成就未来！叁昶公司为某校全新升级的多功能智慧阶梯教室正式亮相！',
            '项目设计结合学院特色，将“胶片”元素造型和LED大屏相融合，应运用文化+科技，艺术+技术的理念，将设备与艺术设计相结合，打造了一个具有美感与科技感的未来智慧数字报告厅。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634245105-6a4361ac-f7b6-4f7a-813d-0071a86a2959.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244286-29ad9356-4be5-435f-8be2-60c32cc7c4d4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244298-2ffde959-a601-4e78-97a0-a80b6c84f274.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241113 周晓强
      title: '未来能源创享中心：探索绿色能源，创享可持续未来',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304415-b2e8ec28-ef53-4a12-b042-6eb6a0d153fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '未来能源创享中心：探索绿色能源，创享可持续未来',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304415-b2e8ec28-ef53-4a12-b042-6eb6a0d153fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶为电力大学建设具有美感与科技感的未来能源创享中心，项目包括入口门头区域，科普展示交流区，工程训练区，智慧教坊四大区域。',
            '其中科普展示交流区和工程训练区分多个版块，将集展陈、互动体验、多媒体展示、创新实践，科普宣传，成果展示，教育教学等功能于一体，为校内师生及来校市民学习能源知识、开展能源科普活动、组织能源实践活动等提供高质量平台和高水平载体，提升公众对能源产业的认知和关注度，引导大众积极参与能源产业创新行动。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304507-ac43eb2a-e400-46c8-86e9-4a543be420e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304518-a584f399-b443-47d5-aec7-21657dc9cd1c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241113 周晓强
      title: '智慧教学、极简部署 | 叁昶打造 "教与学" 的数字化新生态',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628159593-0e0abf28-463b-4afc-bdaf-6f1506c800d8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧教学、极简部署 | 叁昶打造 "教与学" 的数字化新生态',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628159593-0e0abf28-463b-4afc-bdaf-6f1506c800d8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为上海健康医学院打造的智慧教室，采用全IP化一线通方案探索新型智慧教室建设模式，将设备、环境、系统采用统一数据通信标准，应用互联互通统一操作，助力学院老师将智慧教室轻松用起来。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241028 周晓强
      title: '筑牢思想阵地！叁昶打造党性教育与理论宣讲的新空间',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424549-5941969b-4bae-4710-89b2-9b4583f4b0d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '筑牢思想阵地！叁昶打造党性教育与理论宣讲的新空间',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424549-5941969b-4bae-4710-89b2-9b4583f4b0d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为中共闵行党校打造的集“智慧化、多功能、沉浸式”于一体的现代化报告厅，旨在为党政培训、学术研讨、红色教育等活动提供高效、智能化的数字化平台。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424556-8c3a71ed-0690-4137-9109-9b28b42d5277.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424635-c542b3a3-a77b-4391-b0d6-5fdaf3542648.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241012 周晓强
      title: '置身 “元” 宇宙，叁昶引领沉浸式教学交流新潮流！',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265560-8809e15e-2278-44f6-a7a9-3fb7abb6ccea.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '置身 “元” 宇宙，叁昶引领沉浸式教学交流新潮流！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265560-8809e15e-2278-44f6-a7a9-3fb7abb6ccea.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['数字化互动空间突破现实界限，裸眼3D引领元宇宙新潮流！叁昶公司为上海南湖职业技术学校打造的具备虚拟仿真体验的多功能公共智慧教室，同时也是一间具有多功能性，集互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265659-4f8c5276-81ae-453b-903b-c38e24bf9af7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615274394-477a8489-c6e7-4ec2-b0c4-a97ed281e63a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615266689-ab99dbe8-b955-442b-ba36-1d9f8f02d453.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615274101-684a5706-89c0-48cd-a9d1-b4463485d384.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241012 周晓强
      title: '教学楼改造与智慧化同步推进：叁昶让每间教室“会思考”',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615111017-dfe1e3a1-5d23-4a2d-b218-be8247aaa217.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '教学楼改造与智慧化同步推进：叁昶让每间教室“会思考”',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615111017-dfe1e3a1-5d23-4a2d-b218-be8247aaa217.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶圆满完成对外经贸项目整体信息化设备设施和教室空间环境进行改造建设，涉及学校四栋教学楼，包含112间教室和1间监控指挥中心。',
            '通过智慧教室的建设和打造，搭建启发式、探究式、讨论式、参与式的实训空间以及对应软件工具和资源服务平台支持，为学校教育教学改革创新提供立体化、数字化的教学环境，提供教学观念和教学方法改革创新途径，以满足面向现代化、信息化教育教学需求。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615103787-f2084045-0609-47a6-ac8a-97121a9b32b8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615103770-45ffaf85-4439-405b-a427-138dabd1c3f4.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615104026-d46dbeda-c404-4765-8ee0-72e8a686134a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615104117-bd4aa176-63a6-47f6-9de4-e55baf4b2e52.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240826 周晓强
      title: '一厅多用 智慧赋能 | 让每一场分享更具影响力',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761614995566-90047ac6-f505-49d6-80d6-a53fe3bca9ae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '一厅多用 智慧赋能 | 让每一场分享更具影响力',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761614995566-90047ac6-f505-49d6-80d6-a53fe3bca9ae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶助力上海市商业学校报告厅智慧教室的教学环境、信息系统管理等方面，实现全面数字化建设，构建具有多功能性，集线上线下互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'],

          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {//2024-7-9，周晓强
      title: '创新赋能 促转型升级 | 叁昶倾力打造的文化展示、信息化项目顺利落成',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490733238-8e41ee00-9a24-4aaf-bffa-1e1a5d05dc91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=31",
      details: {
        top: {
          title: '创新赋能 促转型升级 | 叁昶倾力打造的文化展示、信息化项目顺利落成',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490733238-8e41ee00-9a24-4aaf-bffa-1e1a5d05dc91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['秉持着“文化+科技”，“艺术+技术”的文化设计理念，叁昶致力于打造集展陈、学习、交流、科研等功能于一体的具有底蕴文化和科技赋能的沉浸式空间。',
            '让我们一同解锁叁昶近期落成的文化展示、信息化项目的部分精彩案例。',
            '<strong>文化展示项目</strong>',
            '叁昶全程把关，为某中院量身定制的<strong>党建活动中心</strong>，设置“初心起航、司法护航、赋能续航、扬帆远航”四大板块。面对施工中出现的突发情况，与施工人员共同研究解决，充分协调调度好工程之间的衔接过程，抢时间、保质量，为项目的顺利完成创造有利条件，仅历时30天完成。',
            '叁昶为某中院设计、建设的<strong>证券审判活动室</strong>，运用数字化、智能化和多媒体化的技术特点，结合特有文化设计特色，助推数智转型，实现多功能需要。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490749723-e666719b-a44b-4629-b7b0-48ab5127488b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747778-2e4c7311-da0d-4d9e-b0af-31c764483677.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747810-09256d84-8a65-4a5d-a4c1-77414b49a30a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747616-262c2a0e-ede3-41ad-93bb-f68d6be1273e.jpeg?x-oss-process=image%2Fformat%2Cwebp', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747643-7659c753-923d-48f7-b093-b9502c003a47.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490748684-b54937f1-1108-4d9d-a4a9-d53871dc39c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490748862-a01fbeee-3da6-4723-8a73-903ad9004858.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1']
        },
        bottom: {
          title: ['<strong>文化展示项目</strong>',
            '叁昶打造<strong>上海交通大学哲生馆</strong>一楼门厅、智慧教室、会议室、多功能厅，通过精心设计和现代技术手段的应用，满足信息发布、党政会议、远程会议、教学及学生活动的哲生馆。',
            '除<strong>文化展示、信息化项目</strong>外，叁昶也牵头公司多部门、多工种，基于安全性、稳定性、美观性以及创新性，全力以赴坚守在<strong>智慧校园设计施工，智慧教室设计改造及智慧操场设计改造</strong>施工一线，后续也将持续落地。敬请期待。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764373-194256f0-38f1-498c-9d1b-4782f68d4a33.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764430-178113f2-8072-400f-84a1-5ad8e6cbd589.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764293-af6ebe81-2a0a-458b-a3b3-c174ef7bcfba.jpeg?x-oss-process=image%2Fformat%2Cwebp', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764294-fc0428d7-6b56-42a3-b951-d822a6ea92f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {//2023-5-10，阮宏宇
      title: '搭建交流协作平台 促进诊改工作开展——市中职“教学诊改平台”应用与改进研讨会在叁昶公司圆满举行',
      img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712230580-72350062-ff21-4adf-93b7-efaf10b431e9.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=30",
      details: {
        top: {
          title: '搭建交流协作平台 促进诊改工作开展——市中职“教学诊改平台”应用与改进研讨会在叁昶公司圆满举行',
          img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712230580-72350062-ff21-4adf-93b7-efaf10b431e9.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2023年3月21日，根据<strong>上海市中等职业学校教学诊断与改进工作的部署</strong>，结合诊改协作组工作计划，为更好发挥人才培养状态数据管理系统对教学诊断与改进工作的支撑作用，推动学校逐步建立和完善内部质量保证制度体系，上海市中职学校教学诊断与改进第六协作组主办了“<strong>教学诊断与改进平台</strong>”应用与改进研讨会，会议由<strong>上海叁昶文化科技有限公司</strong>承办。', '上海教委职教处副处长<strong>黄蕾，</strong>上海教育评估院职成教所所长<strong>刘磊</strong>，全国职业院校教学诊改专委会副主任<strong>邬宪伟</strong>校长，上海产教融合促进会会长<strong>姜晓敏</strong>校长，上海商学院高等技术学院、继续教育学院副院长<strong>李钰</strong>，上海信息技术学校副校长<strong>王鹤</strong>和各兄弟中职校领导及诊改工作负责人等40余人出席了本次会议。会议由第六协作组组长单位，上海市材料工程学校党委书记<strong>金怡</strong>主持。', '上海参昶文化科技有限公司顾问<strong>王志卫</strong>致欢迎词，首先对与会领导、专家莅临参昶公司表示热烈欢迎，其次对教学诊改平台基本情况进行简要介绍，提出“诊改平台关键作在<strong>用</strong>，公司服务的目标就是要让诊改平台助力学校高质量发展，切实做到<strong>能用、好用、管用、想用</strong>”。', '叁昶公司项目技术服务团队负责人<strong>武京</strong>围绕诊改平台总体使用情况，引入数字可视化驾驶舱，通过对诊断点数据进行实时跟踪与动态监测，助力学校高质量发展，实现教育教学大数据可视化展示进行了介绍。', '<strong>上海市材料工程学校</strong>从一期复核的问题出发，交流了学校在二期建设这两年多来的诊改工作和平台校本开发工作。<strong>上海第二工业大学附属浦东振华外经职业技术学校</strong>从数据平台在复核工作中起的支撑作用出发，介绍了专业建设层面的诊改工作。<strong>中华职业学校</strong>则从即将迎接复核工作的角度，汇报了下阶段的工作设想和面临的挑战。'],
          img: ['https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244293-bb918e10-651e-46a1-a444-83206550ffaa.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244269-2415cc5a-e0a0-4736-b27a-c67fd1c3095b.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244278-874c87a9-3585-4104-917e-d8c3555bf9b3.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244271-1605029f-2772-43b2-a3fd-f862b8644345.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244266-2b1d6e18-4d98-41a4-b99d-6bb35eb09c0c.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712245280-25efed27-950d-40d3-82f2-0e4672f8f6e9.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0']
        },
        bottom: {
          title: ['对于3所学校的交流，诊改专家组的专家们给予了肯定，并聚焦数据治理问题进行了专业的指导。全国职业院校教学诊改专委会副主任邬宪伟指出“数据的工作重点在数据分析和数据对比，聚焦关键能力，协调关键要素，采集要下移，分析要上升”。姜晓敏专家强调“数据是基础、分析是诊断、改进是关键，一定要让数据从管理走向治理:依法治理、源头治理、综合治理”。李钰专家从“数据治理”的七个标准进行了具体的分析和讲解，并提供了数据可视化案例供大家学习。王鹤专家建议在数字化背景下，要发挥数据对诊改的支撑作用，推动平台的迭代升级。', '会议最后，上海教委职教处副处长黄蕾、上海教育评估院职成教所所长刘磊对本次活动的举办表示了肯定，希望学校的诊改工作在完成前期办学水平达标的基础上，继续深化，聚焦专业建设水平、专业监测水平，运用好连续多年的对比，发现问题，提升办学质量，落实上海市教学诊断与该改进平台“从无到有从有到用，从用到优”的建设。', '本次第六协作组的活动圆满举行，进一步推进了中职学校教学诊改工作进程，有效促进协作组学校不断提升自我诊改水平，创新诊改工作方法，促进各校互学共建、均衡发展。第六协作组将细化措施，高站位、高标准、高质量地真抓实干，推进诊改见成效，推动协作校工作全面发展，为中职教育高质量发展赋能。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258024-466684e2-8bea-476c-a612-fe5b58207216.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258032-d7bb9fcc-b69d-4a90-8f52-f8f0655fd6b2.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258031-bae21006-875d-425b-a8cb-c0053ba531f0.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258050-1296f7bf-e68f-4d49-9d89-550715269382.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258051-e8f07823-f91b-4d0c-9384-3331f113ae9a.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258916-3fd256a9-3386-4eef-a3ea-be666ee4c9a9.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259008-21250d60-d333-49b3-bbe5-09527f6b9c38.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259092-55408bb7-df70-494c-9f3c-2dafd708328f.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259158-c1806eb8-6e19-4207-9123-439972e30b98.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]
        }
      }
    },
    {//2022-11-10，阮宏宇
      title: '叁昶设计打造的360度环屏数字沉浸商务试验场在第十九届教博会上迎来首秀',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225406608-cc3cbcbc-8c7d-4de5-861c-195b281f693d.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=29",
      details: {
        top: {
          title: '叁昶设计打造的360度环屏数字沉浸商务试验场在第十九届教博会上迎来首秀',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225406608-cc3cbcbc-8c7d-4de5-861c-195b281f693d.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2022年11月18日，<strong>第十九届上海教育博览会上海教育数字化转型高峰论坛分论坛暨长三角区域职业教育数字化转型发展论坛</strong>在<strong>上海商学院</strong>举行。本次论坛以“<strong>数字化赋能职业教育高质量发展</strong>”为主题，邀请了来自长三角地区的<strong>30余名专家、学者、龙头企业，叁昶公司顾问王志卫先生</strong>作为受邀嘉宾，出席了本次论坛并发表了讲话。', '本次论坛采取<strong>线上线下</strong>的形式，围绕<strong>职业教育数字化转型</strong>案例进行沉浸式分享、展示和交流；旨在进一步<strong>深化产教融合、校企合作</strong>，探索职业教育数字化区域协同创新模式，助力长三角职业教育实现更高质量的发展，将区域职业教育数字化转型的有益经验<strong>向外辐射</strong>，更好地服务国家发展全局。', '论坛上，出现的<strong>107数字沉浸教室</strong>引起了广泛关注，叁昶公司作为该教室的<strong>设计和打造方，公司顾问王志卫先生</strong>特此介绍了该数字化教室的功能、可解决的问题和实际效果，发表了“<strong>360度沉浸式数字化课堂助力教育发展</strong>”的讲话。', '<strong>360度环屏全景展示</strong>：107教室，采用了4k曲屏、360度环屏技术，具有自动录播、空间环境一键式控制、沉浸式、多维度、多场景的特征，支持各种录播和直播教学需要。', '<strong>数字化沉浸式体验</strong>：107教室，作为数字沉浸教室（数字商务试验场），符合当前环境下各种线上线下融合教学的需求，能让线上线下的用户产生强烈的参与感、互动感和体验感。', '<strong>科技与艺术完美融合</strong>：107教室所具备的展示及实训模拟功能，增强了现场用户的互动体验感，让本次与会者感受到数字赋能的产教深度融合、对职教未来“无限可能”充满期待，它实现了科技和艺术的完美融合。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390851-950a1ee1-48a6-4ffa-b76d-8212f163f9e5.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390920-95b39f84-b8d7-4f8d-bf0a-1b72c3a2f4d7.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390855-f4c48c12-8aeb-4e40-bdf5-ec320c83c4e9.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390854-bc6822dd-2782-44cb-a38c-0f6abfeaebe5.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]
        },
        bottom: {
          title: [
            '<strong>王志卫先生</strong>表示：“<strong>教育数字化转型</strong>最重要的就是转型到课堂，没有好的课堂，一切转型都等于零。此背景下的教室，要体现“<strong>文化+科技+生活</strong>”的功能，让学生们喜欢，让老师们享受。”而亮相此次教博会的<strong>360度环屏的107数字沉浸教室</strong>正好呈现出教育数字化转型后的教室该有的特征。',
            '本次教博会，<strong>叁昶公司</strong>为教室的数字化转型增添了浓墨重彩的一笔，<strong>数字沉浸教室</strong>的出现也将推进我国教育数字化转型花开遍地。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398685-17e26ac2-fb11-4c35-a769-70ea67d22f3a.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398749-22768986-36ba-4b68-836d-afd7a883c9b9.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398739-6b3908f9-6bde-4e24-aa73-5634a16ba999.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {//2022-11-10，阮宏宇
      title: '【科技赋能 文化换新】叁昶高效打造的全景式智慧校园大数据中心正式启用！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070446982-3694611e-d162-4d29-a5fc-0b3ab1ea6f4c.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=28",
      details: {
        top: {
          title: '【科技赋能 文化换新】叁昶高效打造的全景式智慧校园大数据中心正式启用！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070446982-3694611e-d162-4d29-a5fc-0b3ab1ea6f4c.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['<strong>“十四五”</strong>时期是<strong>“两个一百年”</strong>奋斗目标<strong>承上启下</strong>的关键期，是改善供给体系质量、推动高质量发展的<strong>决胜期</strong>。',
            '<strong>《教育信息化2.0行动计划》</strong>明确提出“以<strong>人工智能、大数据、物联网</strong>等新兴技术为基础，依托各类智能设备及网络，积极开展智慧教育创新研究和示范，推动新技术支持下教育的<strong>模式变革</strong>和<strong>生态重构</strong>。”',
            '<strong>叁昶公司</strong>秉持<strong>文化+科技，艺术+技术</strong>的一体化设计理念，将应用物联网、人工智能等先进信息技术，打造一个集线上课堂、教学研讨、视频会议、展览展示等核心功能为主体的<strong>一体化大数据中心</strong>。',
            '项目功能将具备以下<strong>5 种场景</strong>：1、智慧大数据管理中心。2、在线课堂管理中心。3、综合视频会议中心。4、智慧展览展示中心。5、综合学术报告中心。',],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070417895-66adf3f8-a9ab-4e89-ae66-8541a062c869.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070421066-e68a48b8-6206-4574-98ab-026b6b0887f7.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070423342-b5d1faa4-b990-426e-9dae-cb0a111e8c79.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070427872-8643e6ad-77cb-4fee-b38a-999bcf8251bb.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070431406-e9326104-de86-4364-94a4-28a779928bf9.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070433779-8f9fbf82-0166-4770-a815-76ceeaaa0b96.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
          ]
        },
        bottom: {
          title: [
            '本次项目建设<strong>周期短、任务重、要求高</strong>，公司信息化部门经过多次研讨会、协调会，做好<strong>顶层设计，统筹规划</strong>，确定时间进度表和工作责任人，有序推进项目实施。加强监管和沟通，每周定期召开工作例会，及时<strong>发现问题</strong>和<strong>解决问题</strong>。叁昶信息化部门全体工作人员凝心聚力、共克时艰，只争朝夕抢工期，<strong>高度优化还原设计效果</strong>，如期高标准完成了建设任务。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070475253-50b079df-a4a1-48b0-803c-4779452a85cf.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070479659-36556bfc-2577-4707-afac-268782729508.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070482372-e91c02c9-1b8e-44b0-9703-00ba4f17076a.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070485467-9b10711d-a3d1-4dea-b9fe-c35ce3766938.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2022-8-23，阮宏宇
      title: '叁昶打造的诊改平台亮相世界职业教育产教融合博览会上海馆',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497058284-977d31f9-a1ec-45b2-b34c-a70e754ee13c.png',
      linkTo: "/instanceItem?type=technology&num=27",
      details: {
        top: {
          title: '叁昶打造的诊改平台亮相世界职业教育产教融合博览会上海馆',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497062028-d2d9d2bb-3eb8-4b8e-a5c4-3b598968f32f.png?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['打造诊改平台，提升院校高水平<strong>办学质量</strong>，以<strong>大数据</strong>为基础建成了<strong>上海职业院校诊断与改进应用平台</strong>，为管理决策提供及时、全面、精准的数据支持。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035639-a838de4c-88f5-4596-9642-847680dc8f9d.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035661-6c8afcb7-ebc5-43ba-a42d-9dd47a11fbed.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035675-699d4dc3-b819-4c1b-8dcc-4c28adbaf322.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035784-62127971-b6fb-4388-97c8-4f59c6c1cf23.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035857-db3bae5f-fb86-4950-892b-45774208ea50.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036615-ce8a7e66-06c7-4560-8586-ec0467493c99.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036714-48c73b8c-5a1f-4672-a02d-c01474b6a398.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036931-e9ccd050-f226-40d3-9eb6-730798087834.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
          ]
        },
        bottom: {
          title: ['<strong>叁昶</strong>再出大动作，助力高校<strong>高质量</strong>发展！', '<strong>站位要高、标准要高、手段要高</strong>，叁昶向高职诊改与评价领域进军！', '以“<strong>诊改平台</strong>”为抓手，推动学校质量建设。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047572-5b695c32-21a1-4cc4-897b-40cff45d6d17.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047596-7c1ddd09-733c-4089-a11f-42426ee771a0.png?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047579-538f6239-8085-45b3-8791-7d2d82931596.png?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047576-ea2d3ca5-ab8f-4160-ac7b-d5b692ac4948.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047597-4f3aac9c-08dc-4960-9e8f-5b2bf7702a61.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497048315-bbc8daaa-56f3-43d7-84e9-75e91abc563f.png',
          ]
        }
      }
    },
    {//2022-8-16，阮宏宇
      title: '【低成本、高水准】这个智慧教室，我服了！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497271188-efb1390a-6c2e-4a6a-bcef-37f19f8499ed.png',
      linkTo: "/instanceItem?type=technology&num=26",
      details: {
        top: {
          title: '【低成本、高水准】这个智慧教室，我服了！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497271301-4ba894f7-fe1d-423a-8545-b37272f49297.png?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['虚拟显视空间、4K曲屏更清晰、全自动式录播、空间环境一键式控制、<strong>沉浸式、多维度、多场景……科技+艺术</strong>完美融合。', '在这个暑假，悄然出现在往日熟悉的教室里，进一步为教育客户带来了<strong>跨设备无感连接、自然人机交互、信息无缝流转</strong>的全场景智慧教室体验！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257259-1b63879e-7acf-4694-9562-ab0ceacaf235.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257294-2ccd7c45-17fa-4898-9bed-216a6b76d07f.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257266-92d5d964-87a8-456d-a45f-bd53f70b230e.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257332-6ebc1383-3fd5-4ab9-8125-4250d6fe8cff.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257593-a9301522-3937-4944-959b-6a9e8543dc0b.png'
          ]
        },
        bottom: {
          title: '',
          img: []
        }
      }
    },
    {//2021-8-24，阮宏宇
      title: '夏日炎炎，叁昶人撸起袖子加油干！奋力冲刺，打好暑期信息化项目收尾战',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497406135-3e2e246b-24cf-4109-89c6-150043df0fa4.jpeg',
      linkTo: "/instanceItem?type=technology&num=25",
      details: {
        top: {
          title: '夏日炎炎，叁昶人撸起袖子加油干！奋力冲刺，打好暑期信息化项目收尾战',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497406096-e0593a75-0e85-4f05-acd3-9f18712143c5.jpeg'
        },
        lunbo: {
          title: ['足蒸暑土气，背灼炎无光，力尽不知热，但惜夏日长。在八月酷暑的施工现场，有这样一群人，<strong>身披烈日，分秒必争，抢节点，保进度</strong>，今夏，因你们而精彩。', ' 骄阳似火，盛夏已至。转眼间已到8月中旬，暑期即将<strong>接近尾声，叁昶公司</strong>在今年暑期的<strong>三十多所学校的项目</strong>在紧锣密鼓中进行，在和夏日的炎热和台风带来的风雨对抗中，各项目的<strong>进度没有落下</strong>，每个项目的<strong>安全性、稳定性、美观性</strong>以及<strong>创新性</strong>等方面也仍然保持着<strong>最高要求</strong>。在和时间赛跑中，争取在开学前为每位学生和老师创造一个<strong>安全、实用、舒适</strong>的学习环境。', '<strong>叁昶公司</strong>信息技术部牵头及公司多部门、多工种全力以赴<strong>坚守施工第一线</strong>，顶着滚滚热浪和嘈杂的外环境，严格落实计划目标、抢抓节点施工进度，为项目收尾<strong>全力冲刺</strong>，在项目建成的过程中，我们用图片记录其中的点点滴滴，这个暑假，他们是<strong>最可爱的人</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390412-f83a9135-a3bc-4b8b-965d-96538aad6dab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390412-f83a9135-a3bc-4b8b-965d-96538aad6dab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390338-f124c5fb-9bf3-4a8c-a1f3-71164c17d657.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390328-69874288-fde6-4422-8297-f9ee41940729.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390325-c7e5f590-1b5c-4455-8da5-f56b9ca7ecd3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390712-5d151ba4-c744-4a71-8996-2604d32998f0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390838-13291c75-d4ef-46ab-9b24-69fa49cf4555.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390928-6f1c1672-2d6c-47c8-81c8-0412577b41c9.jpeg'
          ]
        },
        bottom: {
          title: ['原有装修拆除，这个过程既脏又累，伙伴们严格按照设计图纸进行<strong>文明施工拆除</strong>，只能撸起袖子加油干，为了后面施工做好<strong>基础保障准备</strong>。施工之前，<strong>安全技术交底</strong>是第一步，这个时候，大家都很<strong>注意听、用心讲，安全无小事</strong>，施工细节也同要重要。布线需登高作业由于没有安全绳的挂点，都是2人协调配合，虽操作不易，但<strong>工艺不会打折</strong>。整体线路、设备安装做到<strong>横平竖直、美观大方</strong>。施工后的垃圾清运及成品防护亦是要做到<strong>完美收尾</strong>。', '雄关漫道真如铁，而今迈步从头越。时间越近，任务越紧，越催人奋进，<strong>叁昶公司</strong>全体人员将<strong>鼓足干劲</strong>，继续保持大干热潮，以<strong>高昂的斗志，饱满的热情</strong>，全力以赴投入到施工建设中，为确保<strong>按期交工</strong>，开启最后顽强的拼搏和努力。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399029-74f203e1-8a3e-45b5-8627-bda4f7a7c84d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399060-30889e3c-50cc-460f-9d9c-f0c514f45f47.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399152-68a9f200-893f-4087-b6eb-792f95690cf4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399077-ba9ae658-a264-4b9e-8a17-7b7d9d49c115.jpeg'
          ]
        }
      }
    },
    {//2021-8-17，阮宏宇
      title: '叁昶再出大动作，助力高校高质量发展',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497587267-a3350003-1011-48fd-a6c6-e5659b70fa8b.jpeg',
      linkTo: "/instanceItem?type=technology&num=24",
      details: {
        top: {
          title: '叁昶再出大动作，助力高校高质量发展',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497587267-a3350003-1011-48fd-a6c6-e5659b70fa8b.jpeg'
        },
        lunbo: {
          title: ['<strong>专家把脉,引领平台顶层设计大方向;高峰对话,打造高校质量体系新高地</strong>——我司举行<strong>高校内部质量保证体系平台项目研讨会</strong>', '金秋伊始，<strong>叁昶</strong>酝酿教育硕果。8月12日下午，我们公司大咖云集，蓬荜生辉。<strong>上海海事大学校长、上海市教委原主任陆靖，上海教科院院长桑标，上海城建学院党委书记褚敏，教育部信息化建设专家何锡涛，上海评估院职教所所长刘磊，上海高职诊改秘书长罗尧成</strong>等领导、专家来到<strong>叁昶</strong>，就我司研发的<strong>高校教学质量管理平台</strong>给予了精准的、专业的指导，提出了更多的意见，收获满满。<strong>叁昶公司顾问王志卫、副总陈永亮</strong>以及信息软件部等有关人员出席本次会议。', '<strong>上海海事大学校长、上海市教委原主任陆靖</strong>在会议上指出，高校教学质量管理平台应帮助院校树立<strong>过程性评价</strong>和<strong>结论性评价</strong>相结合的理念，让平台的指标更清晰明确。他提出“<strong>评价有底线，标准有依据，定位要清晰</strong>”，要让高校教学质量管理平台更具有特色化，本土化的观点。同时也<strong>高度赞扬</strong>了我司研发的<strong>高校教学质量管理平台</strong>中历史数据轨迹记录功能，很好解决了学校重复填报数据报表的历史难题。', '<strong>上海教科院院长桑标</strong>指出高校教学质量管理平台应帮助各校<strong>梳理评价与诊改</strong>的关系，利用<strong>刚性指标</strong>来督促学校不断健全内部质量保证体系，落实诊改责任机制，将诊改落地，让评价更全面。', '<strong>上海城建学院党委书记褚敏</strong>剖析了质量平台的特点，指出一是要让高校教学质量管理平台<strong>定位于高职院校诊改</strong>，借助信息化数据让学校更了解自身发展情况；二是要<strong>建立和完善科学评价体系</strong>，让学校自我诊断机制可靠有效运行。', '<strong>教育部信息化建设专家何锡涛教授</strong>高度认可了质量平台把<strong>诊改和评价“融合”</strong>的思路，这不但是高等教育未来发展的<strong>大方向</strong>，也能更好的为高校建设提供数据支撑。同时，他指出平台下一步工作重点，就是的把诊改和评价的指标进行<strong>科学的结合</strong>。', '<strong>上海评估院职教所所长刘磊</strong>认为平台针对评价设计的四类指标，不但有校内的数据对比，而且可以<strong>抓取标杆院校</strong>的数据进行分析，这更好的为学校建设发展<strong>指明了方向</strong>。', '<strong>上海高职诊改秘书长罗尧成</strong>谈了自己的体会，指出其见证了平台从无到有，从0到1不断完善的过程，深刻感受到<strong>叁昶公司</strong>思维意识的超前和肯干实干的精神，<strong>期待平台落地</strong>后，为学校高质量发展带来质的变化。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497566629-c38dabf3-7780-44fc-93e1-4d09e3d4b16b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497567030-14a8b5bb-6954-447e-a8dc-b91d3e393909.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497566665-043ef77c-8ef4-41b5-bd08-377fc4b13f24.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497566581-317b5bb1-1b51-4309-9b98-7cda71ccb8d7.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>公司顾问王志卫</strong>也对团队提出了高校质量保证体系系统在保证服务高校的同时下也确保用<strong>信息化数据推动高校内部质量保证</strong>体系的建设完善的要求，我们做的高校教学质量管理平台，始终坚持<strong>不模仿、不照抄，</strong>立足在<strong>白纸上画画</strong>，着力打造出更具特色更有价值的“<strong>上海平台</strong>”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497574021-160a77c1-8ee8-49a9-9ac5-325c48479c8e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497574043-81ce31ea-ff7e-4863-a5d9-ecfd4d9c1d0c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497574044-fc1e8b45-8b86-4e13-8d21-f9a433551998.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497574039-a1affeaa-e93d-4de6-b07c-f1d9bdb63a29.jpeg'
          ]
        }
      }
    },
    {//2021-8-10，阮宏宇
      title: '叁昶加盟中国电信城市数字化转型生态联盟，共同打造行业生态蓝图',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497744688-3c4a5cce-608c-42a0-8357-3e4ef5023965.jpeg',
      linkTo: "/instanceItem?type=technology&num=23",
      details: {
        top: {
          title: '叁昶加盟中国电信城市数字化转型生态联盟，共同打造行业生态蓝图',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497744690-898e77e5-8cc6-45f1-a511-7e852af2d17d.jpeg?x-oss-process=image%2Fresize%2Cw_825%2Climit_0'
        },
        lunbo: {
          title: ['近日，<strong>叁昶公司</strong>受<strong>央企中国电信</strong>之邀，参加<strong>“城市数字化转型生态联盟成立大会”</strong>，与<strong>华为技术、海康威视、科大讯飞、商汤科技、中兴通讯、深信服、金桥信息…</strong>等八大数字化转型领域几十家知名企业生态伙伴携手——以<strong>“创新、平等、诚信、合作、共赢”</strong>为宗旨，把握城市数字化转型契机，以推动政府和企业数字化转型应用场景落地为目标，促进<strong>创新共享、互惠互利、共同发展，</strong>打造生态蓝图。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497723983-0a17eb56-8765-405b-8556-2d2706198149.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497723999-a98045e1-2930-40c7-bc89-8abfa3311449.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497723987-09017226-2aba-46a6-a000-b38cf756af6f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497724320-066f0e0c-5d35-43d0-9f5d-2c6e4ec8ca83.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497724320-066f0e0c-5d35-43d0-9f5d-2c6e4ec8ca83.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497724472-6c45a0ea-c32a-44af-b1b2-6b121e4351f3.jpeg'
          ]
        },
        bottom: {
          title: ['在大会上，<strong>西区局</strong>介绍了联盟成立的<strong>目的、宗旨、主要任务</strong>与<strong>工作机制</strong>。会后，<strong>公司常务副总曹鸣浩</strong>和<strong>副总吴小波</strong>同与会企业伙伴就<strong>业务合作、技术实践、能力互通</strong>等方面进一步展开互动交流。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497735085-6d38a5e5-4679-49ac-b711-6854f76f0ab1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497735103-35007f27-b050-4d5b-b6b9-74d1989e996f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497735215-b875411b-528f-4fc8-aaa7-2c04d307037f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497735279-d1475dff-83be-4379-8633-632cebbf9f07.jpeg'
          ]
        }
      }
    },
    {//2021-7-21，阮宏宇
      title: '鼓足干劲,全面部署,叁昶公司召开暑期信息化项目建设启动动员会',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497902759-dd613ae2-1bf0-4639-8cd8-ca5d134ad1a6.jpeg',
      linkTo: "/instanceItem?type=technology&num=22",
      details: {
        top: {
          title: '鼓足干劲,全面部署,叁昶公司召开暑期信息化项目建设启动动员会',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497903800-e86a1f3b-f47a-4b98-8666-7f3155442ad1.jpeg'
        },
        lunbo: {
          title: ['近日，随着暑期<strong>近二十个信息化项目</strong>开始施工，为了进一步保障工程的<strong>质量</strong>和施工的<strong>安全</strong>，<strong>叁昶公司</strong>召开暑期<strong>信息化项目建设启动动员会</strong>，公司主要领导、信息技术部各项目经理、现场实施队伍负责人及有关人员参会。会议由<strong>公司常务副总曹鸣浩</strong>主持。', '<strong>公司顾问王志卫</strong>就全力做好暑期近二十个信息化项目做了动员讲话并提出<strong>三点要求：一是智慧教室要有创新的设计理念、二是在实际工作中要有务实的工作作风、三是在整体项目中要有严密的组织安排。</strong>随即就时间节点和施工注意事项等做了强调，并进一步激励全员<strong>坚定信心、提振士气，</strong>以良好的精神风貌、务实的工作作风，确保公司暑期工作<strong>顺利完成。</strong>', '<strong>公司副总吴小波</strong>提出<strong>“三个必须”、“三个具备”</strong>的工作要求，项目开工期间，工作人员要<strong>规范管理，严格把关，及时沟通，</strong>同时为了确保所有项目在开学前顺利验收通过，现场就各项目的人员对接和分工安排进行了详细布置。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497881935-b2d621b6-5b3b-47ac-98d4-c0d01e113289.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497881957-6d95a780-9a0f-4b71-9657-d9718cf15d53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497881952-136f163e-4578-4325-9f34-b263343073fe.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497881995-0667ad89-0057-4810-941a-c44bf1a72f9b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497882006-8d5df8d9-7f97-40f6-9c50-d25c82ba3d83.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>“文化+科技”</strong>的融合打造出不一样的现代智慧教室；<strong>“艺术+技术”</strong>的统一让智慧插上了翅膀。<strong>“智慧校园</strong>的建设固然需要<strong>扎实的信息化基础设施建设</strong>，但更<strong>离不开顶层设计”</strong>，叁昶打造智慧校园的关键在于智慧“<strong>日知为智、心悟为慧</strong>”，这意味着智慧校园要和高校的<strong>教学、科研和文化、艺术深度融合</strong>，通过良好的顶层设计，培养具有<strong>创新精神</strong>和<strong>创造能力</strong>的<strong>个性化人才</strong>应该成为高校发展中的<strong>重要目标</strong>，智慧校园由此从一种<strong>外部的创新力量</strong>转变为<strong>内生的驱动力</strong>，不仅能够提升学校的<strong>核心竞争力</strong>，也能够为整个教育行业带来一种新生态。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497893561-dc1a0eef-7891-4512-9035-48584f012025.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497894224-b866f386-c3ac-4eeb-bc16-f0bab83a3544.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497894296-8ea9a955-d8c9-47a4-b730-ad99f7adb60a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497894309-7cc17b21-d522-4bfe-9596-d5917dfb97db.jpeg'
          ]
        }
      }
    },
    {//2021-5-28，阮宏宇
      title: '【以美为媒】我们在浦东又一高校建成具有该校DNA颜值的智慧教室。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498059435-97dab0d9-e2ce-4af2-9d6b-fe1a7e59b69d.jpeg',
      linkTo: "/instanceItem?type=technology&num=21",
      details: {
        top: {
          title: '【以美为媒】我们在浦东又一高校建成具有该校DNA颜值的智慧教室。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498059480-e0a2309c-6b8d-465d-9b49-c46f9d4befb9.jpeg?x-oss-process=image%2Fresize%2Cw_825%2Climit_0'
        },
        lunbo: {
          title: ['清华大学建校110周年校庆日即将来临之际，<strong>中共中央总书记、国家主席、中央军委主席习近平</strong>19日来到清华大学考察。首站参观美术学院校庆特别展时，他提到一个人人可感的字眼——<strong>“美”</strong>。', '<strong>美术、艺术、科学、技术</strong>相辅相成、相互促进、相得益彰，要发挥美术在服务经济社会发展中的<strong>重要作用</strong>，把更多<strong>美术元素、艺术元素</strong>应用到城乡规划建设中，增强城乡审美韵味、文化品位，把美术成果<strong>更好服务于人民群众</strong>的高品质生活需求。', '近日，我们在<strong>浦东</strong>又一<strong>高校</strong>建成具有该校<strong>DNA颜值</strong>的智慧教室，<strong>以美为媒</strong>，这意味着智慧校园要和高校的<strong>教学、科研和文化、艺术深度融合</strong>，通过良好的<strong>顶层设计</strong>，培养具有<strong>创新精神</strong>和<strong>创造能力</strong>的个性化人才应该成为高校发展中的重要目标，不仅能够提升学校的<strong>核心竞争力</strong>，也能够为整个教育行业带来一种新生态，让<strong>信息化绽放光彩</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498041764-aca8b7b4-274e-4a93-a163-891afb7d86a7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498041804-b3575805-90d9-4422-9a11-2d79c2df9f84.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498041750-4bfadfe1-2d91-4afe-895e-d3f6fe6336ec.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498041745-c6efff6f-8dba-42ed-b9b3-48b909083a8c.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['任何空间都如同每个人一样有着<strong>特定的气质和性格</strong>，在不同的场景里以特定的方式影响着人们的<strong>感受与行为</strong>。', '<strong>叁昶公司</strong>将智慧教室的布局营造出<strong>文化与科技相融合</strong>的学习环境，在智慧教室的文化设计中注重<strong>以文化人，以文育人</strong>，把<strong>校训、使命、理念</strong>融入到各个教学育人的场景中来，学校的教育教学目标正是创造这样一种环境和体系来引导学生，为学生<strong>点亮理想的灯、照亮前行的路</strong>，使得教育在<strong>文化、科技</strong>两个维度里形成一种学习与成长的氛围。', '<strong>叁昶公司理性的设计、精湛的施工、高效的管理</strong>，专业化、体系化、集团化创作的设计施工团队，合作院校近<strong>200所</strong>，赢得上海乃至全国各地客户的<strong>广泛赞誉</strong>。我们的格言是<strong>“一旦牵手，放不下手”</strong>！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498050582-685b0057-2984-41da-9cb2-40f49b618366.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498050628-7a9cc7f1-03ef-4bec-a5ac-ac97f0e5f4bb.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498050655-a5547198-3b28-4357-8901-cf6f94e051d7.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498050637-e2888fa3-5582-4ae1-a455-28d0128fc77d.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2021-4-21，阮宏宇
      title: '站位要高、标准要高、手段要高，叁昶向高职诊改与评价领域进军！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498239617-464945a7-c11c-4488-a86f-e7a1419b6b43.jpeg',
      linkTo: "/instanceItem?type=technology&num=20",
      details: {
        top: {
          title: '站位要高、标准要高、手段要高，叁昶向高职诊改与评价领域进军！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498239610-bb038427-b88f-4540-95c4-0d1f9e6be133.jpeg?x-oss-process=image%2Fresize%2Cw_825%2Climit_0'
        },
        lunbo: {
          title: ['四月春意盎然，万物复苏的日子里<strong>叁昶</strong>又有了<strong>大动作</strong>。回顾2020年叁昶公司为<strong>中职诊改与评价</strong>挥洒努力的汗水，助力近<strong>三十所中职学校</strong>的诊改与评价工作的推进，公司并不仅仅满足于中职诊改与评价，为了<strong>更好的服务</strong>与诊改与评价工作，定制开发<strong>符合上海特色</strong>的教学质量诊改与评价平台<strong>“高职院校内部质量保证体系数据分析系统”</strong>。', '叁昶诊改团队人员参考了<strong>《高等职业学校设置标准》、《高等职业教育创新发展行动计划》、《上海市教育委员会关于上海市职业院校制订中高职教育贯通专业人才培养方案的指导意见》</strong>等相关文件，以国务院印发的<strong>《深化新时代教育评价改革总体方案》</strong>为指导方向，用<strong>《“双一流”建设成效评价办法》</strong>为内容框架，抓住<strong>《职业教育提质培优行动计划》</strong>的重点内容，以诊断与改进的内部质量保证体系为基础，从<strong>整体发展水平、成长提升程度、可持续发展能力</strong>三个维度出发，形成以学校、专家、第三方机构<strong>三位一体</strong>的高职院校<strong>“一网通评”</strong>体系。', '公司团队参加了<strong>上海市高职院校教学诊断与改进系统开发研讨会</strong>，并在会上介绍了<strong>平台十大特点</strong>，突出人性化以及合理性。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498221525-96c74445-a4ed-47d8-904d-d46b5de82f26.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498221591-19c47b82-0080-4f93-af37-142920d0a657.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498221541-34d33e72-8974-4570-b522-66c509a9b0e4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498221545-eeeff10e-09e8-4080-95ff-42be15c859a1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498221545-5113633d-2caa-4ede-9a20-34186ad04898.jpeg'
          ]
        },
        bottom: {
          title: ['公司为此特意邀请<strong>全国诊改委信息化专家何锡涛教授</strong>为高职诊改平台的架构蓝图进行指导，何教授在听取诊改团队的汇报之后，给出了<strong>“有思路，有开创，有实干”</strong>的高度评价。同时<strong>公司顾问王志卫</strong>也对团队提出了<strong>“站位要高，标准要高，手段要高”</strong>的要求。', '春华秋实，<strong>“高职院校诊改与评价平台”</strong>经历多方打磨，吸取各方专业人士的经验与参考意见，现已初具模型。叁昶文化科技为达到<strong>“站位要高，标准要高，手段要高”</strong>的要求，现正不断打磨这颗教育行业的璞玉，预计<strong>九月正式投入使用</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498230370-34560d70-ae7b-40c6-9fdb-390eaa65281b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498230385-706e8ae4-a3cd-4b26-9587-0d3c25121cab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498230374-a9b9a983-359c-49ef-9c55-a785c1e429f4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498230398-48dcf011-15ca-4f6d-a184-9bdb02888cea.jpeg'
          ]
        }
      }
    },
    {//2021-3-12，amanda，阮宏宇
      title: '以“诊改平台”为抓手，推动学校质量建设',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498736249-81919ed1-a145-4c54-9611-25affa23b43c.jpeg',
      linkTo: "/instanceItem?type=technology&num=19",
      details: {
        top: {
          title: '以“诊改平台”为抓手，推动学校质量建设',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498736159-e8bcc624-361c-4774-8730-bd8c32b02f71.jpeg'
        },
        lunbo: {
          title: ['2020年<strong>叁昶公司</strong>助力推动<strong>近三十所中职学校</strong>，全面开始诊改平台的<strong>数据采集、数据对接、流程梳理</strong>等工作。其中，令人欣喜的是我们<strong>历经三年</strong>参与<strong>研发</strong>的<strong>中职教学诊断与改进数据中心</strong>上了<strong>中国职业教育核心杂志</strong>，为学校诊断与改进工作的推进，提供<strong>强有力</strong>的技术及服务保障，获得了<strong>各个学校高度认可</strong>。', '新学期伊始，<strong>叁昶公司</strong>组织实施团队，分别<strong>深入</strong>到<strong>各校</strong>拜访沟通，采用<strong>到校培训，分部门培训、驻场服务</strong>等模式<strong>全力辅导</strong>教师更好的去使用平台，同时，<strong>收集</strong>各校使用过程中衍生出的<strong>新需求</strong>，为学校发展<strong>自身特色</strong>的诊改内容，出谋划策。', '学校通过平台的使用，将教学工作记录<strong>及时采集</strong>，如实现<strong>课前提醒、快速考勤、教师评教、教师培训</strong>等实时数据的采集，避免教师事后录入、遗漏等问题，使平台数据在教师教学过程中就“<strong>跑起来，用得了，看得见</strong>”，协助学校进行<strong>两链打造</strong>，落实<strong>八字螺旋质量提升</strong>的诊改理念，为学校提供了有力<strong>数据支撑</strong>和<strong>分析预警</strong>等功能，目前<strong>各校都积极上线使用平台</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720338-02238b96-8b57-44dc-9d2d-003be6460cfc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720371-8f3a185d-b082-4a75-975d-7a9e7ef512ba.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720409-ac388efb-6c46-4166-92db-177e7c86e4ed.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720335-951e996b-6fdb-4a49-b9bc-d767a163305a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720347-be6b23d1-c1ab-4960-b4e7-e77984fd1519.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498720729-d63b4078-a761-4f5c-9074-618fe4509c9b.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>叁昶</strong>在<strong>夯实中职诊改平台</strong>的基础上，还在为<strong>上海市高职诊改</strong>出谋划策，为此特意邀请<strong>全国诊改委信息化专家何锡涛教授</strong>为诊改平台继续<strong>升华</strong>的蓝图<strong>进行指导，何教授</strong>在听取了公司团队的汇报之后，给出了“<strong>有思路，有开创，有实干</strong>”的<strong>高度评价</strong>，同时<strong>公司顾问王志卫</strong>对团队也提出了“<strong>站位要高，标准要高，手段要高</strong>”的要求。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498728519-6e5b3d85-bc12-4f51-ba6a-32c9d270fd7c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661498728541-ed21e2ca-3c59-413c-9931-051239164e22.jpeg'
          ]
        }
      }
    },
    {//2021-3-9，amanda，阮宏宇
      title: '学雷锋，有担当！叁昶服务，先“巡”一步丨全力保障学校顺利开学，为叁昶小伙伴点赞！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499377308-03483ceb-543d-4531-982e-bd243e4e586c.jpeg',
      linkTo: "/instanceItem?type=technology&num=18",
      details: {
        top: {
          title: '学雷锋，有担当！叁昶服务，先“巡”一步丨全力保障学校顺利开学，为叁昶小伙伴点赞！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499377363-1172ab55-7df6-41e0-87fa-722497450b37.jpeg'
        },
        lunbo: {
          title: ['阳春三月，<strong>开学季</strong>到来，每年的开学季是学校<strong>最热闹</strong>的时候，学子们将怀着<strong>对未来的热情与憧憬</strong>来到这里。为了迎接师生们的到来，<strong>叁昶公司</strong>早早做好了开学前，信息化设备、校园文化景观的巡检工作，全力保障学校<strong>顺利开学！叁昶公司</strong>小伙伴们<strong>提前进入工作状态，</strong>对<strong>上海近三十所大中专院校</strong>分别就<strong>防疫测温设备、教学设备、应用系统</strong>的维保检修工作，在学生<strong>返校前完成设备调试</strong>，确保设备<strong>运行稳定</strong>，技术支持全到位，助力维护开学阶段的<strong>正常教学</strong>和<strong>办公秩序</strong>。在教学设备调试中，小伙伴们共计对<strong>近三十所大中专院校</strong>智慧教室设备，学生终端及其他设备进行了<strong>全方面，多模块</strong>的运行检测调试，在现场对<strong>所有设备</strong>进行巡检维护，严格制定巡检表，从细节着手，严格把控每项技术参数指标，从画面到声音，从网络至性能，小到除尘维护，大到调试维修，<strong>全方位、精细化</strong>排查维护，配合校方老师进行自定义升级，极大程度上配合学校的教学计划，设置班牌及电子课表，使老师和同学们都能在上课和学习过程中<strong>提高极大的效率</strong>，教学工作能够<strong>正常有序开展</strong>。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499347589-45bceb8a-ff43-4fd7-a393-83effc1eae05.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499347637-f5d346c4-d424-45fb-b64f-ff5ecce37484.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499347558-ff3d8b14-4b7e-436d-970f-4219e6367893.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499347607-576dc632-8b59-45b3-a4d8-cc2db57b97a8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499347560-b6e6bc64-741c-4053-b6ee-8826566595de.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499348402-76202197-f6a9-4f18-886b-bb5ce0d64de9.jpeg',

          ]
        },
        bottom: {
          title: ['在开学前，<strong>叁昶公司文化设计部</strong>的小伙伴也组成小分队深入到公司<strong>各个大中专院校</strong>的校园文化景观项目进行<strong>复查、保养、维护</strong>和<strong>安全巡查</strong>工作，受到了<strong>各个学校</strong>的<strong>称赞</strong>和<strong>表扬</strong>。叁昶专业的服务团队，乐于奉献，扎实服务，<strong>弘扬雷锋精神</strong>，始终坚持“<strong>以用户利益至上</strong>”、“<strong>给您最好的服务</strong>”，无论飞越高山和大海，面对酷暑严寒，我们将提供健全的售后服务，这是是增进客户互动、实现与用户的无缝对接，建立跨领域的高效服务团队的基础，最终的目的是<strong>为客户提供更好的服务</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499364438-ec172880-bec2-4777-adfb-c826f7d07c62.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499364625-e4edd71c-972d-41fa-8242-c27bdd7e1413.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499364988-ea47bae2-58d8-446e-9470-fe841a90b42d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661499364378-0ff60d45-cf57-48b8-870f-bc527c7aa38c.jpeg'
          ]
        }
      }
    },
    {//2021-2-2，amanda，阮宏宇
      title: '叁昶公司自主设计建设的智慧教室理念在学习强国刊登',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743328733-33786a55-1ae4-4c08-8f91-fa9972215678.jpeg',
      linkTo: "/instanceItem?type=technology&num=17",
      details: {
        top: {
          title: '叁昶公司自主设计建设的智慧教室理念在学习强国刊登',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743328752-3b15b862-5b0f-4c0c-99c2-7d1d4a04ba45.jpeg'
        },
        lunbo: {
          title: ['近日，叁昶为上海财经大学设计打造的5A级智慧教室在学习强国上刊登，我们的设计紧抓互联网、大数据、人工智能等技术发展机遇，创新思路举措，积极推进信息化基础设施建设，大力促进信息技术与教育融合应用，全力推动教育信息化2.0行动实施，以先行一步的姿态打造“数字化、智能化、艺术化”的智慧教室，探索出一条文化与科技融合、艺术与技术统一的高校教育信息化发展新形态，也为全国智慧教室建设提供了可复制、可推广的经验。'],
          img: [
          ]
        },
        bottom: {
          title: '',
          img: [
          ]
        }
      }
    },
    {//2021-2-2，amanda，阮宏宇
      title: '培训，如何让客户来访感觉更满意，叁昶这样做，简直了！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743565621-8dd899bc-5b02-478d-bbfc-ce1ca106d765.jpeg',
      linkTo: "/instanceItem?type=technology&num=16",
      details: {
        top: {
          title: '培训，如何让客户来访感觉更满意，叁昶这样做，简直了！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743565816-e92c901d-ca4e-4de1-a746-e1e02e499c72.jpeg?x-oss-process=image%2Fresize%2Cw_825%2Climit_0'
        },
        lunbo: {
          title: ['辞旧迎新春，值此2021年新年来临之际，公司<strong>自主设计建设</strong>的<strong>智慧教室理念在学习强国刊登</strong>，即将引来<strong>一大波客流</strong>，为了以<strong>最好的状态</strong>迎接预约参观考察<strong>智慧校园5A级景区</strong>的大客流，公司小伙伴主动到<strong>叁昶公司</strong>自己设计建造的<strong>上海财经大学智慧教室</strong>进行信息化业务培训。', '<strong>公司常务副总曹鸣浩</strong>对培训活动提出了<strong>“勤”、“实”、“精”</strong>的三字要求，要求大家<strong>认真投入</strong>，做到<strong>融会贯通，学以致用</strong>。', '室外<strong>寒风刺骨</strong>，室内<strong>暖意如春</strong>，小伙伴们的学习劲头都很足，通过公司讲解员的讲解了解到我们打造的智慧教室的<strong>三大特点：炫、靓、酷</strong>，充分认识到“<strong>文化+科技</strong>”的融合打造出不一样的现代智慧教室与“<strong>艺术+技术</strong>”，重塑教学新生态的智慧教室<strong>“新”理念</strong>，让新媒体新技术在教书育人上<strong>“活”了起来</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743548606-d8a46151-ad4d-4c9c-a05b-8f44e0ffd985.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743548609-6dea2dae-078a-4871-99b7-f65c7e676c44.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743548861-4d6d11ce-f57a-477c-9e59-e24e5bbc1e61.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743548589-f542e481-af6d-426c-b975-9a40290e1127.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743548587-ccde5ccb-3b39-478c-9304-84f633adcaa7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743549113-d0345989-488f-4a8e-8d97-5a3b908fc93f.jpeg'
          ]
        },
        bottom: {
          title: ['本次公司组织的2021年<strong>第一季度信息化内训</strong>，旨在<strong>全面提升</strong>公司员工<strong>信息化素养</strong>，着力打造<strong>学习型团队</strong>，不断<strong>提升服务水平</strong>，也是积极为公司打造的<strong>智慧教室5A级景点</strong>的宣传推广做好充分的接待准备工作。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743556156-353c77f1-4def-4469-bb72-99955c2f88cc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743556133-6aa1a35d-96bd-4020-a0f7-29ad3b08c9c5.jpeg'
          ]
        }
      }
    },
    {//2021-1-5，amanda，龙明发
      title: '我们打造的智慧校园5A级景区',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744202363-d3706904-3899-47a0-9e40-2b85f2249a85.jpeg',
      linkTo: "/instanceItem?type=technology&num=15",
      details: {
        top: {
          title: '我们打造的智慧校园5A级景区',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744202473-0e65084a-6e90-4f7b-bfcb-5a09b61f51de.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['近期，<strong>上海财经大学</strong>委托<strong>上海叁昶文化科技有限公司</strong>设计打造的“<strong>数字化、智能化、艺术化</strong>”的<strong>智慧教室</strong>已完美呈现，<strong>叁昶</strong>探索出一条<strong>文化与科技融合</strong>、<strong>艺术与技术统一</strong>的高校教育信息化发展新形态，也为全国智慧教室建设提供了<strong>可复制</strong>、<strong>可推广</strong>的经验。', '“<strong>文化+科技</strong>”的融合打造出不一样的现代智慧教室；“<strong>艺术+技术</strong>”的统一让智慧插上了翅膀。', '此次<strong>叁昶</strong>打造出来的智慧教室从<strong>顶层设计</strong>着手，全面推进现代智慧教室的建设，搭建强大的<strong>数字教学平台</strong>，在顶层设计引领和数字教学平台支撑下能够在<strong>更广泛</strong>和<strong>更丰富</strong>的场景里<strong>支持各种教学、研讨、自学、分享与探究</strong>等多种多样的学习场景，进一步将课堂<strong>可视化、个性化、人性化</strong>，通过这样的智慧教室氛围打造，养成学生<strong>主动学习、终身学习、勇于探究、善于合作</strong>的习惯与特质，以适应新时代社会<strong>多元性的发展与变化</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744164037-f17022c8-858a-405f-84b9-3ef02e8ec30d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744170502-20f22a46-dc1c-40d6-aed6-de5b5f50cbe7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744172302-6c1a3167-5707-43b6-a9b5-6a30df42448a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744172303-af8c6a30-bd1d-4501-b334-cff0241af4b3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744172282-4ab7dc7b-2d00-454e-aeef-1d59f3bef517.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744172322-505422b6-e2cb-40e5-abe5-1a8157c18caf.jpeg'

          ]
        },
        bottom: {
          title: ['“<strong>智慧校园</strong>的建设固然需要<strong>扎实的信息化基础设施建设</strong>，但更<strong>离不开顶层设计</strong>”，叁昶打造智慧校园的关键在于智慧“<strong>日知为智、心悟为慧</strong>”，这意味着智慧校园要和高校的<strong>教学、科研和文化、艺术深度融合</strong>，通过良好的顶层设计，培养具有<strong>创新精神</strong>和<strong>创造能力</strong>的<strong>个性化人才</strong>应该成为高校发展中的<strong>重要目标</strong>，智慧校园由此从一种<strong>外部的创新力量</strong>转变为<strong>内生的驱动力</strong>，不仅能够提升学校的<strong>核心竞争力</strong>，也能够为整个教育行业带来一种新生态。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661743805114-5f16083a-908a-4784-b3b5-e3f41f915e4f.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744490414-47b08831-30d6-4f3c-b17f-b868b308b9d7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744492262-1b194b05-92fa-4bb8-912b-f0ede876098a.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744492224-f127f10d-05cd-476b-821c-44aae3d3cd07.jpeg'
          ]
        }
      }
    },
    {//2021-1-6，amanda，阮弘宇
      title: '上海外国语大学附属中学杜越华校长一行来到上海财经大学参观考察叁昶打造的5A级景区智慧教室',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744593067-fd70490d-c992-4fb4-849c-8e544470abf0.jpeg',
      linkTo: "/instanceItem?type=technology&num=14",
      details: {
        top: {
          title: '上海外国语大学附属中学杜越华校长一行来到上海财经大学参观考察叁昶打造的5A级景区智慧教室',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744593135-8e429c04-a798-4f76-9c5e-d2929dfcfd80.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>新年</strong>上班<strong>第一天</strong>，<strong>上海外国语大学附属中学杜越华校长一行</strong>带队来到<strong>上海财经大学</strong>参观考察<strong>叁昶</strong>刚刚建成的<strong>智慧教室</strong>。<strong>艺术＋技术</strong>的<strong>完美结合</strong>，打造出智慧校园的<strong>5A景区</strong>，在这里我们的教育教学<strong>更丰富</strong>，在这里我们的老师学生<strong>更享受</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744579773-b403774f-83fb-4849-bcce-9311f5d2b8bc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744579807-0b21abbd-a1ab-42b7-8b5b-b5aea423411a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744579800-abab7e71-62b3-437e-b98c-43f30e0beb29.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744579810-10b0396b-90dc-49df-861c-076fb7eca124.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744579809-ed599d16-d8d4-456b-9dbb-376fd650e5ec.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744580381-2da221bf-87f0-4eda-ac07-ee07b953d9c5.jpeg'
          ]
        },
        bottom: {
          title: ['智慧校园所设计的<strong>教室环境、区域氛围，</strong>所装备的<strong>视听、计算机、投影、纳米黑板</strong>等<strong>声、光、电</strong>设备，让教师更快捷方便地汇集教学信息，使课堂成为一个<strong>小小的浓缩世界</strong>，有利于培养学生的<strong>创新能力、批判性思维、想象力</strong>与<strong>认知能力</strong>，辅之以教学空间的<strong>整体艺术设计</strong>与<strong>信息技术</strong>的有力支撑，极大地提升了校园<strong>服务、治理、教学、科研</strong>的效率，也加速了<strong>因材施教、素质教育</strong>理念的实施，使其成为<strong>教育信息化</strong>发展的<strong>新典范</strong>.'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744587268-f22ba7f0-a837-4202-b53c-374183f2b6dc.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744587251-a6cc72b6-f038-41f6-9b27-e8e8432e4138.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-09-25，amanda，阮弘宇
      title: '高质量高标准高水平丨叁昶暑期信息化建设完美收官，满格充电迎接开学！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744735592-8d5a9b96-2453-4e90-af82-6ed82b7370c5.png',
      linkTo: "/instanceItem?type=technology&num=13",
      details: {
        top: {
          title: '高质量高标准高水平丨叁昶暑期信息化建设完美收官，满格充电迎接开学！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744735694-c6bb0826-fef9-4b5f-b567-6fd8f1c16a0a.png'
        },
        lunbo: {
          title: ['叁昶公司在今年暑期对<b>十几所大中专院校</b>分别进行了<b>智慧校园</b>的<b>设计施工</b>，<b>智慧教室</b>设计和改造，<b>中职学校管理软件</b>开发、<b>标准化考场</b>设计施工、<b>多功能厅智能化集成项目</b>设计施工等，叁昶公司对每个项目的<b>安全性</b>、<b>稳定性</b>、<b>美观性</b>以及<b>创新性</b>等方面始终保持着<b>最高要求</b>，每个项目最终都得到了客户的的<b>一致认可和好评</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744722943-c831b864-ed92-47a3-9c72-e80e9a02d53a.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744723060-aaec1932-17ad-46dc-95e2-f0f9598c33ff.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744723421-e760540d-18f4-4156-83f8-ac428aab089b.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744723399-8532cd9d-fd4c-42aa-9b4f-bbdce4d96a52.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744723430-6f69da5e-5196-4b6c-a273-93e778777c51.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744725078-f261fe71-30a2-4317-8606-f86b5cc4e6c4.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744725139-9a5a9b64-0112-4572-a311-9b3be55ed9b0.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744725188-0795761d-1975-4c56-9294-5155fbd3c8be.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['叁昶公司为了确保在<b>开学前顺利完工</b>，公司的信息化团队在炎炎夏日顶着<b>酷暑</b>,在各个学校里紧张的忙碌着。近日，随着暑期多个学校工程即将<b>接近尾声</b>，为了进一步保证工程收尾的<b>质量</b>和工程施工的<b>安全</b>，公司领导及各项目组同事，冒着高温，逐一巡查<b>施工进度和质量</b>，丝毫不敢松懈。在巡视过程中，注重发现施工中存在的问题，<b>及时联系各方</b>解决问题，确保暑期工程能<b>按时按质量完成</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744731506-f0da8796-fb1c-4c99-8510-cbee1152027a.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744731976-32b25466-4a7f-4269-a1c6-38c0ff82e159.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744731640-a4d32a38-f80b-409d-8599-0439c2154ae4.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661744731986-8c733c07-f149-4469-bb9e-bde44e1f08aa.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-09-14，amanda，阮弘宇
      title: '情暖高原 大爱西藏丨叁昶公司顾问王志卫先生为日喀则市第二中等职业技术学校捐赠30万元',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744891260-5aa525f7-027b-4f4a-91d3-174a5cd1c502.jpeg',
      linkTo: "/instanceItem?type=technology&num=12",
      details: {
        top: {
          title: '情暖高原 大爱西藏丨叁昶公司顾问王志卫先生为日喀则市第二中等职业技术学校捐赠30万元',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744891264-479b7658-51f6-4b7e-8ae6-c7afee623b9f.jpeg'
        },
        lunbo: {
          title: ['在这个承载着<strong>春的希望</strong>，酝酿着<strong>秋的殷实，热情奔放</strong>的季节里，<strong>叁昶文化科技有限公司顾问王志卫先生</strong>在上海对口支援干部日喀则<strong>教育局副局长孙桂芳</strong>的陪同下，来到上海对口支援的<strong>日喀则市第二中等职业学校</strong>，与学校党委书记索旦及其他校领导们共同学习交流了<strong>职业教育</strong>和<strong>技能培训</strong>的经验和体会，并捐款<strong>30万元</strong>，用于学校<strong>智慧教室</strong>建设。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744877770-0b095709-1e26-4aee-88d8-2869d38c42f1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744877784-620147f0-3314-444a-828f-be565631af53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744877776-93b679a9-7e4c-447e-a836-e8c71430b0f1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744877821-74682fcb-7928-45f8-a989-900a7bd8ac2d.jpeg',

          ]
        },
        bottom: {
          title: ['<strong>日喀则第二中等职业技术学校</strong>是由西藏自治区人民政府投资兴建、由日喀则市人民政府属地管理、受市教育局业务指导的一所<strong>高起点、高标准、现代化、智慧化、特色化</strong>的<strong>中等职业技术学校</strong>。学校遵循“<strong>以文化为根、以技能为基、以发展为本、共创未来</strong>”的办学理念，以“<strong>厚德、自信、崇技、发展、成才</strong>”的校训，确立了“<strong>举办一流中职、支撑区域发展、培育大国工匠</strong>”的发展定位，把建成“<strong>国家一流区域特色职业院校</strong>”作为学校的<strong>发展目标</strong>，按照“<strong>创建合格职校—区级一流职校—国家品牌职校</strong>”三步走的发展路径，坚持中高职衔接、普职融通、学历教育与非学历教育并重、职前教育与职后教育并举，实施“<strong>依法治校、改革兴校、质量立校、人才强校、品牌宣校</strong>”五大发展战略，服务区域发展。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744884488-b553c72b-d2a8-43d4-ac2a-55a9b67625f7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661744884521-efd75ca1-79e6-47ba-9752-275125d14a43.jpeg'
          ]
        }
      }
    },
    {//2020-08-25，amanda，阮弘宇
      title: '叁昶首部VR电影——亮相上海市科技馆',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745029752-b26d0e19-4fd1-4c40-b16f-c060b2bd87ac.png',
      linkTo: "/instanceItem?type=technology&num=11",
      details: {
        top: {
          title: '叁昶首部VR电影——亮相上海市科技馆',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745029921-f61149f4-a1d9-41ce-829c-486835432804.png?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['此次叁昶公司出品的<b>VR电影是在复旦大学党委副书记、复旦医学院党委书记抗病毒专家袁正宏教授</b>及<b>上海公共卫生中心党委书记、全国抗病毒专家卢洪洲教授</b>的指导和帮助下耗时<b>半年时间</b>研发设计制作出来。', ' 叁昶公司组织<b>大量科技人才</b>制作这部VR电影，目的是想让市民对<b>新冠病毒</b>有一个更加<b>直观的了解</b>，也能让观众特别是小朋友们体验到科技魅力的同时学到有用的知识，本次活动免费体验哦。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745008862-7871d422-f8b0-4f70-9d4a-291b69a50971.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745008837-c605bb0c-141f-4e1b-9180-46bb20ce8027.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745008865-404bb917-28fb-41d3-9b6e-a4d0b15dc87c.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745008836-f6f6ee5b-3c9f-40bb-8fa0-c2a1a525e716.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: '8月18日是<b>上海科技馆</b>病毒展开始体验的第一天，虽然不是周末，但现场想来体验的观众<b>络绎不绝</b>，经过<b>叁昶小伙伴</b>的悉心解说下观众知道<b>无需排队</b>等待，只要<b>扫码关注公众号</b>即可预约拿号，<b>免费体验</b>。',
          img: ['https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745019124-7d5c8cb5-d9dd-4801-bc4e-b4f0aca517a2.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745019193-1afd9d6d-bc4f-4fda-b9d9-7a1e34ac7650.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745019257-e4a55b83-1eac-4bdb-ad21-93fc0ea38b2f.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661745019265-9a428503-22a6-4a12-a603-50b58f50a052.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-08-13，amanda，阮弘宇
      title: '叁昶大事件—上海市教委原主任、上海海事大学校长陆靖一行莅临叁昶进行调研',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745163214-0a2d682b-2395-42c4-aa46-bc4798e324d3.jpeg',
      linkTo: "/instanceItem?type=technology&num=10",
      details: {
        top: {
          title: '叁昶大事件—上海市教委原主任、上海海事大学校长陆靖一行莅临叁昶进行调研',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745163214-70032379-fcf1-44db-b817-f9c83c785589.jpeg'
        },
        lunbo: {
          title: ['近日，上海市<b>教委原主任</b>、上海<b>海事大学校长陆靖</b>、<b>市教委职教处副处长黄蕾</b>、上海市<b>贸易学校校长姜晓敏</b>、上海市<b>材料工程学校党委书记金怡</b>一行<b>莅临叁昶公司</b>进行工作调研。公司顾问<b>王志卫</b>、常务副总经理<b>曹鸣浩</b>及公司相关业务负责人<b>热情接待</b>并<b>全程陪同</b>。', '期间，叁昶公司就<b>自主研发</b>的“<b>中职学校校本数据分析诊断与改进应用中心</b>”建设应用以及智慧校园“<b>十四五</b>”<b>规划</b>等建设方面的工作进行了专题汇报。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745149877-95794a84-86f5-4f93-86be-3343fe33848f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745149824-90c99c73-69a2-48b9-90c1-8e80aef500e8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745149825-d9da3961-bb7f-457c-bbd2-a88580a88876.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745149836-242dcfba-3ac7-44f0-a2be-47d9e06b6bf0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745149824-6950556a-60f7-470f-b237-f360ab10a75f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745150467-455c8c51-dd17-40e8-a8d5-28de1fd02750.jpeg'
          ]
        },
        bottom: {
          title: ['陆校长对叁昶文化科技对教育事业的关注给予了<b>高度肯定</b>，他表示叁昶文化科技的“<b>中职学校校本数据分析诊断与改进应用中心</b>”研发建设以及智慧校园“<b>十四五</b>”<b>规划</b>等工作能切实推动信息技术与教育教学、日常管理的<b>高效融合</b>，为校园教学信息化、智能化提供新的助力。此外，他鼓励<b>叁昶文化科技</b>进一步<b>加强研发</b>，继续用信息技术驱动教育教学发展创新，<b>为上海教育</b>推进学生综合发展<b>提供更多技术支撑</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745157546-1e523934-f984-47dc-a1bb-2c2e3128ce52.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661745157569-3aef811e-420e-470d-a927-3336fe9dd83f.jpeg'
          ]
        }
      }
    },
    {//2020-08-11，amanda，阮弘宇
      title: '实用是王道！叁昶信息化设计方案部分经典案例',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749499746-cfcfa7b4-d9c4-47f0-adaa-a052fa52a4e0.jpeg',
      linkTo: "/instanceItem?type=technology&num=9",
      details: {
        top: {
          title: '实用是王道！叁昶信息化设计方案部分经典案例',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749499739-97776d04-cc76-474c-ae72-7f7815920696.jpeg'
        },
        lunbo: {
          title: ['公司严格遵循<b>校级考试管理指挥平台系统</b>建设目标，严格按照教育部制定的<b>《国家教育考试网上巡查系统视频标准技术规范》</b>要求建设，实现所属考场、试卷收发室、考点主控室实时网络远程监控、管理。同时，通过网络通讯技术，实现各级考务指挥中心、考点间的监控视频图像<b>互联</b>、<b>互通</b>，达到资源<b>共享</b>、<b>可信</b>、<b>实时</b>、<b>高效</b>的考试指挥、监控和管理。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749483136-95aa30ba-47b5-4b79-855d-b380a7fd17e3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749483165-b0280371-be9f-41b5-8a3f-96265479d79e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749483130-1be4c859-bdcb-4af7-9fca-264921970948.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749483142-d2855e53-163f-4ce6-898c-92daaf89642b.jpeg'
          ]
        },
        bottom: {
          title: ['叁昶公司在今年暑期对上海对外经贸大学、上海市交通学校、上海市商业学校等<b>几十所各类院校</b>分别进行了<b>智慧校园</b>的设计施工，<b>智慧教室</b>设计和改造，<b>中职学校管理软件开发</b>、<b>标准化考场</b>设计施工、<b>多功能厅智能化集成项目</b>设计施工等，叁昶公司对每个项目的<b>安全性</b>、<b>稳定性</b>、<b>美观性</b>以及<b>创新性</b>等方面始终保持着最高要求，每个项目最终都得到了客户的的<b>一致认可和好评</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749492217-3f0e137b-6778-4614-b131-4c7156cc9520.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749492236-532b9ab0-b7d3-405d-bce7-1a9590241f5e.jpeg'
          ]
        }
      }
    },
    {//2020-06-15,amanda,龙明发
      title: '【喜讯】叁昶研发上海中职校诊断与改进应用中心项目顺利通过市教委验收！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749643739-065a6980-8707-4fdb-93d4-7a91e9631f37.jpeg',
      linkTo: "/instanceItem?type=technology&num=8",
      details: {
        top: {
          title: '【喜讯】叁昶研发上海中职校诊断与改进应用中心项目顺利通过市教委验收！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749643821-fba2108e-f1f4-43b8-9063-b9c0d645f39f.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['日前，叁昶公司研发的<strong>“上海中职校诊断与改进应用中心”</strong>项目顺利通过上海市教委有关部门组织的市级层面验收工作，评审专家给予了充分肯定和赞赏，为历时两年的项目画上了一个圆满的句号。公司助力上海市教委推进中职教学诊改工作，紧紧依托中职第六协作组成员学校，以<strong>“共商 共制 共建 共享”</strong>建设理念，显特色、破难点、促改进，在全国诊改专家帮助下，在协作组学校的鼎力支持下，我们“先试先行”，不忘初心，砥砺前行，继续为全市中职学校诊改工作不断凸显实效，提升质量意识做出贡献。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749600584-ee62cd0b-00c5-4cd1-948c-8fd9f20d827a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749600594-84ec2201-f44f-43cf-889d-21076fcee77c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749600583-fa0a0f5c-8915-48be-9f45-201043d72b27.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749600587-31f35dc5-af50-4674-bd17-f31cb6b42ccb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749600595-327527b5-eb79-45d1-a79b-cae59344838d.jpeg'
          ]
        },
        bottom: {
          title: '',
          img: [

          ]
        }
      }
    },
    {//2020-06-02,amanda,龙明发
      title: '上新了!法院虚拟演播室惊艳亮相，叁昶带您揭开法院“神秘面纱”',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749747648-27f45a3f-9298-45d4-ab52-6533d70c7f14.jpeg',
      linkTo: "/instanceItem?type=technology&num=7",
      details: {
        top: {
          title: '上新了!法院虚拟演播室惊艳亮相，叁昶带您揭开法院“神秘面纱”',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749747748-e69f9423-0933-4d5f-a1b2-e7472612c372.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['信息化已经成为当代必不可少的发展趋势，这种潮流波及到各行各业，其中，叁昶有幸成为<strong>上海市第二中级人民法院</strong>的虚拟演播室建设的承建方。虚拟演播室是近几年发展起来的一种独特的电视节目制作技术，它将电脑制作的虚拟三维场景与电视摄像机现场拍摄的人物活动图像进行数字化的实时合成，使人物与虚拟背景能够同步变化，从而实现两者完美融合，以获得真实的画面。', '虚拟演播室建设标志着二中院在积极适应新媒体时代信息传播规律，大力推进“互联网+”法治宣传，打造法院全媒体多元化法治宣传平台方面又迈出了坚实的一步。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749741070-badbf204-dba7-45d0-b1af-62fd7dbcbdd4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749741069-047e9d74-0f6c-46ee-a32f-b3059469244d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749741080-4b79f047-f5e7-4241-89b4-7aca9ebb7ce4.jpeg'
          ]
        },
        bottom: {
          title: '',
          img: [

          ]
        }
      }
    },
    {//2020-06-02,amanda,龙明发
      title: '叁昶入围校园新冠肺炎防疫物资供应商',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749885854-1c6970df-74bd-46a5-a7fb-40aec9f24ba3.jpeg',
      linkTo: "/instanceItem?type=technology&num=6",
      details: {
        top: {
          title: '叁昶入围校园新冠肺炎防疫物资供应商',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749889841-5714610e-9d0b-4fea-a554-62ffee684513.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['我们在校门口设立的测温点，里面的“摄像头”带有人体测温能力和人脸抓图分析能力，只要体温高于了设定的温度，“摄像头”就会发出高温预警并且会将高温的状态的图片进行捕捉、保存，管理人员也将在第一时间对被报警人员进行全面检查。', '热成像测温设备每分钟约可通行<strong>30-40人</strong>左右大大提高了人员流动的效率，避免了人流拥挤下的测温情况。“无接触式测温” “大规模人群实时体温测量”“自动抓取发热人群”这三个特点，也是红外体温快速筛查在防控新型肺炎时能发挥关键作用的主要原因。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749856788-b9f261e9-0f42-47d8-9165-02763c8f02dc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749856790-64c40850-ae60-426d-b5b6-27af4e2c1ad1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749856784-c5cbb276-f273-4987-9dbb-3cc2c7b00539.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749856962-f2250e66-9d25-45b9-bcb4-d0f7963d45f4.jpeg'
          ]
        },
        bottom: {
          title: ['开学在即，叁昶积极落实<strong>国家和本市关于防控疫情，工作部署与要求，</strong>服务近<strong>200家学校</strong>，在三四月份依然在前线为学校安全保障服务，坚持把师生的安全<strong>放在首位，</strong>为保障留校师生、学生返校创造必要的条件!'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749873941-5ed65c22-04f1-40d3-b671-fa85dd9353c9.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661749873969-9f5d3533-01a2-4d09-ae2f-b31940b25325.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-06-01,amanda
      title: '叁昶公司高光时刻——“上海中职校诊断与改进应用中心”项目完美验收',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750021690-4235521b-66ef-4027-b97d-602dee68a17f.jpeg',
      linkTo: "/instanceItem?type=technology&num=5",
      details: {
        top: {
          title: '叁昶公司高光时刻——“上海中职校诊断与改进应用中心”项目完美验收',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750021689-9326e282-ac5e-46f0-805a-059df73de532.jpeg'
        },
        lunbo: {
          title: ['公司助力市教委中职教学诊改工作，以“共商 共建 共推 共享”建设理念，显特色、破难点、促改进，服务上海中职校，在全国诊改专家帮助下，在协作组学校的鼎力支持下，我们“先试先行”，不忘初心，砥砺前行，顺利完成“上海中职校诊断与改进应用中心”项目验收。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750008507-ffb3b9b5-3d5f-4cf8-be56-2441f3ea968d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750008509-840165fd-eb4b-4961-942c-61d0e87c539e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750008621-d718482d-6184-4b25-9862-6f393afd3f18.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750008510-723cb69e-5354-411f-97d5-f0cb1c2e0636.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750008520-54e05c36-56d5-4bcd-a3db-0fdd15b8c3a2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750009199-a6e670ea-130b-41e8-9ca6-630468f7f085.jpeg'
          ]
        },
        bottom: {
          title: ['500多个日夜拼搏、不下50场各类研讨近百次技术优化会议……目标就是研发出适合中职诊改发展之路，奏响诊改工作“事前、事中、事后”三部曲，创建8字形质量改进螺旋。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750015821-b294abd9-8fda-446a-9560-9473433fea3b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750015831-a1400ae2-bf4c-48b9-8511-cd979893a38f.jpeg'
          ]
        }
      }
    },
    {//2020-04-16,amanda
      title: '智慧教室展厅里有“黑科技”？快来一睹为快吧！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750161922-26eff38e-7022-4c17-a7cc-555f2f44f637.jpeg',
      linkTo: "/instanceItem?type=technology&num=4",
      details: {
        top: {
          title: '智慧教室展厅里有“黑科技”？快来一睹为快吧！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750162098-3f7494ad-0390-4103-b52d-fc98e054e612.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['历经两周的精心设计打造，叁昶智慧教室展厅于本周隆重上线！公司将以更加精准的专业技术，为客户带来更好更优质的服务体验，为校园“信息化”发展贡献自己的力量。我公司积极探索研究，实地调研，通过座谈会的形式，与多所学校的学生和教师展开了多次的交流沟通，旨在及时发现存在的问题、了解学生、教师及管理者的需求，结合近年来教育部对教学信息化建设有关政策，提出“<b>智慧教室全覆盖智能校园全方位，软硬件互联互通</b>”的解决方案。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750146958-9e710956-e0ba-44d5-bcca-7a3fc63e34f6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750146973-fe0001fb-d7d2-42ed-9150-c94f6bc0b722.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750146978-cf6356ef-e4f9-4045-84ff-60ae19e07bf5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750146980-d14dbcd4-a232-44da-838e-8cd8ec033633.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750146970-f72f4e7f-95dd-453c-aa6a-7e931e852ff4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750147660-ec507aae-9597-408f-ac7a-658f200982bc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750147742-5f51b415-9a1f-4d7d-bbcd-91b372b72175.jpeg'
          ]
        },
        bottom: {
          title: ['教室作为教学的主阵地，是教师授课育人的地方，是学生获取知识提高自身修养素质的地方。随着信息化技术的发展以及在教学中的应用越来越广泛，教室环境的布置、教学设备的设置、更加智能的运维模式等对教学质量、教务管理有着直接的影响。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750156056-23c45166-bfeb-4f21-8649-d87c49c61cca.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750156056-9a466b59-fbfb-42ee-b909-799dcd66858b.jpeg'
          ]
        }
      }
    },
    {//2020-01-08
      title: '叁昶走进临港自贸区新片区助力教育现代化',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750290881-667fb682-ac9e-4ea1-b499-01d994a401bf.jpeg',
      linkTo: "/instanceItem?type=technology&num=3",
      details: {
        top: {
          title: '叁昶走进临港自贸区新片区助力教育现代化',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750290899-0f38703f-1c10-455a-b28f-283ddcdf4f0f.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['11月25日，叁昶文化科技公司有幸参加上海临港区域高校联盟教学协作组工作总结及教学研讨会议。上海市教育科学研究院院长兼上海市教委高教处处长桑标、上海市教委高教处副处长赵丽霞、上海电机学院校长胡晟、副校长杨俊杰及上海海事大学、上海电力大学、上海海洋大学、上海建桥学院等五校教务处长出席本次会议。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750275994-1986a1c8-dbe0-4cb0-9eb9-be54074ef093.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750276023-14b47400-2f13-4d38-a553-de6d4366c581.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750275965-14f22d89-fefb-4304-99db-6bd339858829.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750275977-ff9652d4-191c-4825-b497-a31622f85e38.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750275989-94162bef-a2f8-4927-8742-9a96276f2d0b.jpeg'
          ]
        },
        bottom: {
          title: ['教育部印发的《教育信息化十年发展规划（2011—2020年）》明确提出：“以教育信息化带动教育现代化，是我国教育事业发展的战略选择”。2019年11月25日，叁昶公司带着“智慧教室建设方案”参与了上海临港区域高校联盟教学协作组工作总结及教学研讨会。会上公司常务副总曹鸣浩以“智慧教室全覆盖—智能校园全方位—软硬件互联互通”为核心建设理念进行了详细阐述，得到与会领导、嘉宾一致好评。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750283087-ffafe72e-eda0-45de-9154-2522e8094273.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750283116-ae59d6ac-5858-4358-b91e-af6c3260b99a.jpeg'
          ]
        }
      }
    },
    {
      title: '创新智慧的教室建设开发',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750402912-52fba09f-35aa-4d69-89db-0c778faa0bf7.jpeg',
      linkTo: "/instanceItem?type=technology&num=2",
      details: {
        top: {
          title: '创新智慧的教室建设开发',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750402924-0d87e280-7b49-4a66-b1c0-6fd3aee9043f.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['公司有强大的软件研发能力，核心团队成员长期服务教育领域和IT行业。产品依托物联网、云平台、移动互联、大数据、传感器、射频识别等信息技术手段，秉承先进教育理念，打造集智慧教学、智能管控、规范监控及一体的新型现代化智慧教室。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750394324-e958937b-f29d-42e1-8146-81f7a2625610.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750394872-2dee3313-777e-45a4-b9b5-22c580bf3992.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750394662-33f9f9ec-c89b-42cd-bae6-6c8de8fd7028.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750394879-cb62b59a-2738-4b6d-9aef-43522daca629.jpeg'
          ]
        },
        bottom: {
          title: ['此外根据高校教学需求，公司设计开发了如班主任网上管理考评系统、教师网上测评系统、学生自我管理系统等多个适应学校使用的教学管理软件，提升教学管理的科学性、规范性、便捷性。'],
          img: []
        }
      }
    },
    {
      title: '上海市中等职业学校教学诊断与改进数据应用与分析建设项目',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750504484-b182a05a-545e-4cb0-b49a-1a1db3a9bdf5.jpeg',
      linkTo: "/instanceItem?type=technology&num=1",
      details: {
        top: {
          title: '上海市中等职业学校教学诊断与改进数据应用与分析建设项目',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750504499-87dee505-3bc5-4b75-acf0-7f44112a2e89.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['为贯彻落实《教育部办公厅关于建立职业院校教学工作诊断与改进制度的通知》和《关于做好中等职业学校教育改进工作的通知》要求，结合上海教育综合改革成效和特点，上海市教委制定学诊断《上海市中等职业学校教学工作诊断与改进实施方案》要求各校积极推进上海市中等职业学校教学工作诊断与改进工作。诊改工作是周期性常态化的工作，在复核工作中要体现上海办学水平，要具有标兵作用；“8”字螺旋的关键在于信息化水平，提高信息化水平建设，把平台做“活”，才能对过程性数据的诊断与改进有着防患于未然的作用。因此需求，公司承接并设计开发了中职学校校本数据分析诊断与改进应用中心在上海市教委和经信委的大力支持下，为期两年的中职诊改中心已经进入到最后的数据测试阶段，并成功入住教委云平台，即将迎来成果验收。 在项目建设中，协作组发挥“共商、共建、共推、共享”精神，团结协作，共同摸索上海市中职诊断改进的实施路径，收到了一定的效果。于9月12日上海市中等职业学校教学诊断与改进数据应用与分析建设项目汇报会上，研发团队陈老师演示了诊改数据分析应用中心功能，得到了与会专家的高度认可。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750490485-f5b393be-7bbc-4e7b-8706-368f68074677.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750490668-40455872-bb21-44ad-be23-4daec1941903.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750490495-14d915e0-7102-40dd-ad0d-3f629aeb908c.jpeg'
          ]
        },
        bottom: {
          title: ['项目汇报会于9月12日上午在上海市材料工程学校行政楼一楼会议室召开。全国诊改专委会主任杨应崧教授（左二）、副主任周俊（左三），项目平台组专家何锡涛（左一）等专家莅临指导。在听取本次汇报后，专家们高度评价了项目建设内容。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750498126-78e8d47a-e1c8-4622-96e2-ea3acda47e61.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750498121-53a7e833-4537-4577-9a19-072367e4e531.jpeg'
          ]
        }
      }
    },

  ],
  // 服务类
  serviceList: [
    {// 20240729 周晓强
      title: '顺利召开！叁昶保障浦东国际机场2024年中期航空公司工作交流会圆满结束',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245325608-75055313-e6ba-4676-8273-f7fdebcbd33f.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=31",
      details: {
        top: {
          title: '顺利召开！叁昶保障浦东国际机场2024年中期航空公司工作交流会圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245325608-75055313-e6ba-4676-8273-f7fdebcbd33f.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['7月29日，叁昶助力<strong>浦东国际机场2024年中期航空公司工作交流会</strong>于上海国际会议中心顺利召开。',
            '上海国际机场股份有限公司浦东国际机场总经理黄铮霖出席并发言。浦东机场各基地航司关键业务的领导，机场47家国外航司的航站及营销部门的负责人莅临出席，共同见证和谋划浦东机场未来枢纽发展的蓝图。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245352680-4d61d739-a047-43e6-addf-1b0ba3207017.jpeg?date=1753346046119',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245351472-7bfd112b-c2f4-4d5c-ad7b-c16fb665633a.jpeg?date=1753346046111',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245345202-53361eda-68c6-4eb3-918c-67f5132484d2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245351694-bfb71b23-2c4a-4668-bcc1-ad3c34e23f4b.jpeg?date=1753346045931',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245353873-88e98935-1184-4df1-9abd-c58afe8ce9d0.jpeg?date=1753346045935'
          ]

        },
        bottom: {
          title: [
            '<strong>以进促稳，凝心聚力推动高质量发展。</strong>会议从航空枢纽、服务体验、运行效率和科技创新四个纬度进行了浦东机场2024上半年工作回顾及2024下半年工作展望，现场外航协会代表、国内航空公司代表及各航司交流发言。',
            '<strong>以细节为抓手，助力圆满落地。</strong>本次交流会整体流程策划、环境布置、视觉设计、落地执行均由叁昶团队精心负责，以细节为抓手，保障了浦东国际机场2024年中期航空公司工作交流会圆满结束，受到主办方高度好评。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245677447-f514f86c-5b37-4a34-a170-d90307123714.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245679026-e77a5419-ccc2-4294-8ce1-7779458d4e74.jpeg?date=1753346045910',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245676864-08af9e27-db6c-48a5-ae41-d519e4d03857.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245679471-387d6aa7-1975-41d9-8652-5b6c2463cb5f.jpeg?date=1753346045908',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245676195-cebdd581-3ff9-431c-a3c1-112ebe50f5ef.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246181611-1fb21be7-3eb1-4bef-a515-650142751249.jpeg?date=1753346045969',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246182529-cf0963af-6b25-4452-918c-9ad6b14dce7d.jpeg?date=1753346045959',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246182379-c21c6654-b0e0-45be-9ae8-f2747773f001.jpeg?date=1753346045969',
          ]
        }
      }
    },
    {// 服务类 2021-12-28，阮弘宇
      title: '智·匠心，创·卓越丨由叁昶打造的世界职业教育产教融合博览会上海馆今天开展！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750650947-a1072e44-c166-4961-be63-df54c7ef7972.png',
      linkTo: "/instanceItem?type=service&num=35",
      details: {
        top: {
          title: '智·匠心，创·卓越丨由叁昶打造的世界职业教育产教融合博览会上海馆今天开展！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750651047-ea92ce56-85e4-4e5b-8fdd-a09246c6cf51.png?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>首届职业教育产教融合博览会</strong>将于2022年8月19-20日在<strong>天津</strong>举行,由<strong>中国职业技术教育学会</strong>牵头举办的<strong>世界职业教育产教融合博览会</strong>(以下简称博览会)将同期举行,博览会的主题为“<strong>大力发展适应新技术和产业变革需要的职业教育</strong>”。', '博览会采用“<strong>线上+线下</strong>”相结合的方式举行，设置了“<strong>云上博览会</strong>”平台，采用最新的“<strong>3D+360°</strong>”数字展览技术，搭建中英双语实时播出的平台环境，实现全天候开放式信息流通和资源共享。大会将打造形成“<strong>一会、一赛、一展、一联盟</strong>”的职业教育国际交流合作崭新平台和范式。', '<strong>叁昶公司</strong>很荣幸参与<strong>博览会上海馆</strong>的展台策划设计制作等服务，为上海集中呈现职业教育<strong>高质量发展成就</strong>、职业教育<strong>服务发展成果</strong>和职业教育“<strong>产教融合、校企合作</strong>”办学特色的完美展示做出叁昶的力量。', '上海馆云展览链接:', 'http://ve.cool360.com/SHExhibition/index.html'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636112-6f6edf77-1ba1-463a-9fa9-0493975b50e7.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636133-a2460270-95ff-4f8b-b2fc-86491d572a1b.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636136-83ebba97-7001-444f-95ac-373e5a6af4b5.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636143-ea8ecf14-9d5a-4e8f-88c6-6943d0fb04c0.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636140-ccb31178-17f3-43f8-889e-0b550f9027ba.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['公司策划的上海馆围绕“<strong>智·匠心，创·卓越</strong>”主题，通过<strong>“育人之道”“数智之核”“合作之基”</strong>三大版块，将<strong>艺术与技术、文化与科技</strong>相结合，以精美生动的图片、精心制作的视频、精彩纷呈的案例，<strong>全方位、多层次</strong>展示了上海职业教育的现代职教体系构建、数字化转型优秀成果及“产教融合、校企合作”办学模式，充分彰显了<strong>上海特点、职教特色、时代特征！</strong>', '<strong>育人之道-多维度构建“技能成才”</strong>体系，上海<strong>勇立改革潮头</strong>，敢于先行先试，成功打造了具有<strong>世界水平、中国特色、上海特点</strong>的区域现代职教体系。', '<strong>数智之核-新科技打造“技能创新”</strong>高地，抢抓<strong>数字化战略</strong>机遇是职业教育增强适应性的关键，作为<strong>全国教育数字化转型试点区</strong>，上海全面推进数字化转型工作，形成职业教育现代范式。', '<strong>合作之基-全方位展现“技能报国”</strong>成效，上海秉持<strong>开放合作、互学互鉴、互利共赢</strong>的职教理念，积极提升校企协同育人成效，向全国以及海外输出<strong>上海风格职业教育</strong>，推广中国特色职教方案。', '展馆采用<strong>3D定制</strong>视频技术，通过LED透明屏呈现大飞机、卫星、火箭等上海高端制造成果，带来<strong>超惊艳、极震撼</strong>的视觉享受；实时展示以大数据为基础打造的<strong>上海职业院校诊断与改进应用平台</strong>，满足个性化、沉浸式的互动体验；综合文字、图片、视频讲述<strong>上海市教育信息化应用标杆培育校</strong>的智慧校园建设及应用实践探索，提供<strong>全方位、多层次</strong>的经验启示。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643284-8f6e9a8b-0f8c-47eb-a0e2-a52e664e1b18.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643301-dece7431-65a6-488e-bb6f-48332af26663.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643303-a1db4499-c573-4b56-8452-19fb44b9ec6a.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643304-80c13cad-ec50-4411-8725-cc2c9062823c.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-12-28，阮弘宇
      title: '当“博士后”遇到“叁昶”后丨我们在佛山打造“上海一条街”讲述上海博士后精彩故事！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750886701-c412ee8d-381d-4c57-b16d-cd30128d39e5.jpeg',
      linkTo: "/instanceItem?type=service&num=34",
      details: {
        top: {
          title: '当“博士后”遇到“叁昶”后丨我们在佛山打造“上海一条街”讲述上海博士后精彩故事！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750886793-336b1733-3c5a-4d8a-a581-6b5a7759f5ea.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2021年12月18日，由<strong>人力资源社会保障部、广东省人民政府</strong>共同主办的<strong>第一届全国博士后创新创业大赛</strong>在广东省佛山市隆重举行！', '举办全国博士后创新创业大赛，是<strong>贯彻落实习近平总书记在中央人才工作会议上重要讲话精神、大力实施新时代人才强国战略的重要举措，旨在推动全国博士后工作创新发展，充分激发博士后创新创业潜能，促进产学研深度融合，强化国家战略人才力量，助力科技自立自强。</strong>', '本次大赛是我国博士后制度实施以来举办的<strong>规模最大、层次最高、覆盖面最广</strong>的全国性博士后创新创业赛事。大赛以<strong>“博采科技精华，创新引领未来”</strong>为主题，共设<strong>创新赛、创业赛、海外（境外）赛</strong>和<strong>揭榜领题赛</strong>等四个组别，分为新一代信息技术、高端装备制造、新材料等<strong>八个专业领域</strong>进行比赛。大赛期间，还设置了近9000平方米的博士后工作成果展示专区，各省区市和部分高校、科研院所、重点实验室、博士后创新平台参会设展，并借助VR技术手段同步线上布展。', '<strong>叁昶公司</strong>很荣幸参与第一届全国博士后创新创业大赛及工作成果展，主要负责<strong>上海地方馆、复旦大学馆，交通大学馆，同济大学馆</strong>的展台策划设计搭建及落地保障等服务，为上海人才队伍科技创新成果的完美展示做出<strong>叁昶的力量</strong>。', '为更好地讲好<strong>上海故事</strong>，上海馆的设计采用了一体化的理念，<strong>叁昶</strong>为上海市人力资源和社会保障局与上海交通大学、复旦大学、同济大学<strong>打造“1+3上海一条街”</strong>，“1”即上海地方馆，“3”为三所高校馆，通过打造上海一条街来给予观展者<strong>一站式畅通</strong>的参观体验。上海一条街的两侧顶部是黄浦江两岸建筑的剪影。同时，将会用外轮廓LED跑马灯来对建筑剪影进行装饰，效果十分酷炫。三所高校的校门也被进行了艺术化处理还原，放置于各高校馆的入口处。', '叁昶打造的上海人才队伍科技创新成果<strong>展示一条街</strong>，展台设计从提案到定稿中间经历了数次修改，中间又经历疫情的延期，但是<strong>叁昶从来都不畏艰难</strong>，我们心中的目标是<strong>用最好的理念做最好的效果</strong>。按照设计搭建方案，经过我们<strong>快速、专业，精益求精</strong>的精神完成展台的前期搭建工作以及展品展示工作。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864622-2e27c3c3-076f-45ff-8698-b6347f468919.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864628-02b6eb2a-6cbe-444c-a93e-0fd6999b250f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864631-c1c65588-4ef7-48d7-81ee-6e6359b07f0a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864638-fe5ffe7c-dd0c-463f-9cb1-2a11fb3f2ec3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864637-4f7a27be-8d9e-411f-9ce0-2943ac750bb0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865141-c657bb2a-d400-47e3-9a06-126fd7a259ff.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865175-3629fccd-76b8-4046-aaf3-49d557769c0b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865270-d0a03c38-88b4-495f-b326-69aadc1d0f53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865472-ef027df3-7808-4457-b9a4-ff29e9392991.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865562-06c86925-b155-4207-af89-a2f37c81a84b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865733-10ab2d9d-48cd-473f-8e10-ecdf69e97ace.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865862-b05ffe18-86ae-451f-8a18-6809b1be4738.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866136-c425d261-da42-4736-8196-0fe26c38fa6e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866218-56fa084b-5b9a-4cc9-a03a-7a4d1ea52c20.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866256-cde0b010-2a43-4628-acf1-ad73fdf9bf6d.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>人社部部长张纪南及副部长汤涛</strong>参观上海馆悉心听取上海博士后工作成果介绍，并了解参展、人才培养等情况。此次大赛经过激烈角逐，最终获得<strong>7枚金奖，5枚银奖，8枚铜奖，奖牌数位列全国第二</strong>，上海市代表团、复旦大学代表团、交通大学代表团荣获<strong>优秀组织奖</strong>。', '叁昶全体工作人员始终以最佳的精神状态、饱满的热情，专业细致的服务赢得了客户的高度认可。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877096-ee736021-6bcc-4fe0-aced-1767547bd7be.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877102-67e9a55d-776b-4e49-a0c2-ca9a3922d30a.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877118-4f808692-a7cb-4934-9007-5ef488d4da5b.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877109-608a32e2-c65a-4e6a-96cb-62fd78ab2827.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877119-ff344528-6716-4ee7-9d7d-1dd4523dfd90.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877967-13027b61-a2a7-4f50-a56d-d3b675ac655f.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-10-22，阮弘宇
      title: '独家策划丨进实师生璀璨东艺',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751143752-d22ee27b-3d6d-40eb-a8d2-a4f73674b4d9.jpeg',
      linkTo: "/instanceItem?type=service&num=33",
      details: {
        top: {
          title: '独家策划丨进实师生璀璨东艺',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751144047-3cc68d77-f74a-4da4-b4eb-f972bc8032db.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['10月9日下午，<strong>叁昶公司</strong>精心策划的<strong>上海市上海市进才实验中学庆祝建校20周年主题活动</strong>在<strong>东方艺术中心</strong>圆满举办！各级领导、社会各界嘉宾、家长代表、历届校友、在校师生，济济一堂，共襄盛典。此次活动结合<strong>线上</strong>与<strong>线下</strong>，视频与图片双直播的方式，凝聚国内和海外的各方关注，超过<strong>数万人</strong>关注浏览！', '<strong>校长兼党总支书记杨龙</strong>在活动中回顾了学校的办学之路，他由衷感谢各级领导在学校发展过程中给予的<strong>亲切关怀</strong>，感恩社会各界对学校发展的<strong>鼎力相助</strong>。学校将在“<strong>崇尚理性 独立思考</strong>”校训的激励下，谱写浦东教育引领区的时代新乐章。', '学校<strong>交响乐团</strong>带来的恢宏的多媒体交响合奏<strong>《红旗颂》</strong>拉开了本次主题活动的序幕。学校师生带来了他们的20周年校庆献礼——原创配乐诗朗诵<strong>《因为有你，所以有我》</strong>，表达对学校的诚挚谢意、殷殷祝福。', '来自校园各个文艺社团的同学们表演了一组校园文化的展演秀<strong>《我们都是追梦人》</strong>，其中包含铿锵激越的民鼓表演<strong>《鼓舞青春》</strong>，优雅的芭蕾舞<strong>《追光圆舞曲》</strong>，典雅婉转的昆曲<strong>《西厢记·佳期》</strong>，以及民舞<strong>《茉莉花开》</strong>和歌舞<strong>《我们都是追梦人》</strong>。', '二十年的发展之路，对于一所学校，说长却短；但是，对于一个人，二十年的光阴说短却长。二十年，是从幼年到青年，从青年到壮年，从壮年到老年。学校<strong>短短的二十年</strong>发展史却在很多师生的人生中留下了<strong>长长的回忆</strong>。今天4位师生代表就带来了他们和进实不得不说的故事——音乐情景剧<strong>《光阴的故事》</strong>。历届获得<strong>星光少年</strong>称号的学生代表们也从四面八方来到了现场，他们带着<strong>感恩的心</strong>对一直以来支持<strong>"十大特长星光少年"</strong>评选活动的<strong>科慕化学（上海）有限公司</strong>表达感谢。', '<strong>叁昶公司</strong>还精心策划了启动仪式<strong>《启程·再出发》</strong>，展现出了进才实验中学的学校师生们对于共推学校未来发展的<strong>坚定信心和决心</strong>。活动最后，<strong>校领导、教职员工代表、学生代表、家长代表</strong>等共同合唱<strong>《不忘初心》</strong>，更将现场情感推上高潮。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122029-2df1dd31-152e-4d7f-95d3-997c050a65e8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122028-e922bbcc-6085-4f89-8d8a-5027e34c3aeb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122033-f3632e36-11ff-4178-9ed2-ac7af5fadbd4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122025-f33e50f7-cca5-41b4-b429-e229e1911d00.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122050-3419f92c-77ea-4b3a-8b8e-d54565af57c8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122510-ef44d24e-382b-4092-8cce-a5c1bfe13c40.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122584-e3d67ceb-4e1c-4d1b-b8d7-7de90c1bcb83.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122594-476ff656-edf3-4e25-b38e-8fe3500fdb81.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122703-208ce353-75d9-4e3a-b45f-62658404f0cf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123186-41d30e4c-dd80-4dad-a755-d50ed08b6c3c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123301-c0cc05fa-7158-49bd-8554-de25fa3953dd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123363-2dec6977-3a90-4212-bac9-af585e210c63.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123376-055da100-5d38-4f46-94f0-4aa30150aee5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123558-850465b6-c645-4cae-8ec6-6c99831f7877.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123608-30e195cc-8869-49d5-a135-c5db866ae6f5.jpeg'
          ]
        },
        bottom: {
          title: ['公司小伙伴多次赴<strong>上海市进才实验中学</strong>汇报校庆策划方案，并在具体深化过程中多次来校汇报商讨校庆<strong>各项事宜</strong>。此次校庆舞台上的精彩演出，都是学校孩子们和老师们<strong>不厌其烦，努力排练</strong>的成果，当然也离不开<strong>公司导演团队</strong>耐心细致的指导，辛苦了，认真彩排的每个你！', '现场演出当天，学生们都早早的来到演出化妆间进行长达<strong>三个小时</strong>的化妆准备，并一直在重复回忆各个表演动作，为你们点赞！当人们还在梦中沉睡之时，叁昶小伙伴<strong>通宵搭建</strong>现场演出场地，只为了<strong>完美呈现</strong>本次校庆活动，为你们加鸡腿！', '20周年是学校发展史上的<strong>重要里程碑</strong>，更是学校深化改革强化发展的一个新起点，<strong>叁昶公司</strong>非常有幸参与其中为学校服务此次20周年大会，得到了学校方和社会各界的<strong>广泛认可，叁昶</strong>祝全体<strong>进实人</strong>在未来的日子中继续<strong>坚守初心、砥砺奋进</strong>，以昂扬的姿态走在素质教育发展的康庄大道上！ —— <strong>上海叁昶文化科技有限公司</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133561-2867d7ea-d0e7-4c9d-96ee-191b28f50762.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133574-7e60f34f-3990-44a4-b6eb-d4beccf7025c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133589-0eaaead0-514e-4631-b5ea-21ed3171032f.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133602-88513d85-2ac9-4efa-b49e-75672f640c00.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133599-a0b248d4-4adf-4a51-9b8b-b41d58458d41.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751134288-cced1eb1-889b-4d09-a07f-41b130453ad0.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-09-22，阮弘宇
      title: '这个暑期叁昶注重文化育人，全新打造“看得见、听得到、亮得出”的校园文化',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751471549-33a5bff3-a883-40d9-aac6-e39d18813f66.jpeg',
      linkTo: "/instanceItem?type=service&num=32",
      details: {
        top: {
          title: '这个暑期叁昶注重文化育人，全新打造“看得见、听得到、亮得出”的校园文化',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751471552-e5cbf645-7ebc-4a9b-af42-0d7bc23e0d47.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>习近平</strong>在<strong>清华大学建校110周年校庆</strong>考察时指出，<strong>美术、艺术、科学、技术相辅相成、相互促进、相得益彰</strong>。要发挥美术在服务经济社会发展中的重要作用，把更多<strong>美术元素、艺术元素</strong>应用到城乡规划建设中，增强城乡<strong>审美韵味、文化品位</strong>，把美术成果更好服务于人民群众的高品质生活需求。<strong>社会责任和使命担当</strong>，是艺术高校办学的方向和宗旨，在建设一流大学的同时更应担负起服务社会的重任。', '教育部下发了<strong>《关于大力加强中小学校园文化建设的通知》</strong>。通知指出，<strong>校园文化</strong>是学校教育的重要组成部分，是全面育人不可缺少的<strong>重要环节</strong>，良好的校园文化，对培养德智体全面发展的中国特色社会主义事业接班人具有重要意义，各地必须<strong>高度重视</strong>加强<strong>校园文化建设</strong>。', '<strong>叁昶公司</strong>在今年暑期对<strong>近二十所大中小各类学校</strong>进行了校园文化的<strong>量身设计</strong>、改造和施工，公司致力于打造<strong>“看得见、听得到、亮得出”</strong>校园文化特色，对每个项目的<strong>安全性、稳定性、美观性</strong>以及<strong>创新性</strong>等方面始终保持着最高要求，每个项目最终都得到了客户的一致认可和好评。', '在设计学校走廊文化时，采用抽象概括的方法对其<strong>形态、造型</strong>进行概括，色彩上在校园LOGO的基础色上提高其明度等，每一个学科处赋予该学科<strong>专属颜色和标识</strong>。在设计单体墙面和党建文化时，大胆的撞色其中一种。校园LOGO上的色彩，形成视觉的冲击，依据不同楼道分布，组成一幅文化长廊。', '在设计的<strong>“歌声里的党史”</strong>文化长廊以党在百年奋斗历程中形成的<strong>伟大精神</strong>为轴线，串联重要史实，用红色音乐文化解读精神内涵，通过<strong>手机扫码</strong>唱享红歌，激励师生从党的光辉历史中汲取红色力量，筑牢信念之基，赓续<strong>共产党人精神血脉</strong>。', '在设计<strong>党建文化馆</strong>时通过五大版块：<strong>“开天辟地”、“改天换地”、“翻天覆地”、“惊天动地”，“艺路前行”</strong>，既令展厅的展示效果有叙事、有重点、有层次;也高度契合了<strong>“紧密团结在党的周围、一切以党的领导为中心”</strong>的这一<strong>党建主旨</strong>，点燃参观者心中最炙热的红色情怀。', '在设计以<strong>恰同学少年</strong>为主题的校园文化时，紧抓<strong>青春澎湃+电子科技</strong>为主要脉络，融入工业风与未来的世界打造年轻感，适度时尚感，动感，温馨科技感非冷酷不近人情的设计风格。', '<strong>专业实训室</strong>的打造是培养学生操作能力的一个重要场地，在学生的健康成长中发挥着<strong>至关重要</strong>的作用。设计紧贴校园文化内涵与专业发展进行不断更新，让专业教学更好地<strong>服务于老师、服务于学生</strong>。', '在设计以<strong>未来</strong>为主题的校园文化时，设计思路是让每一个学生都能学好，让每一个学生都能创造成长的奇迹，创造学生的<strong>无限可能</strong>，以无限为设计符号，校徽颜色为基本色彩，着意打造在传统文化背景下<strong>蓬勃发展</strong>的现代学校形象。', '设计的<strong>初心</strong>是为了发挥学校文化传播以及助力正能量的传递作用，因此在设计上紧贴学校文化特色，端庄大气，在材质上一定要<strong>采用耐用</strong>，具有<strong>防腐蚀、抗日晒</strong>的特点，特别精心设计的灯带在晚上也能给学校带来一抹文化色彩。', '设计是以<strong>学校文化为核心</strong>展开的，对学校文化LOGO的 图形<strong>（形）</strong>、颜色<strong>（色）</strong>、理念<strong>（神）</strong>、声音<strong>（音）</strong>做了整体延展设计，将这些元素融入到<strong>校园环境</strong>中，使人们在平时的生活、学习中，潜移默化的受到学校学校文化的熏陶。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453084-968e5846-cc69-4fd5-a6a4-982414c46ae5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453086-9a3971c4-db3c-468f-8c2d-7e833d6cfc50.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453082-2513b649-d469-4cf0-a358-3cf5d1e1279a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453085-ab8ea942-12d3-4c10-b4d6-3cadfcc9e50e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453125-3e36a4ae-9b82-4485-b944-57a527a3bc53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453681-c8a74d87-0484-4252-9bf2-81fecfabf884.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453775-44741a12-169d-4abc-ae65-e26374eb9d16.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453803-f54b750e-e8bd-48be-abbb-6df07e4ca472.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453998-9fb66a3f-964f-4adb-a106-8215719991fb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454232-a8c0358c-80c9-4d9a-9e99-997ca2354a5b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454480-445b3763-7904-4344-9ffb-0d2c576a454a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454474-5e8b2f9b-945d-46cf-a189-4c34ac512d3e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454523-7a08a55d-1be4-413a-8d44-779593f4bc13.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454547-053fba98-5be4-40f8-a6ae-9d13e4f76a95.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454858-cb0c1d72-347d-4fab-bb58-c5041c5b8b81.jpeg'
          ]
        },
        bottom: {
          title: ['本次设计整体富有<strong>活力与动感</strong> ，大气简约，与孩子们联系紧密。简约的设计风格使得标志不宜过时，可以长久使用，便于孩子们记忆与辨识，增强标志的视觉感受。', '让<strong>墙壁“说话”</strong>，它是利用学校所有墙壁因素去<strong>陶冶感染学生</strong>，是一幅有<strong>“主体的画”</strong>，是一首<strong>“无声的诗”</strong>，但情深意切，融知识性、教育性、艺术性于一体，达到<strong>“润物无声”</strong>的教育目的。', '<strong>校园文化设计</strong>不仅是视觉上<strong>美的享受</strong>，更是一场<strong>心灵的洗涤</strong>，它与学生之间产生的<strong>互动性、参与性</strong>和<strong>展示性</strong>，就体现了学生的心理和精神的成长，我们可从不同视角来看墙壁传达的不同语意。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751463619-25dd743c-b253-4232-b434-100c78c522b6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751463657-07f3e15b-ddfe-4f81-83a1-0a8f1a9263ac.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-07-23，阮弘宇
      title: '叁昶携手互促共赢 助力轨道交通高技能人才培养',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751812954-80460579-76a4-408e-a406-1a42bd7c075a.jpeg',
      linkTo: "/instanceItem?type=service&num=31",
      details: {
        top: {
          title: '叁昶携手互促共赢 助力轨道交通高技能人才培养',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751813388-5f27d449-b858-456b-afc3-dc91ae8e7e40.jpeg'
        },
        lunbo: {
          title: ['6月9日，<strong>世界技能组织全球行业合作伙伴签约仪式</strong>在京举行，<strong>郑州捷安高科股份有限公司</strong>正式成为世界技能组织“<strong>全球行业合作伙伴</strong>”。世界技能组织<strong>首席执行官大卫·霍伊和赞助事务部主任亚历山大·阿米里</strong>，人力资源社会保障部相关单位负责同志，郑州捷安高科股份有限公司负责人，上海第 46 届世界技能大赛事务执行局赛事部负责同志以及有关院校和专家代表参加了签约仪式。<strong>上海叁昶文化科技有限公司顾问王志卫</strong>主持本场签约仪式。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799497-b0ff4138-2725-473b-83d5-2f3d6dbb0ec1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799482-f8c0edda-283d-4a21-ae17-7b79174b7b4a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799511-ef9b30d3-9091-46ff-bc07-92d039134851.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799495-6d19c549-3750-439a-a6d7-e205e115b854.jpeg'
          ]
        },
        bottom: {
          title: ['7月14日，<strong>上海叁昶文化科技有限公司</strong>（以下简称上海叁昶）与<strong>上海申通地铁集团有限公司</strong>（以下简称申通地铁）、<strong>郑州捷安高科股份有限公司</strong>（以下简称捷安高科）三方在上海共同签署<strong>战略合作框架协议</strong>。我们将携手合作，为<strong>全球轨道交通教育培训基地（中心）设计、设备、课程</strong>提供全面解决方案。', '<strong>上海叁昶顾问王志卫、申通地铁培训中心主任叶华平、捷安高科总经理高志生</strong>代表三方签署协议。', '叁方强强联合，优势互补，紧紧围绕服务<strong>轨道交通创新发展</strong>的目标，通过<strong>实训基地建设</strong>及<strong>项目咨询、装备技术研发</strong>及<strong>成果推广、培训服务、X证书</strong>等领域<strong>全方位、多层次、多形式</strong>的合作，加快提升三方在轨道交通高技能人才培训服务领域中的地位和服务水平，为培训效率和质量的提升持续赋能，为<strong>“交通强国”“一带一路”</strong>国家战略、为国内外轨道交通行业发展培养更多<strong>高端技术技能型人才。</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751806449-e2e77325-ac3e-4a00-b56b-ee62b65d72c0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751806456-29b536d8-cce5-4946-9194-fc4716ffad51.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-06-30，阮弘宇
      title: '叁昶保障上海首次承办全国职业院校技能大赛圆满成功！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751950043-e534f6e4-c1f5-4cc3-b85f-ac5f169b3d07.jpeg',
      linkTo: "/instanceItem?type=service&num=30",
      details: {
        top: {
          title: '叁昶保障上海首次承办全国职业院校技能大赛圆满成功！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751950041-66c3724c-517b-4576-a577-283e84005e47.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['6月18日-21日，由<strong>叁昶</strong>保障的<strong>2021年全国职业院校技能大赛“现代模具制造技术-注塑模具技术”赛项（中职组）</strong>在<strong>上海市工业技术学校</strong>成功举办。', '这是<strong>上海市首次</strong>承办全国职业院校技能大赛赛项，<strong>叁昶</strong>伙伴们都是边摸索边实施，而且此次任务<strong>规格高、时间紧、要求严，</strong>但是叁昶的伙伴们以<strong>精心设计</strong>的氛围布置、专业标准的赛事软硬件保障大赛，不仅体现了上海职业教育的<strong>高质量</strong>内涵发展，也让来自全国各地的选手赛出水平、赛出风采。全国职业院校技能大赛是<strong>教育部发起，</strong>联合相关部门、行业组织和地方共同举办的一项<strong>全国性</strong>职业院校学生技能竞赛活动，每年举办一次。', '在活动期间从场地布置方面，充分考虑<strong>上海元素、技能元素、学校元素、</strong>群策群力，精心设计主画面方案，渲染积极向上、凝心聚力、营造<strong>以赛促教、技能成才</strong>的浓厚环境氛围。设计师在各区域设计细节、保障物资、安装调试、现场画面进行一遍又一遍的确认，<strong>“已确认画面准备到位”“已确认现场设施设备一切正常”“已确认画面全部无误”</strong>细致服务是我们服务的一贯标准。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932376-a3dcf0ae-05b9-4b1d-82b1-be23598c4d9d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932379-33aa4bd2-85de-4f72-be86-1966c68b657b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932378-f34c6146-80f4-405e-aba4-e93aaf39deb2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932393-efd5f7f4-2bb7-49f7-a528-8c8805c018f8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932384-7ffebbe2-644b-422d-86f5-7964d4987c3e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751932857-66968819-9997-470b-8b3e-53f80eb6c096.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751933050-071d5a00-6c4c-4fa9-b1b1-76d25717d76e.jpeg'
          ]
        },
        bottom: {
          title: ['此次在沪举办的大赛，既是对公司赛事组织能力的考验，同时也是展现<strong>叁昶硬核实力</strong>以及团队良好精神状态的一次难得机会。叁昶还为本次大赛专门成立了项目小组，目的是<strong>加强沟通协作</strong>，互通有无，不放过每一个细节，确保场地布置达到组委会的各项要求。', '<strong>叁昶公司顾问王志卫</strong>三次到达现场，全面落实大赛场地布置情况，了解布置进度，要求公司员工一定要把各项工作<strong>做实做细</strong>，全力以赴保障好此次<strong>全国职业院校技能大赛</strong>。', '活动即将结束之时，现场工作人员组织大家有序撤场，完成相关收尾工作，此次活动我们本着<strong>站位高、创新强、落地细</strong>的原则，为本次大赛<strong>保驾护航</strong>，切实做好大赛保障服务。感谢主办方对<strong>叁昶公司</strong>服务的信任与肯定，我们会一直努力，为大家提供<strong>更优质</strong>的服务，最后热烈庆祝本次活动圆满举行。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751942207-acba1ae5-56cd-4c2e-9ed4-86d0e10471eb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751942242-c1e95d4d-8eb2-4f2b-bc3d-37f2e5772cd5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751942247-162607ac-756a-43a4-9278-ad824544c430.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751942261-ed9c7bb5-09c5-433b-a278-63296ca2b96f.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-06-11，阮弘宇
      title: '公司策展十余展位，涵盖高校、高专、中职、普教！第十八届教博会我们真正做到了全覆盖。',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752355795-4c0a83d2-949c-47df-a6e6-ab394ef755e5.jpeg',
      linkTo: "/instanceItem?type=service&num=29",
      details: {
        top: {
          title: '公司策展十余展位，涵盖高校、高专、中职、普教！第十八届教博会我们真正做到了全覆盖。',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752355840-f4278917-d74b-4c29-aaea-53aa4d4772ab.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['由<strong>中共上海市教育卫生工作委员会、上海市教育委员会</strong>指导，<strong>上海教育报刊总社</strong>主办的<strong>2021第十八届上海教育博览会</strong>5月22日在上海展览中心开幕。', '今年是<strong>建党百年</strong>，也是<strong>“十四五”规划开局之年</strong>。本届教博会以<strong>“信仰的力量，教育的梦想”</strong>为主题，全方位呈现教育系统<strong>育新人、传薪火</strong>的不渝初心，多视角展示教育系统奋斗担使命、砥砺新征程的丰富内涵，为上海乃至长三角地区教育事业发展<strong>“开新局、谋新篇”</strong>注入强大活力和动力。', '从5月22日起，教博会进行了为期<strong>三天</strong>的现场展和为期三个月的线上展，日前，教博会现场展已经圆满落下帷幕，<strong>上海叁昶文化科技有限公司</strong>参与策展<strong>十余展位，涵盖高校、高专、中职、普教</strong>，凭借对每一个展位负责的态度，公司设计团队<strong>精心策划，量身打造</strong>，以干货满满的展示内容以及独特的参展理念为各个展位赋能，真正做到了第十八届教博会<strong>展位全覆盖</strong>，并受到参观领导、主办方和观众的<strong>高度好评</strong>。', '在<strong>嘉定馆</strong>中，我们特策划邀请了一位<strong>新四军老战士阮武昌</strong>给少年儿童讲革命战斗故事，<strong>老首长声情并茂</strong>，燃爆了整个现场。<strong>上海市副市长陈群</strong>巡视嘉定馆时与<strong>老首长</strong>也进行了<strong>座谈</strong>。这次活动意义重大，影响深远，我们就是要借<strong>庆祝建党百年之际</strong>，把老同志的精神财富通过<strong>声音、画面</strong>记录下来，珍藏永远。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331319-80208bf9-c2b5-46f3-b5b9-2d9e10cfc4b6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331298-ec9280e3-4749-4861-b7d0-32753aee657b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331292-1e2cfec3-a152-4534-bc7c-0c9d13de7ac8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331315-32b1fc5f-036e-48a0-a3d0-839304cdd496.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331309-b66e0ca8-7b5e-4d03-9db1-4e967a47383a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331871-f10b9479-e2bd-4fa3-842f-63f3b02e0fab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331929-e26ac8de-bbf8-4378-9340-38cd5f76187e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752331969-d3ea90a5-c86e-4bba-ad2c-2ac50b21bb42.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752332044-e28a5ad2-2b70-47e0-9031-17f9a24173b2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752332079-4572c985-3980-4aca-817f-5264d526382f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752332543-3ce4780c-707a-4579-909d-c1cf2a3f3709.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752332666-7b74ee6f-3c6f-4673-8cc8-a8300041cb79.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752332691-dbc2c4d9-3b58-4e9a-89e8-59700963f043.jpeg',
          ]
        },
        bottom: {
          title: ['通过此次<strong>教博会</strong>，不仅再次展示了公司<strong>硬实力</strong>，也展示了公司员工<strong>昂扬向上、奋发有为、敢于拼搏、勇于担当</strong>的精神风貌，增强公司员工团队意识、协作精神，赢得了客户的<strong>广泛赞誉</strong>。', '我们的格言是<strong>“一旦牵手，放不下手”</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752346212-8aa7a224-1a9e-4d4c-b6d3-b0159e65752a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752346231-295f996b-4c74-485a-87db-0defb5a4b29a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752346230-b1f08c04-eb84-4210-b99a-716e55b1e302.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752346250-627c6672-e8e8-4fbf-b745-222d62a96c49.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-05-28，阮弘宇
      title: '【穿中国鞋，走复兴路】叁昶助力2021年上海市高校“校长杯”健步走比赛活动圆满成功！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752749986-f8296ca7-cb65-4b5f-ac32-54472451ef32.jpeg',
      linkTo: "/instanceItem?type=service&num=28",
      details: {
        top: {
          title: '【穿中国鞋，走复兴路】叁昶助力2021年上海市高校“校长杯”健步走比赛活动圆满成功！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752750238-b24bc145-f8e6-49b6-88f7-83dac61dd419.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['5月9日上午，由<strong>上海市教育委员会、中国教育工会上海市委员会</strong>主办，<strong>上海市大学生体育协会、杨浦区教育局</strong>承办的<strong>“奋斗百年路，启航新征程”</strong>2021上海高校“校长杯”春季健步走比赛在<strong>杨浦滨江大道-绿之丘</strong>南侧广场隆重举行。<strong>中国银行上海市分行、上海叁昶文化科技有限公司</strong>对本次赛事给予了<strong>大力支持</strong>。我司<strong>顾问王志卫、常务副总曹鸣浩、副总吴小波</strong>携全体员工参加了本次比赛。', '当天，艳阳高照，烈日当空，我司三位领导携全体员工与<strong>市教卫工作党委、市教委代表队、本市各高校近300位领导</strong>一同参加了比赛，全程6公里赛程，大家沿着上海市老工业基地杨浦滨江一路行进。叁昶小伙伴们努力拼搏，热情饱满、不惧骄阳，沿着<strong>总书记考察的路线</strong>，以坚韧的毅力顺利闯过了“红歌进行曲（唱歌接力）”“党的光辉照我心（拍照互动）”“学习强国（知识问答）”三个打卡点，成功完成了全程比赛。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728507-9b2b7077-7c5c-46b2-8c3e-9d03ed0befc2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728521-df55200c-0eb7-4e4d-9bd4-d1dfbc32026f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728531-417484df-da2b-47f3-9fc4-bbb10eb06cdd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728513-16830552-ac1b-4554-be12-8d7940bf8068.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728634-bf0e362a-6c4c-43ad-a540-19b452fb8541.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752728958-c01d3bf3-a329-4648-9903-e080e5ee34ae.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752729083-295baa56-d5c9-4a87-a295-2cce2b5a5280.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752729217-abde3ec9-e054-4472-b0d7-d15fb289e2da.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752729396-b78f7279-c3fc-4b78-90ca-e356561aba46.jpeg'
          ]
        },
        bottom: {
          title: ['今年是<strong>中国共产党成立100周年</strong>，也是<strong>五四运动102周年，叁昶公司</strong>为喜迎建党百年，<strong>传承五四精神</strong>，特组织公司<strong>五四青年节座谈会</strong>活动。', '座谈会上公司<strong>全体员工</strong>一起学习中国共产党的<strong>百年光辉历程</strong>，学习和传承<strong>“爱国、进步、民主、科学”</strong>的伟大五四精神。座谈会上公司青年代表们就如何继承和发扬五四精神纷纷进行发言。', '<strong>叁昶公司顾问王志卫</strong>作为一位老党员，曾经的<strong>军校团支部书记</strong>，与公司青年们分享了个人青年时代的奋斗故事，他说：从几位青年的发言中，我深深地感受到了他们情感和价值观。概括就二句话，<strong>一是做为中国人，当下是最幸福的。二是做为青年人，当今是最快乐的</strong>。这一切的幸福和快乐都离不开中国共产党领导，离不开国家的繁荣昌盛。我一个曾经的军校团支部书记，过了一个<strong>难忘的团日</strong>，特别有意义。最后，<strong>公司常务副总曹鸣浩</strong>对本次公司团建活动做了详细的介绍和安排。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752740076-47d00103-9c72-427d-a776-71a01a3dedb9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752740121-34d177f1-b0eb-4895-a108-fe38cd15cdbd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752740065-4c4ca4d5-1a45-48a1-ab26-41d1410fca38.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752740076-762ef289-d8f6-43e9-8a7d-effa5a5d16ad.jpeg',
          ]
        }
      }
    },
    {// 服务类 2021-05-28，阮弘宇
      title: '新时代、新技能、新精彩！叁昶保障第九届上海市“星光计划”开幕式圆满成功',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753023973-64956859-0e6d-44d1-8845-8540b242aa68.jpeg',
      linkTo: "/instanceItem?type=service&num=27",
      details: {
        top: {
          title: '新时代、新技能、新精彩！叁昶保障第九届上海市“星光计划”开幕式圆满成功',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753024087-919ea759-3c79-49a4-bb07-8cf034df30b8.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>劳动光荣，技能宝贵，创造伟大放光芒。我们心中充满热情，开创技能新梦想 ……</strong>”5月8日上午，由<strong>叁昶公司</strong>保障的<strong>第九届“星光计划”职业院校技能大赛总决赛</strong>开幕式圆满举办，伴随着<strong>上海市中职学生星光合唱团</strong>唱响第46届世界技能大赛推广曲<strong>《相约上海》</strong>，<strong>上海市副市长陈群</strong>宣布第九届上海市“星光计划”职业院校技能大赛总决赛开赛。', '<strong>首届</strong>上海市“星光计划”中等职业学校技能大赛自2004年开始举办，每<strong>两年一届</strong>。自第二届起增设了教师组比赛项目，师生同台竞技。第六届起，<strong>上海高职院校</strong>也加入了“星光计划”大赛的行列。“星光计划”赛项从首届的11个专业大类、33个比赛项目增加到第九届的22个专业大类、100个比赛项目，大赛坚持与<strong>教育培养目标</strong>相结合、与<strong>专业教学标准</strong>相结合、与<strong>国家职业标准</strong>相结合、与<strong>全国技能大赛和世界技能大赛</strong>相结合；坚持面向全体，采取随机抽取决赛选手，让每一个学生都有机会出彩；上海市“星光计划”职业院校技能大赛已成为本市<strong>职业教育的品牌项目</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984281-6a975cb8-ff67-42d2-b6ca-cbf9f0cf94bc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984095-954c8a6b-13a5-46bf-92a0-783dee232d73.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984102-eecbb223-cdf4-43e4-87b0-4146d111e9ca.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984102-eecbb223-cdf4-43e4-87b0-4146d111e9ca.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984101-3e2bafd4-b79a-4270-9cff-2165820b6c2b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984683-8ddc4164-b180-462e-94e3-2e320bb7495c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661752984836-e457b6e3-1177-49a2-95a1-b78f4ffe4156.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>叁昶公司</strong>作为本次开幕式的<strong>策划保障团队</strong>，从前期的策划研讨，撰写朗诵稿、主持稿、排练节目，彩排到最后的<strong>完美呈现</strong>，这都离不开<strong>叁昶公司</strong>团队幕后的全力奉献。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753012135-5f3e3d7a-b42b-4d4c-a95a-d5c6bd984519.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753012052-33c69e99-5759-4668-a725-84c858b72a4a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753012048-98abf8b7-5ad1-4a69-b14e-258dac6aa1e9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753012051-b39f0368-32f6-4a02-bada-1b0ee8a30b0e.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-05-28，阮弘宇
      title: '【时间紧、任务重、责任大】建立全民免疫 叁昶“针”心实意您会懂！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753288129-2f1690e4-9b16-4955-8d0c-068d1db5290b.jpeg',
      linkTo: "/instanceItem?type=service&num=26",
      details: {
        top: {
          title: '【时间紧、任务重、责任大】建立全民免疫 叁昶“针”心实意您会懂！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753288302-58f4b3cf-8bf5-4da1-9065-f882d4061591.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['为<strong>全面贯彻落实国家、省、市、区</strong>关于开展大规模人群<strong>新冠疫苗接种</strong>工作的有关会议精神，<strong>淞南镇</strong>按照<strong>“分步实施、有序推进”</strong>的原则，积极推动疫苗接种工作。', '<strong>叁昶公司</strong>作为本次活动的承办方，接到任务<strong>不到二十四小时</strong>，从<strong>活动策划、环境设计、节目编排</strong>、到<strong>现场搭建、服务保障</strong>，虽然下雨，团队一直在突破，完成了几乎完不成的任务。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753272460-ca311769-fef1-46f7-880f-8c2d12bdc874.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753272477-73886673-71ec-4013-ad1c-97b2ac63b1ca.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753272463-d7f281ca-ab7e-4c6f-8595-204b2da466ea.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753272466-6be02ffb-1275-41f9-abe2-8e291d03da91.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753272471-f1af5d06-0cc8-4dd9-90bb-5e2152f15208.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['为了能让<strong>淞南镇</strong>的市民有更加开心愉悦的<strong>接种氛围</strong>，<strong>叁昶</strong>的工作人员早早的来到接种点，把现场布置好后，以<strong>最热情的歌声、良好有序的氛围</strong>迎接接种疫苗的市民朋友们。', '不少市民表示，打疫苗还能体验到相关文艺活动，<strong>非常的开心</strong>，能够感受到举办方的用心，为他们<strong>点赞</strong>！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753278850-9f8cdb7d-7794-4c49-9d36-606391a3de70.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753278852-611f0632-8039-44af-9594-d9d0fd63e040.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-04-13，阮弘宇
      title: '叁昶保障上海市首个新型高职院校揭牌仪式圆满成功!',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753486989-b9beaa06-affe-4331-a7b8-699a3322c3fe.jpeg',
      linkTo: "/instanceItem?type=service&num=25",
      details: {
        top: {
          title: '叁昶保障上海市首个新型高职院校揭牌仪式圆满成功!',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753487275-3a44d1e0-e798-4994-a953-a0e32047e431.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['崭新的校园风貌迎来全新的开始，殷殷的期盼让梦想起航。2021年4月9日下午，由<strong>上海叁昶文化科技有限公司</strong>保障的<strong>全面推进上海新型高职院校高质量发展论坛暨上海南湖职业技术学院揭牌仪式圆满举办</strong>。上海市政府副市长<strong>陈群</strong>，上海市政府副秘书长<strong>黄永平</strong>，上海市教卫工作党委书记<strong>沈炜</strong>，虹口区委书记<strong>郭芳</strong>，虹口区委副书记、区长<strong>胡广杰</strong>，上海开放大学校长<strong>袁雯</strong>，上海市教委副主任<strong>毛丽娟</strong>等参加了揭牌仪式。揭牌仪式由虹口区人民政府副区长<strong>张雷</strong>主持。', '当天，还举办了<strong>《全面推进上海新型高职院校高质量发展》</strong>微论坛，云集了本市职业教育专家、知名企业代表和部分高等职业院校领导。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468102-3e946164-c863-4e85-aab4-d448440543d6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468117-1340149c-9c8a-476d-b050-8ca6aa3ae092.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468113-ba992851-e9a0-4841-9179-92d18b94c18b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468116-c8f884f3-1681-43b2-baf8-81498c36de86.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468116-14452aad-6f66-4ca0-a5ff-59e6f217c4c4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468731-2c45a8aa-6c1a-41dd-b3e7-2e419bb6660b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468734-e1d4b9a6-65f9-453f-beaf-a698d7320795.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468947-1913e057-6657-4b41-91ad-9461a227fdfb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753468972-389ebe4b-13fd-4f04-9de2-f7a78fc86849.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753469098-75d618a1-982e-477b-9d7c-81d6269c2175.jpeg'

          ]
        },
        bottom: {
          title: ['本次活动的<strong>圆满举办成功</strong>离不开<strong>叁昶团队</strong>的全力奉献，我们进行设计的主<strong>KV动态画面</strong>、各个仪式环节的<strong>精心策划、现场视频直播、图文直播、定制邮册、席卡、签到台、指引牌</strong>等等所有的一切，每位叁昶小伙伴在台下所付出的辛勤汗水，都<strong>绽放</strong>在了整场活动的各个环节之中。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753477764-a4f8f941-f032-479e-9dc4-362ed41745ee.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753477841-dbd66dd0-73d3-4def-aaae-ec6d84a58ae1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753477810-bb73de32-420c-40fc-8399-ef9e74cc19c6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661753477831-96b07c29-1d41-4bbb-8a9e-9f9fafe5631b.jpeg'
          ]
        }
      }
    },
    {// 2021-1-14，amanda，阮弘宇,从近期活动copy过来
      title: '2020有惊，有喜，有惊喜，2021有梦，有想，有梦想！叁昶2020年终述职大会暨团建活动圆满举行',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754682202-988462f4-86d6-433e-aa0e-f9bc3a8477c5.jpeg',
      linkTo: "/instanceItem?type=service&num=24",
      details: {
        top: {
          title: '2020有惊，有喜，有惊喜，2021有梦，有想，有梦想！叁昶2020年终述职大会暨团建活动圆满举行',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754682320-8a3d0816-37d3-4c81-93d4-7fec2254d55b.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2021年1月8日-1月10日<strong>叁昶文化科技有限公司</strong>开展丰富的<strong>年终述职大会暨团建活动</strong>，走出工作岗位，亲近大自然，增进伙伴之间相互了解，提升团队<strong>活力和凝聚力</strong>，既<strong>充实又欢乐</strong>。这是一次<strong>学习之旅</strong>，也是一次<strong>放松之旅</strong>。', '抵达扬州后，在高大上的会场开展了“<strong>2020年上海叁昶文化科技有限公司年终述职大会</strong>”，<strong>全体伙伴</strong>在扬州讲述了我们自己的故事。<strong>回顾2020，展望2021</strong>，每个部门及个人都找准了自己的不足，并制定了整改的措施。', '<strong>公司顾问王志卫先生</strong>对公司所有员工在2020年的付出<strong>给予肯定</strong>，也借此机会向所有员工及其家属送上<strong>新春祝福</strong>。<strong>公司常务副总曹鸣浩</strong>汇报2020年度公司整体情况，表态：<strong>公司赢在格局，但不能输在执行上</strong>。新一年我的工作标准：<strong>只为成功想办法，不为困难找借口。公司副总吴小波</strong>也对2020年自己的工作情况做出<strong>深刻总结</strong>，对自己团队做出<strong>深切期望</strong>，并表态：<strong>没有执行力的团队就是失败的团队，在2021年里将强化团队执行力</strong>。其余的各位部门经理以及员工也都发表一年来的工作汇报。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754662775-e65427ed-969e-4da9-addc-8c8f46958c5a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754662792-40752c58-d941-48f8-b20f-5ea50295cf55.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754662781-b4ddd9d3-b87f-44b6-a27a-a852582aabec.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754663081-860107d8-d0da-44a1-a5f9-66ce8184360e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754662776-94fb7ee6-c4d6-4abc-8d97-6e42e9c9f181.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754663603-cd869a3c-660c-49ad-93d0-1e1c9a92dd9c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754663594-e61db329-4fec-458a-9316-0147a9eaa692.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754663617-9dbc97d6-8067-472a-b0e9-1a1750ca8cd7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754663946-44b81812-7feb-4a32-a62a-6e9264b0d7f1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754664188-98b2e362-0a76-493d-8a0f-f6ab563c4c4a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754664268-d2c10dd9-0689-4a07-8d21-1f0a54b328f7.jpeg',
          ]
        },
        bottom: {
          title: ['2021年1月8日，叁昶公司<strong>全体员工</strong>以及受邀而来的<strong>嘉宾朋友</strong>，迎着朝阳，展开以“<strong>乘风破浪，筑梦远行</strong>”为主题的年终述职大会暨团建活动。窗外<strong>寒风刺骨</strong>，车内<strong>热血沸腾</strong>，一路300公里，我们来到了“<strong>世界遗产城市—扬州</strong>”。扬州，古称广陵、江都、维扬，有着“淮左名都，竹西佳处”之称；享有“园林之盛，甲于天下”美誉。', '第二天上午，我们来到了<strong>瘦西湖</strong>，瘦西湖以“瘦”为特征，湖面时宽时窄，两岸林木扶疏，园林建筑古朴多姿。当天下午，我们<strong>再次启程抵达苏州</strong>。苏州是首批国家历史文化名城之一，全球首个“世界遗产典范城市”，有近2500年历史，是吴文化的重要发祥地，有“<strong>人间天堂</strong>”的美誉。并且共同参观了著名的<strong>拙政园</strong>，品尝了<strong>得月楼</strong>的美味佳肴，可谓是<strong>既饱眼福，又享口福</strong>。', '  一元复始万象更新，2021年又是一个我们<strong>创造梦想、扬帆启航</strong>的关键之年。我们将<strong>紧密依托领导的指导方针</strong>，提高服务品质，求真务实，勤于学习，乐于工作，享受生活，<strong>共创2021新辉煌</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754675294-ab4e5b51-7582-4e69-8a4d-c0b871cc499b.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754675321-280a0689-b8c8-4ca1-acfc-fcbfe9ccbb4b.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754675276-9352751a-2d1f-4ea0-b096-d8ba4d7cccf0.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661754675307-6b3cbf23-24ed-436c-a254-5d1098c423ef.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2020-12-29，amanda，阮弘宇
      title: '2020年第八届上海市“中华杯”职业技能竞赛闭幕式暨颁奖大会',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755277361-c313639d-b34b-465d-8197-2f9fbdd9903a.jpeg',
      linkTo: "/instanceItem?type=service&num=23",
      details: {
        top: {
          title: '2020年第八届上海市“中华杯”职业技能竞赛闭幕式暨颁奖大会',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755277344-7b488d42-c8c9-4752-b4a9-68e0fdcbd2ec.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['匠心筑梦、砥砺前行。为<strong>贯彻落实习近平总书记</strong>对技能人才工作的<strong>重要指示精神</strong>，全面提高劳动者的职业技能素养，加快推进技能人才队伍建设，同时为<strong>第 46 届世界技能大赛</strong>营造良好的社会氛围，由<strong>上海叁昶文化科技有限公司</strong>精心策划——<strong>2020年第八届上海市“中华杯”职业技能竞赛闭幕式暨颁奖大会</strong>圆满成功。', '期间，<strong>上海市政协副主席、上海中华职业教育社主任周汉民</strong>出席活动并讲话。<strong>上海中华职业教育社副主任、上海市人力资源和社会保障局副局长张岚</strong>报告了第八届上海市“中华杯”职业技能竞赛活动举办情况。<strong>上海中华职业教育社副主任、上海海洋大学校长程裕东</strong>宣读了第八届上海市“中华杯”职业技能竞赛获奖通报。<strong>中共闵行区委常委、统战部部长李红珍</strong>代表闵行区委致欢迎辞。<strong>市职教社副主任胡卫</strong>主持颁奖大会。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755258285-d598bba8-d258-4dd6-8eef-43a36136d018.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755258149-9ee4b9d8-a53d-4e9e-9397-32364073b94f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755258170-2b17f5e2-ba00-4e00-b2b1-30b2261c6d35.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755258181-5e7da449-4a69-4bdc-b356-83174dfa79b2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755258184-bd2f6b4e-8a32-40bd-81ad-a04f084404ae.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755259001-e3c7a452-231c-4664-939b-a7f334bc4951.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755259042-3bcf5ab4-594a-4bb1-a87f-38d3fdccd3c3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755259157-f58bf23c-1b5e-4c03-b2ba-2cfd8e384d22.jpeg'
          ]
        },
        bottom: {
          title: ['活动现场，<strong>叁昶</strong>公司围绕<strong>非遗技艺、人工智能和美食制作</strong>三大主题设计制作三大区域<strong>“非遗长廊”</strong>、<strong>“智能天地”</strong>、<strong>“美食工坊”</strong>共<strong>27个展位</strong>，吸引了与会观众的积极围观和互动。', '外场的技能公园分为“非遗长廊”、“智能天地”、“美食工坊”，<strong>看点到位</strong>；内场有服装秀节目和讲述《温暖2020》，<strong>泪点到位</strong>；闵行区刘副区长交旗给下一主办方，<strong>燃点到位</strong>；这一切都离不开我们为共同目标而付出的点滴！<strong>感恩天公作美</strong>，给了无比好的天气，<strong>感恩各级领导</strong>对闵行职教社的关心和支持；<strong>感恩参展单位和部门</strong>的大力相助；<strong>感恩群益职校</strong>无微不至的周到，从台上的朗诵学生到幕后后勤的保障，还有出色的志愿者团队；<strong>感谢西南工程学校</strong>专业的礼仪团队；也<strong>感谢咱们叁昶团队</strong>精心的编排、设计和创作！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755270276-79f5e53d-872f-451b-8d30-ece7936fec33.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755270302-9d7f905b-f6a1-4b93-8409-0f9f2de441c9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755270271-71d32028-c160-4e2f-9743-550e0d1e6833.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755270277-7b76beee-5f2a-47b5-9105-2a6f2b2d17ed.jpeg'
          ]
        }
      }
    },
    {// 服务类 2020-12-29，amanda，阮弘宇
      title: '上海市建筑工程学校建校60周年主题大会完美举办',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755753083-62f260a7-f5a3-43a9-9275-d05cf04f6471.jpeg',
      linkTo: "/instanceItem?type=service&num=22",
      details: {
        top: {
          title: '上海市建筑工程学校建校60周年主题大会完美举办',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755753107-e9c52756-b751-4638-8991-1ce09010d2fd.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>匠心不辍六十载，筑梦前行向未来</strong>', '<strong>叁昶公司精心策划的上海市建筑工程学校建校60周年主题大会</strong>成功举办！大会结合<strong>线上</strong>与<strong>线下</strong>、协同<strong>校内</strong>与<strong>校外</strong>、凝聚<strong>国内</strong>和<strong>海外</strong>的各方关注，超过<strong>万人浏览！！！</strong>', '<strong>上海城建职业学院党委书记褚敏</strong>向建筑工程学校建校60周年表示祝贺。<strong>学校党委书记、校长杨秀方</strong>向各级单位和领导、学校历任老领导、离退休老同志、海内外校友以及所有关心支持学校教育事业发展的朋友们致敬。<strong>住房和城乡建设部人事司二级巡视员路明先生</strong>通过视频发表祝贺。<strong>退休教师代表、上海市两届园丁奖获得者费惠民老师</strong>表达了对学校60周年华诞的美好祝愿。<strong>学校党委副书记何光</strong>主持校庆60周年主题大会。', '<strong>学校外籍学员、国际友人代表阿卜杜勒·侯麦德</strong>以及2018年“一带一路”基础设施国际人才研修班第一期学员、<strong>现印度尼西亚IQSI质量测量协会主席</strong>也通过视频的方式向学校送上诚挚的祝福。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736308-5a8a869d-72f5-48f4-8135-18b65cd9e856.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736404-714dadb5-84aa-4be3-a1d6-c9c9199c2e33.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736302-5d8c2e88-f7fe-4057-978d-f4278ed34dfa.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736300-a4c658d6-1672-4d71-8eca-5961d2d1de7f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736308-c2830915-2b4f-43f3-b52b-eebf4fc29db1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755736950-dc8c3ce2-e183-4b78-98c5-24b2b51a6024.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755737066-8a9ab1dd-4619-4553-8e9b-1efc582acf8c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755737012-f628fa3b-674b-459d-be51-ddec09ff43c0.jpeg'
          ]
        },
        bottom: {
          title: ['本次活动既有流畅的<strong>大会议程</strong>，还精心策划了<strong>启动仪式《启程未来》、上级领导赠送纪念品、</strong>致敬老领导、<strong>诗朗诵《匠心筑梦》、情景舞蹈《秀出精彩》、大合唱《我们走在大路上》</strong>等精彩的师生节目，展现出了建筑工程学校师生们的<strong>良好精神风貌</strong>和对于共推学校未来发展的坚定<strong>信心</strong>和<strong>决心</strong>。同时在校内还搭建了<strong>主题门头、大型合影区</strong>域等营造氛围的设备，让同学们在欢声笑语中喜迎学校<strong>甲子华诞</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755744772-07e3fd3d-bf07-45a7-9dce-d667d3e80f83.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755744761-afc7c119-16aa-4200-b889-e5a1dbab1e64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755744880-68b88829-473f-40df-8ade-2b304122497a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661755744765-d07c674d-22f3-40ca-bdf9-1653534a1dc1.jpeg'
          ]
        }
      }
    },
    {// 服务类 2020-12-11，amanda，阮弘宇
      title: '我们用自然之光，绘出七彩音符，打响文化品牌',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756391769-d92eb3bb-6ef9-47e3-872b-44b873f5590b.jpeg',
      linkTo: "/instanceItem?type=service&num=21",
      details: {
        top: {
          title: '我们用自然之光，绘出七彩音符，打响文化品牌',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756391788-93a93786-cc92-4e84-9171-49be408a000f.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['近日，<strong>叁昶历经两年</strong>设计打造的<strong>上海市现代音乐职业学校实训大楼文化景观</strong>圆满通过学校验收并得到学校领导与老师的<strong>一致认可与点赞</strong>。', '此次项目打造出不凡的<strong>精品之作</strong>，是在叁昶<strong>设计部总监</strong>带领着团队成员们经过耐心细致的思考推敲，并与校方<strong>多次研讨会议，多次到现场勘测，</strong>不放过每一个细节，为学校量身定制<strong>最佳设计方案</strong>。', '叁昶打造的<strong>看的见的校园文化</strong>要让每一面墙都会说话，要让每一个作品都能传神。在建设“<strong>看的见、听的到、演的活、学的会、亮的出</strong>”的校园文化上我们将不断探索和实践！', '我们将整个校园文化景观用“<strong>自然之光</strong>"设计成“<strong>七彩音符</strong>”，设计以“<strong>工匠精神</strong>”为核心，以良好的室内空间、文化环境为宗旨，以<strong>曙光之音、晨光之音、阳光之音、智光之音、星光之音、时光之音、炫光之音</strong>作为每一层的主题植入到各个空间内，用<strong>七彩光和七色音对应七个楼层</strong>，在保持建筑原有结构的基础上，将<strong>艺术</strong>和<strong>功能</strong>融为一体，将满足师生在室内进行教学、生活、工作、休闲的要求置于首位。使室内环境<strong>合理化、舒适化、科学化</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756363308-a49af0f6-8c64-4832-82f1-a7e1d9f0942c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756363337-da2fbcd7-03cc-4833-95a1-4e75dc3a39a0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661756363367-689bc869-3984-4978-990b-8cce01d51321.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756363356-11baa40a-3bf2-48a3-8d1d-d6a8fb1a48bf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756363319-6da62a73-d897-4c04-9824-95fe7a00f2a1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756363828-64584549-1f3a-489c-b23c-0471d5d8c008.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756364589-7ced88c6-d4c2-4530-8f6c-7d178525b54f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756364125-9af3a9ff-9638-4a8e-bc1c-582e898ed1b6.jpeg'
          ]
        },
        bottom: {
          title: ['近日，<strong>全国一百多位校长和美育老师</strong>参观了叁昶刚落地完成的<strong>上海市现代音乐职业学校实训大楼文化景观</strong>设计。', '叁昶用<strong>自然</strong>为学生谱写一曲最“<strong>动听</strong>”的歌，在校园景观设计中，始终遵循<strong>教育、技能、德育</strong>并重原则，通过文化景观设计，为学生提供最为贴切的<strong>人性化关怀</strong>，让他们感受到，这个世界的缤纷与美好。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756372333-c523d2e5-1aaf-4194-922f-93eeb7f36997.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756372357-293f6fb1-a8e4-40ea-b94e-288d168b9e32.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756372414-3c22716d-a617-44a6-a83d-52fbf487830f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756372371-a072c606-a5a2-4cc3-98aa-da8b802e36ba.jpeg'
          ]
        }
      }
    },
    {// 服务类 2020-11-27，amanda，阮弘宇
      title: '叁昶这事儿，让全市学校围观！！！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756636359-2ebb2b50-2b97-4dfb-97c1-b941f3497b45.jpeg',
      linkTo: "/instanceItem?type=service&num=20",
      details: {
        top: {
          title: '叁昶这事儿，让全市学校围观！！！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756636471-1823d62d-eed0-42e0-a076-e744314bb77e.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['<strong>上海第46届世界技能大赛将在国家会展中心（上海）</strong>举行。届时将开展一系列<strong>文化交流</strong>、<strong>技能推广</strong>、<strong>观众体验</strong>等活动。其中“<strong>一校一队</strong>”是世界技能大赛期间<strong>唯一由参赛选手</strong>与当地<strong>中小学生</strong>开展面对面交流的一项活动，承担着<strong>文化交流</strong>的重要任务。 ', '近日，由<strong>上海市教育委员会</strong>、<strong>上海2021年第46届世界技能大赛世赛事务执行局</strong>主办、<strong>上海叁昶文化科技有限公司</strong>承办的<strong>第一场</strong>“一校一队”宣传推广活动<strong>圆满举办</strong>，活动出席人员有<strong>上海市教委相关领导</strong>，<strong>上海第46届世界技能大赛事务执行局大型活动部相关人员</strong>，<strong>部分区教育局相关领导</strong>，“一校一队”活动<strong>上海接待学校负责人</strong>、<strong>联络员</strong>等150余位莅临现场。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621121-46429fd2-40f9-4920-bb5a-b9730ffae686.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621079-3a964d87-973d-492a-8442-9cbb1c4a108b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621097-b97a2793-16be-49bf-ac20-c7511ad67d82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621095-572ccb04-ddcc-4ad1-a4d9-472fcf500c75.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621104-3aea26f6-b6a5-4de6-9397-fc27cbeed772.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756621508-e8698353-7503-4644-a5c4-ece602f0177a.jpeg'
          ]
        },
        bottom: {
          title: ['本次活动的<strong>圆满举办成功</strong>离不开叁昶团队的<strong>全力奉献</strong>，主KV、画册、定制纪念品、点心、签到台、指引牌等等<strong>所有的一切</strong>，每位叁昶小伙伴在台下所付出的<strong>辛勤汗水</strong>，都<strong>绽放</strong>在了整场活动的<strong>各个环节之中</strong>。', '此次活动受到了<strong>领导和全场所有与会人员的一致认可</strong>，所有参与者<strong>专心致志</strong>，<strong>认真笔记</strong>，浓厚的<strong>学习热情</strong>和热烈的<strong>现场气氛</strong>让这个寒意渐浓的冬天也变得<strong>温暖如春</strong>，本次第一场“一校一队”取得<strong>圆满成功</strong>！12月，我们即将举办第二场“一校一队”活动，相信这场活动的成功举办会让“一校一队”活动<strong>更加精彩、更有意义</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756629787-7f7c10e9-f912-4c63-a925-e164bdf92a42.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756629811-73709079-8184-4726-b28d-b4650b11698d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756629844-5c911ef1-efcf-4bbd-8d4a-5ed55655f800.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756629822-ed142709-4886-4c13-b920-9abf90021c78.jpeg'
          ]
        }
      }
    },
    {// 服务类 2020-10-27，amanda，阮弘宇
      title: '学礼工商外，习礼好少年；懂礼满校园，守礼成君子--叁昶策划职业学校礼仪轮训活动',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756951449-a4f6d587-e762-432e-adde-6dcdc2423f54.jpeg',
      linkTo: "/instanceItem?type=service&num=19",
      details: {
        top: {
          title: '学礼工商外，习礼好少年；懂礼满校园，守礼成君子--叁昶策划职业学校礼仪轮训活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756951464-13831ec0-9c3d-48a2-b051-5842e1a1476b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['本次礼仪轮训的主题为“<strong>校园有礼</strong>”，分别从<strong>仪态礼仪</strong>、<strong>握手礼仪</strong>、<strong>引导礼仪</strong>、<strong>递接礼仪</strong>和<strong>餐桌礼仪</strong>五个方面展开教学。主讲老师们首先向同学们简单进行了自我介绍后，并向大家分享了在她们年轻时对于<strong>礼仪的看法</strong>以及<strong>礼仪对她的影响</strong>。然后老师们详细的为同学们讲解了<strong>五个礼仪</strong>的具体表现形式，<strong>正确站姿</strong>、<strong>面部表情</strong>、<strong>体态变化</strong>。并通过自身的示范，为同学们更好的展示了<strong>正确的礼仪</strong>，帮助同学们更好的<strong>掌握</strong>这各项礼仪。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756855883-be430c04-7e4c-43f8-89ee-34f49aadf6cb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756855911-4c20ee8b-045b-47fc-b64a-f6561cf08e54.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756855898-5eb95214-174c-43a9-a818-b89847659b26.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756855879-5e41bd1f-4846-4978-83d8-32df17b5fcf2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756855915-f15eda7a-998a-4613-ab41-e21c282bc268.jpeg'
          ]
        },
        bottom: {
          title: ['金秋十月，秋风萧瑟，层林尽染，一片金黄。为<strong>全面提升</strong>学子<strong>文雅形象</strong>，传承我国优秀的<strong>礼仪传统</strong>，加强对学生精神追求、内涵发展、气质品格方面的<strong>塑造和培育</strong>，在总结以往礼仪轮训的<strong>成功经验</strong>下，本年度我公司继续对<strong>上海市工商外国语学校</strong>2020级学生开展<strong>全覆盖</strong>的礼仪轮训。', '礼仪是文化修养的<strong>重要载体</strong>，也是<strong>塑造形象</strong>的重要手段。在社会活动中，交谈讲究礼仪，可以变得<strong>文明</strong>；举止讲究礼仪可以变得<strong>高雅</strong>；穿着讲究礼仪，可以变得<strong>大方</strong>；行为讲究礼仪，可以变得<strong>美好</strong>……只要讲究礼仪，事情都会做的<strong>恰到好处</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756862911-2906a18b-4d2b-4005-9fa8-569779772563.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661756862899-87cbeee9-b9ec-4b48-baa9-9077da961fb8.jpeg'
          ]
        }
      }
    },
    {// 2020-10-22，amanda，阮弘宇
      title: '叁始善成，昶赢未来丨叁昶公司第一届供应商大会圆满召开',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757150621-5ae2ba05-1755-44e6-b059-46893add5cc0.jpeg',
      linkTo: "/instanceItem?type=service&num=18",
      details: {
        top: {
          title: '叁始善成，昶赢未来丨叁昶公司第一届供应商大会圆满召开',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757150967-1527896e-7fc7-4e19-b079-054edc5a5070.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['10月16日，上海叁昶文化科技公司<b>第一届供应商大会</b>在上海宝隆宾馆举行，大会秉承“<b>精诚合作，发展共赢</b>”的精神，邀请广大供应商出席，感谢合作伙伴对叁昶公司的<b>大力支持</b>，叁昶公司领导和来自<b>全国各地的70家供应商代表</b>共聚一堂，就进一步<b>巩固长期良好合作关系</b>进行交流座谈。会上<b>广州视睿电子科技有限公司刘畅</b>、<b>上海尚骏信息科技有限公司丁俊芝</b>作为供应商代表发言。两家单位回顾了与<b>叁昶公司</b>的合作历程，表达了<b>加深合作</b>的意愿和对合作前景的坚定信心。', '会上，公司<strong>常务副总曹鸣浩</strong>与<strong>广州视睿电子科技有限公司</strong>、<strong>上海博大数据通信有限公司</strong>、<strong>维谛技术有限公司</strong>三家公司签署<strong>战略合作签约</strong>仪式，公司将深耕与供应商伙伴的战略合作，开启<strong>互利共赢</strong>、价值实现的新篇章。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757134731-b7b96196-133a-40c2-a45a-7ffab2bf4d52.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757134709-d172e12c-9947-4e2e-ac10-586f815eee29.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757134815-85f1aa0c-f6de-4d24-8a8a-0a44846e24ab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757134721-e49f2cb6-d33c-40f1-91f9-0a02b52a8125.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757134721-e49f2cb6-d33c-40f1-91f9-0a02b52a8125.jpeg'
          ]
        },
        bottom: {
          title: ['千帆竞发，百舸争流。<strong>上海叁昶文化科技有限公司</strong>成立于2017年5月，三年来在市场经济的大潮中，<strong>坚定信念</strong>、<strong>找准定位</strong>、<strong>奋力拼搏</strong>，在各位合作伙伴的帮助下，公司规模从开始之初的<strong>3个人</strong>发展到目前的<strong>30多人</strong>，办公面积也近<strong>1000平方</strong>，业务范围也不断扩大，目前已发展为以信息产业为主导，集信息化系统集成服务、软件和信息技术服务、设计和文化创意服务、智能化技术推广服务、大数据信息运营服务为一体的<strong>文化科技公司</strong>，公司致力于为用户提供<strong>完整的产品与服务体验</strong>。“<strong>叁始善成 昶赢未来</strong>”，是今天的大会主题，释义就是：<strong>选择叁昶作为合作的开始，我们善于将事情做好做成，与叁昶合作，共赢未来</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757142688-a1f60417-2f47-4924-a04d-73262712d350.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757142727-28fa1b58-b161-49bc-9b35-ddfc89ec3161.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757142731-3469dce2-4026-4476-b5bd-81d9327069b0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757142746-de23bfa8-e05a-4d53-8759-37371c27d2eb.jpeg'
          ]
        }
      }
    },
    {// 服务类 2020-09-25，amanda，阮弘宇
      title: '叁昶助力“相约上海 技能筑梦”上海2021年第46届世界技能大赛倒计时一周年活动完美呈现',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757467252-bf42a05b-7f2c-4720-ab83-3ce7a4c5e091.png',
      linkTo: "/instanceItem?type=service&num=17",
      details: {
        top: {
          title: '叁昶助力“相约上海 技能筑梦”上海2021年第46届世界技能大赛倒计时一周年活动完美呈现',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757467341-ee9d30e7-7ede-4ac7-a930-18c135f76785.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['2020年9月22日，是<b>上海2021年第46届世界技能大赛倒计时一周年</b>。作为<b>最高层级</b>的<b>世界性职业技能赛事</b>，世界技能大赛被誉为“<b>世界技能奥林匹克</b>”，代表了各领域职业技能发展的<b>世界先进水平</b>，在大赛开幕<b>倒计时一周年</b>之际，叁昶出品第46届世界技能大赛倒计时一周年活动在上海展览中心友谊会堂<b>完美呈现</b>！为明年大赛<b>成功举办</b>广泛宣传预热，营造氛围。', '2020年9月22日<b>上海展览中心友谊会堂</b>，灯光璀璨，高朋满座。来自<b>人社部世赛工作领导小组</b>，<b>上海世赛事务执行局</b>，<b>世赛组织委员会上海成员单位</b>，<b>部分上海市高技能人才培养中心</b>、<b>高等学校</b>、<b>中职学校的代表</b>以及部分<b>第46届世赛场地经理</b>、<b>选手代表</b>共约<b>160人</b>汇聚一堂，共同庆祝世赛开幕倒计时一周年。<b>人力资源和社会保障部副部长汤涛</b>与<b>上海市副市长彭沉雷</b>与会，并携手启动世赛倒计时一周年仪式。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757439624-9bf85cab-9157-498c-8774-ddb49d8faf7b.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757439651-fadb1f8f-21fa-48da-847d-6dae693845f3.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757439634-5f8f926e-c291-4723-9c1f-bb8da36e20e8.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757439625-19bb20c9-1c1c-4eba-b35b-a0ae5482355b.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757439730-00e11c44-04c3-442b-9682-2842d1d02b0b.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['本次倒计时1周年主题活动还包括<b>设立第46届世赛倒计时牌</b>和配套宣传活动等多项内容。当然啦！活动的完美呈现<b>离不开叁昶小伙伴们</b>废寝忘食的付出与<b>精心准备</b>！前期的<b>策划</b>与<b>沟通</b>也是相当重要的，每次的<b>头脑风暴会议</b>都在顺利愉悦的过程中把活动内容<b>调整充实完善</b>，最终才能<b>不负众望</b>，给大家呈现出此次<b>盛会</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757458271-50f2b90e-616a-447c-97c0-fb45c5319afa.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757458291-ef39cb11-64d1-49f7-8280-8798c4bac2ce.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757458275-aa034058-7a94-495f-af27-6a2dcc6298fe.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757458635-e7d4f821-abb2-43cb-a2ab-08a240bdeafb.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2020-09-14，amanda，阮弘宇
      title: '叁昶公司组织策划的“科技战疫 智慧生活”闵行科技节开幕式活动全满完成',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757733406-cea861eb-34e5-47f9-a3e2-10ec51f1acd6.jpeg',
      linkTo: "/instanceItem?type=service&num=16",
      details: {
        top: {
          title: '叁昶公司组织策划的“科技战疫 智慧生活”闵行科技节开幕式活动全满完成',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757733467-f6f70130-0b1b-441e-b10b-965bbf361f9e.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['叁昶公司设计制作本次科技节的<strong>整体环境氛围布置</strong>，主要聚焦在“<strong>科技战疫，智慧生活</strong>”上来进行设计与布置，使整场活动充满着<strong>科技感</strong>的氛围，使来宾朋友感受到满满的<strong>科技创新精神</strong>。8月23日进活动现场搭建，彩排，24日，叁昶小伙伴们<strong>准时</strong>来到活动现场。在各自的岗位<strong>全力以赴</strong>地做着准备工作，活动现场到处是他们忙碌的身影，<strong>不负众望</strong>，在所有工作人员共同的努力下，<strong>圆满完成</strong>此次活动！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757716978-da609519-baa0-4cff-9382-c2a44852dc71.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757716932-2c7bf853-6c9a-4fc8-89e4-714f84307acc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757717265-b964b0ae-64f2-414e-982b-7638bc9cc7d7.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757717020-dff10d97-db52-45a3-8906-1a9e34026485.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757716982-2218e30d-ba49-48fb-9a6b-9fbd3bb24f04.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757717539-86fea39c-e986-474a-8461-a87765167226.jpeg'
          ]
        },
        bottom: {
          title: ['上海市科协党组书记、副主席<strong>马兴发</strong>，上海市科委副主任<strong>谢文澜</strong>、闵行区人大常委会副主任<strong>倪学斌</strong>、闵行区副区长<strong>吴斌</strong>、闵行区政协副主席<strong>王一力</strong>、上海航天技术研究院副院长<strong>李昕</strong>等领导出席，各纲要成员单位、各街镇、各孵化器、园区、企业代表等<strong>100多人</strong>参加了开幕式，并进行了各奖项颁奖仪式与风采展示。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757725795-9706b14d-7d42-42ed-9ce2-90efa5bbf438.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757725779-58a4ffe5-eb25-4b12-b286-7276c4fc8124.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757725817-fad43212-ace9-4aab-be97-d309c22f5380.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661757725791-7a35b909-733d-4241-bfa9-f9d3b891b4aa.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-08-11，amanda，阮弘宇 由于从别的类异动过来，所以图片名称是这样
      title: '叁昶承办的“云毕业典礼”圆满成功，送别2020届医药毕业生',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757968565-dacd4683-c55f-4a07-8ef8-d251b1fc0c11.jpeg',
      linkTo: "/instanceItem?type=service&num=15",
      details: {
        top: {
          title: '叁昶承办的“云毕业典礼”圆满成功，送别2020届医药毕业生',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757968591-2883c959-1914-4af1-b980-5fe8627b62c9.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['上海市医药学校<b>云端毕业典礼</b>，叁昶公司承办<b>圆满成功</b>、不忘初心、砥砺前行、感恩遇见、相聚云端，共赴一场<b>青春盛宴</b>。经过叁昶<b>精心策划设计</b>，此次的毕业典礼，呈现出了，<b>炫丽震撼</b>的舞美效果，<b>精彩纷呈</b>的直播节目，使得叁昶的家人们，就算经过了几个<b>不眠不休的夜晚</b>，也觉得一切都值得！！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757953640-4091917e-fc1d-4149-9be0-5cee8d0b6457.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757953646-aebf3c32-4a64-4b9d-be2a-571c94585350.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757953642-fca5df7f-6789-44dc-a4f4-6ce44f1fbdf4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757953648-7c38f2dd-12bb-4420-9fce-624b9f5e962c.jpeg'
          ]
        },
        bottom: {
          title: ['本次毕业典礼能够<b>这么震撼</b>，少不了叁昶优秀制作男团，在背后的默默付出，颜值高、 实力强，生活要有仪式感，工作要有归属感，感谢所有付出的同事和家人们，叁昶也带着家人们的祝福，<b>把每一位客户，都服务到极致</b>，此次上海市医药学校2020毕业典礼的<b>圆满成功</b>，得到学校领导的<b>一致认可与好评</b>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757960966-7f629eee-1039-425d-9bd3-e6405ed64301.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757961137-5bbdcd61-84fc-4232-a146-16a627cbdbdb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757961043-a7ef763c-2681-4dbe-8629-ac4e86ad6a46.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661757961893-06f04705-994f-4bd1-bbc6-eee99d5e950a.jpeg'
          ]
        }
      }
    },
    {//2020-08-12，amanda，阮弘宇
      title: '“最高层级的世界职业技能赛事机构”成立，叁昶倾力协助',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758144676-8c68a0bd-62f4-45dc-b452-f61e889b61e8.jpeg',
      linkTo: "/instanceItem?type=service&num=14",
      details: {
        top: {
          title: '“最高层级的世界职业技能赛事机构”成立，叁昶倾力协助',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758144639-58e41d47-9c90-4102-9c23-21076b139510.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['7月29日，上海2021年<b>第46届世界技能大赛事务执行局</b>在沪<b>正式揭牌成立</b>。<b>上海市委书记李强</b>为执行局揭牌。人力资源社会保障部党组书记、部长<b>张纪南</b>，上海市委副书记、市长<b>龚正</b>分别致辞。</n>在7月29日的上海2021年第46届世界技能大赛<b>事务执行局</b>成立大会上，人力资源社会保障<b>部汤涛副部长</b>、上海市<b>彭沉雷副市长</b>，分别就事务执行局成立大会做出讲话。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758128169-b36441c6-f251-4d10-a42b-9beb915fc20f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758128199-a882c9ea-44ee-4a01-9901-0c75ad1814dd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758128175-ffe79fab-8040-4016-b648-b2d08e41ac94.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758128262-7f787d6a-fa0a-402f-8ea8-54f7d6b96c00.jpeg'
          ]
        },
        bottom: {
          title: ['<b>习近平总书记</b>曾作出<b>重要指示</b>指出，我国将举办2021年上海第46届世界技能大赛。要做好各项筹备和组织工作，加强同各国在<b>技能领域</b>的<b>交流互鉴</b>，展示我国职业技能培训成就和水平，<b>努力办成一届富有新意、影响广泛的世界技能大赛</b>。', '   2020年7月29日早上，<b>叁昶团队</b>的小伙伴们早早的来到了<b>现场</b>，进行成立大会的<b>最后准备工作</b>。中午，叁昶团队的小伙伴们继服务完成立大会后，又<b>转场服务揭牌仪式</b>活动。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758136570-45742139-74aa-4619-b32e-90b77f5059bf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758136655-3979dc0c-3536-4d22-a905-088b164a9adc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758136641-b94c2435-3fca-4e18-b601-293e5ee1b98c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758136638-4d700d05-7e6e-4b73-be0f-0e4757c1a6dd.jpeg'
          ]
        }
      }
    },
    {//2020-06-15，amanda，龙明发
      title: '上新闻了啦！ |  叁昶公司建设闵行区”四史“学习教育研究中心成立！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758337492-4d42c776-06bb-4347-bdc0-cafc95aea1ef.jpeg',
      linkTo: "/instanceItem?type=service&num=13",
      details: {
        top: {
          title: '上新闻了啦！ |  叁昶公司建设闵行区”四史“学习教育研究中心成立！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758338705-31f8188c-7609-4624-8497-9e3883e510c4.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0'
        },
        lunbo: {
          title: ['日前，叁昶公司设计建设的闵行区委党校<strong>“党史党性教育馆”</strong>举办了闵行区四史学习教育研究中心的成立揭牌仪式。上海市委党校副校长，上海行政学院副院长谢根华，闵行区委副书记，组织部部长王观保共同为研究中心成立揭牌。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758323418-3d75bafa-7845-4729-bbe9-b3970c145a06.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758323406-0bf9839e-4ce5-4aa1-9388-58dfa6be319b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758323415-21940efd-cc33-46b0-90e0-b7b3584608ee.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758323427-822342c1-b4ec-4acb-9298-8e28d35dd766.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>闵行区“四史馆”设计宗旨</strong>', '叁昶公司精心设计实施的闵行区四史馆是以闵行区委党校党史党性教育馆为载体，汇聚资源，始终致力于馆内情与景相统一，史与论，教与研相结合的闵行区四史学习教育红色基地，致力于讲好闵行故事，闵行的发展史。', '<strong>闵行区“四史馆”设计思路</strong>', '因地制宜将全馆布局设计为五大版块，分别为<strong>“开天辟地”、“红色征程”、“奠基伟业”、“改革开放”、“中华复兴”</strong>等内容，让全区广大党员干部进一步厚植对马克思主义的信仰，坚定对中国特色社会主义的信念，增强实现中华民族伟大复兴中国梦的信心。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758330393-6b768a2d-f57a-45e1-b45f-87f1d830006b.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758330502-5a4180c6-015d-4aad-aa22-c73cb82a3dd4.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758330425-9b04c3ca-9537-4ffd-a0ea-a87d5778fa3a.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758330416-182168e6-7ddb-4863-a4db-cb156b172124.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2020-06-02，amanda，龙明发
      title: '上海市贸易学校专业文化建设宣传片杀青啦！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758812702-37b53c55-0fd9-476b-a924-b8633609b50b.jpeg',
      linkTo: "/instanceItem?type=service&num=12",
      details: {
        top: {
          title: '上海市贸易学校专业文化建设宣传片杀青啦！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758812840-f717398e-30d5-4df2-8ccf-014950edf956.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['<strong>近日，我们叁昶文化拍摄小分队，</strong>前往上海市贸易学校，为这所洋溢着青葱绿意的美丽校园，拍摄着关于学校宣传片的点点滴滴，每一个人都用尽全力，只为了最后把最好的贸易学校，展现在全校师生眼前，公司出品的每一部优秀的作品，都离不开公司所有工作人员辛勤的努力，为你们点赞。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758806406-31a2f3b1-dce7-4da8-9886-f804090ac4c5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758806470-64a7e425-2424-4198-81d2-9404746e109f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758806406-ac12a13b-b214-401f-b5aa-ff8542e9ed04.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758806460-f6ecf8ec-a5d9-48c7-bcca-5d998af6e08e.jpeg'
          ]
        },
        bottom: {
          title: '',
          img: [
          ]
        }
      }
    },
    {//2020-4-9
      title: '“送教入滇，职场领航”叁昶携手贸易学校情系滇西学子',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758972964-92f9adb0-8625-4d1a-9cd6-c18f4871e7a5.jpeg',
      linkTo: "/instanceItem?type=service&num=11",
      details: {
        top: {
          title: '“送教入滇，职场领航”叁昶携手贸易学校情系滇西学子',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758972972-f39958d6-236c-48df-9856-5f80c6c5140b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['沪滇两地远隔千里，扶贫扶志爱融于心。1月9日-12日我司策划承办上海市贸易学校“送教入滇，职场领航，关注学生未来发展”精准扶贫进滇暨沪滇合作联盟校校合作交流活动。专业复训、实战培训、职场签约、家访送爱等内容安排得紧凑有序，既“干货”满满，又收获满满。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758956073-448fd0d7-4b6f-4b50-b149-7a6e2f5d5755.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758956052-b23cfa8b-a8b3-4311-b005-fbd7a5d52ba6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758956034-d353154e-3d43-427f-86d9-b6cb06258484.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758956079-c8f62314-396f-419b-b44b-6b2e4be66d15.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758956034-f10fe779-2eab-4e7e-82ab-a87b9c0a6dbd.jpeg'
          ]
        },
        bottom: {
          title: ['为期四天的“送教入滇，职场领航，关注学生未来发展”精准扶贫进滇暨沪滇合作联盟校校合作交流活动至此圆满结束，大山深处的风土人情深深烙印在大家的心底，全体工作人员和老师们都感慨万千，感叹大山深处孩子们的求学不易，纷纷感叹，作为职业教育工作者，要承担起新形势赋予的重要使命担当，成为学生们成长成才路上的呵护者和领路人，为他们今后就业创业成才，带领全家脱贫致富奠定坚实的基础。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758963426-7414de09-f49d-4c02-a152-053e24a4fe35.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661758964277-71164aef-7d89-49df-87ec-ce95119e90a9.jpeg'
          ]
        }
      }
    },
    {//2019-11-27
      title: '2019年上海市“青年启航”求职能力提升项目完美收官',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765096650-8405c537-9a5b-4867-8bfa-92176cf311e0.jpeg',
      linkTo: "/instanceItem?type=service&num=10",
      details: {
        top: {
          title: '2019年上海市“青年启航”求职能力提升项目完美收官',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765096662-afb7d5dd-3fc3-4680-8522-5eaef96c0cb2.jpeg'
        },
        lunbo: {
          title: ['“青年启航”求职能力提升项目自今年6月14日开启，于近日圆满收官。三个多月的时间，公司精心策划并组织了来自全市16个区的363位待业青年们走进了包括上海申美饮料、中国汽车消费网、巴比食品集团、平安总部等12家企业，进行参观学习和岗位体验。“青年启航”求职能力提升项目不仅开拓了青年们的眼界，更让他们有机会走进生产和服务一线，激发了青年的社会责任感与使命感，明确了他们的求职意识，起到提升其职业素养，增进职业技能，实现“三位一体”职业成长的作用。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765080579-44fd4767-3c4c-4af8-8624-ebff5b2691a5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765080584-b3bd2922-ee04-4a87-be6e-a96ddf2f3aa1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765080582-9689c9e1-afe6-4c5c-81dc-34b340e2646a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765080549-13877a91-5762-4165-94a5-176a0966c1b1.jpeg'
          ]
        },
        bottom: {
          title: ['通过参观、交流与实践，青年们在零距离接触生产、工作一线的过程中逐渐明确了求职意识的重要性，在和人力资源负责人的互动中提升了职业素养，在实践与学习相结合的环境里点亮了新的职业技能。提升青年就业率，我们一直在行动。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765088566-437b4a61-27ad-4722-be66-67f6e62d1e5b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661765088434-82b58abd-94a4-419b-b367-1290bcaa4e42.jpeg'
          ]
        }
      }
    },
    {//2020-01-08
      title: '“职”引未来，启迪人生——2019职业指导能力提升计划比赛顺利举行',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826269931-4daa3145-6e99-4477-8e77-e5488a15c587.jpeg',
      linkTo: "/instanceItem?type=service&num=9",
      details: {
        top: {
          title: '“职”引未来，启迪人生——2019职业指导能力提升计划比赛顺利举行',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826269955-4da5ae5d-376c-4adc-a22c-22624d8cd75e.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['2019年11月14日下午，由叁昶承办的上海市就业促进中心“2019职业能力提升计划第八届职业指导师大赛”决赛，在上海开放大学国际会议中心展开激烈角逐。决赛随着上海市就业促进中心副主任沈浩的致辞拉开序幕，随后决赛现场以视频短片，回顾了“2019职业指导能力提升计划”的实施过程。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826255393-3cb4400a-afa6-453f-bf42-5164b4dd63dc.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826255384-08bf910d-2799-4a5b-8790-43db3a87a673.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826255387-a36a7d46-d6e8-4385-8515-0a953ac6305a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826255407-bd9407f0-3833-4362-abca-3e27cc7b4585.jpeg'
          ]
        },
        bottom: {
          title: ['今后，上海市就业促进中心将持续将职业指导能力提升计划进行下去，期待继续合作！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826262414-37009635-1d8d-471a-85ab-d8cfe1328b2d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826262435-d02ab27f-98b1-4f70-8625-ca4b2b39875a.jpeg'
          ]
        }
      }
    },
    {//2019-12-06
      title: '2018泰山论坛于上海宝山区举行',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826412901-73083503-56a4-4a2e-9472-a81cdfadf279.jpeg',
      linkTo: "/instanceItem?type=service&num=8",
      details: {
        top: {
          title: '2018泰山论坛于上海宝山区举行',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826414626-019afcb1-6416-4c90-b9a1-5b873f8fbb51.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['叁昶公司策划组织2018泰山论坛暨中国微能源网产业技术创新战略联盟年会于12月3日在上海宝山区举行。本届论坛由中国产学研合作促进会、上海市宝山区人民政府主办。来自政府和业界的能源专家先后就多能融合、能源资源节约和环境保护、微能源网系统及运营关键技术等问题发表观点。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826399657-2d51ecc1-d03c-477f-921a-4e7de6af842d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826399996-c8511831-129c-4457-a8e3-4041c611c8a4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826399983-428e5eec-1b8d-45ff-8ecb-125bacf629af.jpeg'
          ]
        },
        bottom: {
          title: '',
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826405895-0d249464-7543-435e-a54e-4520724852be.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826406273-95021615-ecb0-430e-ad3e-8fa947f28f05.jpeg'
          ]
        }
      }
    },
    {//2019-11-27
      title: '牢记使命、不忘初心——服务闵行党校，为祖国庆生',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826522388-7bdae000-3531-4c96-9749-345fe644a321.jpeg',
      linkTo: "/instanceItem?type=service&num=7",
      details: {
        top: {
          title: '牢记使命、不忘初心——服务闵行党校，为祖国庆生',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826522403-b3243281-6bc0-42dc-ad6b-9f7f0d831219.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为庆祝中华人民共和国成立70周年，落实“不忘初心、牢记使命”主题教育要求，9月27日上午，叁昶承办上海市闵行区委党校联合其他共建单位举行的“诞生”读书会暨中心组联组学习活动，闵行区委党校党员、全体教职工和闵行区第23期中青班全体学员等参加活动。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826502254-bd29b3b4-bebb-43b9-99bd-602074542960.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826502257-074a8138-f930-4599-88f1-fbecf0e82ba0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826502260-1366a5cb-b79f-468d-a75d-da5f74ffbc5a.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0',
            ''
          ]
        },
        bottom: {
          title: ['叁昶小伙伴在后台保障活动顺利举行。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826516225-5a5b5f61-c544-4f93-9f1d-1f1da0d9626d.jpeg'
          ]
        }
      }
    },
    {//2019-11-27
      title: '怀材抱德，匠心逐梦——助燃上海市材料工程学校40周年校庆庆典',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826639229-73f6deb0-ecb2-4a35-92b9-8c6341438887.jpeg',
      linkTo: "/instanceItem?type=service&num=6",
      details: {
        top: {
          title: '怀材抱德，匠心逐梦——助燃上海市材料工程学校40周年校庆庆典',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826639203-af073384-4cbe-4c9e-a127-65f927ac1468.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['10月26日，我司承办上海市材料工程学校40周年校庆活动在学校大礼堂隆重举行。上海市材料工程学校校长金怡，上海应用技术大学党委副书记、副校长王瑛，上海市教委职教处处长赵宁先后上台致辞。校庆献礼片<a href="https://v.qq.com/x/page/e3008hdyqht.html" target="_blank">《筑梦四十载 逐梦新时代》</a> 带领全场回顾了学校40年来厚德强技、励志笃行、立德树人的发展历程和办学追求。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826639203-af073384-4cbe-4c9e-a127-65f927ac1468.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826624151-fdb4eb6e-5201-419c-88e2-e1de96b3eecb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826624052-48be96ce-c3e5-47f5-aa0b-f9c6386112bb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826624054-80356424-7e4e-4a03-8ea4-b7b6ba81b3b8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826624054-3efc5718-3125-44bc-952a-18c008902b93.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826624682-e7c27ec0-82b0-46bc-98e7-668246c47b8c.jpeg',
          ]
        },
        bottom: {
          title: ['值此时刻，上海叁昶文化科技有限公司的全体员工祝愿上海市材料工程学校越办越好，打造上海职业教育示范品牌。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826631519-3aa4ff2b-f4d8-4d21-b06b-134883b4e40d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826631551-340e1f35-9d9d-4f1b-be75-31176fb13974.jpeg'
          ]
        }
      }
    },
    {
      title: '上海市学生职业体验日活动宣传片拍摄制作',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826760934-cd8dce24-c0ff-4ab5-b1f8-4e6b6bc8b382.jpeg',
      linkTo: "/instanceItem?type=service&num=5",
      details: {
        top: {
          title: '上海市学生职业体验日活动宣传片拍摄制作',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826760942-f301382f-3ec0-4e44-96a6-7673855bfaf8.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为落实全国教育大会精神和《国家职业教育改革实施方案》新要求，营造庆祝中华人民共和国成立70周年的良好氛围，由上海市教育委员会主办，上海市教育委员会教育技术装备中心承办了2019年上海市学生职业体验活动。本次活动围绕“迎祖国七十华诞，展职教时代风采”的主题，聚焦“体验职业，发现自己，启迪未来”，分五个阶段开展。“教博会体验活动”紧紧围绕“职业成才，匠心筑梦”的主题，设立“遇见未来的自己”职业体验互动专区，让观展者亲身体验职业教育的温度、高度与深度'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826747331-288095b3-c36a-4e70-ba53-14a985624f2f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826747281-412ebe27-35ae-4219-9ef2-2b3510417e20.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826747287-e8224ae2-e382-4c05-a474-0e2c3df96f75.jpeg'
          ]
        },
        bottom: {
          title: ['应活动通过新媒体平台、户外宣传、地铁广告、校园宣传等丰富途径开展广泛宣传的需求，公司策划制作了“2019上海职业体验日广告”，为活动多渠道宣传，并获得了良好传播效果'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826753608-146936f2-820e-4b65-910c-fdcac5eca3cf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826753715-0539a747-b502-44f2-99cc-8612de6a5aef.jpeg'
          ]
        }
      }
    },
    {
      title: '上海市星光大赛宣传片拍摄制作',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826868466-55db5181-475c-4e32-adeb-f377e6f73a38.jpeg',
      linkTo: "/instanceItem?type=service&num=4",
      details: {
        top: {
          title: '上海市星光大赛宣传片拍摄制作',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826868466-1e7a5e46-6286-492c-a20a-02751bc6ce86.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['上海市“星光计划”职业院校技能大赛，由上海市教育委员会、上海市人力资源和社会保障局、上海市教育发展基金会、上海市民办教育发展基金会主办，上海市教育委员会教学研究室、上海市教育科学研究院、上海市职业技能鉴定中心、上海科技馆承办。作为2019全国职业教育活动周系列活动之一5月11～12日第八届大赛在上海科技馆举办'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826854393-cd4e6a94-a9c8-4666-830a-7369ed2778f6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826854364-add2c0ac-410e-4910-a2dd-8eeabd1498ee.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826854361-666352dc-fd20-4484-af47-b864e0ee9568.jpeg'
          ]
        },
        bottom: {
          title: ['本届大赛在我国“一带一路”等大背景下，以“弘扬工匠精神，创造精彩人生”为主题，为职业教育学生提供了展示专业技能、实现人生价值的重要舞台。公司应需制作了2019第八届上海市星光计划职业技能大赛广告，投入大赛宣传，获得了良好传播效果。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826862382-20f38cdc-436a-4e25-9a4b-bd3c65593445.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826862314-b7579efd-a024-4b42-8dae-4f6ce6551595.jpeg'
          ]
        }
      }
    },
    {
      title: '上海市中等职业学校德育-思政精品课100例拍摄制作',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826968719-ed9deb88-731e-4f92-a0f9-2a739c3498b3.jpeg',
      linkTo: "/instanceItem?type=service&num=3",
      details: {
        top: {
          title: '上海市中等职业学校德育-思政精品课100例拍摄制作',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826968746-50e0e50b-b172-4311-8454-34fe8add59b5.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['习近平总书记从党和国家事业发展的全局出发，深刻阐述了上好思政课的重大意义，深入分析了教师的关键作用，明确提出了推动思政课改革创新的重大要求。为贯彻落实习近平总书记思想政治工作会议精神，经研究开展中职德育-思政课精品课100例建设工作。为进一步提升上海中职德育-思政学科教学质量。激发学校德育-思政课程教学改革活力。我司策划拍摄与制作了。具有时代特色的全媒体下的100例精品课视频。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826955564-95d73ecb-266b-4ec2-875a-116d46f06f26.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826955546-2be2ce7f-f7b3-4401-8af6-23d27b8f0b19.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826955560-7e5f7d1a-b6a9-4aa9-8382-c7bbbc043d49.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826955548-647d772c-d10b-43c5-878d-74c41a351619.jpeg'
          ]
        },
        bottom: {
          title: ['本次项目打造德育-思政精品微课100例，公司团队协调教师整理收集教学讲稿与课程资料，丰富视频内容、避免课程单调；梳理重点内容、落实基本环节、塑造关键行为；运用全媒体、大数据、智能化，以新兴的教育资源，助力不断开创中职德育-思想政治理论教育的新局面。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826962620-4351e2fc-dabe-4575-bd2a-403f2f5a2bfd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661826962635-8b415d25-7789-468b-9c89-afc8d6c4feee.jpeg'
          ]
        }
      }
    },
    {
      title: '闵行中学九十周年校庆',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827124826-e3bbfbe2-bb24-40be-90a9-eabbd1c50586.jpeg',
      linkTo: "/instanceItem?type=service&num=2",
      details: {
        top: {
          title: '闵行中学九十周年校庆',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827124968-453350ab-59a9-4056-ab19-54c56044024c.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['11月18日，公司策划开展了上海市闵行中学建校90周年校庆。本次活动邀请到政府部门领导、行业企业、共建单位、兄弟学校、媒体代表等参与。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827110612-9ad86f65-1c7c-4392-ada4-9d5d61cda5a0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827110608-fc7d85fe-df85-44a9-82ca-9cca81c22db0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827110657-5ea9832d-f374-43cc-bdac-10a99017080c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827110619-b3c66059-2e82-4bc1-b6a6-12beeece1370.jpeg'
          ]
        },
        bottom: {
          title: ['活动大获成功，不仅在学校师生中取得良好反响，更对全市高校学生德育产生了积极影响。*图片来自东方网教育频道'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827117922-9e78bf4f-684e-443f-a680-115bf2c4cdac.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827117973-181ef8f6-8542-4e47-85a7-3b05b516db29.jpeg'
          ]
        }
      }
    },
    {
      title: '万众瞩目的上海教育博览会展示',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827253623-d047396b-f8c2-4033-9139-6ddcf9341446.jpeg',
      linkTo: "/instanceItem?type=service&num=1",
      details: {
        top: {
          title: '万众瞩目的上海教育博览会展示',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827253686-e2706c83-db3b-407d-87c8-4a661199f536.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['2017～2019年，公司连续三年参与上海市教育博览会现场展示公司助力上海多家职校设计专业展区。策划了“水的故事”、“轨道交通仿真模拟驾驶”“汽车仿真模拟驾驶”“3D打印体验”等展示项目，融入VR、3D打印、远程互动等先进技术手段'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827239222-0a319eb0-7aa2-444e-9029-8df961ef5b4b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827239223-0e4f4f76-711b-4778-af7d-345bec18da27.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827239303-fe88e9a4-8472-429b-afac-91abdc4a4e9c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827239244-7c234aac-e473-4bc2-80b9-afb2b52b75b6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827239245-126284aa-3973-47ad-875b-af1e09321af5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827240052-49ed3de9-8f5f-4d3c-8369-4a2061d8645c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827240055-bf32c03c-2256-4f6b-abe3-8a1296716666.jpeg'
          ]
        },
        bottom: {
          title: '设计展位得到主办方、参观者和社会各界高度关注，帮助参展单位连续三年被评为“教博会十佳展台”。',
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827246905-1b9ee118-14f6-468c-b59a-a9387bb8ca34.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827246941-dc98a80d-aff8-42b6-b691-84987056e1ea.jpeg'
          ]
        }
      }
    },
  ],
  // 咨询类
  consultationList: [
    {//2021-01-22,amanda.阮宏宇
      title: '我们用“数据”讲述职教那些事！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446490-b4370ea5-8592-47f4-83fe-21718b80154b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=7",
      details: {
        top: {
          title: '我们用“数据”讲述职教那些事！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446512-2ad83ec0-196a-444b-8a31-13b35f8b6e8b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为更好地做好<strong>上海市中职生发展调研工作</strong>，叁昶公司于2021年1月15日邀请<strong>上海市学生事务中心就业服务部副部长杨彦辰，国家督学、上海市职业教育协会副会长鲍贤俊，中华职校校长黄玉璟，上海科技管理学校副校长周卫民，叁昶公司顾问王志卫开展上海市中职生发展调研工作研讨会。</strong>出席会议的还有<strong>上海市学生事务中心就业服务部周文济、尼平、鲍茜倩，叁昶公司常务副总曹鸣浩</strong>以及调研培训部相关人员。', '为了更好的开展<strong>中职校学生实习管理和就业服务工作</strong>，市学生事务中心于2020年11月26-27日召开了<strong>2020年上海中职校就业工作培训会</strong>，来自<strong>全市中职校就业办主任、数据员</strong>等<strong>共120余人</strong>参加。', '2021年1月13日，<strong>叁昶为上海市高级技工学校党政班子及中层干部、班主任近百名教师</strong>进行2018-2020届毕业生就业质量调查报告解读。', '2021年1月6日，<strong>叁昶</strong>为<strong>沪遵职业教育联盟部分成员学校领导</strong>进行“2017-2019届遵义在沪毕业生及上海市工程技术管理学校2019-2020届毕业生职后发展调研工作汇报”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426509-52d4d876-cb07-43ac-8271-72d9d7570455.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426493-77124c46-9cca-49b7-b1ea-59de39d71628.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426507-7cb80158-38e6-4709-a91d-5c3daee30a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426525-a4aff0b4-a547-49ec-867c-739ca8d8b741.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426511-9d0d5e78-bccd-4b47-8ad3-42035d2eee4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827427103-8a062a09-6165-4def-8067-c1a2d425f0e8.jpeg'
          ]
        },
        bottom: {
          title: ['工作培训会期间，<strong>上海叁昶文化科技有限公司常务副总曹鸣浩</strong>就2020年上海市中职毕业生职后发展调查报告<strong>“诞生记”</strong>，<strong>用数据说职教故事</strong>给<strong>全市中职就业办老师</strong>上了<strong>“一堂课”</strong>。', '<strong>上海叁昶文化科技有限公司</strong>作为<strong>业内知名</strong>的<strong>第三方数据咨询机构</strong>，自2017年开始<strong>连续撰写发布《上海市中职毕业生职后发展调查报告》</strong>，为上海市中等职业教育人才培养<strong>提供数据支持</strong>。在2020年新冠疫情影响下，<strong>叁昶</strong>撰写的2020年<strong>《上海市中职毕业生职后发展调查报告》</strong>为<strong>上海市教委</strong>在中职生就业方面采取应对措施提供数据支撑。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439806-52c7febb-ef29-46b1-9c6e-75e4abe2669f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439984-37be7a0c-ad86-4b1e-b370-2a66ffea8cb0.jpeg'
          ]
        }
      }
    },
    {//2020-09-14,amanda.阮宏宇
      title: '科学调研，叁昶助力2020年上海市中职生职后发展跟踪调查项目工作正式启动啦！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585097-32c84074-e590-4833-9084-73418bb45d54.jpeg',
      linkTo: "/instanceItem?type=consultation&num=6",
      details: {
        top: {
          title: '科学调研，叁昶助力2020年上海市中职生职后发展跟踪调查项目工作正式启动啦！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585126-3daed20c-22c1-4e50-8824-01c3b86defd0.jpeg'
        },
        lunbo: {
          title: ['2020年9月8日（周二）下午2点在<strong>上海市学生事务中心</strong>召开了<strong>2020届上海市中职生职后发展跟踪调查项目启动工作研讨会</strong>，参加会议领导有上海市教委副处长<strong>谢俊</strong>、上海市学生事务中心副主任<strong>周红星</strong>、就业服务部部长<strong>周璐璐</strong>、就业服务部副部长<strong>杨彦辰</strong>、就业服务部<strong>周文济</strong>、<strong>尼平</strong>，参加会议的专家有上海市第二轻工业学校校长<strong>滕琴</strong>、上海电子工业学校副校长<strong>张贯彻</strong>、上海市环境学校副校长<strong>王亚彬</strong>、上海科技管理学校副校长周卫民、上海市城市建设工程学校（上海市园林学校）招生就业办主任<strong>章春泉</strong>以及上海叁昶文化科技有限公司<strong>调研团队部分成员</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567574-a5b343a6-0f5a-46f7-92ee-63cd6c6f6170.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567516-a43df773-dd64-4de9-adff-56bad3707d64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567485-b7dbd9c2-b9ce-4854-91c5-f0d990d88b85.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567643-511a26dc-0db5-4a71-b266-19469d3afc8b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567486-1bf77693-2eba-4ea0-ae65-4f3d18d2cd82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567905-c5e3c1fe-b3e9-4304-ab13-9eb229198bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568014-b90ec268-0732-4094-b17c-832bf4bb13d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568160-ecf5b61b-5c2b-45ae-abcb-0c03ba32abc8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568190-91d39f5a-038c-47cc-854e-0153c9cf6fc6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568251-5ed880c1-c073-45a2-973e-52f6d9309480.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568568-6e1661da-2e15-4a0a-9343-c8ac745bc104.jpeg'
          ]
        },
        bottom: {
          title: ['会议上，叁昶文化科技<strong>常务副总曹鸣浩</strong>就2020年全市中职生职后发展调研工作思路和具体安排做了<strong>工作汇报</strong>。期间，<strong>谢俊副处长</strong>频频与各位专家<strong>互动</strong>，对报告的细节展开研讨，认为做好中职生职后发展跟踪调查是<strong>非常有必要</strong>的，将为教委提供很好的<strong>政策决策依据</strong>。<strong>周红星副主任</strong>要求，要“<strong>不忘初心</strong>”，紧紧围绕职教工作需求，做好调研工作，为上海教育<strong>做好数据分析工作</strong>。期间，与会领导、专家还围绕调研工作进一步增设部分专业、关注“<strong>对口</strong>”支援群体等的话题展开了深入探讨。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576223-1060acb1-bbdd-4317-b86c-13a1750e5051.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576244-ab981bf4-57c6-40b6-a503-9f1b9bd8bc30.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576237-72b9ab30-b19e-4fff-954a-7b8d734c55d2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576252-0a058c48-fd81-49d4-89ef-8f60a98d1b92.jpeg'
          ]
        }
      }
    },
    {//2020-04-09
      title: '传承美丽，破茧成蝶——普通中职生也能成为优雅ACIC国际注册高级礼仪培训师',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827747026-4fd7bfbd-9048-4b17-a4e2-f6f561d279c3.jpeg',
      linkTo: "/instanceItem?type=consultation&num=5",
      details: {
        top: {
          title: '传承美丽，破茧成蝶——普通中职生也能成为优雅ACIC国际注册高级礼仪培训师',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827747027-f3d8b220-fd80-4bda-a4e9-e4fdc561ab07.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['叁昶公司连续三年承接上海工商外国语学校礼仪培训项目，项目包含了各年级全员轮训、“五大古礼”仪式活动、礼仪校本教材开发等。在2019年全员培训活动中，由学校自主推荐，<strong>叁昶全程组织培训的7位学员率先进行美国ACIC注册礼仪培训师考证工作，经系统课程培训和多轮严苛考核，全部获得了“美国ACIC注册礼仪培训师”证书。</strong>ACIC国际资格认证证书被162个WTO成员国政府全部认可,ACIC认证学员是国际化人才和通晓国际惯例的标志。这7位优秀学员是工商外的骄傲！他们不仅以良好的精神面貌和优异的成绩展现工商外学子的风采，更是身体力行践行了学校的校园文化品牌——“融和文化”。“融和创新，合作共享”，工商外学子们在蓬勃发展的新时代不断锐意进取、开拓创新！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827735057-35b66875-33c8-4c71-935a-a4270361e6d9.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827734991-76c7a550-6bdf-4491-b6c8-08a8984b9d21.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827736290-7c503d96-c5b8-4000-9fb8-4084ad9091da.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827735028-21f2dacf-aa00-46fd-a97d-cba486318bac.jpeg'
          ]
        },
        bottom: {
          title: ['余秋雨曾经说过：礼仪就是文明人的行为规范，甄别一个人的文明与低俗，就是看这个人有没有礼仪！青少年时期是校园礼仪教导的最佳时期，叁昶以正规的培训体系、完善的培训课程、名师保驾护航、情景实战演练，对在校学生有着严格的礼仪达标标准，彰显公司的综合培训能力。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827735028-21f2dacf-aa00-46fd-a97d-cba486318bac.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827740488-e8af4ece-c49c-46ac-93f9-e63bcd9984e6.jpeg'
          ]
        }
      }
    },
    {//2020-04-07
      title: '抗疫争“先锋” 调研不“掉线”——叁昶完成上海科技管理学校毕业生职业生涯发展跟踪调研项目',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827881835-f99a8cea-f06f-40b5-a897-344ad2cb0bf3.jpeg',
      linkTo: "/instanceItem?type=consultation&num=4",
      details: {
        top: {
          title: '抗疫争“先锋” 调研不“掉线”——叁昶完成上海科技管理学校毕业生职业生涯发展跟踪调研项目',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827881831-302bea4a-7305-49a0-90a4-d6e77809a305.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['疫情当下，叁昶公司积极响应政府号召，自2月10日起开始逐步复工复产，在做好自身防疫工作的同时，为近200所各类院校提供了优质的防疫物资保障服务工作。期间，公司数据调研团队克服各种困难，采用线上办公，线下研讨等形式，坚持不“掉线”，通过近1个半月的努力，顺利完成了上海市科技管理学校2016-2018届毕业生职业生涯发展跟踪调研项目。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868346-63907df7-333a-4379-8d33-82b86f646d51.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868343-80356287-293d-48ea-8a6a-8d1206ae9351.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868343-bc875b01-d825-45fb-8cde-bd1e072e49f0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868348-6da477cd-5a68-4779-a24b-fb6375ffb497.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868349-84212e96-d4c0-4d0b-8d34-322f3fd5df48.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827868808-6c2357b7-9867-4ecf-acea-c53dfd487049.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827869005-ac5ca952-3004-4fcf-8984-f0d1e71e66c6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827869242-b377a17a-7b35-4886-aaa8-4a016a2298f7.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827869388-c4df6bd9-9ae9-4abc-a0a0-28a4ee221162.jpeg'
          ]
        },
        bottom: {
          title: ['为更有效地采集数据与更深度地了解数据背后的职教故事，团队与学校就业指导部门也是通力协作，定期召开网上会议，随时沟通调研细节，确保了项目质量。该报告，将学生分为“普通中职学生”、“中高贯通学生”、“星光获奖学生”、“遵义对口学生”等四大类进行系统分析，形成了七大章节，近两万五千字的高质量报告，为学校发展提供有力的数据支持。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827875163-6788edaf-8564-4299-9780-afe1040d33c3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827875181-dda38aed-cf84-45bf-b285-255ca4a05a67.jpeg'
          ]
        }
      }
    },
    {//2020-01-10
      title: '深挖数据价值链 赋能教育现代化——叁昶公司助力毕业生就业质量跟踪调查项目',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828017453-5863e69f-b081-4936-9862-1849ed89f02b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=3",
      details: {
        top: {
          title: '深挖数据价值链 赋能教育现代化——叁昶公司助力毕业生就业质量跟踪调查项目',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828017451-bdbc99f7-a0fb-4d4a-9e3f-574ee689270f.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['叁昶作为业内知名的第三方数据咨询机构，自2017年开始连续撰写发布《上海市中等职业学校毕业生职业生涯发展跟踪调查报告》，于2019年承接首次“上海高职高专毕业生就业质量跟踪调查”项目，并承担上海市多所学校毕业生就业质量及职业生涯发展调查项目的数据调研和数据分析工作。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828004596-143c8dec-3994-4be1-89db-51e73c695a80.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828004598-0a28123f-6098-48be-ae2d-269e4deb785c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828004599-b1510606-3e6a-4b58-923f-e9b040987540.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828004639-369e5dca-a2b4-4434-9b83-f5b2139e19ef.jpeg?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828004607-c066319f-e920-407f-8525-5aa92d9f67b8.jpeg',

          ]
        },
        bottom: {
          title: ['习近平总书记在全国教育大会上强调，要把立德树人融入思想道德教育、文化知识教育、社会实践教育各环节，贯穿基础教育、职业教育、高等教育各领域。编制和发布毕业生就业质量报告是落实立德树人根本任务的重要举措，对完善就业反馈机制、深化人才培养改革、指导学生成长发展有重要意义。叁昶调研团队也同时尽心尽力落实习总书记所强调的建设内容，立志用数据说话，还原一个更为准确的教育环境。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828010843-1f903349-5acc-4514-93e1-1504274cca74.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828010843-1f903349-5acc-4514-93e1-1504274cca74.jpeg'
          ]
        }
      }
    },
    {
      title: '中职毕业生之后发展调研项目',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828131108-4d9cdc58-47f4-4f83-8e54-5e3216ff9dc5.jpeg',
      linkTo: "/instanceItem?type=consultation&num=2",
      details: {
        top: {
          title: '中职毕业生之后发展调研项目',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828131114-8553426e-d817-4101-9deb-804ab7534636.jpeg'
        },
        lunbo: {
          title: ['中职毕业生的就业质量不仅关系到社会的和谐稳定，更加关系到职业学校人才培养目标的顺利实现。通过对就业质量的检测与分析，进一步优化中职教育模式，调整中职教育布局。深入了解中职毕业生入职后的发展状况，了解毕业生就业现状、对学校教育教学评价和各用人单位对于中职毕业生岗位表现的评价等。公司应需求开展了多次毕业生职后发展调研活动策划、运行、撰写、组织。连续两年度参与上海市2010—2018届中职毕业生职后发展调查，并承接上海市房地产学校2015-2017届毕业生职后发展调查、复旦大学药学院2013-2018届毕业生职后发展调查等调研活动。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828117570-8d8e9a09-0803-440b-9555-0613cfdee9ad.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828117602-b76c0566-85da-4704-b9bb-3d74479f06fa.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828117602-b76c0566-85da-4704-b9bb-3d74479f06fa.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828117589-93aa5e77-579c-4701-86c4-3d337d9c42c0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828117669-f6ff27d2-19c7-4dc6-a414-86b508941eb9.jpeg'
          ]
        },
        bottom: {
          title: ['调研采用了科学的数据处理方式，针对数据条进行科学采用、数据预处理。并提供专家研讨、结题汇报、数据解读等增值服务，得到众主办单位的一致好评！一天两会聚焦学生职后发展大计——于东方绿舟大会宣讲理念、冠生园路小会结题汇报，学生事务中心领导、沪上知名职教校长共同关注职教，关注学生生涯发展。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828123385-fb53af32-74ff-4447-b00f-a2ec5b4bb57b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828123355-02284978-1e55-45fc-92d6-0111d7fbd34d.jpeg'
          ]
        }
      }
    },
    {
      title: '复旦大学药学院毕业生就业质量调查研究',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828235509-7bac6802-80f5-48ee-ae78-e5f237ec6714.jpeg',
      linkTo: "/instanceItem?type=consultation&num=1",
      details: {
        top: {
          title: '复旦大学药学院毕业生就业质量调查研究',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828235502-ccfbd627-3baf-4b4d-bccb-b3f309e2bd52.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['应复旦大学药学院需求，公司设计策划了其2014～2018届本科毕业生就业质量调查并做研究报告'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828230182-35560943-449c-4fd3-be9d-f7f2eed59ff3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828230031-dfdf2aaf-743c-46d7-be8d-13d3323a77a2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661828230020-f0d512d7-d4c1-4ada-be44-b6172eeb9088.jpeg'
          ]
        },
        bottom: {
          title: ['本次调研方法主要采用问卷调查法，包括网络问卷调查和电话问卷调查。根据学院的要求，设计的指标涵义明确，测算方式标准，统计计算方法规范，能够反映本科毕业生就业状况的内涵和目标的实现程度，保证评估方法的科学性和评价结果的真实性、准确性，为复旦药学院的统计工作提供了一大助力。'],
          img: []
        }
      }
    },
  ],
  // 近期活动类
  activityList: [
    {// 20260705 周晓强
      title: '展陈空间｜构建叙事场景，塑造沉浸观感',
      time: '2026-07-05',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724313-66171501-659c-4495-b9ee-bbd49d63559a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=65",
      details: {
        top: {
          title: '展陈空间｜构建叙事场景，塑造沉浸观感',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724313-66171501-659c-4495-b9ee-bbd49d63559a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶坚持一展一方案的定制化设计，以空间叙事+沉浸式多媒体交互，打造主题清晰、动线合理的一体化交付精品展陈空间。',
          ],

          img: []

        },
        bottom: {
          title: [''
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724285-834a0675-3120-494b-873b-51e8b1199349.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387724276-3978b4b7-171c-4b13-9cdf-dd52f51dafa3.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260704 周晓强
      title: '街道站点｜激活城市末梢，赋能基层服务',
      time: '2026-07-04',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692313-63088663-2bdf-49f2-bca1-492cfa83d5cc.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=63",
      details: {
        top: {
          title: '街道站点｜激活城市末梢，赋能基层服务',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692313-63088663-2bdf-49f2-bca1-492cfa83d5cc.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶依托众多基层点位落地实操经验，为北站街道量身打造第一综合网格工作站、党群服务中心。',
          ],

          img: []

        },
        bottom: {
          title: ['第一综合网格工作站以“多格合一”为抓手，合理规划动线、功能、展示，服务等合理化布局及样式展示；党群服务中心集基础党务、图书阅览、健身运动、艺术互动、儿童活动等功能于一体，秉承“开放式、集约化、共享性”的理念，利用技术赋能、创新呈现，大力探索党建宣传及教育新形势。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387692297-aaf75fd1-6ee6-4293-8e8a-84fed9f557fe.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260703 周晓强
      title: '主题公园｜融汇人文景致，助力技能传承',
      time: '2026-07-03',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387643147-7ab8b129-5843-445a-9dbf-fd1aade50384.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=62",
      details: {
        top: {
          title: '主题公园｜融汇人文景致，助力技能传承',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387643147-7ab8b129-5843-445a-9dbf-fd1aade50384.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶为上海闵行职业技术学院建造的技能公园，以"传承匠心淬炼卓越"为核心主题，通过空间叙事与景观艺术，展现人类技能文明的演进脉络与工匠精神的永恒价值。',
          ],

          img: []

        },
        bottom: {
          title: ['园区以"技能之路"为游览主线，串联起技能启蒙、锤炼、升华与沉淀的全过程，打造一座兼具教育性、互动性与艺术性的沉浸式文化体验空间。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636853-e86df25e-ee96-4d09-a182-c9cd047347ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636651-290c4ec9-5354-467b-bc1b-f57c834a05cc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387635839-b312a7e1-39d1-40d4-abfa-2e5d9b39946b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387636261-a3fd6d77-c5f0-4248-9238-1ccb774bee6d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387636970-848b66c8-4bf8-4294-bec2-804a3d22ba58.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20260702 周晓强
      title: '党政阵地｜筑牢红色根基，夯实思想堡垒',
      time: '2026-07-02',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587156-c24be6fa-e54f-4da6-bc71-3dc3543dec21.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=61",
      details: {
        top: {
          title: '党政阵地｜筑牢红色根基，夯实思想堡垒',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587156-c24be6fa-e54f-4da6-bc71-3dc3543dec21.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托成熟的一体化空间交付能力，叁昶团队凭借丰富的党政类标杆落地项目落地经验，定制化打造特色党政阵地。',
          ],

          img: []

        },
        bottom: {
          title: [''
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587221-4d459cbd-3b0a-4b85-854a-adde9c1a5a57.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387587193-0c7303ce-a544-42c4-9370-1cb623d64441.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260701 周晓强
      title: '文化建设｜雕琢空间肌理，沉淀人文底蕴',
      time: '2026-07-01',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531508-d61b63f9-bc3d-4c88-9153-b17b4c65a518.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=60",
      details: {
        top: {
          title: '文化建设｜雕琢空间肌理，沉淀人文底蕴',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531508-d61b63f9-bc3d-4c88-9153-b17b4c65a518.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托大量高水准落地项目的持续淬炼，叁昶团队以定制化设计为起点，沉浸式体验为语言，一体化交付为承诺，形成了以文化空间建设为核心、多元场景协同拓展的业务格局。',
          ],

          img: []

        },
        bottom: {
          title: ['从轻量化局部改造到综合性展馆建设，叁昶业务全面覆盖立体化文化建设。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531609-8d47c24c-e035-4975-ada7-2eb00ecf0f4c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387533717-d04a407c-4850-4eb4-92d5-f08b004615bc.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531565-237d45b1-b35a-446f-a056-69f0c81c868c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387531555-614a7f2b-c423-4392-955e-0cb8de2d909c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532534-d860f3df-462d-4deb-8db2-aeed81bc01ba.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532631-ed3adc46-5537-4087-8ae9-c7c76fa2fdef.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387532827-89fa85ff-6622-4d2d-b3c1-315ad8dbcf0a.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260630 周晓强
      title: 'AI赋能｜叁昶 12 大诊改功能模块全新上线',
      time: '2026-06-30',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387164126-a751c65c-d915-4803-a7e6-22e8a1c42148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=40",
      details: {
        top: {
          title: 'AI赋能｜叁昶 12 大诊改功能模块全新上线',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783387164126-a751c65c-d915-4803-a7e6-22e8a1c42148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['针对当前上海中职诊改复核标准持续更新，院校普遍存在多套数据重复填报、台账繁杂、质量监测缺乏可视化工具、迎检溯源难等痛点。叁昶<strong>全新上线12大诊改功能模块</strong>，打造AI赋能、数据互通的一体化诊改平台。',
          ],

          img: []

        },
        bottom: {
          title: ['整套升级模块<strong>对标全国人才培养状态库，打通国市校三级数据链路，配备双版本数据底座</strong>，适配不同院校需求，同时<strong>集成五层AI智能画像与五大业务管理模块</strong>，精准匹配上海中职诊改复核要求，支持院校按需灵活选配。',
            '未来叁昶将持续迭代智能化、标准化诊改工具，助力院校深化内涵建设，推动职业教育高质量发展。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783387172226-78972200-83df-4358-b4b7-e12cda1310a5.png?x-oss-process=image%2Fformat%2Cwebp']
        }
      }
    },
    {// 20260625 周晓强
      title: '智慧操场 | 打造可感知、可量化的实践成果',
      time: '2026-06-25',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474741391-005dfb1f-b9e4-4928-8028-5970da9d0669.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧操场 | 打造可感知、可量化的实践成果',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474741391-005dfb1f-b9e4-4928-8028-5970da9d0669.png?x-oss-process=image%2Fformat%2Cwebp '
        },
        lunbo: {
          title: ['通过物联网摄像头+人工智能运动视觉算法，叁昶将机器视觉与体育教育深度融合，实现中小学、普通高中体育教学、自主锻炼、标准化体质测试等全场景使用需求，解决体育教学、测试信息化资源缺乏等难题。'
          ],

          img: []

        },
        bottom: {
          title: ['目前叁昶团队已成功助力20余项校园智慧操场及体测室的智能化建设及升级。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474750804-00fdd3d2-5c44-47a9-85b2-08610b1dfff4.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474750849-69d0c141-e4e8-43d4-98e2-918967aadec2.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260624 周晓强
      title: '智慧教室 | 以科技助力焕新 以智慧赋能课堂',
      time: '2026-06-24',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474489801-0ce335dc-305d-4437-a48f-cb24bd78b8b6.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧教室 | 以科技助力焕新 以智慧赋能课堂',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474489801-0ce335dc-305d-4437-a48f-cb24bd78b8b6.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['多年来，叁昶始终专注于数字化升级与文化空间营造的双轮驱动，构建起从方案策划、技术研发、工程实施到售后运维的完整服务闭环。'
          ],

          img: []

        },
        bottom: {
          title: ['运用文化+科技，艺术+技术的理念，叁昶团队通过对设备的全面升级与功能优化，将原有教室改造为满足现代化教学需求的智慧教室，以适配新的功能定位，提升教学体验与管理效率。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500596-193b03ac-8387-4188-a329-7aabe3cfae5f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500555-7084d858-7998-41d1-8eb2-5594f9bae64a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500545-0e094e5e-e2a5-41d0-b136-bed76d17cc97.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500573-1b6cf01d-edd8-4eef-abb8-0075700d6e5c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474500610-1e0fd43e-f0eb-4c6a-80c7-e8fd7f1b9826.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474501456-dc641153-3545-4654-94fd-79de0f557775.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260623 周晓强
      title: '智慧报告厅 | 以境育学 焕发教育新活力',
      time: '2026-06-23',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474301619-148c472f-0e4a-4b4f-9dcb-747c42b8f64a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧报告厅 | 以境育学 焕发教育新活力',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474301619-148c472f-0e4a-4b4f-9dcb-747c42b8f64a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['依托数字化软硬件集成，叁昶致力于打造集“智慧化、多功能、沉浸式”于一体的现代化报告厅，构建集约便捷、特色鲜明的智慧空间。'
          ],

          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296718-4781b133-ee9b-4bf6-8568-e8ff75f5b50d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296781-5dfab54a-24d5-48c9-a905-3189b439cf99.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296645-2c8c1d7f-f9a5-4da3-8536-ddfcae76ae4d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474296779-a64c6f2d-8005-49a1-811e-80c21b7ea033.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260622 周晓强
      title: '智慧研学空间 | 助推数智升级 践行一体化服务',
      time: '2026-06-22',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474078570-275dedb5-cb72-4d17-bf54-922b14de927f.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧研学空间 | 助推数智升级 践行一体化服务',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474078570-275dedb5-cb72-4d17-bf54-922b14de927f.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['以沉浸式体验与环境智能交互为核心，叁昶团队通过对物理空间的立体化视觉重构与多维交互能力的深度融合，构建一个能全方位激发感知、促进情境化认知与协作探究的沉浸式智慧研学空间。'
          ],

          img: []

        },
        bottom: {
          title: ['从规划落地，到部署运维，叁昶团队以全生命周期服务为支撑，全面赋能硬件升级与服务增效。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087849-136e295a-23b1-4906-935a-09405172bb42.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087823-c6a306de-5158-4d73-b27a-b4ec1f2d9189.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474088118-dba67e9d-120e-4c70-a45e-6cc270cf391b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783474087941-d6c8e4c5-4a5c-46c8-a50d-0de1dada128a.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260612 周晓强
      title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
      time: '2026-06-12',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473780077-fe10b024-2b3a-4335-808d-3bbe7bb7b13e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473780077-fe10b024-2b3a-4335-808d-3bbe7bb7b13e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['6月12日，由教育部组织，由中国建筑集团有限公司、同济大学、上海城建职业学院三方牵头，汇聚60家企业、普通高校、职业院校参与的国家城市更新行业产教融合共同体在上海成立。本次会议主视觉设计、活动策划保障、背景视频、内外场搭建、全套物料均由叁昶团队全权负责。'
          ],

          img: []

        },
        bottom: {
          title: ['团队以专业的服务标准，深度参与本次会议的主视觉设计、环节策划，负责内外场搭建保障及全套物料制作，圆满呈现60位共同体代表同台参与的国家城市更新行业产教融合共同体启动仪式、32家校企合作单位签约等重磅环节，收获主办方及参会嘉宾的高度认可。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473789664-8a955025-903c-4a59-9404-82e9dbd2d8bd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473789646-92298138-9d4c-4734-82b6-4060ddeed147.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473792210-7342267c-5bf2-440e-84d8-df89ffc1dd18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20260516 周晓强
      title: '叁昶护航 | 以青春之名，驰骋技能赛场！',
      time: '2026-05-16',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473525293-a6392b37-3111-4185-a0f1-16c78e87915b.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航 | 以青春之名，驰骋技能赛场！',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473525293-a6392b37-3111-4185-a0f1-16c78e87915b.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['近日，第十五届上海市大学生机械工程创新大赛暨第十二届全国大学生机械创新设计大赛上海赛区预赛在上海理工大学圆满落幕。',
            '本次大赛以“灵巧智能，美好生活”为主题，设“特定水产品初加工机械”“高性能仿生蝴蝶”“叶菜洁净化处理包装一体化机械”三个赛道，鼓励学生通过创新设计与智能技术的融合，为相关产业发展提供更便捷、更智能的技术解决方案。来自上海交通大学、同济大学等17所高校的179支参赛队伍同台竞技，参赛师生近800人。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536486-e7b67087-889d-4e1c-97fe-f07fc298a5a6.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536882-90feb5d7-c06d-4558-ac7b-da63bb6da767.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473536588-5f0e2185-ae8b-4f36-b230-6a8b56e5ef55.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶深度参与本次大赛的<strong>策划筹备、赛区搭建、开闭幕式、现场保障、全套物料及环境布置</strong>，受获一致认可和好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555294-1d635c84-0da2-4a94-80e7-cfe2fd36d2e9.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555297-3cd9b550-eb45-41da-9206-6cb25cbfae9b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555300-f3b58a32-8972-462c-8ec9-f70308bc92dd.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555018-17f58006-c14e-45e5-bddf-39a869af92d8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783473555247-cd715778-dc3c-4fa2-95c2-3d1cfc9b2f9c.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260516 周晓强
      title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
      time: '2026-05-16',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473269779-28299cf0-1a0d-4566-89c1-db92afc2adc5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶护航｜国家城市更新行业产教融合共同体在上海成立！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473269779-28299cf0-1a0d-4566-89c1-db92afc2adc5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，“匠心筑梦，人人出彩”——2026年上海职业教育活动月启动仪式暨上海市中等职业学校第九届“璀璨星光”校园文化节开幕式在上海信息技术学校举行。上海市教育委员会副主任赵震出席。',
            '此次活动月启动暨“璀璨星光”校园文化节开幕，集展示、观摩体验活动等为一体，叁昶深度参与本次活动的策划筹备、视频制作、原创节目、视觉舞美及环境布置，受获一致认可和好评。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281757-9565f1ea-4c51-4bcc-936f-e9b9fe950159.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281640-64b1d3c9-877b-4770-bf66-76754a2f304a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281604-bddc38e9-3614-4588-b936-c9fe40f96db1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281847-ce2bf24c-d1ea-44ea-aa48-aef95214fc3e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473281588-3a2e0506-8288-4c57-993b-10e80937f202.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473282834-4d9b9d68-05ac-4583-8442-3a81d18e2f62.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473283095-b419e9f9-da8f-428d-af2d-6293dac65ded.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783473283201-ef545ba2-079d-4efc-b84c-514e8248e60b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20260328 周晓强
      title: '叁昶助力 | 城建职院召开“重服务、强贡献”职业教育综合改革推进大会',
      time: '2026-03-28',
      img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472956149-3a5848d1-4e74-42f6-a72e-80eeb7b0f9dc.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '叁昶助力 | 城建职院召开“重服务、强贡献”职业教育综合改革推进大会',
          img: 'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472956149-3a5848d1-4e74-42f6-a72e-80eeb7b0f9dc.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['3月28日上海城建职业学院“重服务、强贡献”职业教育综合改革推进大会在奉贤校区顺利召开。中国职业技术教育学会会长、教育部原副部长鲁昕，上海市教委副主任、总督学刘玉祥出席会议。城建职院校领导班子、教职工及各界嘉宾300余人参会，共商职教高质量发展大计。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969011-9ad35665-6b92-4286-9645-1e982688bd3c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969306-cd1f1ab0-68d6-413e-b628-b18a067ce299.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969090-f5e41471-7ce0-4c1d-8709-9b1c35a7b898.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472969158-1a4c74a5-1fc6-4c8d-b6cf-5eef93a513b2.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [
            '叁昶深度参与本次大会的<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置</strong>，收获一致认可和好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472992483-3878f458-e9c1-4631-a816-27e70c579132.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783472992479-3e1a96aa-bf0b-46d1-a983-29b299ff91f4.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20260211 周晓强
      title: '汇骐骥腾辉颂硕果，仁心筑梦启新程  | 叁昶助力国妇婴2026年春节迎新表彰大会暨职工文化艺术节开幕式圆满完成！',
      time: '2026-02-11',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415580988-966e3923-c26f-4771-ab62-9187960c53c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '汇骐骥腾辉颂硕果，仁心筑梦启新程  | 叁昶助力国妇婴2026年春节迎新表彰大会暨职工文化艺术节开幕式圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415580988-966e3923-c26f-4771-ab62-9187960c53c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2月11日下午，“骐骥腾辉颂硕果，仁心筑梦启新程——2026年春节迎新表彰大会暨职工文化艺术节开幕式”在国妇婴徐汇院区报告厅举行，医院党政领导班子成员、获奖职工代表一百余人欢聚一堂，表彰先进典型、共话发展成果，同时开启 2026 职工艺术文化节新篇章，共迎丙午马年的到来。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592229-9f215ee2-15f7-4b77-92d3-961045ab81aa.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592269-13974adc-1efe-4ce7-8e23-add6df5d84d3.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592414-063f0cdd-7b4e-450a-8b15-3fe8d3912b8d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592403-c76af084-9a89-4877-958a-d0c795350fab.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415592358-de67058f-e50f-49bf-9542-87be6cdaaea6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415593307-5459631d-f2a3-4495-a7ee-a41c113103ee.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415593552-7a02dcdd-9077-4fe5-9637-1dae5603eea5.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['整场活动在<strong>《来嘛过新年》</strong>激动人心的律动中拉开帷幕；现场播放的视频<strong>《逐光而行・共护新生》</strong>，生动再现了过去一年里，全体国妇婴人在守护新生命、关爱妇幼健康道路上砥砺前行留下的足迹；<strong>改编歌曲《一路同行着》、手舞《苍穹唤》、企鹅舞《高雅人士》、女声合唱团的《Try Everything》</strong>，以及尾声领导们的<strong>新春贺曲《步步高》</strong>更将现场氛围推向高潮。',
            '本次活动<strong>策划方案、舞美呈现、原创节目、视频制作、视觉画面及氛围布置</strong>均由叁昶设计、落地并全程保障，将众多精彩纷呈的多元形式贯穿始终。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604666-c3b7bf78-b758-45c8-be83-07021651e65b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604616-aaec9aec-104d-480d-80a2-65d1825783e4.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604662-698a5a60-91db-4a34-813a-f77663364f13.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604534-d033d5b3-b0f0-4913-b4b4-471792ccdb4b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415604712-ae032dc7-bb85-4582-a791-dab903f76b20.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415605484-c07915a6-e7c4-4c05-8f1e-e9ff8fab7c2b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415605685-c2703d7d-a56f-4f2e-a347-28c2e3bf8633.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20251223 周晓强
      title: '焕新升级 | 叁昶助力“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”圆满开幕！',
      time: '2025-12-23',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415193622-30065df3-4cde-4154-9d8b-5cffcc8214a9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '焕新升级 | 叁昶助力“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”圆满开幕！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415193622-30065df3-4cde-4154-9d8b-5cffcc8214a9.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['12月23日下午，“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”正式启幕。市区相关领导、企业代表、职教专家及区域内四所中职校师生、中小学嘉宾齐聚现场。',
            '叁昶深度参与本次活动的<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置</strong>，收获一致认可和好评。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206257-2f421f87-b484-4fb5-b651-42ad6e14acbf.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206321-5dce8df8-a9f0-4bb1-8248-e0762f1c7240.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206337-d6b8b60c-3638-4635-8414-a0d3d71e95e1.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206377-6909e4ef-0604-48be-88f5-13568c20baef.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415206291-022a8a8d-33f5-4908-b2bc-cd257bda88c3.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207121-cbcbb637-c459-4012-a8c1-0b68c2ba96ff.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207352-b294c603-cfc8-4b3d-acee-0f1013f3a003.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415207320-ee4ba408-fc68-433a-ac8d-30294709af4d.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['此次“智享汇创2.0——2025年徐汇区中等职业学校学生人工智能节”，集展示、赛事、互动体验为一体。开场表演“AI舞动 智享汇创”呈现人机共融，瞬间点燃全场；情景讲述环节中设置了现场连线，将匠心传承搬上舞台；核心环节徐汇区中职生AI创新设计大赛总决赛，亮点十足；此外启动环节、互动问答、专家点评及尾声合唱环节等多元环节，兼具科技感、教育性与观赏性，全方位展现徐汇中职学子的人工智能创新风采。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221512-dd754bfe-3b76-4ed9-ae0b-01c285eccdc6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221497-44fa171c-ca3f-4a97-a425-990190136615.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221538-775bfb1e-9684-43dc-b1ae-a8d1eceaa59e.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221538-e3108321-2d1f-47d2-ba11-25ac3018ee8b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415221664-7d191bab-c2f7-44b5-b590-90b44f609ca6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415222546-7e58c379-34e3-4f71-83ae-ed03f9726c4b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783415222676-3fb14947-5965-4932-94be-2753ed69d492.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20251214 周晓强
      title: '首秀即样板，出手必出彩 | 叁昶保障中国基础教育国际论坛圆满举办！',
      time: '2025-12-14',
      img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414738867-3a3608f9-0dd2-49df-98c3-23b01163f764.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '首秀即样板，出手必出彩 | 叁昶保障中国基础教育国际论坛圆满举办！',
          img: 'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414738867-3a3608f9-0dd2-49df-98c3-23b01163f764.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2025年12月13日-14日，中国基础教育国际论坛（CICBE 2025）于上海举行。论坛由中国教育学会、北京外国语大学、上海师范大学、上海市嘉定区人民政府共同主办，主题为“人工智能发展与教育教学变革——机遇与挑战”。教育部党组成员、副部长任友群视频致辞'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414753527-022108d1-69c9-4931-b223-fdb402ef16b9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414753798-e8197048-eb4d-4fc4-8f4f-e30575eacd43.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754039-ca450dcc-fc00-41d4-8b0f-0384a09919c2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754151-366b41b1-2cad-473e-bf35-cbddd26269e8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414754090-14e25f13-be3d-4ea6-b14d-be45b3e7d6c2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414755007-7ccd1633-c5fc-41b0-bbc5-9dad8ded8e42.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414756549-8f5ec144-b3bf-4d28-9130-9a57517392b8.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶公司以专业化、智能化、国际化的服务标准，深度参与本次论坛LOGO、主视觉、会务手册、参会证、指引等视觉设计，开场、致辞、启动等各环节视频制作及内外场策展和环境布置，结合全自动升降演讲台与全自动签约机器人实现数字化呈现，圆满完成主论坛及五大平行分论坛的策划设计和服务保障。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414777463-80d61a7d-f2b6-4ce3-8608-964379decc9d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414778836-c3939950-4b03-4baa-8e15-e1072d6faab5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414777964-8f877d0d-684e-4d6b-afcd-e6664128d77d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414777779-5911dc88-ee91-4d19-af7d-fcd9e68eb6f8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414778527-2e4c9e6a-37ad-4eb1-a139-ea349ddf5322.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/png/38716037/1783414779613-0f79e4b6-7e1a-4e8e-9782-be822d94bff5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414779493-d6431c5b-655b-4269-8aba-b3f10bf4ea1b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414779862-93969c5f-26b8-4137-a97b-da59f7c29f9f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414780231-8cc52162-9ae4-41cc-9aa7-8d0fca89218b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2026/jpeg/38716037/1783414780198-cbf08c79-2bd8-4929-b315-5496a14bc299.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20251015 周晓强
      title: '华东师大成立创新研究院！叁昶助力“国家队”携手“主力军”！',
      time: '2025-10-15',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283938049-a9c18707-7e33-4815-8412-55d05fee7612.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=39",
      details: {
        top: {
          title: '华东师大成立创新研究院！叁昶助力“国家队”携手“主力军”！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283938049-a9c18707-7e33-4815-8412-55d05fee7612.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月15日，国家心理健康和精神卫生防治中心（以下简称“国家心理健康中心”）与华东师范大学联合成立的心理健康数治创新研究院在华师大普陀校区举行成立大会。叁昶圆满完成本次大会的策划设计并全程参与保障。',
            '国家心理健康中心主任、党委书记付强，华东师大党委书记梅兵上台致辞，并与国家心理健康中心副主任王钢，上海市教育委员会副主任王浩，上海市卫生健康委员会医政处副处长孙明明，长宁区卫生健康工作党委书记江平，普陀区卫生健康工作党委书记邓海巨，闵行区卫生健康工作党委书记赵艳，华东师大心理与认知科学学院院长周晓林共同为心理健康数治创新研究院揭牌。华东师大党委常委、副校长程静主持大会。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761283953872-3b3d6385-bd41-4839-8ef5-e476d87dcc3a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951702-609c80e6-abeb-452a-9073-6621fdff8b06.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951729-a55f637e-3043-47af-9b2e-f4d2de00967c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951818-bc8f3d64-2983-4aa2-9f02-3600800b3639.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283951783-e63f96eb-7167-42b6-8924-945a1576e1cb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283952897-9f463259-7351-4ca0-becc-a4c2462a7b8c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953106-3742b639-2a62-4adc-bc78-b8801b0cbc9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953019-2f6c5e36-ebdd-4f75-a00f-4d38c278217b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283953055-4c13586f-016c-45c5-98ab-ce3d803a27c8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283954027-da8a71b6-2d79-4181-ac49-529cfcaa7e10.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['会上还进行了心理健康数治创新研究院聘任仪式、心理健康促进数治实验室博士后工作站”揭牌仪式，并发布研究院建设方案及12个首批重点研究项目。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283959966-483aa167-a356-4da1-8d5d-fd1d270e8b7d.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250922 周晓强
      title: '梦想启海上 技能赋未来 | 叁昶助力上海第48届世赛倒计时一周年活动完美呈现！',
      time: '2025-09-22',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283862197-7b4efb63-4dda-4c7c-8a53-533977e82185.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=42",
      details: {
        top: {
          title: '梦想启海上 技能赋未来 | 叁昶助力上海第48届世赛倒计时一周年活动完美呈现！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283862197-7b4efb63-4dda-4c7c-8a53-533977e82185.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['9月22日，上海第48届世界技能大赛倒计时一周年活动，在上海展览中心友谊会堂隆重举行。世界技能大赛是最高层级的世界性职业技能赛事，每两年举办一届，代表了各领域职业技能发展的世界先进水平。',
            '<strong>人力资源社会保障部党组成员、副部长，世赛组委会副主任颜清辉与上海市委常委、副市长，世赛组委会副主任陈杰</strong>共同为上海第48届世界技能大赛事务执行局揭牌。上海市人力资源社会保障局党组书记、局长，第48届世赛组委会秘书长杨佳瑛出席并致辞。世界技能组织首席执行官大卫·霍伊向倒计时一周年活动发来视频致辞。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283877863-5ff56c25-eac1-4c44-bf83-92cd4e4052eb.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283877881-f6382264-f8e2-4d70-8eca-04493c90a0fb.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878136-291a32c2-869b-4978-aced-b8cebba8a0e9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878287-10390167-3c68-4335-922a-3fc8feef8dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283878894-36633c0f-1571-47d1-81b7-d694c075f38e.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283879027-c9f585e8-8abc-47f9-893e-f19675b8dceb.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [
            '以技能之光点亮全球盛会，本次<strong>活动策划、舞美设计、原创节目、作词编曲、视频制作、内外场环境视觉布置</strong>均由叁昶公司策划、设计、落地和全程保障。',
            '活动现场，<strong>蛟龙号接旗仪式、志愿者招募启动、四大国家战略赞助商服务发布、技能梦想大使亮相等环节</strong>亮点纷呈，叁昶在保证议程环节创新、创意的同时，用专业能力确保每一个环节高效衔接、完美呈现。',
            '由叁昶编曲作词，创排的原创节目中，更有<strong>智能机器人</strong>和技能代表们以独特的方式，诠释新时代技能潮涌，并于节目最后展示了<strong>现场绘制的世赛logo</strong>。',
            '围绕“技能蓝海”、“心中山海”、“照亮星海”、“热情上海”，现场也邀请到了世赛选手代表及专家分享技能故事以各自的视角，采用<strong>现场讲述和场外直拍</strong>的形式，表达对技能的赤诚热爱，共同抒发一年后对世赛成功举办的憧憬与期待。',
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889166-bd517375-fb17-4137-8b96-685819651e8c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889078-deeeb705-d376-4edc-9fd0-56ef706ee119.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889112-f3698572-b0a6-4185-8d25-74ceeedf9b3d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889077-1694571e-f736-4ddf-a00c-8effae9bda12.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889064-94399d2d-7e65-46e2-a125-a66a18a89cec.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761283889829-0e7a752b-f6b0-464f-8d17-fb997948ce35.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761283890118-ec81a667-ef77-4f6f-abb4-4a4952b8db86.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250830 周晓强
      title: '南模校园焕新记：从篮球风云到人文角落，叁昶打造现代化育人多元场景',
      time: '2025-08-30',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550397646-dfaa20eb-b16f-4f9d-8ef3-b4ec1c6195c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=57",
      details: {
        top: {
          title: '南模校园焕新记：从篮球风云到人文角落，叁昶打造现代化育人多元场景',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550397646-dfaa20eb-b16f-4f9d-8ef3-b4ec1c6195c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司赋能校园文化建设，为南洋模范中学进行校园文化升级。从展现南模篮球风采、记录校园活力的<strong>南模篮球风云录</strong>，到展示南模<strong>篮球发展历史、体现南模体育精神</strong>的场景营造；从涵养艺术气质的<strong>音乐空间</strong>、浸润书香的<strong>阅读空间</strong>，到串联校园动线的创意<strong>楼梯间</strong>，再到聚焦科技教育的<strong>机器人实验室</strong>空间优化，每一处均深度融合“功能性”与“人文气息”。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410320-73146fd5-13bb-4dec-9218-d2f56e48e37f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550409020-76ddd63f-17ae-43ae-ada5-3cbc34698a01.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410965-cbf14f77-7750-4742-8d63-2e0883783dab.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550410851-dd250918-62a4-4336-9d4b-0d0d7d63b020.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550409051-a49d8c53-d6e1-46a6-bb66-a0b0b3aa6ce0.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550412964-648f351a-d647-454b-9037-6dc80a572cd6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['叁昶通过场景化、个性化的精神窗口打造，不仅满足师生多样化使用需求，更让校园成为承载成长记忆、激发探索热情的现代化育人载体，助力南洋模范中学构建独具特色的校园文化新生态。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550417983-67e52b20-bfdb-49c4-b0aa-53ab6efb8dd8.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550418229-94ff52c8-1e1c-48c8-b3cf-aa2a82cf0296.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550418383-44e67629-343f-463b-9aa2-3c9ea9c85886.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250726 周晓强
      title: '叁昶出品 必出精品！非遗文化长廊、学生活动中心项目获得一致好评！',
      time: '2025-07-26',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174543-c6e149f0-ac1a-4233-aff5-c5d778471869.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=56",
      details: {
        top: {
          title: '叁昶出品 必出精品！非遗文化长廊、学生活动中心项目获得一致好评！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174543-c6e149f0-ac1a-4233-aff5-c5d778471869.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['为更好地展示中华传统建筑文化，实现展览互动、教学等功能，叁昶为某校量身定制的非遗文化长廊将长廊分为序、中国优秀传统建筑文化历史、建筑思想与人文情怀、建筑艺术、建筑技术五个版块。',
            '各版块通过展墙、图文展板、模型实物、互动道具等多种形式、多角度形象生动的打造可观、可感、可触的沉浸式互动体验，展示出中国传统建筑文化的魅力，发挥了“中国传统建筑文化实践体验基地”中华优秀传统文化传承作用，强化文化育人功能。',
            '此外，现已投入使用的学生活动中心装备了先进的电子显示屏和综合控制系统，这些设备促进了学校双创教育课程的有效开展和项目研讨的活动。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761550174276-b899c69d-dc78-4e29-900c-71d2cce9986b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175162-3acd6179-e40f-4d3c-9046-03770e984daa.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175958-5817e8ff-4e97-4bd0-852c-64d12f4f5576.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550175532-40acf3a9-7bd7-4c8d-8815-d573eb30777e.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550176253-d6bfc292-5fbf-48ad-aa10-9e45e423314d.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761550178781-26a64257-1dc1-4fdf-9bbc-e585b499e35b.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250708 周晓强
      title: '打造集“科研、会议、展示”于一体的智能化多功能报告厅！',
      time: '2025-07-08',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761635032284-7958dea0-ec2b-42e1-8f7f-e67102fcbdad.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '打造集“科研、会议、展示”于一体的智能化多功能报告厅！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761635032284-7958dea0-ec2b-42e1-8f7f-e67102fcbdad.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为长征医院打造的智慧教室及公共空间，以“智慧教育、科技教学”为核心理念，打造集“科研、会议、展示”于一体的智能化多功能报告厅。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {//20250707，周晓强
      title: '压实责任，凝心聚力 | 叁昶召开2025年度重大项目启动会',
      time: '2025-07-07',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237042177-64abee14-a561-4712-b243-44795b3f1d91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=41",
      details: {
        top: {
          title: '压实责任，凝心聚力 | 叁昶召开2025年度重大项目启动会',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237042177-64abee14-a561-4712-b243-44795b3f1d91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['7月7日，叁昶<strong>2025年度重大项目启动会</strong>顺利召开，公司顾问王志卫主持会议并作总结发言，项目负责人、采购部负责人分别围绕项目整体实施、现场管理、供应保障及重要时间节点等关键内容作进一步明确，叁昶技术骨干、合作单位代表等参与会议并展开深入交流。',
            '公司顾问王志卫提出<strong>“技术保障、人力保障、财力保障、安全保障”四项核心保障，</strong>并表示在项目推进过程中，各方要秉持协同作战的理念，秉持<strong>“紧而又紧、细而又细、实而又实”</strong>的精神态度，共同维护良好的合作关系，建立健全内部沟通机制，做到<strong>“从源头到末梢”</strong>的高效协同配合，保质保量，按期交付；应对<strong>“时间紧、任务重、要求高”</strong>的现实情况，要<strong>按每小时卡点，务必做好需求把控，提前预设意外情况、突发情况</strong>并明确应对措施，形成一盘棋，稳步推进项目落地。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348365415-95c68e98-22f9-4c17-953d-a7fb4ee60370.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348365194-b7271bd6-524d-475b-83bc-10f08829bc2c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348365204-e747173b-0f29-4ff2-a941-eab0a7411488.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348365452-8f61c686-4875-43c6-a108-45de1332c218.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348365650-b9e21501-55f6-4279-9581-bf2d4c4f251a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753348366024-c99f1199-d943-4549-9f86-39956e4cc541.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        },
        bottom: {
          title: ['次启动会的圆满召开，为叁昶公司年度重大项目的顺利启动推进明确了方向，秉持<strong>“安全第一、质量为本”</strong>的原则，全员需深刻认识到项目建设的<strong>重要性、严峻性。</strong>',
            '未来，叁昶将以<strong>一如既往的高度责任感和紧迫感，科学规划、周密部署，坚持问题导向，靶向攻坚突破，</strong>确保年度重点项目整体迈上新台阶，为叁昶高质量发展贡献力量。'
          ],
          img: []
        }
      }
    },
    {//20250707，周晓强
      title: '大战7.8.9，奋战100天 | 叁昶公司召开暑期项目动员大会',
      time: '2025-07-07',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236972136-cb0b5c97-29d2-415d-b876-12967ff2b8d0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=40",
      details: {
        top: {
          title: '大战7.8.9，奋战100天 | 叁昶公司召开暑期项目动员大会',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236972136-cb0b5c97-29d2-415d-b876-12967ff2b8d0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['7月7日下午，叁昶公司召开<strong>“大战7.8.9，奋斗100天”</strong>暑期项目动员大会。公司顾问王志卫、常务副总曹鸣浩、各部门负责人、叁昶全体员工及相关合作伙伴共同参与。',
            '公司顾问王志卫<strong>深刻分析了公司当前存在的主要问题，并对暑期100天的相关项目进行梳理，</strong>明确周期内大小各类项目<strong>合计24项。</strong>“时间紧、任务重、要求高”！为更圆满的协同推进项目，公司顾问王志卫提出<strong>六点警醒。一，认清形势、端正态度；二、了解需求、认真落实；三、抓住重点、兼顾其他；四、周密计划、按步实施；五、团结协作、有序推进；六、安全第一、出事归零。</strong>',
            '<strong>“大战7.8.9，奋战100天”</strong>是一次意义重大，从叁昶创建初期延续至今的叁昶文化，是100天，更是每一天！',
            '通过本次大会，叁昶全体员工要以高度的责任感和使命感，<strong>充分考虑，争分夺秒，走一步看十步，勇于担当，积极作为，始终把安全放在首位，立足岗位，事不过夜，</strong>充分发挥主人翁精神，与公司同命运共呼吸，全力以赴推进各项工作落地落实，共同为实现公司的年度目标而努力奋斗，携手共创公司美好未来。',
            '奋战百天、时不我待！以更高的站位、更硬的作风、更实的举措，全力跑出发展“加速度”，奋力拼出卓越“新业绩”。'],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236981811-af47ebc4-bb36-4a81-ac66-695a5dfc69a8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236983168-4eceb6d8-3e5e-4059-a537-cecd3f4c970a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236982355-525d1ce6-a864-4bf3-a3cc-a86c48228152.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236980953-7094014a-b1b1-417d-991b-235dead26d4a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        },
        bottom: {
          title: [
          ],
          img: []
        }
      }
    },
    {// 20250624 周晓强
      title: '技能造就美好未来 | 叁昶保障上海市第二届职业技能大赛圆满落幕！',
      time: '2025-06-24',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237281236-5411be05-6a74-473e-940f-ab94a56574aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=39",
      details: {
        top: {
          title: '技能造就美好未来 | 叁昶保障上海市第二届职业技能大赛圆满落幕！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237281236-5411be05-6a74-473e-940f-ab94a56574aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['<strong>6月24日，</strong>以“技能造就美好未来"为主题的上海市第二届职业技能大赛在青浦区东方绿舟剧场荣耀闭幕。上海市职业技能大赛是本市规格最高、规模最大、项目最多的综合性职业技能竞赛。本届大赛共吸引全市16个代表队共1367名参赛选手同台竞技。',
            '市政府副秘书长张英出席活动并宣布大赛闭幕。市人力资源和社会保障局党组书记、局长杨佳瑛，青浦区委副书记、区长金晓明，市人力资源和社会保障局副局长谭友林，青浦区政府党组成员陈锡琦，闵行区副区长杨辛，团市委副书记唐志宇等出席闭幕式。',
            '叁昶深度参与本次<strong>大赛闭幕式、LOGO、主视觉、吉祥物、回顾视频及内外场策展和环境布置，</strong>圆满完成本届大赛<strong>开闭幕式的策划设计和全程保障，</strong>获得了各方好评。',
            '闭幕式由<strong>“荣耀加冕·梦想新程”和“荣耀之星·闪耀蓝毯”</strong>两部分组成，通过<strong>获奖选手蓝毯秀、大赛精彩回顾视频片、冠军选手荣耀时刻等环节，</strong>充分展示技能青年奋勇争先、勇攀高峰的精神风貌。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951228-d9e86551-1118-4d78-99c2-26d0c98aa635.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951199-9fb8d043-cbe5-4152-9ed5-8da65b90b4ae.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951203-1fa8f7be-a046-421e-a47f-f363e7deda42.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406951173-7c386ed4-8205-4694-98e3-05bcb1ae7284.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406951981-26c57a6d-2d63-44e3-b2e4-fcc6c38bdc5c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952563-ddc296d3-7add-4f0b-998f-3664d4e85cc9.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952831-6eaaed8f-aeda-46b6-beff-7e8d998739a3.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952779-7e9e717c-e03d-4099-9975-dca4d374f6e8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406952701-7fd7a3b6-5932-48de-bdcb-90c4c8e48763.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753406954319-bbffee86-f4b5-4dc2-b050-dd50c7916d35.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753406953910-2717bdc0-42c3-407f-bdbb-24cae1f3f4ec.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [
            '值得一提的是荣耀蓝毯环节打破传统红毯的刻板印象，以技能蓝为基调，打造宛如全明星般的<strong>蓝毯秀场。99个赛项的322位获奖选手</strong>在授奖后，依次沿着闪耀着技能之光的蓝毯大道在欢呼与掌声中问鼎桂冠，依次登上属于他们的荣耀之台，展示专属于技能人的独特魅力。',
            '以实力镌刻品质高度，叁昶以 “追求卓越，精益求精” 的硬核执行力精研策划、匠心锻造精品，昶赢未来，叁昶乘势而上！',
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327058-f047f547-5559-4a99-8d65-aaf7a2e7a81d.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327054-3db1179d-9306-48e6-a8f8-a1bad5ce02ac.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237327637-1e469c44-35a1-450e-a485-eaf6965e200b.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237328153-e042bbb4-1281-4350-8ee4-cdf2b525b859.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237327147-5b84a4a3-6ef6-4ec3-ab13-d7d508e57eb1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753237328405-b8ef53c2-1dc2-489a-a6ae-c124c5b10da0.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237328060-385f63bc-64f2-4c38-b98b-58c697cf40c2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237328260-34f98248-b42e-4027-840d-002995c942f1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250611 周晓强
      title: '以“叁昶标准”打造中职诊改复核服务标杆！',
      time: '2025-06-11',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761284190048-a79256eb-0a63-447a-aba0-710b81dbbf43.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '以“叁昶标准”打造中职诊改复核服务标杆！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761284190048-a79256eb-0a63-447a-aba0-710b81dbbf43.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['6月11日，2025年度叁昶服务的上海中职学校诊改复核现场服务保障工作圆满结束，叁昶公司开发的整改平台为五所学校提供重要支持，凭借“专业团队+标准流程+数据赋能”三位一体保障体系，<strong>五校复核结论全部为“有效”，服务满意度全部为“很满意”，</strong>整体服务工作赢得了所有学校的高度赞誉。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223446-7ef3db5e-32b2-4be1-a371-8bcd548437ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223817-f241b929-e523-4f2e-912a-d2d5bbeb2aef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284223595-2b1a9569-d568-4a8f-a12c-29e4f6d5d6ff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761284224437-6eef15ba-cc8c-4f57-b73e-700ff29bb2f5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250530 周晓强
      title: '毕业快乐！叁昶再次为上海七宝德怀特高级中学学生毕业典礼划上圆满句点。',
      time: '2025-05-30',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333956107-893635c3-5a92-4084-a91c-4abb46da9ddd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '毕业快乐！叁昶再次为上海七宝德怀特高级中学学生毕业典礼划上圆满句点。',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333956107-893635c3-5a92-4084-a91c-4abb46da9ddd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月30日，上海七宝德怀特高级中学2025届学生毕业典礼如期而至。在这个离别与温情交织的时刻，七德理事会、监事会、全体中外教师、毕业生亲友约700余人，一起见证G12学子亲手为有笑有泪有成长有梦想的三年高中校园生活画下圆满的句点。',
            '继去年七德十周年校庆暨毕业典礼圆满落地后，本次毕业典礼<strong>策划方案、舞美呈现、节目指导、视频制作、视觉设计</strong>依旧由叁昶策划并全程保障，现场进行实时转播并双语同步翻译。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979166-f99be61c-204a-43e4-8d46-f819b5e12fae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979111-c2b36bc1-d667-4335-ac86-d0cf14bc2394.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979353-4c0d63a4-ca35-41c2-8ede-43c3a92324fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979117-b7a35765-51da-4031-942f-381dda490e9f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333979158-e1f4372d-c163-48bf-b1ed-874bad4259ba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980177-a679e1b3-c35b-485c-9fad-a8e41603db14.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980352-4d25c812-de05-4bc2-a9e2-98dbd73c4923.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333980432-a6716acc-7f3c-490a-994b-425d707fcb0b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]

        },
        bottom: {
          title: ['以毕业生入场仪式开场，庆典在说唱、合唱和乐团演奏中正式拉开帷幕。除发言环节、毕业电影、学生捐赠、颁发毕业证书及奖学金等众多精彩纷呈的多元形式贯穿始终，呈现了在一片中西融合的教育土壤中，来自不同文化背景的教师群体能全面地滋养学生的认知与理想。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013872-c853df6c-577a-4f44-8af6-b09e57fcd9bb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013887-d0e3cf7d-c7f2-4f34-b6c5-5feec427ece0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753334014748-796c4723-c57e-48fc-85ac-26d48bd018f2.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013884-fb560db1-b442-46b7-8e5d-b59751fcdf35.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334013957-87fff558-4373-4d4d-85b0-d5b014cc1555.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753334014927-c1c8246d-07d3-4295-8ac4-24b29905a835.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]
        }
      }
    },
    {// 20250516 周晓强
      title: '育”见AI，智启未来 | 叁昶公司助力2025年第22届上海教育博览会！',
      time: '2025-05-16',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911690-6c8e85ce-b411-496e-8a40-6f288ed3f73a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=53",
      details: {
        top: {
          title: '育”见AI，智启未来 | 叁昶公司助力2025年第22届上海教育博览会！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911690-6c8e85ce-b411-496e-8a40-6f288ed3f73a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，2025第二十二届上海教育博览会在上海展览中心正式开幕，本次展会的主题为“‘育’见AI，智启未来”。5月16日-18日为线下展，众多教育单位现场集中展示，展区分为市级展区、长三角教育一体化发展展区、“AI+教育”特色主题展区、区域教育展区等，全方位、多视角展示上海乃至长三角地区人工智能赋能教育高质量发展，构建以人为本的创新教育生态，打造全国领先的人工智能创新策源地。同期线上开展至6月底。',
            '叁昶公司设计打造的展馆齐齐亮相本次教博会，紧扣AI教育，融入诸多创新理念，全方位展示 AI 赋能教育的多元成果与无限可能，引领大家共同迈向智慧教育的未来。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911471-89ca3166-44e9-472f-9a84-59e129499d7e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911521-b155021d-636f-46e8-b4de-7a775200052b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911661-be0e4b6e-fd4e-44e8-bc70-d0cd042e9481.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549911649-14d9cf29-a37b-4c99-837d-791f770d9db0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549912673-67caa09d-1a36-4bc2-a020-6c2ca7b1ef71.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549912776-269dbc99-e4c9-4e6c-9307-8db82c79eb00.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250516 周晓强
      title: '叁昶助力2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛圆满开赛！',
      time: '2025-05-16',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333878552-27bfa5ce-ba92-4228-957f-012de9e06c18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=37",
      details: {
        top: {
          title: '叁昶助力2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛圆满开赛！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333878552-27bfa5ce-ba92-4228-957f-012de9e06c18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月16日，2025年上海职业教育活动月启动仪式暨上海市“星光计划”第十一届职业院校技能大赛（简称“星光大赛”）开赛式在上海市信息管理学校举行。',
            '市教育发展基金会理事长王荣华，市教卫工作党委副书记、市教委主任周亚明，市教委副主任赵震，市教育发展基金会副理事长蒋红，徐汇区副区长王志华，及职业教育活动月相关参与单位、大赛组委会成员单位、各区教育局、行业企业、职业院校代表约200人参加了本次活动。',
            '叁昶深度参与本次开赛式<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置，</strong>受获一致认可和好评。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894671-e83d54ef-58ba-4e44-8beb-6ddc03ebf465.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894787-36115932-be92-40aa-af25-f005c9766b9e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894488-0dc1e281-fa8a-4df3-8697-6666b9285785.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894810-8eb0836d-32f8-4a5e-b69e-bfb332501190.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333894694-eb73cc40-ddb7-4065-a58b-1b4a6bba207a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333895648-bf85af6c-172e-46b2-a561-6d018b03f43f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333895701-7cd03c8c-b025-41ec-806b-d4abd41594b1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['此次活动月启动仪式暨星光大赛开赛式，集大赛、展示、观摩体验活动等为一体，<strong>开场视频《技能筑梦 成就未来》、情景讲述《星光点亮梦想》 、舞蹈《流光》世校赛金牌作品、师生合唱：《梦启海上》，以及对企业家、校长的星光纪实采访环节，</strong>均为<strong>叁昶原创出品，</strong>折射出制度供给更加充分、条件保障更加有力、产教融合更加深入的上海职业教育发展新成果。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333919774-eec706b3-1118-40ff-b57c-666676db12fa.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333919847-0244192a-c5c9-499b-86ba-f002cdc3b1c2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333920113-2298aae3-1981-44d9-a513-a114f0039266.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333920307-1fe5dee7-5ddc-44b7-997f-5f6e90fe8091.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },

    {// 20250516 周晓强
      title: '构建高效教学空间，叁昶助力打造现代化教学新场景',
      time: '2025-05-16',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547656-d4fe4c73-09df-42bb-acca-ead87b3ec314.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '构建高效教学空间，叁昶助力打造现代化教学新场景',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547656-d4fe4c73-09df-42bb-acca-ead87b3ec314.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶公司为上海理工大学第三教学楼打造了47 间教室及 1 间智慧教室监控中心。其中 35 人智慧教室7间、50人智慧教室3间、67人智慧教室4间、76人智慧教室4间、92人智慧教室3间、112人智慧教室24间、165人智慧教室2间。同时所有教室门禁及公共区域安防监控系统一并纳入建设。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547517-29b88192-9fd7-4bad-a89b-99753f6d6fb7.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634547559-41c47395-98b1-4701-a2ff-208fc4734438.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634549300-ad08432f-397c-49ed-b4e4-7b8bd136ce60.png?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250507 周晓强
      title: '双空间升级焕新：叁昶打造多功能会议新空间！',
      time: '2025-05-07',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415201-2b1676c3-4d48-42fe-8b46-4c467a9c3f70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '双空间升级焕新：叁昶打造多功能会议新空间！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415201-2b1676c3-4d48-42fe-8b46-4c467a9c3f70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶升级改造的上海交通大学智慧教室项目，涵盖一间容纳20人的小型会议室和一间可容纳116人的多功能会议室。',
            '小型会议室可满足日常20人以下的小规模内部会议，并提供多媒体音视频展示功能。而多功能会议室则可适应多样化的会议与活动需求，配备先进的显示系统、远程会议系统、中央控制系统和专业音响系统。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415250-bebc2a80-7781-47b3-94f7-40a05b5343f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634415108-2151eb99-bb06-4f52-a8c9-4127e3f8698f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250416 周晓强
      title: '艺术与智慧共生！叁昶赋能审美教学，打造“课演一体”空间',
      time: '2025-04-16',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244176-78ecfe1d-b2e7-42bc-bc9e-199cd88cebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '艺术与智慧共生！叁昶赋能审美教学，打造“课演一体”空间',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244176-78ecfe1d-b2e7-42bc-bc9e-199cd88cebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['智慧赋能艺术，创新成就未来！叁昶公司为某校全新升级的多功能智慧阶梯教室正式亮相！',
            '项目设计结合学院特色，将“胶片”元素造型和LED大屏相融合，应运用文化+科技，艺术+技术的理念，将设备与艺术设计相结合，打造了一个具有美感与科技感的未来智慧数字报告厅。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761634245105-6a4361ac-f7b6-4f7a-813d-0071a86a2959.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244286-29ad9356-4be5-435f-8be2-60c32cc7c4d4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761634244298-2ffde959-a601-4e78-97a0-a80b6c84f274.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250328 周晓强
      title: '赋能红色新动力，叁昶打造的党群活动中心让人眼前一亮！',
      time: '2025-03-28',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627796-e01036bc-06af-4e5f-8cd9-c521675eb64f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=51",
      details: {
        top: {
          title: '赋能红色新动力，叁昶打造的党群活动中心让人眼前一亮！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627796-e01036bc-06af-4e5f-8cd9-c521675eb64f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为三中院打造的党建活动中心，以“党建引领法制，科技赋能司法”为核心理念，建设了集“智慧化、交互式、文化融合”于一体的现代化党建活动中心，结合特有文化设计特色，助推数智转型，实现多功能需要。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627698-7a830625-ce21-4e28-90ff-06f9ef38248f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549628030-9fb74bf9-51c6-4414-afef-98ecf69367cc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549627977-e9140fce-6ff9-4c1d-befa-36e356ab4b06.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250323 周晓强
      title: '追求卓越，再出精品！叁昶助力上海市第二届职业技能大赛盛大开幕！',
      time: '2025-03-23',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237094630-28eb72cc-7db5-455c-ae60-3f04b0944a40.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=36",
      details: {
        top: {
          title: '追求卓越，再出精品！叁昶助力上海市第二届职业技能大赛盛大开幕！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237094630-28eb72cc-7db5-455c-ae60-3f04b0944a40.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['3月23日，以“技能造就美好未来”为主题的上海市第二届职业技能大赛开幕式于国家会展中心（上海）举行。',
            '继叁昶助力首届上海市职业技能大赛开闭幕打造完美样板后，时隔两年叁昶再次深度参与，完美助力第二届大赛盛大开幕。',
            '上海市职业技能大赛作为本市<strong>规格最高、规模最大、项目最多</strong>的综合性职业技能竞赛，参照世赛、国赛办赛模式，共设置101个比赛项目，采用“主赛区+分赛区”协同办赛机制，将吸引16支区代表队，近千名选手同台竞技，通过技能展示、技能体验等模块，打造<strong>“可观、可感、可参与”</strong>的技能嘉年华。',
            '本次大赛<strong>开幕式、LOGO、主视觉、吉祥物、宣传片及内外场策展和环境布置</strong>均由叁昶策划设计并全程保障，开幕式现场还有<strong>宇树机器人</strong>和观众进行惊喜互动。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237116079-284c0812-285d-44a4-8205-f3da198a1bba.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237115512-ccc9bf76-2c21-4f05-981e-81354578f7b6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237115538-cc6f5bf8-04e1-43b1-bcb8-dd5e10b3784a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237118274-47d1c55f-c79e-40a4-aa7a-0cac42bfbf31.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237118373-82400cc6-beff-4379-a5b8-272f635755fc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237119501-7166726f-8e29-42c4-87c6-0c9513380498.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237119248-843c0500-2c74-4b80-ac3e-5cb765fb4595.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237120979-de50efe9-2a78-417a-bb24-5974859dcd4c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237122998-ee650e98-a274-483f-9b21-05348597be45.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237123214-13103954-6799-4479-a633-52c543b250fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['<strong>开幕式：吹响以赛强技“集结号”</strong>',
            '上海市副市长陈杰宣布大赛开幕。市政府副秘书长庄木弟，人力资源社会保障部职业能力建设司二级巡视员张达分别致辞。市人力资源社会保障局党组书记、局长杨佳瑛，青浦区副区长倪向军，大赛组委会成员单位及各区相关负责同志参加大赛开幕式。',
            '开幕式上，与会嘉宾观看了大赛宣传片，16个区参赛代表入场，选手代表、裁判员代表分别宣读比赛誓词。',
            '<strong>青浦馆：聚焦技能成才“大检阅”</strong>',
            '叁昶团队着力打造的“青浦馆”，聚焦技能与产业的融合发展，围绕三大核心产业集群，融入<strong>科技元素、青浦元素</strong>，通过精心的设计策划，全方位展现青浦在科技创新、技能人才培养和主导产业发展等方面取得的突出成效。',
            '<strong>氛围布置：以斑斓文化展现工匠力量</strong>',
            '全场氛围布置是提升大赛体验的关键环节。通过内外场氛围布置，营造出浓厚的大赛氛围。在入口、通道以及公共区域，都能看到醒目的大赛标志和宣传标语，让每一位进入赛场的人都能感受到大赛的热烈气氛。',
            '<strong>视觉设计：赋予品牌符号崭新定义</strong>',
            '主KV颜色采用<strong>技能蓝、数智蓝</strong>为背景主色，延续了“技能造就美好未来”的大赛主题，整体设计以斑斓文化展现蓬勃工匠力量、以深厚底蕴展现多元城市风貌，<strong>赋予了一以贯之的大赛品牌符号崭新定义，</strong>引领技能人才进入新时代职业发展快车道。',
            '大赛吉祥物名为<strong>“小青果”，</strong>“青” 取自本次技能大赛的举办地青浦，“果”吉祥物的整体形状像一颗果实，也象征着技能大赛的选手，所铸就的闪耀成果。',
            '简约、隆重、振奋、激扬，叁昶以“追求卓越，精益求精”的强大执行力，精心策划、全力打造精品，昶赢未来，叁昶正当时！',],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237149616-d65e52bc-cca6-4efe-afc7-8aba6404d287.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237148745-894850e0-a179-43a0-bd22-505f71cad191.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237151105-66a330e4-ae8e-4260-9260-c36805bd8aa6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237149000-1557be30-a3c5-48eb-9519-960c7f832d67.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237148772-0168cecc-87e4-4821-b0e7-70bdcc1a154e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237151907-e2883b48-3f30-4c72-9c09-a540305cb49d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237153623-165ddeb3-e14c-47e0-a496-e1b9bcc07b51.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237150450-cfc7d767-cd2f-4c0b-984d-35cc3827d6cc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753237150955-b5088a61-59f2-425e-b8e9-df4e17a46b6c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20250315 周晓强
      title: '叁昶公司打造的院史墙、院内文化顺利落成！',
      time: '2025-03-15',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334718-ddfeb2ae-53cf-416d-a0a3-5d3dd79200e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=49",
      details: {
        top: {
          title: '叁昶公司打造的院史墙、院内文化顺利落成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334718-ddfeb2ae-53cf-416d-a0a3-5d3dd79200e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为市二院独家定制的院史墙，以“江河归流，共济致远”为设计主题，通过河流动态汇聚的创意形式，生动呈现由四所机构逐步融合、共筑新生的历程，寓意“多元汇聚、同心同行”的办院精神。',
            '院内文化设计上，除院内装置外，独具匠心的剪影贴画艺术墙成为文化亮点，叁昶团队以剪影贴画艺术生动呈现医院特色科室与医者故事，将传统艺术与医学人文深度融合。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334541-891363a3-1a29-40ed-aa5d-e6742c1ab371.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334788-e900182d-b307-4cf9-9c39-2e2b83eb354b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334755-d8b59c25-6b90-4dcd-bdd3-d4d1a55c9441.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549334662-f5c7b111-6cc0-4f03-a812-15e8eeecdc2f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761549335834-88c39ee5-a6ca-42f6-baba-b14f43be18ce.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20250315 周晓强
      title: '传承百年医脉，开启奋进新征程 | 叁昶助力上海市第二人民医院恢复冠名！',
      time: '2025-03-15',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333766295-75cf1dd2-6f9f-4cfb-b2ec-7365f16ed130.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '传承百年医脉，开启奋进新征程 | 叁昶助力上海市第二人民医院恢复冠名！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333766295-75cf1dd2-6f9f-4cfb-b2ec-7365f16ed130.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['3月15日，上海交通大学医学院附属第九人民医院黄浦分院举办“恢复上海市第二人民医院冠名”揭牌仪式暨大型义诊活动。上海市卫健委主任闻大翔、黄浦区委书记杲云出席仪式并讲话。黄浦区委副书记、区长徐惠丽，区人大常委会主任韩顺芳，区政协主席陈志奇等出席仪式。叁昶<strong>全程参与揭牌仪式的策划及圆满落地，并保障外场氛围布置及义诊活动顺利开展。</strong>'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785971-060df819-1376-4d14-a5ef-db94e45f1a59.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785980-3e9a7f20-4fdc-4306-906a-9427bcf25115.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333785988-acda70df-631b-4aed-bf75-73bf12a3346c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333786120-e85757cc-20c7-4bf6-a734-62f2d6555026.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333786076-62d067bc-e254-435e-8c91-e61f46922e78.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787022-38050a49-dac9-46ce-be4b-3d9c7e06f09a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787251-da49f3f0-d133-4852-9685-03026f8d5ca3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787243-740d37bd-f474-4632-a7f9-e51fc2661575.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787204-147b5e04-1b3c-4042-9c57-a93cc820c5ee.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333787451-ba786b1a-59bc-4cc8-a26d-8f4ca696eaf6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333788028-c6f6d464-8387-4d83-bf72-c9119ca4ba8b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',


          ]

        },
        bottom: {
          title: ['启动仪式融合了<strong>颁奖、清单发布、讲述发言，</strong>并实现了<strong>内场装置与外场大楼红绸</strong>同步启动揭牌，壮观非凡。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827109-7607d806-7e75-45e9-9ca3-930fbb57011e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827128-41849194-8f0d-4584-842e-134e3b19bb1a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827131-2bbec929-e98a-4fb6-b7b4-4c92541f7fe0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827131-b5007f8d-1a13-4c9b-980b-33229a05da78.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333827175-a8af83bd-fadd-49a3-8898-a4be7c8be50e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828186-97874268-395b-47f5-9f9b-5bcf681c63ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828282-0c388cec-ae18-49b8-a2bc-f06fdfffd8dc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333828253-5a3f0a94-1bc9-4c38-be23-0f6479c76c51.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1']
        }
      }
    },
    {// 20250217，周晓强
      title: '乘势而上，追则能达 | 叁昶2025年度新年心语发布会圆满完成！',
      time: '2025-02-17',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753236360991-2cb7c718-49a6-40ed-b74b-f53de84b9ec1.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=technology&num=34",
      details: {
        top: {
          title: '乘势而上，追则能达 | 叁昶2025年度新年心语发布会圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753236360991-2cb7c718-49a6-40ed-b74b-f53de84b9ec1.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2月17日，叁昶一年一度的新年心语发布会圆满结束。公司顾问王志卫、常务副总曹鸣浩、各部门负责人及全体员工共同参与。',
            '争第一，创唯一。在热烈的氛围中，叁昶全体员工总结发布了各自的新年心语。叁昶公司顾问王志卫就大家的新年心语做了总结性发言及动员，并将<strong>年度工作总结</strong>讲话中提出的<strong>七言七治</strong>作为本年度的金句与大家再次共勉。',
            '<strong>以更加严格的标准迈入2025 ，以严治心，粘起来；以严治懒，动起来；以严治散，紧起来；以严治虚，实起来；以严治学，强起来；以严治廉，查起来；以严治规，惩起来 。</strong>',
            '实字当头，干字为先，青衿之志，履践致远！每一年新年心语的分享不仅是叁昶一以贯之的企业文化，更是大家的自我激励和互相勉励。勤学善思、勇于创新，提升能力、攻坚克难，叁思而行  交出“奋斗答卷”，2025 昶赢正当时!'],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236422674-241016e3-5b8e-4cf5-8adc-cfa31f167e65.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236422650-5c781e91-f177-48c8-ae1b-1c0a409367c1.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236422652-ccf677b3-bb0c-40ca-b83b-8335f198aef6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753236423247-2bf548f1-35fe-406b-a8a8-98deb70a6151.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236422682-6e3a1cf3-4dab-4a5a-8c99-8dd91f8d33fe.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753236423981-08b764f2-0212-4519-8026-d7157dd5075a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236423509-14e6497b-8f7e-4c37-80c8-c030897e4c2a.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        },
        bottom: {
          title: [],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236436456-c4eed99f-f4d4-40b5-9981-6c6a0bb080d6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236436411-63082e9b-3b8f-45c8-a043-1a258e7805f4.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20250120 周晓强
      title: '聚力共创新征程，同心齐进耀未来 | 叁昶助力国妇婴2024年度表彰暨2025年迎春会圆满完成！',
      time: '2025-01-20',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333682960-c5dd338a-fc77-4de3-88c8-ed4f6fe31b84.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=33",
      details: {
        top: {
          title: '聚力共创新征程，同心齐进耀未来 | 叁昶助力国妇婴2024年度表彰暨2025年迎春会圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333682960-c5dd338a-fc77-4de3-88c8-ed4f6fe31b84.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['1月20日，“聚力共创新征程，同心齐进耀未来——2024年度表彰暨2025年迎春会”在国妇婴徐汇院区举行，医院党政领导班子成员、获奖职工代表一百余人齐聚一堂，展望美好未来，共迎蛇年新春。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698992-e551f8dd-232e-4e7c-a412-02aefc2e633d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698978-bf64c87d-27fd-43ae-8ed1-8ad851222172.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333698942-406c97f9-c284-446f-89a4-8d383f851ba5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333699056-f2ac526f-4070-4a83-8c3a-83ef9e20f580.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333699005-458781d2-a33a-4370-b1cf-dba7d2b88524.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700021-f84fa2b4-aaab-42da-923d-9c4a9bb0b257.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700087-fc82122c-ff0d-4028-bcba-61b725f952c9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700096-7c87578e-d99b-400e-9735-27af48230148.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333700206-6a993f5f-4fce-41c2-8dc6-dfc5bbe95d48.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',

          ]

        },
        bottom: {
          title: ['整场活动在<strong>《鼓舞新春》</strong>激动人心的律动中拉开帷幕；<strong>音乐沙画《守护生命，砥砺前行》</strong>用一幅幅流动的画面回顾展示了2024年医院的重点工作成效；<strong>情景朗诵《爱在奉献，爱在国妇婴》</strong>以仁心、奉献、守护、新生交融讲述；以及<strong>歌曲《红旗飘飘》和《火花当燃》</strong>环节，分别进行了太极拳展示以及《真心英雄》、《只此青绿》、《APT》等歌舞展示；活动最后，在<strong>合唱《我奋斗我幸福》</strong>的高潮部分，8位院领导也步入台上一展歌喉，并送上新春的祝福，将现场气氛推向高潮。',
            '本次活动<strong>策划方案、舞美呈现、原创节目、视频制作、视觉画面及氛围布置</strong>均由叁昶设计、落地并全程保障，将鼓舞、沙画、朗诵、歌曲、表彰等众多精彩纷呈的多元形式贯穿始终。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716978-29f1dffd-66ec-470a-832b-797b4471b39c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716986-775a5d3c-6e64-4e4a-88f7-14d55574535a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717042-04da9e09-c442-41a6-a5fd-7b4d5da64279.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716948-f7ca72b6-3f46-4bfe-abcf-68eda1a9e859.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333716971-61fdde49-60e5-480e-a721-3d9ddddfbc5b.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717660-b166638a-1811-4a13-9b84-ad212e82d34a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333717977-c7fd1cac-2235-4f5a-ab86-43f7a07f1ae1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20250117 周晓强
      title: '笃行不怠聚力前行|公司2024年终工作总结系列活动圆满完成!',
      time: '2025-01-17',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236019942-5ca4fbc4-43d5-45ca-aa9a-9369a1d73649.jpeg?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=32",
      details: {
        top: {
          title: '笃行不怠聚力前行|公司2024年终工作总结系列活动圆满完成!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236019942-5ca4fbc4-43d5-45ca-aa9a-9369a1d73649.jpeg?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2025年1月2日-1月16日，叁昶公司2024年终工作总结系列活动圆满完成。本次系列活动通过<strong>个别谈心、部门述职、员工座谈会、干部述职、年度工作总结讲话等</strong>多种形式展开。<strong>着力总结成绩，深入查找问题，切实把成绩讲够，把问题说透，</strong>把一个人的经验变成大家的收获，把个别人的问题形成明鉴，唯有如此方能步步高、年年高！',
            '述职亮答卷，实干谋新篇。各部门小伙伴在<strong>述职</strong>中准备充分、表达流畅，以端正的态度向大家展示了过去一年的成果与反思，并对2025年的工作进行了展望。',
            '<strong>年度工作总结讲话中</strong>公司顾问王志卫指出，公司全体员工需<strong>时刻警醒，时刻认真对待，以更加严格的标准迈入2025，</strong>并对2025的工作提出七点意见和希望：以严治心，粘起来；以严治懒，动起来；以严治散，紧起来；以严治虚，实起来；以严治学，强起来；以严治廉，查起来；以严治规，惩起来。',
            '讲问题，提要求，王校长也再次提醒大家“态度决定一切，细节决定成败”的重要性，每个人都要持续创新、持续精进，紧抓每一个环节、每一个流程，实现严格管理、严格落实，实现“拼多多”、”学多多”、”会多多”，明确“效率就是生命”。讲话最后，校长同样引用金句作为结束语，并为大家提前送上了新春的祝福。',
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236033965-689b24ef-5c79-4648-af80-7abfe8d4e3a6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047108-aeb4d59e-a21e-4942-b581-a8901d59e128.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047072-e5e56668-1d8e-4a59-982e-cb55a1a01376.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047101-68396c5c-5fb6-4838-b21b-6552441d8618.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047085-96d87e70-0de8-4e26-8f5e-00cdaafb77ff.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047283-e0b8169c-229e-414d-b729-4f10aa8b8ae9.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236047900-48a3272b-4bb7-40a1-a6ff-6b0140adaf82.jpeg?x-oss-process=image%2Fformat%2Cwebp',

          ]

        },
        bottom: {
          title: ['<strong>员工座谈会</strong>现场气氛活跃，各部门员工代表集思广益，提出优化意见和建议，公司领导积极采纳，当即落实，促进公司各环节提质增效；<strong>干部述职大会</strong>公司各部门负责人以详实的数据、清晰的图表，全面且深入地回顾了过去一年本部门的<strong>工作成果、重点项目及进展情况。</strong>同时，也坦诚地剖析了工作中存在的<strong>问题与挑战，</strong>并提出了具有前瞻性的2025年<strong>工作计划。</strong>公司顾问王志卫对各部门述职情况逐一点评。',
            '群英荟萃赴新程，以专业为纲为未来蓄力，2025年叁昶将再次提升全员作战能力，共绘叁昶高质量发展蓝图。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236070131-98507c92-e5cd-4853-b995-093da1cc7e46.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236070263-18f555e9-ca64-470a-a04d-1b0b70994c61.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753236070194-844e9b00-b687-441c-b1be-ae2426762f18.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20241210 周晓强
      title: '以墙为纸，叁昶为胸科医院绘就温暖底色！',
      time: '2024-12-10',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548739806-7863a06a-ccaa-47f0-b0ff-e9f165e495b5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=46",
      details: {
        top: {
          title: '以墙为纸，叁昶为胸科医院绘就温暖底色！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548739806-7863a06a-ccaa-47f0-b0ff-e9f165e495b5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶通过特色的文化设计推进上海市胸科医院医院内涵式发展，用文化软实力涵养医院高质量发展的“动力源”。'],
          img: []

        },
        bottom: {
          title: ['本次项目设计结合专业特色，配色延用了医院品牌色调，与整体相统一。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548746841-92ecdc2c-85e7-489b-ad3a-f10ea5290d28.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548746928-2c11acb2-4240-480e-93dd-6445ec687855.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241206 周晓强
      title: '同创耀辉煌 共建创荣光 |  叁昶助力2024年虹桥机场同创共建年会圆满呈现!',
      time: '2024-12-06',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413314824-be65b8cf-ab3e-4dde-8f6b-c72a825b47e4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '同创耀辉煌 共建创荣光 |  叁昶助力2024年虹桥机场同创共建年会圆满呈现!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413314824-be65b8cf-ab3e-4dde-8f6b-c72a825b47e4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['12月6日，“同创耀辉煌 共建创荣光”2024年机场同创共建年会于虹桥源盛大举行，现场欢笑不断，热闹非凡。叁昶深度参与本次开赛式<strong>策划筹备、视频制作、原创节目、视觉舞美及环境布置，</strong>受获一致认可和好评。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329506-e81e3f07-e1a6-4cf7-97ed-703f49a5ed49.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329306-fc101ce8-b4d3-4387-9f04-84eb31d75691.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329525-82d6e1a3-f694-4066-b28a-e594326f333f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329524-5c2bc8a2-c355-41e3-8f78-0605676a0a65.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413329397-504d273f-d0fd-415e-aea7-92103bdd46e1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330529-37dfba72-9af4-4381-afe5-3ea2fa24b8f6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330515-c586e0c7-342a-49de-97ca-a0db8c812bc4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330682-dc246828-da5a-49a4-9c99-9a221ec52655.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330757-1914d13d-4dd6-48bd-b93c-960a6750cc4e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413330806-4d54a340-09f9-4767-a99c-2027050a196b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413331601-2d7449c6-7f1e-4d9d-ada5-a3cf17f43eef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['现场设置了茶歇供宾客享用，年会内容集<strong>开场鼓舞、回顾视频、情景讲述、表彰仪式、颁奖词、知识问答、抽奖环节、合唱等</strong>多元形式构成，均为叁昶原创打造。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341847-8da0f006-4ffe-4f05-9e14-6cc5fc8d908f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341873-4bd46a22-121e-46c1-8e2e-c1e0bcf09356.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341836-4b704a73-e721-417c-b6fd-e14ff9c180bf.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341862-90a7cb59-4f93-40c8-a1df-ef9657efa47a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413341963-efa0507b-0410-4e75-b218-72aff6ccbe36.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753413343128-5d40c5c4-1f66-4606-9e49-6291b03b6b7c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20241203 周晓强
      title: '智享汇创 | 2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会圆满举办!',
      time: '2024-12-03',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412895744-d4dc35ce-a9af-4776-aba7-9f9cc6316934.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '智享汇创 | 2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会圆满举办!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412895744-d4dc35ce-a9af-4776-aba7-9f9cc6316934.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['12月3日，以“智享汇创”为主题的2024年徐汇区中等职业学校学生科创节暨数字化学习应用场景成果发布会在漕河泾开发区会议中心举行。',
            '徐汇区教育工作党委书记姚黎红，市教委职教处四级调研员谢俊，区教育局副局长、徐汇职教集团常务副理事长林琛，虹梅街道党工委副书记王晶，区科委副主任虞蔚，以及区域中职校的校领导们出席活动。<strong>叁昶策划设计并全程保障活动落地及环境布置。</strong>'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909822-bb5bff5f-2e23-4495-8d9c-0dec3cc6bf6d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909567-936d351a-77cb-40b6-968c-e90fa8535790.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909698-353283f3-1374-4294-af4e-548c8356b464.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909501-ee49e6c6-0462-4a6d-b5d1-3cfd7314aae4.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412909516-5909418d-cb1f-41c0-afe2-c198aa6374c7.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910365-0bebc930-3da9-4cbf-a3bb-a5f0cac1cdba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910588-5c5a84a3-9637-4e59-8be0-ff43a662c3e7.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412910730-a4cd3687-806b-4f0c-969a-e45e48f534c9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412911391-91095281-3c14-43b2-be02-535ef42a6519.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412911192-df5cb9e4-cd33-4acc-8347-b1f961f9127a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]

        },
        bottom: {
          title: ['发布会以叁昶原创的科技舞蹈“时光穿梭”及开场视频拉开序幕，除1位真人主持外，本次活动还制作了<strong>5位数字主持人</strong>。现场项目成果发布围绕<strong>【未来工厂】、【创意工坊】、【时空穿越】、【数智生活】四个应用场景，以数智展示、珠宝走秀、路演示范、专家点评等多重形式，</strong>展开一系列精彩纷呈的展示与分享。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924045-ef128c45-3acd-4cc0-97cd-def56ea1293d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924040-d92652dd-7a9e-43c6-aab2-e13ec0aeceda.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924045-b4ea33fe-2236-4000-8db4-0058ee3c195c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412923993-9e7109ba-07f0-4e51-8e8c-a768ae6130f5.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924732-fc95a28c-c687-4288-b290-f204c157ca42.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412924928-964d96f8-2965-4196-bfc0-3440288c6799.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412925690-dba3f9e1-d34b-4083-9c69-5ec63ba69a2c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753412925786-8b939143-c98b-40c5-8ed1-e2544db4539e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20241114 周晓强
      title: '上海市劳动和社会保障学会成立40周年暨学会高质量发展大会圆满召开！',
      time: '2024-11-14',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753410803645-49541e45-1ae7-4b91-8272-82a5c618cf09.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '上海市劳动和社会保障学会成立40周年暨学会高质量发展大会圆满召开！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753410803645-49541e45-1ae7-4b91-8272-82a5c618cf09.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['2024年11月14日上午，上海市劳动和社会保障学会成立40周年暨学会高质量发展大会在上海展览中心友谊会堂三楼会议厅召开。',
            '国务院参事室特约研究员、中国劳动学会会长、人力资源和社会保障部原党组副书记、副部长杨志明，上海市政协第十二届委员会副主席、上海市拥军优属基金会理事长周太彤，第十四届全国政协委员、中国劳动和社会保障科学研究院院长莫荣，上海市人力资源和社会保障局党组书记、局长杨佳瑛，上海市社会科学界联合会党组书记、专职副主席王为松，上海市劳动和社会保障学会会长张岚以及学会老会长张剑萍等领导出席会议。',
            '来自上海市社联、上海市人社局、市兄弟学（协）会相关部门负责人，学会副会长、常务理事、理事、监事，各专业委员会、分会、区劳动保障学（协）会、直属会员单位代表320余人参加会议。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813662-9307e174-2205-4b92-b44f-44c789867e1a.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813867-5df3367f-79e5-4d87-9df8-a820e48c5cee.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813907-df24290b-b097-43d2-a56e-07d46f3bcb4c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813949-867b7d9c-a95d-470e-a22a-d395ccf3f367.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410813937-a674ad9b-c6ef-411d-82a0-49b71ecf611f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814637-d0a80673-f78f-461e-a979-1f4339808723.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410815046-132df6bf-3d3b-4f25-a609-f7ea48213b70.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814807-adc9cbe0-25cc-4111-a769-70e6a505bfa0.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410814814-4f4e97b4-65b4-4229-8ca3-3d5fb70598b2.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['叁昶深度参与本次大会策划筹备、视频制作、原创节目、视觉舞美及环境布置，暖场视频、40周年视频均为叁昶原创。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410831025-a4a4de21-de94-4c99-a424-c1a2636261fd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410831101-87bef03e-3340-45f2-b2d1-54181f5190b9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753410830993-da531ee0-ab50-4c9f-997a-ade63ce1b773.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },

    {// 20241113 周晓强
      title: '未来能源创享中心：探索绿色能源，创享可持续未来',
      time: '2024-11-13',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304415-b2e8ec28-ef53-4a12-b042-6eb6a0d153fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '未来能源创享中心：探索绿色能源，创享可持续未来',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304415-b2e8ec28-ef53-4a12-b042-6eb6a0d153fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶为电力大学建设具有美感与科技感的未来能源创享中心，项目包括入口门头区域，科普展示交流区，工程训练区，智慧教坊四大区域。',
            '其中科普展示交流区和工程训练区分多个版块，将集展陈、互动体验、多媒体展示、创新实践，科普宣传，成果展示，教育教学等功能于一体，为校内师生及来校市民学习能源知识、开展能源科普活动、组织能源实践活动等提供高质量平台和高水平载体，提升公众对能源产业的认知和关注度，引导大众积极参与能源产业创新行动。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304507-ac43eb2a-e400-46c8-86e9-4a543be420e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628304518-a584f399-b443-47d5-aec7-21657dc9cd1c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241113 周晓强
      title: '智慧教学、极简部署 | 叁昶打造 "教与学" 的数字化新生态',
      time: '2024-11-13',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628159593-0e0abf28-463b-4afc-bdaf-6f1506c800d8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '智慧教学、极简部署 | 叁昶打造 "教与学" 的数字化新生态',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761628159593-0e0abf28-463b-4afc-bdaf-6f1506c800d8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为上海健康医学院打造的智慧教室，采用全IP化一线通方案探索新型智慧教室建设模式，将设备、环境、系统采用统一数据通信标准，应用互联互通统一操作，助力学院老师将智慧教室轻松用起来。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241031 周晓强
      title: '京津冀沪+交通职业教育集团联盟2025年工作推进会在上海召开！',
      time: '2024-10-31',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409570207-2066a119-a414-4f85-8b63-33f2dc099dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '京津冀沪+交通职业教育集团联盟2025年工作推进会在上海召开！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409570207-2066a119-a414-4f85-8b63-33f2dc099dbc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月31日，京津冀沪+交通职业教育集团联盟（以下简称“联盟”）专项研讨会在上海举行。本次研讨会主题为“交通助力人民城市，人才筑基新质生产力”。',
            '同济大学城市风险管理研究院院长、市交通委原党组书记、主任孙建平，市交通委二级巡视员孙林骏，市教委二级巡视员、职教处处长马建超，公共交通产教融合共同体（上海交通物流职教集团）理事长蔡军，联盟名誉主席靳和连、鲍贤俊、李怡民，以及联盟成员单位、观察员单位、兄弟院校和公共交通产教融合共同体（上海交通物流职教集团）成员单位领导、专家、代表共70余人参与了本次研讨会。上海交通职业技术学院党委书记徐刚、校长董晓峰分别主持了开幕式和主旨报告。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589696-2073ae35-ebfe-4f02-b98b-37410419bfb5.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589628-73ae6b93-a1b3-46b6-ab90-29a383a4c3d6.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589810-3aafa1cc-66fc-4194-8ee5-9c7cffce0d28.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589786-c3f46b96-382d-4198-8826-f740dfec5c3d.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409589835-4d5d714b-894d-4745-ac11-f07937dd1605.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590475-0e59b83c-b85b-43d7-86ec-7fd1b08e9122.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590499-563fd4a4-40dc-48b3-ae42-bae9fec095ba.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409590510-68ac0583-4fd6-4281-b770-51477d12734a.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['本次活动由开幕式、主旨报告和互动沙龙环节组成，整体<strong>流程策划、环境布置、视觉设计、落地执行</strong>均由叁昶团队精心负责，保障了京津冀沪+交通职业教育集团联盟2025年工作推进会圆满结束，受到主办方高度好评。'
          ],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602087-f240d765-3e7f-45e2-b5d6-a07777ea811a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602134-f18ed61f-875e-4ffc-b6f3-56735e34c779.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602027-01e1de57-e2cc-43c1-8bdc-2c40dda7f382.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753409602040-d4ad9f8e-9154-4dc6-b180-6671731e85aa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',]
        }
      }
    },
    {// 20241028 周晓强
      title: '腾飞十五载 沪港向未来 |  叁昶助力沪港公司成立十五周年庆祝主题活动顺利举行!',
      time: '2024-10-28',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408889186-0dab08e4-ad26-4a8f-bf95-7c803a9e8a1e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=31",
      details: {
        top: {
          title: '腾飞十五载 沪港向未来 |  叁昶助力沪港公司成立十五周年庆祝主题活动顺利举行!',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408889186-0dab08e4-ad26-4a8f-bf95-7c803a9e8a1e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['10月28日，“腾飞十五载 沪港向未来”虹桥机场沪港公司十五周年纪念主题活动于沪港机场管理（上海）有限公司举行。',
            '桥机场党委书记、董事长李政佳，虹桥机场党委副书记、总经理朱传武，虹桥公司工会主席沈小玲，沪港公司常务副总经理李浩峰莅临出席，沪港公司领导及各部门负责人、员工代表、杭州萧山机场代表共同见证。',
            '活动随着叁昶原创开场视频正式开启，定制款印制员工姓名的彩虹奖杯、定制款十五周年生日蛋糕及抽奖环节将活动的气氛一次次推向高潮。',
            '本次活动还准备了精美的茶歇供宾客享用，整体流程策划、环境布置、视觉设计、落地执行均由叁昶团队精心负责。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901145-0aee01a3-24ed-44a5-ab4e-78700834bd14.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901189-09f78fde-a39e-460b-a5ad-5421564084f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901115-2c864376-3b2f-4ad0-aa38-fd2a0252f895.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901299-211c5838-2ac8-4bfd-ba13-f86ae1852599.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408901321-39c22f10-3ae0-4e83-a9dd-fb478df5fa6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408902254-6a7231f2-c376-49ce-956a-2a6c8488cbeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408902470-023fad80-1829-4528-9b01-3b1ef2226697.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241028 周晓强
      title: '筑牢思想阵地！叁昶打造党性教育与理论宣讲的新空间',
      time: '2024-10-28',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424549-5941969b-4bae-4710-89b2-9b4583f4b0d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '筑牢思想阵地！叁昶打造党性教育与理论宣讲的新空间',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424549-5941969b-4bae-4710-89b2-9b4583f4b0d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为中共闵行党校打造的集“智慧化、多功能、沉浸式”于一体的现代化报告厅，旨在为党政培训、学术研讨、红色教育等活动提供高效、智能化的数字化平台。'
          ],
          img: []

        },
        bottom: {
          title: [],
          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424556-8c3a71ed-0690-4137-9109-9b28b42d5277.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615424635-c542b3a3-a77b-4391-b0d6-5fdaf3542648.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241024 周晓强
      title: '它来了！叁昶打造了一座可读可玩可探的校园科普馆！',
      time: '2024-10-24',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595053-923f6605-b8d0-4323-af71-dea938cf5afd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=40",
      details: {
        top: {
          title: '它来了！叁昶打造了一座可读可玩可探的校园科普馆！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595053-923f6605-b8d0-4323-af71-dea938cf5afd.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: [],
          img: []

        },
        bottom: {
          title: ['叁昶对上海市环境学校科普馆的教学环境、信息系统管理等方面全面数字化，构建具有多功能性，集互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595118-55c93697-d89f-4520-9854-44df9a6a6f28.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548595155-e33797a2-f3a8-4487-9b2a-16466693de35.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20241012 周晓强
      title: '置身 “元” 宇宙，叁昶引领沉浸式教学交流新潮流！',
      time: '2024-10-12',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265560-8809e15e-2278-44f6-a7a9-3fb7abb6ccea.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '置身 “元” 宇宙，叁昶引领沉浸式教学交流新潮流！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265560-8809e15e-2278-44f6-a7a9-3fb7abb6ccea.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['数字化互动空间突破现实界限，裸眼3D引领元宇宙新潮流！叁昶公司为上海南湖职业技术学校打造的具备虚拟仿真体验的多功能公共智慧教室，同时也是一间具有多功能性，集互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615265659-4f8c5276-81ae-453b-903b-c38e24bf9af7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615274394-477a8489-c6e7-4ec2-b0c4-a97ed281e63a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615266689-ab99dbe8-b955-442b-ba36-1d9f8f02d453.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761615274101-684a5706-89c0-48cd-a9d1-b4463485d384.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20241012 周晓强
      title: '教学楼改造与智慧化同步推进：叁昶让每间教室“会思考”',
      time: '2024-10-12',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615111017-dfe1e3a1-5d23-4a2d-b218-be8247aaa217.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '教学楼改造与智慧化同步推进：叁昶让每间教室“会思考”',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615111017-dfe1e3a1-5d23-4a2d-b218-be8247aaa217.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶圆满完成对外经贸项目整体信息化设备设施和教室空间环境进行改造建设，涉及学校四栋教学楼，包含112间教室和1间监控指挥中心。',
            '通过智慧教室的建设和打造，搭建启发式、探究式、讨论式、参与式的实训空间以及对应软件工具和资源服务平台支持，为学校教育教学改革创新提供立体化、数字化的教学环境，提供教学观念和教学方法改革创新途径，以满足面向现代化、信息化教育教学需求。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615103787-f2084045-0609-47a6-ac8a-97121a9b32b8.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615103770-45ffaf85-4439-405b-a427-138dabd1c3f4.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615104026-d46dbeda-c404-4765-8ee0-72e8a686134a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761615104117-bd4aa176-63a6-47f6-9de4-e55baf4b2e52.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240929 周晓强
      title: '百年门户 畅享虹桥 | 叁昶助力上海虹桥机场服务品牌圆满发布！',
      time: '2024-09-29',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753407992515-b2a58261-bbf2-4023-b5be-6e8dfa1f74ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=31",
      details: {
        top: {
          title: '百年门户 畅享虹桥 | 叁昶助力上海虹桥机场服务品牌圆满发布！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753407992515-b2a58261-bbf2-4023-b5be-6e8dfa1f74ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['9月29日，上海虹桥机场在2号航站楼举办“虹桥服务”品牌发布会，民航华东地区管理局党委书记姜春水，机场协会理事长王瑞萍，机场集团总裁冯昕，东航集团副总经理万庆朝，机场公安分局副局长刘民，虹桥机场公司、虹桥机场海关、虹桥边检站、上海质科院、市市场监管局机场分局、市质协领导出席发布仪式。',
            '本次活动策划方案、舞美呈现、节目指导、视频制作、视觉及装置均由叁昶设计、落地并全程保障，以原创沙画发布视频、原创情景剧、独唱合唱等多重形式内本次活动进行丰富。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003727-7b610cfb-c1b7-43c1-801f-3e3e151b27e8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003625-120bc4c9-8954-4240-9cf7-17147b1ea279.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003784-524fb515-b5ee-4ddc-852b-12750bb04f88.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753408003860-87588e62-9937-4fbe-842f-df32dd5f9ec3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240928 周晓强
      title: '见贤思齐！嘉定一中文化墙：青春榜样，薪火相传',
      time: '2024-09-28',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548405501-53569c73-905d-4fb1-b9b6-4f2514f6b769.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '见贤思齐！嘉定一中文化墙：青春榜样，薪火相传',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548405501-53569c73-905d-4fb1-b9b6-4f2514f6b769.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: [],
          img: []

        },
        bottom: {
          title: ['叁昶公司设计的嘉定一中文化墙正式亮相校园。当青春的奋斗故事被定格，当优秀的成长轨迹成为风景，这一面面承载着荣耀与希望的文化墙，不仅是对优秀学子的致敬，更是以 “看得见的榜样”，叁昶为每一位莘莘学子搭建起的精神桥梁。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548402778-75af9edc-78ab-4d6f-add6-9636d876b2b3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761548402812-592bf11f-8702-4261-8b62-c27a330d4ea9.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240920 周晓强
      title: '叁昶助力人工智能产业领域基础性技能人才培养试点项目启动仪式圆满完成！',
      time: '2024-09-20',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753333623361-25ce86d7-4cb0-4b2e-b36a-49ac1f1f5f3c.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=32",
      details: {
        top: {
          title: '叁昶助力人工智能产业领域基础性技能人才培养试点项目启动仪式圆满完成！',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1753333623361-25ce86d7-4cb0-4b2e-b36a-49ac1f1f5f3c.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['9月20日，人工智能产业领域基础性技能人才培养试点项目启动仪式于上海南湖职业技术学院5G会议中心隆重举行。上海市人力资源和社会保障局党组成员、副局长谭友林、上海市经济和信息化委员会副主任张宏韬、虹口区副区长章维共同启动人工智能产业领域基础性技能人才培养试点项目。上海南湖职业技术学院副院长周一峰主持。',
            '活动中观看了试点项目介绍视频并在最后的启动仪式环节全息智能启动球自主移动至舞台中央，叁昶策划设计并全力保障活动圆满结束。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633047-3d90a09c-b07b-4acb-a07b-72891d96bfd8.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633104-e1c7d5b4-ad20-4446-acb8-d3a41c36b2ed.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633048-dc6fc19c-636a-421e-967f-64b57ad6ef29.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1753333633142-d43a0561-88cb-4e93-9a9e-032c1b3e126b.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240912 周晓强
      title: '叁昶以设计承精神，规划吴孟超院士精神教育基地设计方案',
      time: '2024-09-12',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264369-a44a7e50-3c15-4945-9a65-46ab908bd0e6.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=36",
      details: {
        top: {
          title: '叁昶以设计承精神，规划吴孟超院士精神教育基地设计方案',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264369-a44a7e50-3c15-4945-9a65-46ab908bd0e6.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶公司为海军军医大学第三附属医院（上海东方肝胆外科医院）规划的吴孟超院士精神教育基地设计方案，以“叙事性空间+沉浸式体验”为核心设计逻辑，将吴孟超精神融入每一处细节，实现“见空间即见精神”的效果，让参观者直观感受“一生为医”的坚守。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264302-30637d4e-6214-4e63-92f7-67140fddbdce.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264750-40e91a70-592e-4a3a-a089-763653e58791.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264367-afdb9911-e935-4d05-b62d-34117dd7758c.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548264395-01d18af9-8891-48be-af09-f79f43312423.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761548266538-70466d59-a28e-4cda-9752-12108dafb9ea.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240902 周晓强
      title: '创新引领 人文赋能！叁昶打造的这一党群服务中心焕新亮相',
      time: '2024-09-02',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804619-8701e214-ee89-4ae3-a126-37991768b562.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=35",
      details: {
        top: {
          title: '创新引领 人文赋能！叁昶打造的这一党群服务中心焕新亮相',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804619-8701e214-ee89-4ae3-a126-37991768b562.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶团队为北站街道量身定制的<strong>党群服务中心</strong>充分结合区域特点及绿色建筑的要求，秉承“开放式、集约化、共享性”的理念，利用技术赋能、创新呈现，大力探索党建宣传及教育新形势。',
            '中心集<strong>基础党务、图书阅览、健身运动、艺术互动、儿童活动</strong>等功能于一体，引领观众参与互动，给人以强烈的震撼。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804509-1c4a4bb0-4940-423e-8b8f-88077c7862e5.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804203-5c0a6943-ad85-4389-a105-b9e4272ba512.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532804309-6e5430e1-9ff8-40e1-ad3e-1c465c254f7f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532803955-86d1d35c-3f2a-427c-b30e-a782332cf77a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532807086-0b7e02c4-5df7-4d02-b27b-33acca21ba92.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240826 周晓强
      title: '一厅多用 智慧赋能 | 让每一场分享更具影响力',
      time: '2024-08-26',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761614995566-90047ac6-f505-49d6-80d6-a53fe3bca9ae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=38",
      details: {
        top: {
          title: '一厅多用 智慧赋能 | 让每一场分享更具影响力',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761614995566-90047ac6-f505-49d6-80d6-a53fe3bca9ae.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶助力上海市商业学校报告厅智慧教室的教学环境、信息系统管理等方面，实现全面数字化建设，构建具有多功能性，集线上线下互动教学、学术讨论交流、会议演讲、交互式实践中心的全功能智慧教室。'],

          img: []

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20240729 周晓强
      title: '顺利召开！叁昶保障浦东国际机场2024年中期航空公司工作交流会圆满结束',
      time: '2024-07-29',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245325608-75055313-e6ba-4676-8273-f7fdebcbd33f.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=31",
      details: {
        top: {
          title: '顺利召开！叁昶保障浦东国际机场2024年中期航空公司工作交流会圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245325608-75055313-e6ba-4676-8273-f7fdebcbd33f.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['7月29日，叁昶助力<strong>浦东国际机场2024年中期航空公司工作交流会</strong>于上海国际会议中心顺利召开。',
            '上海国际机场股份有限公司浦东国际机场总经理黄铮霖出席并发言。浦东机场各基地航司关键业务的领导，机场47家国外航司的航站及营销部门的负责人莅临出席，共同见证和谋划浦东机场未来枢纽发展的蓝图。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245352680-4d61d739-a047-43e6-addf-1b0ba3207017.jpeg?date=1753346046119',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245351472-7bfd112b-c2f4-4d5c-ad7b-c16fb665633a.jpeg?date=1753346046111',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245345202-53361eda-68c6-4eb3-918c-67f5132484d2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245351694-bfb71b23-2c4a-4668-bcc1-ad3c34e23f4b.jpeg?date=1753346045931',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245353873-88e98935-1184-4df1-9abd-c58afe8ce9d0.jpeg?date=1753346045935'
          ]

        },
        bottom: {
          title: [
            '<strong>以进促稳，凝心聚力推动高质量发展。</strong>会议从航空枢纽、服务体验、运行效率和科技创新四个纬度进行了浦东机场2024上半年工作回顾及2024下半年工作展望，现场外航协会代表、国内航空公司代表及各航司交流发言。',
            '<strong>以细节为抓手，助力圆满落地。</strong>本次交流会整体流程策划、环境布置、视觉设计、落地执行均由叁昶团队精心负责，以细节为抓手，保障了浦东国际机场2024年中期航空公司工作交流会圆满结束，受到主办方高度好评。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245677447-f514f86c-5b37-4a34-a170-d90307123714.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245679026-e77a5419-ccc2-4294-8ce1-7779458d4e74.jpeg?date=1753346045910',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245676864-08af9e27-db6c-48a5-ae41-d519e4d03857.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725245679471-387d6aa7-1975-41d9-8652-5b6c2463cb5f.jpeg?date=1753346045908',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1725245676195-cebdd581-3ff9-431c-a3c1-112ebe50f5ef.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246181611-1fb21be7-3eb1-4bef-a515-650142751249.jpeg?date=1753346045969',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246182529-cf0963af-6b25-4452-918c-9ad6b14dce7d.jpeg?date=1753346045959',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1725246182379-c21c6654-b0e0-45be-9ae8-f2747773f001.jpeg?date=1753346045969',
          ]
        }
      }
    },
    {//20240708，周晓强
      title: '创新赋能 促转型升级 | 叁昶倾力打造的文化展示、信息化项目顺利落成',
      time: '2024-07-08',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490733238-8e41ee00-9a24-4aaf-bffa-1e1a5d05dc91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=31",
      details: {
        top: {
          title: '创新赋能 促转型升级 | 叁昶倾力打造的文化展示、信息化项目顺利落成',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490733238-8e41ee00-9a24-4aaf-bffa-1e1a5d05dc91.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['秉持着“文化+科技”，“艺术+技术”的文化设计理念，叁昶致力于打造集展陈、学习、交流、科研等功能于一体的具有底蕴文化和科技赋能的沉浸式空间。',
            '让我们一同解锁叁昶近期落成的文化展示、信息化项目的部分精彩案例。',
            '<strong>文化展示项目</strong>',
            '叁昶全程把关，为某中院量身定制的<strong>党建活动中心</strong>，设置“初心起航、司法护航、赋能续航、扬帆远航”四大板块。面对施工中出现的突发情况，与施工人员共同研究解决，充分协调调度好工程之间的衔接过程，抢时间、保质量，为项目的顺利完成创造有利条件，仅历时30天完成。',
            '叁昶为某中院设计、建设的<strong>证券审判活动室</strong>，运用数字化、智能化和多媒体化的技术特点，结合特有文化设计特色，助推数智转型，实现多功能需要。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490749723-e666719b-a44b-4629-b7b0-48ab5127488b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747778-2e4c7311-da0d-4d9e-b0af-31c764483677.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747810-09256d84-8a65-4a5d-a4c1-77414b49a30a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747616-262c2a0e-ede3-41ad-93bb-f68d6be1273e.jpeg?x-oss-process=image%2Fformat%2Cwebp', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490747643-7659c753-923d-48f7-b093-b9502c003a47.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490748684-b54937f1-1108-4d9d-a4a9-d53871dc39c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490748862-a01fbeee-3da6-4723-8a73-903ad9004858.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1']
        },
        bottom: {
          title: ['<strong>文化展示项目</strong>',
            '叁昶打造<strong>上海交通大学哲生馆</strong>一楼门厅、智慧教室、会议室、多功能厅，通过精心设计和现代技术手段的应用，满足信息发布、党政会议、远程会议、教学及学生活动的哲生馆。',
            '除<strong>文化展示、信息化项目</strong>外，叁昶也牵头公司多部门、多工种，基于安全性、稳定性、美观性以及创新性，全力以赴坚守在<strong>智慧校园设计施工，智慧教室设计改造及智慧操场设计改造</strong>施工一线，后续也将持续落地。敬请期待。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764373-194256f0-38f1-498c-9d1b-4782f68d4a33.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764430-178113f2-8072-400f-84a1-5ad8e6cbd589.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764293-af6ebe81-2a0a-458b-a3b3-c174ef7bcfba.jpeg?x-oss-process=image%2Fformat%2Cwebp', 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1720490764294-fc0428d7-6b56-42a3-b951-d822a6ea92f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240620 周晓强
      title: '合作交流 携手共进 | 上海大学新闻传播学院学生赴叁昶公司参观学习',
      time: '2024-06-20',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941197575-9834a857-c21f-4fac-8a1f-149b63e729e3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=30",
      details: {
        top: {
          title: '合作交流 携手共进 | 上海大学新闻传播学院学生赴叁昶公司参观学习',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941197575-9834a857-c21f-4fac-8a1f-149b63e729e3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2024年6月20日下午，上海大学新闻传播学院的同学们走出校园，前往学院人才培养实习基地——上海叁昶文化科技有限公司进行参观学习。<strong></strong>。',
            '叁昶公司顾问、上海大学新闻传播学院创新创业导师王志卫对学院师生一行的到来表示欢迎，并与同学们讲述了从“战场”、“官场”再到“商场”一路走来的叁昶故事。',
            '同时，王校长结合了同学们的专业特色，分享、解读了叁昶在<strong>科技、文化、教育、咨询、服务五大领域业务板块的丰厚案例</strong>，并基于个人丰厚经历经验为同学们提供了中肯的<strong>择业就业建议</strong>。',
            '互动环节中，同学们积极发言，就<strong>职业发展路径、工作机会等</strong>方面进行了提问，展开了深入交流，王校长一一进行解答。通过王校长的解答，同学们对行业未来趋势及企业发展获得了更清晰的认识。',
            '在叁昶公司常务副总曹鸣浩的引导下，同学们还参观了公司企业文化墙、心语分享区，对叁昶文化有了更为直观的了解。',
            '作为一家<strong>有着核心引领，可提供多元化产品和服务</strong>的公司，此次参观学习是叁昶公司和上海大学新闻传播学院的友好交流合作的延续。参观学习的最后，王校长也对同学们加入叁昶进行实习工作表示欢迎。',
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941213028-05926486-718d-4c74-bf34-f2356196cc5a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941213449-72fbf607-cd4b-4c56-b4cc-c7e66107b42f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941211343-e2ebf26b-1346-41df-97d7-b52396fbdeb3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941214209-b55ddf03-2ba1-4c4b-bccd-02eedc079801.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718941214828-02fafe6f-1543-42df-8a75-a15b79d915f2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1344%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {}
      }
    },
    {// 20240602 周晓强
      title: '向善向美向未来 | 叁昶助力上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼圆满呈现！',
      time: '2024-06-02',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082826021-028cf065-d78f-49a8-8f4e-5b99224997fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1500%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=30",
      details: {
        top: {
          title: '向善向美向未来 | 叁昶助力上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼圆满呈现！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082826021-028cf065-d78f-49a8-8f4e-5b99224997fa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1500%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['6月2日，上海七宝德怀特高级中学十周年庆典暨2024届毕业典礼顺利举行，现场<strong>超1000人共同见证</strong>。',
            '贵州省高级人民法院原院长、闵行区原区委书记孙潮，上海市人民政府副秘书长赵祝平，上海市教育学会会长、上海市教育委员会原副主任尹后庆，上海市政协科技和教育委员会常务副主任、闵行区原副区长杨德妹，上海市教育委员会副主任王浩等领导莅临出席。'
          ],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082841807-5eecf882-29ab-48f3-a324-43e93e194b6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082840331-a4736664-e798-4a6a-8290-e21a28ec1e00.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082837821-646cc9d6-381a-4f74-8d3e-184a697800c7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082838911-b9d4f116-7c95-49bc-b4e7-a2267595ca11.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1056%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082838803-3b1bf4d4-b69b-4911-b07a-5fde04d4b65c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1043%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['本次活动<strong>策划方案、舞美呈现、节目指导、视频制作、视觉及装置</strong>均由叁昶设计、落地并全程保障，实现了<strong>现场转播及双语同步翻译</strong>。',
            '以七德十年大事记和毕业生入场仪式开场，伴随着民乐团与爵士乐团  庆典正式拉开帷幕。除<strong>学生职业发展项目基地发布、颁发毕业证书及奖学金等环节外</strong>，庆典将<strong>汇演、音乐剧、情景讲述、表彰</strong>等众多精彩纷呈的多元形式贯穿始终呈现了风华正茂、神采卓越的七德风貌。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082857656-38c7544f-51cc-4b5e-b4ff-36cd34879c65.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1019%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082856668-43a8eb07-8aa4-4b6c-a9ab-7eeaaeec0b6e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859907-1e2321bf-fa39-4293-b2db-34d572d78191.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859682-ba86004d-9e4b-4e46-b4d4-62134aacd30b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_993%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082857284-2c7089ec-b5a6-4eae-bbfa-9d7317cee534.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082859894-c96be186-8442-424f-8a82-f2a63fbeecfa.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1038%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082863373-1d032e31-bfbf-4d7f-8973-3d2bf40566c4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082865587-9e702cf7-df82-495b-a2fe-e93cef2f6827.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1046%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240531 周晓强
      title: '慧心逐梦 创享未来 | 叁昶助力上海市材料工程学校第四届“慧之创”材料双创节启动',
      time: '2024-05-31',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082762951-9944cf67-bb6a-4f43-be7d-5abc65f66275.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=29",
      details: {
        top: {
          title: '慧心逐梦 创享未来 | 叁昶助力上海市材料工程学校第四届“慧之创”材料双创节启动',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082762951-9944cf67-bb6a-4f43-be7d-5abc65f66275.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['5月28日，“慧心逐梦 · 创享未来”第四届“慧之创”材料双创节于上海市材料工程学校大礼堂举行。围绕学校“慧·竹”文化，叁昶公司进行了“慧之创”全案策划及设计制作，展现活动有激、比赛有绩、宣传有迹的双创特色。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772841-edbbbf9c-f4f6-41d2-b341-be241cf22fa2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772794-3872971b-7aa8-4daf-82cc-d85f9f7c07b2.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082772704-9b794a4e-2936-45ee-9ca8-c1d367b2cafe.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773021-ac3edd65-68a1-4792-b864-1321c264404b.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773104-55ba2d0f-bec0-4e27-a6e6-f4df24e32d10.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773618-d9fb7196-3bdf-4400-87db-f87da8c857d3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773277-c157be22-f554-45f3-a6a0-bde22c0bbd7c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082773447-b2aba9b8-2b73-4b32-974e-e606f54ad586.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['在活动内容设计中，叁昶团队深度挖掘学校双创元素进行节目创作，通过<strong>视频回顾、路演展示+导师点评、故事分享、音乐剧</strong>等多种内容形式， 呈现丰富、立体的双创活力；在仪式环节设计中，叁昶团队在传统模式中进行了道具和形式的创新，实现了领导和<strong>AI虚拟人</strong>同台进行活动内容的发布。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082785965-3d2a6722-a53f-480a-9d8a-4a7b2ab7a603.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082785857-56bb822b-7c7c-4edf-88b1-ea27bcecb9dc.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082786316-3568d0d7-0f61-47ee-94e9-67182d2cc2d6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082786003-ac9e4b44-02d7-4c01-8f75-44d81f979e3f.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]
        }
      }
    },
    {// 20240430 周晓强
      title: '上海新型高职联合马克思主义学院揭牌',
      time: '2024-04-30',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082669043-68781396-3a8c-4f41-b491-19f42cf8bd9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1768%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=28",
      details: {
        top: {
          title: '上海新型高职联合马克思主义学院揭牌',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082669043-68781396-3a8c-4f41-b491-19f42cf8bd9c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1768%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['4月30日上午，上海南湖职业技术学院、上海科创职业技术学院、上海闵行职业技术学院、上海现代化工职业学院、上海建设管理职业技术学院五所新型高职在上海南湖职业技术学院举行上海新型高职联合马克思主义学院成立仪式。市教卫工作党委书记沈炜、虹口区委书记李谦出席仪式并讲话，共同为上海新型高职联合马克思主义学院揭牌。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082683240-2c7f3b37-f5e7-4380-87a1-ce5feb07eb34.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082685038-602b57c8-069a-4169-9a6d-b4b899f9dba2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082682255-484c2a6b-a552-42f6-8951-7904d0dbebeb.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1541%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082682147-91544232-8f87-4e62-b44f-5ab5b8160079.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1642%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082677451-6109f4a1-8514-4fa8-a11a-81dba5249ed3.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['会上，市教卫工作党委书记沈炜、虹口区委书记李谦为上海新型高职联合马克思主义学院揭牌；五所新型高职共同签署《上海新型高职联合马克思主义学院合作备忘录》，为上海新型高职联合马克思主义学院特聘专家颁发了聘书，并举办了专家微报告。',
            '本次活动的<strong>策划、视觉设计及内外场布置</strong>均由叁昶公司落地和全程保障。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082700736-0b295855-aff8-486e-85ba-6a36023b586c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1764%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082703888-c0daa1d6-405e-4399-bd1a-884c00b30ad7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082697659-eded4ad1-ce19-4fde-8001-4113397b9e12.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240422 周晓强
      title: '同一本书，不同的世界 | 叁昶助力上海市基础教育读书行动交流展示活动暨“阅‘嘉’行动”启动仪式举行',
      time: '2024-04-22',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082591835-2e2ca3ce-b87e-438a-b337-42d612dec4d9.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=27",
      details: {
        top: {
          title: '同一本书，不同的世界 | 叁昶助力上海市基础教育读书行动交流展示活动暨“阅‘嘉’行动”启动仪式举行',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082591835-2e2ca3ce-b87e-438a-b337-42d612dec4d9.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['4月22日下午，在第29个世界读书日来临之际，“同一本书、不同的世界”——2024年上海市基础教育读书行动交流展示活动暨嘉定区“阅‘嘉’行动”启动仪式在嘉定区图书馆举行。上海市教育委员会副主任杨振峰、嘉定区副区长汤东英、嘉定区政协副主席陈宾等出席活动。叁昶<strong>全程参与策划并保障</strong>活动的顺利落地。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605563-f830fd1e-cf0c-411f-aa00-b5398610e91c.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605514-20870648-cd52-4d2e-af29-9dce76e379c0.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605438-0499ec0c-da3f-48b9-9b96-2a647b9f9b40.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605387-4eb12fc4-5481-4de9-8cb7-d0f5d14f4d7f.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605595-6f0fb7de-8183-43bb-9daf-1135f6b369a7.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082605707-a3874e18-b30c-495f-8825-a35f25efebb5.jpeg?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: ['本次活动由上海市教委、嘉定区政府和区政协共同主办，嘉定区教育局、区文旅局、区政协文化文史和学习委共同承办。',
            '市教委相关处室，嘉定区相关委办局，上海市教师教育学院（市教委教研室）和市教委中小学图工委相关负责同志，各区教育局分管局长、教育学院院长和基教科科长，以及嘉定区相关部门的负责同志和全区校长、园长等近500人参加活动，共同见证了“阅‘嘉’行动”及“孔庙讲堂”的启动。嘉定区的师生进行了<strong>诗乐表演、阅读讨论会、情景剧、教师微研修、脱口秀、国学分享会</strong>等多样形式的表演。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/webp/38716037/1718082620289-f436304a-9b4a-4dbb-abc9-3cf2214d5ed4.webp',
            'https://cdn.nlark.com/yuque/0/2024/webp/38716037/1718082620390-2a564e32-df0d-4458-8375-523923d9006f.webp'
          ]
        }
      }
    },
    {// 20240320 周晓强
      title: '第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区比赛圆满结束',
      time: '2024-03-20',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082489062-82f60f2e-39e8-47bc-acee-360cf431a70b.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=26",
      details: {
        top: {
          title: '第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区比赛圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082489062-82f60f2e-39e8-47bc-acee-360cf431a70b.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2024年3月20日，叁昶助力为期两天的第47届世界技能大赛集中考核（上海赛区）上海市建筑工程学校分赛区的管道与制暖、抹灰与隔墙系统、砌筑三个比赛项目圆满完赛。',
            '第47届世界技能大赛集中考核（上海赛区）龙吴路分赛区由中华人民共和国人力资源和社会保障部主办，上海市人力资源和社会保障局承办，上海市建筑工程学校提供龙吴路分赛区场地及技术支持。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082505936-9fb95676-b763-46b7-9687-f56fc8e0cd1c.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082510195-72195352-6830-49c8-a25e-3089afbb28c1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082511752-a51d5796-a080-49cb-b3d9-aab0f596dfb2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082509161-3e7d7fd9-23da-4e55-968c-be5334fb4941.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082508675-6e200b32-1317-4b71-add5-f861200d3728.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['赛场<strong>环境布置、内外宣传、赛务用品、赛务手册、花絮拍摄、赛程拍摄及后期制作</strong>均由叁昶公司<strong>策划、设计制作、布置并保障</strong>。',
            '据悉，第47届世界技能大赛将于今年9月在法国里昂举办。为积极备战第47届世界技能大赛，人社部在上海、河南、广东等3个赛区组织开展集中考核工作，并决出代表我国出征第47届世赛的正选选手和备选选手。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082537953-7439e36d-b97f-41e4-934f-20c24a3246ac.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1295%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082536754-8762642b-17ea-4711-9515-fcca4b689ac4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1333%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082533718-5b0fd8f3-c12a-4083-b3c4-0c3ce64b350c.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082537585-ae014995-1178-4716-aebe-70f8a78492bc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1311%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 20240206 周晓强
      title: '叁昶全力保障浦东机场飞行区模拟驾驶培训基地启用仪式圆满结束',
      time: '2024-02-06',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082191486-03687ee4-6885-41d2-a38d-c209f73f2120.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1587%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=25",
      details: {
        top: {
          title: '叁昶全力保障浦东机场飞行区模拟驾驶培训基地启用仪式圆满结束',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718082191486-03687ee4-6885-41d2-a38d-c209f73f2120.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1587%2Climit_0'
        },
        lunbo: {
          title: ['2024年2月6日，浦东机场“飞行区模拟驾驶培训基地启用仪式”顺利举行。上海机场 (集团) 有限公司总裁冯昕出席并致辞。叁昶<strong>策划设计并全力保障</strong>活动圆满结束。',
            '活动中观看了《浦东机场飞行区模拟驾驶培训系统介绍》短片并进行了方向盘模型交付仪式及飞行区模拟驾驶培训基地启用仪式。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082326688-2d063ec7-be93-4e15-b4a7-6ecf61ea6856.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082324879-7d9583ef-28d9-4fb9-abe6-524c5eefa949.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082325813-e268be32-d849-4d4f-838e-8a0960319dd6.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718082324970-4ead4f6b-262a-434a-848f-25bd7e93887c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1728%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {}
      }
    },
    {//2024-03-08 武京
      title: '赴新途 谱新章 | 叁昶公司2024年度迎新春年会圆满落下帷幕！',
      time: '2024-01-20',
      // img: '/assets/240108main.png',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709880399071-e1f1ea6b-c09a-4e23-9ace-60b8e65d9bb2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=30",//存疑，原因：不清楚来源,作用:不明
      details: {
        top: {
          title: '赴新途 谱新章 | 叁昶公司2024年度迎新春年会圆满落下帷幕！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709880399071-e1f1ea6b-c09a-4e23-9ace-60b8e65d9bb2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: [
            '2024年1月20日，叁昶2024迎新春年会庆典在万豪国际集团旗下的上海宝山德尔塔酒店圆满落下帷幕。',
            '叁昶公司顾问王志卫在开场致辞中对所有嘉宾及全体同仁的莅临表示热烈的欢迎及诚挚的感谢，并将<strong>叁昶2024的工作目标</strong>总结为三个字——<strong>“闯”、“创”、“窗”</strong>，即做到<strong>有敢“闯”的勇气；不断“创”新的锐气；做出“窗”口样板的神气。</strong>',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878301724-1eada657-3307-42e5-bf5f-ce1a83deeaee.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878301575-278300d5-2709-42ca-9488-be8bc54bf08e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878302566-faa4839c-b9a7-4cfb-b485-659276879d54.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878302770-2c39a3cf-0bc2-41ee-8b2f-909c0c1987be.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878302986-4d72db85-8a82-4f5c-9296-dd4e85ff9081.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878302965-e0df80e3-0315-4a14-b29f-4adee1b089a3.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
          ]
        },
        bottom: {
          title: [
            '年会现场叁昶全体员工及受邀而来的合作伙伴，欢聚一堂，共襄盛举。全场座无虚席，热闹非凡，更是完成了一场近200人的《科目三》。除了叁昶管理团队集体亮相、优秀员工表彰、合作企业代表发言等环节，更有现场乐队、公司伙伴、特邀嘉宾带来的精彩节目，以及奖品丰厚的游戏和幸运抽奖环节。在欢声笑语中，2024年度迎新春年会圆满落下帷幕。',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878303821-0d527087-0796-4adb-a593-68277fe93ede.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709878304346-dadab753-96a3-448d-9466-3e8891352007.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878304344-59037467-35e4-436c-98a9-9a5b10fa5ab4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709878304314-819a2da2-c6bc-4e17-8763-6917a6359e04.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709878301685-40c75a42-24d0-4063-99b3-373d7d128408.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709878301716-0f1a6621-8508-4fbc-ad8e-e3dcd2e81401.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709878301778-dbe4dd04-1121-44cb-bb8d-87dc2a98b506.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_750%2Climit_0',
          ]
        }
      }
    },
    {//2024-03-06 武京
      title: '叁始善成·昶赢未来 | 叁昶公司2023年终述职大会顺利召开',
      time: '2024-01-18',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716463411-4073cab0-f7ab-422f-92f6-704fa060994a.jpeg',
      linkTo: "/instanceItem?type=technology&num=30",//存疑，原因：不清楚来源,作用:不明
      details: {
        top: {
          title: '叁始善成·昶赢未来 | 叁昶公司2023年终述职大会顺利召开',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716463411-4073cab0-f7ab-422f-92f6-704fa060994a.jpeg'
        },
        lunbo: {
          title: [
            '2024年1月18日，2023年终述职大会首先由各部门负责人回顾了2023年工作亮点及重点工作完成情况，并就工作展开总结与反思，明确2024年的工作方向和计划。公司顾问王志卫对各部门述职情况逐一点评。',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709717177410-ea543506-9323-4d1a-a9b0-cebb2f80d548.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709717322865-47baedbc-d55c-4f56-93ef-9d7eef080010.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716465046-7c1e9dab-9028-4f24-a338-31bd7ea4e81e.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716465128-2dbf31bb-7501-48a3-b42e-08fc55815283.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716465285-2881bab5-689e-42d0-a6fd-255a19dd027e.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716465814-1f3c721a-17c9-414e-9758-b5385ac9ea47.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716465812-e5f37b19-9a6a-4e9d-971f-b17eb9866c55.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716463384-10adee5f-a8d2-4e00-ac6b-f985d6aeb90c.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716463389-59004ef2-9ad9-4f13-a3dc-d8ab7f13bcec.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716463399-4d2aebf0-15ac-41a6-b95c-ffcafb81d0e4.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709717399806-ee063514-aa42-4740-a534-cd00319111b8.jpeg',
          ]
        },
        bottom: {
          title: [
            '王志卫在大会上肯定了团队在2023年的成绩并指出：得益于良好的管理方法、顽强的作风和人性化的企业文化， 公司正蓬勃向上的发展。',
            '同时，也对2024年叁昶的工作提出四点意见和建议：',
            '1.进一步坚定信心，找准人生的目标；',
            '2.强化管理，从管理上要效益，从管理上要目标，从管理上要成果，事不过夜，做到“严、紧、细、实、快”；',
            '3.协调合作，提高工作作风，在平凡的岗位做不平凡的事，每一个环节都不能懈怠；',
            '4.做好服务，营造一个好的环境。',
            '最后，王校长以送给大家一段金句：“坚定信心瞄准目标、加足精神、明年大干！”',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716464040-7fbf8073-fcac-4ecd-9a79-63d22966256e.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716464102-cdc2d770-f0a8-45b0-ae3e-31d5da1cc028.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716464197-b55df7d9-a8a5-4166-96a6-0260572e61e4.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709716464607-804d3fd1-539d-4fc6-b06a-660e486c4c73.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '叁昶保障第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展！',
      time: '2024-01-06',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077771263-0b146d55-1f10-4eec-bfae-6a4666f5f90c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1053%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=24",
      details: {
        top: {
          title: '叁昶保障第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077771263-0b146d55-1f10-4eec-bfae-6a4666f5f90c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1053%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: ['2024年1月6日，由上海中华职教社联合市人社局、市教委共同主办的第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会在上海南湖职业技术学院举行。',
            '上海市副市长、市职教社主任解冬出席并讲话。市政府副秘书长王平，虹口区委书记李谦，市中华职教社副主任、浦东新区人大常委会副主任李国华，市中华职教社副主任、上海体育大学党委副书记、校长毛丽娟，市中华职教社副主任丁光宏，市中华职教社副主任、市教委副主任孙真荣，市就业促进中心主任周国良，虹口区委常委、统战部部长郑宏，市中华职教社副主任叶才福、丁祖昱等领导出席活动。市职教社常务副主任、市政府参事胡卫主持活动。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077786285-52215da7-9bcf-4e83-aa4c-0276c84255c4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077783714-240b845c-1226-492a-89bd-3710dc120f18.jpeg?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077785153-bb478ed8-a024-4b2b-a931-b899955a92e8.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077788168-a7b5e89b-6a4a-45c1-b24a-488e9a6fd974.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077784035-73100227-b9e6-4a3d-a92b-5e498811ce73.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077788122-28514be3-f07b-4368-bcba-d3135771d98f.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1047%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['本次<strong>活动议程、内外场视觉、视频制作、环境布置、图片直播</strong>均由叁昶团队精心负责，保障了第十一届上海市“中华杯”教师职业技能竞赛闭幕式暨颁奖大会顺利开展， 受到主办方高度好评。',
            '活动内场除领导讲话汇报、颁奖表彰、表演、赛旗交接等环节，叁昶助力上海中华职业教育社“上海市虹口区产教联合体-创新研究基地”顺利启动。活动外场设有“职技匠心·沪创未来”职业技能成果主题展，现场展示了蜡染、传统香道制作技艺、葫芦雕刻等非遗项目，以及智能新能源汽车5G+XR虚拟仿真等新兴技术。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077816057-053aa441-d7a0-4d7a-8eae-88715a1df0c5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077810915-e1580eed-b6af-4f1b-8c78-d29132985cf1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1050%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077810638-097aa79f-7e76-4f8c-8130-98458fe193dc.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077811346-772c209e-8380-4c29-bdce-bdd120a3237a.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077812134-c56accb3-a10e-4b4a-bc6c-b13570237809.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077813587-b102fb67-7972-4ba3-8e54-6b276986e506.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {// 2024-6-11 周晓强
      title: '创新创业|叁昶助力徐汇职业教育集团举行区中等职业学校学生“双创节”',
      time: '2024-01-05',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077441215-08015ceb-8cdc-4224-89f5-10ddf7309683.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=23",
      details: {
        top: {
          title: '创新创业|叁昶助力徐汇职业教育集团举行区中等职业学校学生“双创节”',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/38716037/1718077441215-08015ceb-8cdc-4224-89f5-10ddf7309683.png?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2024年1月5日，2023年徐汇区中等职业学校学生创新创业节在上海市信息管理学校顺利举行。',
            '徐汇区教育局副局长、徐汇职教集团常务副理事长林琛，市教委教育技术装备中心党总支书记周齐佩，上海市学生事务中心副主任王涛，市教委职业教育处四级调研员谢俊，徐汇区人力资源和社会保障局局长彭燕及区域中职校领导，部分企业负责人参加活动。叁昶策划设计并全程保障内外场活动及环境布置。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077505290-ad878361-eee3-4d79-a83d-884170b0da11.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1047%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077504457-36002808-5e57-4226-b335-60cf16a08193.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1057%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077504982-a7679ae2-cf6a-4ce4-b5f9-b99199489303.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1041%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077503091-23ac3479-758f-4389-a268-ce1b4ad186da.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1028%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077510220-6f33d830-5104-42ac-8fb4-60ca867184df.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: ['活动分为<strong>“双创”舞台秀和“双创”成果展示市集</strong>两个部分。',
            '双创”舞台秀由<strong>暖场直播、舞龙、走秀、舞蹈、路演示范、成长故事分享</strong>等多元形式构成，活动中举行了区中职创新创业导师聘任仪式、区创新创业共同体成立揭牌仪式。',
            '双创”成果展示市集设置了<strong>蓝毯区、打卡</strong>区及来自徐汇区中职校15个创客创业成果转化展示展位构成的<strong>市集区</strong>。'],
          img: ['https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077529196-97a07946-e6bd-43b5-9624-95d31ecb6b02.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528481-2bd93690-9229-49b7-af38-06b1256991a1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528591-7cc454b3-94d3-449d-81e9-dabf575b7110.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077528853-2befcbc0-42bf-49d6-b0d4-798af68bc6a2.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077531316-6c017cbd-d8fb-41c8-aad3-69142709f3b8.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077532160-44506d7b-a269-40da-8fc7-4a30e1afe2ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077534222-365d5824-93e4-4d96-8bc7-c00b17d43c43.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077529414-1375fda1-6b0d-41f4-9134-33c017752d6c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_937%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077535065-7ceea8f5-3a9d-40b8-ad6f-26977ae550b4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1600%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/38716037/1718077534200-cfea83a0-9600-46ab-b7d1-b569cc379e52.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Fresize%2Cw_1066%2Climit_0%2Finterlace%2C1'
          ]
        }
      }
    },
    {//2024-03-06 武京
      title: '位正育卓 | 叁昶助力上海市位育中学、位育初级中学建校八十周年主题活动完满呈现',
      time: '2023-12-06',
      img: 'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709715905742-742ae8ec-a751-4979-a537-48e05b2a000a.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=30",//存疑，原因：不清楚来源,作用:不明
      details: {
        top: {
          title: '位正育卓 | 叁昶助力上海市位育中学、位育初级中学建校八十周年主题活动完满呈现',
          img: 'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709715905742-742ae8ec-a751-4979-a537-48e05b2a000a.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: [
            '2023年12月16日，叁昶承办的上海市位育中学、位育初级中学建校80周年主题活动于学校艺体楼隆重举行。',
            '全国政协常委、上海市政协原副主席周汉民，上海市社会科学界联合会主席、原上海社会科学院院长、国家高端智库首席专家王战，徐汇区委副书记、区长钟晓咏，上海市教卫工作党委副书记、市教委副主任闵辉，徐汇区委副书记、区委教育工作领导小组组长沈权，中国科学院上海分院院长胡金波出席并表达祝贺。徐汇区教育工作党委副书记、教育局局长王彤，副局长周刚、奚云斐等参加活动。',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715903430-7d14c12f-945c-4e2b-9939-351091fc5651.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715903522-1a4aaabe-66ba-401c-92e2-3916a052c7cb.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715907053-f13397ef-511e-4558-9219-206a1b73e2f9.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715907375-5d9128d7-3608-4e15-8d15-49641ef8be14.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715907710-44f72849-0793-419d-b504-67ba56dc5418.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
          ]
        },
        bottom: {
          title: [
            '本次校庆的<strong>活动议程、舞美设计、原创节目、视频制作、内场视觉及活动布置</strong>均由叁昶公司策划、设计、落地和全程保障。执着于质量和服务的细节呈现，活动得到了完美呈现，并获得了各方好评！<strong>新闻晨报、新民晚报</strong>等多家媒体发布相关活动讯息。',
            '活动现场庄重而热烈，叁昶团队旨在通过原创的形式展现学校的传承与发展。除原创情景合唱、文化展演秀、诗朗诵、校友对话等原创节目外，叁昶在上海交通大学创新中心拔尖人才联合培训基地揭牌仪式、上海荣昶公益基金会捐赠仪式、“位育荣誉专家”导师团成立仪式和位育集团高质量发展行动《位正育卓向未来》等多个远传仪式环节中，采用了<strong>多元化、差异化</strong>的创新呈现形式。',
            '在整体布置中，叁昶负责活动内场的<strong>背贴、台卡、节目单</strong>的设计制作。此外，校方为欢迎广大的莘莘学子回家，精心准备了校庆衍生品，并布置了多处打卡点位。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715905829-d2a0cbaf-5043-470e-9404-1b2e95c4790b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715907065-9e475d73-98e4-4641-a758-464c3ef1f1dc.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715900090-1faf9457-09c2-44d3-ae3b-a679fe736e58.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715903661-5905189a-174e-44e6-b6fe-f4d56dd12ccf.jpeg?x-oss-process=image%2Fresize%2Cw_1905%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715903147-a08b0012-a561-4041-b81b-e872d6211e3b.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715903227-8905c2c2-39a6-4bde-bd66-544ae097e12d.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709715900091-82111ff3-2ad1-48e5-9234-1be85ab31c31.jpeg'
          ]
        }
      }
    },
    {//2024-03-06 武京
      title: '全球首家！叁昶全力保障世界技能博物馆开馆仪式圆满完成',
      time: '2023-11-06',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706194343-dcf244ab-3322-4292-8f07-0f3a7eb101fe.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
      linkTo: "/instanceItem?type=technology&num=30",//存疑，原因：不清楚来源,作用:不明
      details: {
        top: {
          title: '全球首家！叁昶全力保障世界技能博物馆开馆仪式圆满完成',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706194343-dcf244ab-3322-4292-8f07-0f3a7eb101fe.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1'
        },
        lunbo: {
          title: [
            '2023年11月6日我司在世界技能博物馆杨树浦路1578号组织开展世界技能博物馆开馆仪式，仪式上，国家人力资源社会保障部部长王晓萍、上海市市长龚正、世界技能组织主席克里斯·汉弗莱斯共同启动博物馆开馆装置，标志世界技能博物馆建设完成并进入常态化运营。国家人社部副部长俞家栋、上海市副市长华源、大卫·霍伊致辞，世界技能大赛创始人阿尔伯特·维达家属应邀出席。世界技能组织部分成员国、全球合作伙伴、技能组织专家发来祝贺视频。仪式后，中外嘉宾共同参观了博物馆。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706195236-d9b8a061-a1e9-4b53-818d-070dece773d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706195981-7f6e5142-315f-4e21-b834-16fad36c0777.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706195478-52e39e23-00ba-4a6f-9ab6-1e45a63a6c8f.jpeg?x-oss-process=image%2Fresize%2Cw_1920%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706194331-9f457a86-4447-4d35-8ba1-c68884c6fb2e.jpeg',
          ]
        },
        bottom: {
          title: [
            '世界技能博物馆坐落在上海杨浦滨江，是<strong>世界技能组织认可、全球首家</strong>冠以“世界技能”之名的博物馆，由<strong>国家人社部、上海市政府、世界技能组织三方共建</strong>。',
            '世界技能博物馆馆址前身是永安栈房，是一座百年历史文化保护建筑。按照“修旧如旧”的原则，博物馆在修缮时对永安栈房的八角棱柱、墙面、天花板等进行了保留，完美融合了中国元素、上海符号、工匠精神。',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706194359-247cd046-71b2-476b-9301-3de8ac94beed.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709706195207-b1caab99-3d20-4ea6-a7ba-f808c1c3662c.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
          ]
        }
      }
    },
    {// 20240526 周晓强
      title: '科学引领未来，教育助力强国 | 2024第二十一届上海教育博览会盛大举办！',
      time: '2024-05-26',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590090-120233fe-ec63-42f4-a4fe-7045f356cd38.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=26",
      details: {
        top: {
          title: '科学引领未来，教育助力强国 | 2024第二十一届上海教育博览会盛大举办！',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590090-120233fe-ec63-42f4-a4fe-7045f356cd38.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['5月24日-5月26日，2024第二十一届上海教育博览会在上海展览中心盛大举办，本届教博会由中共上海市教育卫生工作委员会、上海市教育委员会指导，上海教育报刊总社主办，以“科学引领未来，教育助力强国”为主题，将继续采用线上、线下相结合的方式进行。其中，5月24日-26日为线下展，线上展同期开展并将持续至6月底。',
            '展区分为市级展区、长三角融合发展主题展区、科学教育特色主题展区、高等教育展区、区域教育展区、职业教育展区以及相关企业展区等。',
            '叁昶公司设计打造的展馆齐齐亮相本次教博会。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590567-f3ec63bb-c154-4e71-a7c1-1a7628e01760.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590324-71af0360-3456-4ed6-9fb3-96b8bcd31a01.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532590892-4dbf6e8d-63dc-4f70-95ec-31175dbbde8e.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532591131-30c5ae9e-bcf2-47ae-aec3-d9756a31986d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532592153-13d71c3a-2def-42fe-a593-eff6eae273fe.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532592006-fd591531-2de5-4abf-97d5-da00557688ef.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {//2024-03-06 武京
      title: '出手就出彩、首届即样板！叁昶助力上海市第一届职业技能大赛开闭幕式及内外场策展活动圆满成功！',
      time: '2023-04-22',
      img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702531655-ea8b085e-f8ba-44ba-b943-747ff8de910b.jpeg',
      linkTo: "/instanceItem?type=technology&num=30",//存疑，原因：不清楚来源,作用:不明
      details: {
        top: {
          title: '出手就出彩、首届即样板！叁昶助力上海市第一届职业技能大赛开闭幕式及内外场策展活动圆满成功！',
          img: 'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702531655-ea8b085e-f8ba-44ba-b943-747ff8de910b.jpeg'
        },
        lunbo: {
          title: [
            '2023年4月22日，以“技能造就美好未来"为主题的上海市第一届职业技能大赛在上海汽车会展中心拉开序幕，并于6月21日在嘉定区闭幕。',
            '上海市第一届职业技能大赛吸引了全市16支代表队、1076名参赛选手参与，是上海各级各类赛事中<strong>规格最高、规模最大、项目最多</strong>的综合性职业技能竞赛。大赛聚焦上海重大战略部署、重要产业发展，紧跟新技能发展趋势，共设置了109个正式比赛项目，涵盖63个世赛项目和46个国赛项目。',
            '出手就出彩、首届即样板。叁昶不负重托，全程保障了<strong>大赛开、闭幕仪式及大赛内外场策展服务</strong>的顺利展开，获得了各方好评。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702663403-a0f30540-552d-4eec-a484-17ff5072c338.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702663426-9bc43785-3345-4046-b505-fc6eadc6a31f.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709702663496-4cecc491-6f6b-4a52-af8b-039141f8ebd2.png?x-oss-process=image%2Fresize%2Cw_644%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702663735-1e3dbdf0-90cb-424f-8c53-bf62f204bea6.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702664216-42e7f649-4dc3-4340-be53-0fdbfd8cea80.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709714743325-d670c24d-090f-4875-80a4-cfb4bc50a39c.png?x-oss-process=image%2Fresize%2Cw_696%2Climit_0',
          ]
        },
        bottom: {
          title: [
            '叁昶团队为本次大赛策划设计了<strong>全套视觉标识、主题歌曲、主画面、全市相关宣传海报、奖牌、视频及开闭幕式内外场策展、环境布置、新媒体直播间</strong>等内容，并形成了<strong>《上海市第一届职业技能大赛手册》</strong>。',
            '大赛的<strong>LOGO</strong>标识图形，既为上海的“上”字，亦为匠心的“匠”字。造型类似“燃烧的火焰”，也像“努力奋斗的攀登者”“上”寓意大国工匠在技能上精益求精、不断向上的卓越精神，同时也代表是上海举办的技能大赛。“匠”寓意大国工匠在技能上永争第一的匠心精神。色彩搭配选用红色与蓝色作为主色调，凸显中国红、技能蓝和上海蓝，寓意炉火纯青的技艺。',
            '大赛<strong>吉祥物</strong>名为“嘉宝”，设计原型为嘉定特色美食“南翔小笼包”，外形可爱，且小笼包制作技艺还代表了民间文化、情怀和技能的传承。',
            '叁昶团队策划的<strong>开、闭幕式</strong>融入技能元素、嘉定元素、上海元素、世赛元素展现全市技能人的技能水平，匠心精神让新时代上海技能人走上舞台的最中央。由叁昶团队设计的舞美，结合舞台科技以及多种艺术形式，充分彰显了年轻化、时尚化技能化。为配合开幕式活动，积极营造热烈欢腾、热情洋溢的盛会氛围，对上海汽车会展中心内外也进行了整体氛围布置。',
            '参昶团队着力打造的<strong>“嘉定馆”</strong>由汽车嘉定、平安嘉定、科技嘉定三个区域构成，展智能制造，创非凡远景。展馆设计聚焦“两面观”，一面为文化底蕴，解构地标建筑，彰显历史传承;一面为科技创新，提炼明朗线条，彰显高速发展。将比赛、展示、体验、观摩相结合，同步举办了观赏度高、互动性强的技能展示活动。',
            '为满足大赛的直播需求，给线上观众带来身临其境的观赛体验，团队设计并搭建的<strong>“新媒体直播室”</strong>得到了高效利用。',
            '此次大赛受到<strong>央视网、东方卫视</strong>等多家主流媒体的关注和报道，央视新闻、“上海人社微信视频号、"上海嘉定”微信公众号、百度直播等多个平台进行了全程直播，让民众足不出户即可观看技能高手同台竞技，近距离感受技能魅力，在全社会营造了良好的大赛氛围扩大了大赛影响力，让民众走近大赛，了解大赛，参与大赛。'
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702664283-4c5b705c-5d9f-4125-acb4-4a705561534c.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/png/29599659/1709702664440-b1208d9d-f6df-4361-bfe9-65611cf9c2da.png?x-oss-process=image%2Fresize%2Cw_647%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702662448-7a1b9024-12e3-49f6-b623-22ea5b91a1a8.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702662446-d971f59c-cf33-462e-85d2-8d7197f0740f.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702662445-84dbdac3-ca5e-445b-a3e0-09efc3854130.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702662461-64793b1b-e312-41a2-b57c-ac93d43bdb1e.jpeg',
            'https://cdn.nlark.com/yuque/0/2024/jpeg/29599659/1709702662456-fd1afd0f-7ab3-4301-9d2f-4df11f804564.jpeg'
          ]
        }
      }
    },
    {// 20240320 周晓强
      title: '新时代廉洁教育新高地——河滨清风新时代e+廉洁主题公园',
      time: '2024-03-20',
      img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239557-23c21251-c674-4207-8ccd-cc7a9e3e113a.png?x-oss-process=image%2Fformat%2Cwebp',
      linkTo: "/instanceItem?type=culture&num=25",
      details: {
        top: {
          title: '新时代廉洁教育新高地——河滨清风新时代e+廉洁主题公园',
          img: 'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239557-23c21251-c674-4207-8ccd-cc7a9e3e113a.png?x-oss-process=image%2Fformat%2Cwebp'
        },
        lunbo: {
          title: ['叁昶将河滨清风新时代e+ 廉洁主题公园巧妙融合了彭浦镇白遗桥滨河绿地的自然风光与深厚的廉洁文化底蕴，通过家训长凳、清风长廊、竹编莲花、投影廉灯、网上廉洁文化展馆等廉洁文化元素，带领游园者聆听古代清廉典故的低语，感受先贤们高风亮节的精神风范，以此打造出一处寓教于乐、润心无声的新时代廉洁教育新高地。叁昶将河滨清风新时代e+ 廉洁主题公园巧妙融合了彭浦镇白遗桥滨河绿地的自然风光与深厚的廉洁文化底蕴，通过家训长凳、清风长廊、竹编莲花、投影廉灯、网上廉洁文化展馆等廉洁文化元素，带领游园者聆听古代清廉典故的低语，感受先贤们高风亮节的精神风范，以此打造出一处寓教于乐、润心无声的新时代廉洁教育新高地。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239592-24d286b1-7cfd-40ae-b9e6-986ec4aace4a.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532238616-a52fa9f4-89e6-49af-adcf-9f45517a0a40.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532239064-3feb7aa5-5ba3-4cfd-bfe2-4baa557d69f1.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532238458-93eea65e-8fd8-4761-a7f6-65b4e48fef2f.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532241456-e5867139-22c5-429f-b23b-bb2afeb3efd1.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532241595-fe3cf71b-4207-485d-b3a6-6323b58e8193.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/png/38716037/1761532242765-5db4acec-e044-4bf1-9665-2c81d8f3dd21.png?x-oss-process=image%2Fformat%2Cwebp'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20231230 周晓强
      title: '叁昶出品 | 仁济医院户外文化景观：医脉相承，人文共生',
      time: '2023-12-30',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024374-425090f8-b398-42b3-8f69-623ea0d27cff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=24",
      details: {
        top: {
          title: '叁昶出品 | 仁济医院户外文化景观：医脉相承，人文共生',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024374-425090f8-b398-42b3-8f69-623ea0d27cff.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['叁昶公司为仁济医院打造的户外文化景观项目，以“医脉相承，人文共生”为主题，将医疗文化、科技创新与自然生态深度融合，塑造了一座兼具疗愈功能与人文关怀的艺术空间。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024293-bcc2a34c-3e89-4802-913c-a875e642523d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024293-bcc2a34c-3e89-4802-913c-a875e642523d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024487-cf94e20f-5879-496e-bd16-0af5365613e5.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761532024251-6232f6ce-e273-44f3-85b7-a4fe4e9c6ef1.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {// 20230830 周晓强
      title: '探秘上海现代化工职业学院学生活动中心：五层空间的活力密码',
      time: '2023-08-30',
      img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531845376-a2a4d76e-efce-4e42-afe5-1d74f0ed071c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
      linkTo: "/instanceItem?type=culture&num=23",
      details: {
        top: {
          title: '探秘上海现代化工职业学院学生活动中心：五层空间的活力密码',
          img: 'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531845376-a2a4d76e-efce-4e42-afe5-1d74f0ed071c.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
        },
        lunbo: {
          title: ['作为上海现代化工职业学院校园文化建设的核心载体，叁昶倾力打造的学生活动中心，通过“图标+ 五层空间” 的一体化设计，构建起兼具功能性与文化感的学生专属场域。',
            '空间设计上，五层区域层层递进、各有侧重：直观呈现 “一楼一主题、一步一文化”的建设成果，为学校师生与外界提供了解项目的便捷窗口，也为校园文化赋能学生成长注入持久动力。'
          ],

          img: ['https://cdn.nlark.com/yuque/0/2025/png/38716037/1761531854840-fc6cf471-edd0-4e32-9db3-89dd8b1b4a53.png?x-oss-process=image%2Fformat%2Cwebp',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531853809-4fab051b-1abf-46ff-9094-6a499841f9ed.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531853835-01deee0f-c1fc-4299-98e0-cd2c8d13fc5d.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1',
            'https://cdn.nlark.com/yuque/0/2025/jpeg/38716037/1761531854018-8f6730db-da4c-4d8b-b15a-37fc92b7f1b4.jpeg?x-oss-process=image%2Fformat%2Cwebp%2Finterlace%2C1'
          ]

        },
        bottom: {
          title: [],
          img: []
        }
      }
    },
    {//2023-5-10，阮宏宇
      title: '搭建交流协作平台 促进诊改工作开展——市中职“教学诊改平台”应用与改进研讨会在叁昶公司圆满举行',
      time: '2023-05-09',
      img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712230580-72350062-ff21-4adf-93b7-efaf10b431e9.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=30",
      details: {
        top: {
          title: '搭建交流协作平台 促进诊改工作开展——市中职“教学诊改平台”应用与改进研讨会在叁昶公司圆满举行',
          img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712230580-72350062-ff21-4adf-93b7-efaf10b431e9.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2023年3月21日，根据<strong>上海市中等职业学校教学诊断与改进工作的部署</strong>，结合诊改协作组工作计划，为更好发挥人才培养状态数据管理系统对教学诊断与改进工作的支撑作用，推动学校逐步建立和完善内部质量保证制度体系，上海市中职学校教学诊断与改进第六协作组主办了“<strong>教学诊断与改进平台</strong>”应用与改进研讨会，会议由<strong>上海叁昶文化科技有限公司</strong>承办。', '上海教委职教处副处长<strong>黄蕾，</strong>上海教育评估院职成教所所长<strong>刘磊</strong>，全国职业院校教学诊改专委会副主任<strong>邬宪伟</strong>校长，上海产教融合促进会会长<strong>姜晓敏</strong>校长，上海商学院高等技术学院、继续教育学院副院长<strong>李钰</strong>，上海信息技术学校副校长<strong>王鹤</strong>和各兄弟中职校领导及诊改工作负责人等40余人出席了本次会议。会议由第六协作组组长单位，上海市材料工程学校党委书记<strong>金怡</strong>主持。', '上海参昶文化科技有限公司顾问<strong>王志卫</strong>致欢迎词，首先对与会领导、专家莅临参昶公司表示热烈欢迎，其次对教学诊改平台基本情况进行简要介绍，提出“诊改平台关键作在<strong>用</strong>，公司服务的目标就是要让诊改平台助力学校高质量发展，切实做到<strong>能用、好用、管用、想用</strong>”。', '叁昶公司项目技术服务团队负责人<strong>武京</strong>围绕诊改平台总体使用情况，引入数字可视化驾驶舱，通过对诊断点数据进行实时跟踪与动态监测，助力学校高质量发展，实现教育教学大数据可视化展示进行了介绍。', '<strong>上海市材料工程学校</strong>从一期复核的问题出发，交流了学校在二期建设这两年多来的诊改工作和平台校本开发工作。<strong>上海第二工业大学附属浦东振华外经职业技术学校</strong>从数据平台在复核工作中起的支撑作用出发，介绍了专业建设层面的诊改工作。<strong>中华职业学校</strong>则从即将迎接复核工作的角度，汇报了下阶段的工作设想和面临的挑战。'],
          img: ['https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244293-bb918e10-651e-46a1-a444-83206550ffaa.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244269-2415cc5a-e0a0-4736-b27a-c67fd1c3095b.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244278-874c87a9-3585-4104-917e-d8c3555bf9b3.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244271-1605029f-2772-43b2-a3fd-f862b8644345.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712244266-2b1d6e18-4d98-41a4-b99d-6bb35eb09c0c.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712245280-25efed27-950d-40d3-82f2-0e4672f8f6e9.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0']
        },
        bottom: {
          title: ['对于3所学校的交流，诊改专家组的专家们给予了肯定，并聚焦数据治理问题进行了专业的指导。全国职业院校教学诊改专委会副主任邬宪伟指出“数据的工作重点在数据分析和数据对比，聚焦关键能力，协调关键要素，采集要下移，分析要上升”。姜晓敏专家强调“数据是基础、分析是诊断、改进是关键，一定要让数据从管理走向治理:依法治理、源头治理、综合治理”。李钰专家从“数据治理”的七个标准进行了具体的分析和讲解，并提供了数据可视化案例供大家学习。王鹤专家建议在数字化背景下，要发挥数据对诊改的支撑作用，推动平台的迭代升级。', '会议最后，上海教委职教处副处长黄蕾、上海教育评估院职成教所所长刘磊对本次活动的举办表示了肯定，希望学校的诊改工作在完成前期办学水平达标的基础上，继续深化，聚焦专业建设水平、专业监测水平，运用好连续多年的对比，发现问题，提升办学质量，落实上海市教学诊断与该改进平台“从无到有从有到用，从用到优”的建设。', '本次第六协作组的活动圆满举行，进一步推进了中职学校教学诊改工作进程，有效促进协作组学校不断提升自我诊改水平，创新诊改工作方法，促进各校互学共建、均衡发展。第六协作组将细化措施，高站位、高标准、高质量地真抓实干，推进诊改见成效，推动协作校工作全面发展，为中职教育高质量发展赋能。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258024-466684e2-8bea-476c-a612-fe5b58207216.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258032-d7bb9fcc-b69d-4a90-8f52-f8f0655fd6b2.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258031-bae21006-875d-425b-a8cb-c0053ba531f0.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258050-1296f7bf-e68f-4d49-9d89-550715269382.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258051-e8f07823-f91b-4d0c-9384-3331f113ae9a.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712258916-3fd256a9-3386-4eef-a3ea-be666ee4c9a9.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259008-21250d60-d333-49b3-bbe5-09527f6b9c38.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259092-55408bb7-df70-494c-9f3c-2dafd708328f.png', 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1683712259158-c1806eb8-6e19-4207-9123-439972e30b98.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]
        }
      }
    },
    {
      title: '叁始善成·昶赢未来丨叁昶公司2022年述职暨总结大会顺利召开',
      time: '2023-01-04',
      img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141692752-25497dad-894f-48b9-a2da-b64fb33172d0.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=24",
      details: {
        top: {
          title: '叁始善成·昶赢未来丨叁昶公司2022年述职暨总结大会顺利召开',
          img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141692752-25497dad-894f-48b9-a2da-b64fb33172d0.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0'
        },
        lunbo: {
          title: [
            '日月其迈，时盛岁新。转眼2022年已成为过往，充满希望的2023年向我们走来，韶光流转，盛事如约，2023年1月12日公司召开<strong>2022年总结大会</strong>。',
            '首先由<strong>各部门负责人</strong>在回顾2022年工作<strong>亮点</strong>及<strong>重点</strong>工作完成情况基础上，总结<strong>问题与不足</strong>，明确2023年工作计划。<strong>公司顾问王志卫</strong>对各部门述职情况逐一点评。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141710382-998c01ba-0e66-4051-a080-a71be162209e.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141710414-1899122e-947d-49ef-a8cc-f13138c0ff80.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141710418-92f368fa-d944-45fc-9320-53dffcd265f4.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141710440-1e82f83d-aa40-4bb7-9680-31e8a522d44f.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141710421-72fcf463-eda3-4a20-b158-f331b8e4add0.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141711180-0161cd88-3c5b-49b8-93ff-a984e777d1df.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141711253-f9ee68f0-07de-4e1e-93b4-e1fd009b53f5.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141711368-e9b14eb8-d6eb-4268-a2bc-5349fa2a2035.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141711422-d6f284a9-5735-4d58-b64c-4b5918540f08.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141711415-2651acdc-4e4f-461f-ab4a-f5951d50b5e3.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141712171-c3cadc2d-3f07-4bec-ab85-6c7a5ea00412.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141712242-58dfa359-a2f9-4992-b5f6-0f00d0ffb454.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141712288-0d870e4f-3270-4956-bebc-2cc2e066b31a.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1675141712338-b4cec4d6-7baf-4153-959f-1dd749668024.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'

          ]

        },
        bottom: {
          title: [
            '王志卫指出：各部门<strong>准备充分，形式创新，激情四射</strong>，全面总结了2022年工作情况，深入分析了存在的<strong>问题</strong>和<strong>不足</strong>，认真谋划了2023年重点工作安排，思路清晰，目标明确，2022年底我们彻底和三年疫情告别，迎来全新的，充满希望的2023年，新一年意味<strong>新起点，新机遇，新挑战</strong>。',
            '同时也对2023工作提出三点意见和建议：',
            '<strong>1.需要提高能力，学习永远在路上</strong>；',
            '<strong>2.加强部门管理，从管理出效益、从管理出人才</strong>；',
            '<strong>3.密切部门配合，各部门及员工充分发挥配合优势、及时提醒、补位</strong>。',
            '2022年，对叁昶公司来说，虽然短暂，但却意义非凡。最后送给了大家一段金句“<strong>勇气比办法更重要</strong>”。',
            '2023年，疫情后复苏的第一年，有机遇亦有挑战。叁昶公司将在公司领导的带领下，铸牢同心、笃定前行，书写鸿图发展新篇章！',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278293-d9fc59bf-4807-4d9e-a885-d76f926b76de.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278291-0b3d5465-a75d-4ad7-aeb4-adc53d2cc53b.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278271-5b3725b2-8e05-4d7c-80be-00b0ce956350.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278236-7f268cb6-e676-4d58-a709-3dd069b2c753.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278305-2263dc5b-b5d4-4181-b32c-cd5a642312f3.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278885-37e58b5a-9b92-4824-9d86-805cbbf9cf92.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824279019-c9c1bbaa-1d70-42c6-9d14-1bf6a983b64a.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {
      title: '叁始善成·昶赢未来丨公司2022年度亮点回顾',
      time: '2023-01-04',
      img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824229865-df9f532f-c010-4a1a-aaf9-158f953d87c4.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=23",
      details: {
        top: {
          title: '叁始善成·昶赢未来丨公司2022年度亮点回顾',
          img: 'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824229865-df9f532f-c010-4a1a-aaf9-158f953d87c4.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['日月其迈，岁律更新。在不知不觉中，2022年已进入尾声，回顾这一年，<strong>叁昶公司披荆斩棘，迎难而上</strong>，各项工作开创新局面，今天我们共同解锁公司年度“<strong>八大</strong>”精彩亮点。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261443-6d3de8d6-9279-40ac-b012-357ed703f026.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261446-94a153ba-1604-4b1e-b3c8-baaf417ef7af.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261443-107c7a10-64b4-4486-b9ae-d42c7707372a.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261410-585c74a7-c57c-484e-873d-81154417265d.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261444-5d41a7de-d3c3-4488-92d2-982cbbaf8d6e.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824261917-8cd56b32-ae00-4eb3-983f-242acd4c1c4d.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262047-7d7f394e-291d-43f2-b2dc-6fe4d9f6f193.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262317-a96e6fe9-b95e-4cf9-baf5-79557ba28a97.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262378-30334d93-97f8-4574-a60f-89732c1eda9d.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262884-5dcb5cfb-a9a9-403f-aeb0-ba0c466f2a6d.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262968-7f133aed-1514-4199-ac93-709fd686de57.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824262949-56132844-6562-45b0-985c-3226263fc979.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824263199-31adf9f7-06a1-440d-b66d-6bed6d13ff6d.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824263209-c46b5faa-745e-4c2e-8275-49bb3dc72e83.png'
          ]

        },
        bottom: {
          title: [
            '<strong>一、传承精神，创新展陈：</strong>叁昶倾力打造中共二大会址提升项目，通过精心设计和现代技术手段的应用，集声光电一体，生动立体的演绎党章百年历史。',
            '<strong>二、智·匠心  创·卓越：</strong>叁昶带你云游世界职业教育产教融合博览会上海馆，成为线上参观打卡第一站。',
            '<strong>三、无限延展的融合型课堂：</strong>叁昶首创360度环屏数字沉浸试验场，为上海商学院在日常学习、论坛、公开课等活动中增强现场互动体验感，让全校师生感受到数字赋能的产教深度融合，对未来无限可能充满期待。',
            '<strong>四、科技赋能  文化换新：</strong>叁昶将应用物联网、人工智能等先进信息技术，打造一个集线上课堂、教学研讨、视频会议、展览展示等核心功能为主体的一体化全景式智慧校园大数据中心。',
            '<strong>五、“文化+科技” 赋能学校：</strong>叁昶智慧教室“5A”景区再添“新地标”，为上海财经大学设计打造的“数字化、智能化、艺术化”智慧教室面向教育创新发展前沿，探索出了一条“文化与科技”融合、“艺术与技术”统一的高校教育信息化发展新形态。',
            '<strong>六、服务教学 应用为王：</strong>叁昶打造上海交通大学智慧教室投入使用。',
            '<strong>七、雅致敏捷 智能共享：</strong>叁昶为上海大学建设多功能计算机实验室。',
            '<strong>八、教学筑基 培育匠心：</strong>叁昶荣获上海市教学成果一等奖。',
          ],
          img: [
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278293-d9fc59bf-4807-4d9e-a885-d76f926b76de.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278291-0b3d5465-a75d-4ad7-aeb4-adc53d2cc53b.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278271-5b3725b2-8e05-4d7c-80be-00b0ce956350.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278236-7f268cb6-e676-4d58-a709-3dd069b2c753.png',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278305-2263dc5b-b5d4-4181-b32c-cd5a642312f3.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824278885-37e58b5a-9b92-4824-9d86-805cbbf9cf92.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2023/png/25884864/1672824279019-c9c1bbaa-1d70-42c6-9d14-1bf6a983b64a.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {
      title: '【传承、创新】叁昶倾力打造！二大会址·中国共产党党章学习厅喜迎开放活动',
      time: '2022-12-05',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228745183-7431d509-3959-4eb1-8813-840492bc7d7a.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0',
      linkTo: "/instanceItem?type=culture&num=22",
      details: {
        top: {
          title: '【传承、创新】叁昶倾力打造！二大会址·中国共产党党章学习厅喜迎开放活动',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228745183-7431d509-3959-4eb1-8813-840492bc7d7a.png?x-oss-process=image%2Fresize%2Cw_674%2Climit_0'
        },
        lunbo: {
          title: ['12月2日下午，<strong>市委书记陈吉宁</strong>来到位于老成都北路的<strong>中共二大会址纪念馆</strong>。陈吉宁瞻仰了中共二大会议旧址，在一件件文物史料前驻足凝视、听取讲解。他说，<strong>上海是党的诞生地</strong>、初心始发地和伟大建党精神孕育地，也是<strong>首部党章诞生地</strong>。要把学习党章作为学习贯彻党的二十大精神的重要内容，<strong>常学常新、笃信笃行</strong>，做<strong>学习贯彻党章的忠实践行者</strong>，大力弘扬伟大建党精神，坚定理想信念，强化使命担当，团结一心奋进新征程、展现新气象。要在<strong>党史研究、展陈创新、社会教育</strong>等方面下更大功夫，吸引更多人走进纪念馆，了解党的历史，接受精神洗礼，更加自觉<strong>传承红色基因、赓续红色血脉</strong>。',
            '2022年11月27日，<strong>叁昶设计建立</strong>的中共二大会址纪念馆举行了开放活动“<strong>永远的旗帜——中国共产党党章学习厅</strong>”。<strong>市委常委、市委宣传部部长赵嘉鸣</strong>出席活动，为中国共产党党章学习厅开放揭幕。<strong>叁昶公司顾问王志卫先生</strong>，以及来自机关、企事业单位的<strong>30余名党员</strong>也来到活动现场，共同见证党章学习厅的全新开放揭幕。', '当天，活动以党章学习流动教室巡讲正式开始。活动现场，中共二大会址纪念馆被纳入静安区“<strong>学思践悟新思想</strong>”现场教学点，获授牌。中共二大会址纪念馆将依托叁昶设计建成的党章学习厅等阵地，开展<strong>全方位</strong>教学资源深度发掘，充分发挥其作为现场教学点的教育培训的<strong>载体作用</strong>、成果展示的<strong>窗口作用</strong>、示范引领的<strong>样板作用</strong>、调查研究的<strong>平台作用</strong>，为深入学习习近平新时代中国特色社会主义思想和推动党员教育走深走实提供有力支持。', '<strong>中共二大会址纪念馆</strong>依托叁昶设计建成的党章学习厅，意味着叁昶设计的党章学习厅得到了区政府的<strong>高度认可</strong>，也说明叁昶的精心设计不负众望。'],

          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727883-3a40033a-9bcd-4bbc-b505-cb06ccce6026.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727914-920fa2c8-77ad-434c-965d-17641d492672.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727929-b345bfec-ef91-420d-b2ff-8f1e1e4b0f0e.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727881-6d5d2744-0698-4b5c-95cc-e1bc4acca12f.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228727879-9969b28b-3824-4113-8a60-867c74da0bdc.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728487-1eec03c4-82e1-4e36-ad92-ef7a40f4ef36.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728752-33e6b3a4-e776-4308-9b8b-a3692c477cbf.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228728835-babfb2c1-ee51-4bd6-bf15-5e000e5800b4.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]

        },
        bottom: {
          title: ['展厅内共展示了<strong>19部党章</strong>，详细地罗列了每一部的背景和细节；在“<strong>党章集锦</strong>”墙上，收集了<strong>77本</strong>各个时期不同版本的党章。公司采用了<strong>最先进</strong>的施工技术、<strong>最精湛</strong>的匠心工艺、<strong>最精细</strong>的工程管理，展陈设计精心用心、精雕细琢，并落实到每处细节、每个环节，进一步突出主题、凸显特色，充分彰显<strong>建党光辉历程</strong>和<strong>伟大建党精神</strong>，充分展示中国共产党人的精神家园。'],
          img: ['https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737784-12ce1e09-fde5-439e-b768-ad9c9be97c80.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737780-b6550c0a-ccf3-498e-b5e1-0952aef42acd.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737769-6e2a78cc-ddf6-4595-89cb-0ca01fa9bd72.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670228737803-cbb0250b-d09e-408d-8479-5465a041f5c4.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {//2022-11-10，阮宏宇
      title: '叁昶设计打造的360度环屏数字沉浸商务试验场在第十九届教博会上迎来首秀',
      time: '2022-12-05',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225406608-cc3cbcbc-8c7d-4de5-861c-195b281f693d.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=29",
      details: {
        top: {
          title: '叁昶设计打造的360度环屏数字沉浸商务试验场在第十九届教博会上迎来首秀',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225406608-cc3cbcbc-8c7d-4de5-861c-195b281f693d.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2022年11月18日，<strong>第十九届上海教育博览会上海教育数字化转型高峰论坛分论坛暨长三角区域职业教育数字化转型发展论坛</strong>在<strong>上海商学院</strong>举行。本次论坛以“<strong>数字化赋能职业教育高质量发展</strong>”为主题，邀请了来自长三角地区的<strong>30余名专家、学者、龙头企业，叁昶公司顾问王志卫先生</strong>作为受邀嘉宾，出席了本次论坛并发表了讲话。', '本次论坛采取<strong>线上线下</strong>的形式，围绕<strong>职业教育数字化转型</strong>案例进行沉浸式分享、展示和交流；旨在进一步<strong>深化产教融合、校企合作</strong>，探索职业教育数字化区域协同创新模式，助力长三角职业教育实现更高质量的发展，将区域职业教育数字化转型的有益经验<strong>向外辐射</strong>，更好地服务国家发展全局。', '论坛上，出现的<strong>107数字沉浸教室</strong>引起了广泛关注，叁昶公司作为该教室的<strong>设计和打造方，公司顾问王志卫先生</strong>特此介绍了该数字化教室的功能、可解决的问题和实际效果，发表了“<strong>360度沉浸式数字化课堂助力教育发展</strong>”的讲话。', '<strong>360度环屏全景展示</strong>：107教室，采用了4k曲屏、360度环屏技术，具有自动录播、空间环境一键式控制、沉浸式、多维度、多场景的特征，支持各种录播和直播教学需要。', '<strong>数字化沉浸式体验</strong>：107教室，作为数字沉浸教室（数字商务试验场），符合当前环境下各种线上线下融合教学的需求，能让线上线下的用户产生强烈的参与感、互动感和体验感。', '<strong>科技与艺术完美融合</strong>：107教室所具备的展示及实训模拟功能，增强了现场用户的互动体验感，让本次与会者感受到数字赋能的产教深度融合、对职教未来“无限可能”充满期待，它实现了科技和艺术的完美融合。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390851-950a1ee1-48a6-4ffa-b76d-8212f163f9e5.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390920-95b39f84-b8d7-4f8d-bf0a-1b72c3a2f4d7.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390855-f4c48c12-8aeb-4e40-bdf5-ec320c83c4e9.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225390854-bc6822dd-2782-44cb-a38c-0f6abfeaebe5.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0'
          ]
        },
        bottom: {
          title: [
            '<strong>王志卫先生</strong>表示：“<strong>教育数字化转型</strong>最重要的就是转型到课堂，没有好的课堂，一切转型都等于零。此背景下的教室，要体现“<strong>文化+科技+生活</strong>”的功能，让学生们喜欢，让老师们享受。”而亮相此次教博会的<strong>360度环屏的107数字沉浸教室</strong>正好呈现出教育数字化转型后的教室该有的特征。',
            '本次教博会，<strong>叁昶公司</strong>为教室的数字化转型增添了浓墨重彩的一笔，<strong>数字沉浸教室</strong>的出现也将推进我国教育数字化转型花开遍地。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398685-17e26ac2-fb11-4c35-a769-70ea67d22f3a.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398749-22768986-36ba-4b68-836d-afd7a883c9b9.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670225398739-6b3908f9-6bde-4e24-aa73-5634a16ba999.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {
      title: '【合作交流 携手共进】叁昶与上海大学新闻传播学院共同签署合作协议',
      time: '2022-12-05',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221359960-bf3aa42e-52c2-4543-9d72-f4a4293e5362.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0',
      linkTo: "/instanceItem?type=education&num=9",
      details: {
        top: {
          title: '【合作交流 携手共进】叁昶与上海大学新闻传播学院共同签署合作协议',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221359960-bf3aa42e-52c2-4543-9d72-f4a4293e5362.png?x-oss-process=image%2Fresize%2Cw_675%2Climit_0'
        },
        lunbo: {
          title: ['2022年11月17日上午，<strong>叁昶公司</strong>与<strong>上海大学新闻传播学院</strong>在上海大学智能媒体创新实验中心开展了<strong>合作交流会</strong>。此次参会成员有上海叁昶文化科技有限<strong>公司顾问王志卫先生</strong>，上海大学<strong>对外联络处副处长彭明霞</strong>、上海大学<strong>新闻传播学院院长严三九</strong>、上海大学新闻传播学院<strong>党委副书记兼副院长王智君</strong>、上海大学新闻传播学院<strong>二位副院长牛盼强和周宇豪</strong>。',
            '本次合作交流会上，叁昶公司和上海大学新闻传播学院共同完成了<strong>四大事件</strong>。一是，叁昶公司和上海大学共同<strong>签署了合作协议</strong>；二是，双方就人才培养共同完成了<strong>揭牌仪式</strong>；三是，叁昶公司作为捐赠方，为上海大学新闻传播学院<strong>捐赠了十万元作为人才培养经费</strong>；四是，上海大学新闻传播学院聘请叁昶公司顾问王志卫先生为<strong>学生导师</strong>。', '这四大事件的顺利完成，标志着叁昶公司和上海大学新闻传播学院的友好交流合作进入<strong>更高阶段</strong>，也意味着双方将就此展开<strong>更深远</strong>的合作交流。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344394-9d139439-447d-447d-b930-9459d3b1c8a1.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344365-d1d9edcf-301a-41bb-bf28-858799c3c0e8.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344381-d7aed800-7f8e-47d8-bf3c-26ae51e342ad.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344458-9c7c9c45-9d62-4d61-a93c-063118d15617.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344359-88834d9c-84da-42b0-9583-884c0af21f62.png?x-oss-process=image%2Fresize%2Cw_332%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221344965-101b69a3-132c-4e3d-a750-7bc6a2d7421e.png'
          ]
        },
        bottom: {
          title: ['会上，叁昶公司顾问王志卫先生为大家带来了其精心准备的课程<strong>《执行力：优质保量完成任务的金钥匙》</strong>。王志卫先生结合其个人事迹，分享了他22年的军旅生活、一路走来的点滴、事业上取得的成就，这些都离不开他<strong>贯彻到底的执行力</strong>。',
            '他结合自己以往的经历经验、所见所闻、所思所想，从“<strong>执行不力的表现及原因</strong>”、“<strong>摆正角色和位置</strong>”、“<strong>明确优秀的标准</strong>”和“<strong>努力进阶提能力</strong>”四个方面，讲述了如何提高执行力成为更好的自己。', '此次合作交流会，叁昶公司和上海大学新闻传播学院建立了<strong>深远的友好合作关系</strong>，学生们也从王志卫先生分享的课程中获得关于执行力的启发，会议取得了圆满成功。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221352601-2c99ba3a-4f79-4699-b487-eda92f5a87c2.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1670221352634-64b11c46-2f1f-4cca-9ef3-a476c48244e8.png?x-oss-process=image%2Fresize%2Cw_503%2Climit_0'
          ]
        }
      }
    },
    {//2022-11-10，阮宏宇
      time: '2022-11-04',
      title: '【科技赋能 文化换新】叁昶高效打造的全景式智慧校园大数据中心正式启用！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070446982-3694611e-d162-4d29-a5fc-0b3ab1ea6f4c.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0',
      linkTo: "/instanceItem?type=technology&num=28",
      details: {
        top: {
          title: '【科技赋能 文化换新】叁昶高效打造的全景式智慧校园大数据中心正式启用！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070446982-3694611e-d162-4d29-a5fc-0b3ab1ea6f4c.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['<strong>“十四五”</strong>时期是<strong>“两个一百年”</strong>奋斗目标<strong>承上启下</strong>的关键期，是改善供给体系质量、推动高质量发展的<strong>决胜期</strong>。',
            '<strong>《教育信息化2.0行动计划》</strong>明确提出“以<strong>人工智能、大数据、物联网</strong>等新兴技术为基础，依托各类智能设备及网络，积极开展智慧教育创新研究和示范，推动新技术支持下教育的<strong>模式变革</strong>和<strong>生态重构</strong>。”',
            '<strong>叁昶公司</strong>秉持<strong>文化+科技，艺术+技术</strong>的一体化设计理念，将应用物联网、人工智能等先进信息技术，打造一个集线上课堂、教学研讨、视频会议、展览展示等核心功能为主体的<strong>一体化大数据中心</strong>。',
            '项目功能将具备以下<strong>5 种场景</strong>：1、智慧大数据管理中心。2、在线课堂管理中心。3、综合视频会议中心。4、智慧展览展示中心。5、综合学术报告中心。',],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070417895-66adf3f8-a9ab-4e89-ae66-8541a062c869.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070421066-e68a48b8-6206-4574-98ab-026b6b0887f7.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070423342-b5d1faa4-b990-426e-9dae-cb0a111e8c79.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070427872-8643e6ad-77cb-4fee-b38a-999bcf8251bb.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070431406-e9326104-de86-4364-94a4-28a779928bf9.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070433779-8f9fbf82-0166-4770-a815-76ceeaaa0b96.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
          ]
        },
        bottom: {
          title: [
            '本次项目建设<strong>周期短、任务重、要求高</strong>，公司信息化部门经过多次研讨会、协调会，做好<strong>顶层设计，统筹规划</strong>，确定时间进度表和工作责任人，有序推进项目实施。加强监管和沟通，每周定期召开工作例会，及时<strong>发现问题</strong>和<strong>解决问题</strong>。叁昶信息化部门全体工作人员凝心聚力、共克时艰，只争朝夕抢工期，<strong>高度优化还原设计效果</strong>，如期高标准完成了建设任务。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070475253-50b079df-a4a1-48b0-803c-4779452a85cf.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070479659-36556bfc-2577-4707-afac-268782729508.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070482372-e91c02c9-1b8e-44b0-9703-00ba4f17076a.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1668070485467-9b10711d-a3d1-4dea-b9fe-c35ce3766938.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 2021-11-8，阮弘宇，
      time: '2022-09-16',
      title: '七易七迁十突破，赓续传承向未来丨叁昶设计打造的上海电子信息职业技术学院校史馆圆满完成',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598948855-cf7d76e9-dfe9-4d80-9272-c2803a9ab421.jpeg',
      linkTo: "/instanceItem?type=culture&num=21",
      details: {
        top: {
          title: '七易七迁十突破，赓续传承向未来丨叁昶设计打造的上海电子信息职业技术学院校史馆圆满完成',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598948855-cf7d76e9-dfe9-4d80-9272-c2803a9ab421.jpeg'
        },
        lunbo: {
          title: ["序厅以“画卷”打开的形式，娓娓道来学院悠久的历史与文化。",

            "展馆内容分为“艰苦创业”、“漫漫求索”、“转型升级”、“创新发展”四大板块，正厅四大板块以各时代校门变迁为主题，采用新中式风格，整体搭配棕色系展开，体现出历史的厚重与沧桑，在视觉上给人以沉浸式的感受。",

            "整体平面布局以“匠”字为格局，结合传统中式窗花与现代发光灯牌的运用，在体现历史感的同时，融入现代科技元素，形成历史感与科技感的结合与对比，营造整体环境氛围。"],

          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598974973-50a99340-b5a7-430c-adae-dba6575c3c76.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598981538-824a20a7-2323-4014-9d79-8c661c59039b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598984938-b985ad31-86f9-4d78-b5bd-6c9311d9d377.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666598998796-d2f4f034-fbc5-4190-af7f-139a99d398cd.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
          ]

        },
        bottom: {
          title: [
            "学院领导对我们的设计十分认可，也正是因此在我们后续主导进入施工阶段时，领导们给予了我们充分的信任，在我们工程部与设计部的充分协作下，最终圆满完成本次校史馆的设计建设工作。",

            "新学年开启的时间渐渐临近，上海电子信息职业技术学院校史馆静静等待着归来的师生和新入学的孩子，它将会给他们讲述一个怎么样的学校故事？让我们一起期待吧！",

            " 与此同时，越来越多的校园文化项目也在学园公司设计与工程团队的努力下持续落地，成为让师生真正看得见，摸得着的文化景观。关注我们，你将有机会感受这一系列校园的文化之美。"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599026290-1f0c9a1c-fc0e-493f-9c34-d4ec9aa20f84.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599034045-a76d3a50-0284-4605-8869-3509c5120ae0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599042585-baac3101-dfcd-489b-ae0f-2018bc6ae3f0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1666599032120-3f710c7c-c728-42f5-99f9-bf90ae180772.jpeg'
          ]
        }
      }
    },
    {//2022-8-23，阮宏宇
      time: '2022-08-23',
      title: '叁昶打造的诊改平台亮相世界职业教育产教融合博览会上海馆',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497058284-977d31f9-a1ec-45b2-b34c-a70e754ee13c.png',
      linkTo: "/instanceItem?type=technology&num=27",
      details: {
        top: {
          title: '叁昶打造的诊改平台亮相世界职业教育产教融合博览会上海馆',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497062028-d2d9d2bb-3eb8-4b8e-a5c4-3b598968f32f.png?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['打造诊改平台，提升院校高水平<strong>办学质量</strong>，以<strong>大数据</strong>为基础建成了<strong>上海职业院校诊断与改进应用平台</strong>，为管理决策提供及时、全面、精准的数据支持。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035639-a838de4c-88f5-4596-9642-847680dc8f9d.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035661-6c8afcb7-ebc5-43ba-a42d-9dd47a11fbed.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035675-699d4dc3-b819-4c1b-8dcc-4c28adbaf322.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035784-62127971-b6fb-4388-97c8-4f59c6c1cf23.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497035857-db3bae5f-fb86-4950-892b-45774208ea50.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036615-ce8a7e66-06c7-4560-8586-ec0467493c99.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036714-48c73b8c-5a1f-4672-a02d-c01474b6a398.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497036931-e9ccd050-f226-40d3-9eb6-730798087834.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
          ]
        },
        bottom: {
          title: ['<strong>叁昶</strong>再出大动作，助力高校<strong>高质量</strong>发展！', '<strong>站位要高、标准要高、手段要高</strong>，叁昶向高职诊改与评价领域进军！', '以“<strong>诊改平台</strong>”为抓手，推动学校质量建设。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047572-5b695c32-21a1-4cc4-897b-40cff45d6d17.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047596-7c1ddd09-733c-4089-a11f-42426ee771a0.png?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047579-538f6239-8085-45b3-8791-7d2d82931596.png?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047576-ea2d3ca5-ab8f-4160-ac7b-d5b692ac4948.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497047597-4f3aac9c-08dc-4960-9e8f-5b2bf7702a61.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497048315-bbc8daaa-56f3-43d7-84e9-75e91abc563f.png',
          ]
        }
      }
    },
    {//2022-8-16，阮宏宇
      time: '2022-08-16',
      title: '【低成本、高水准】这个智慧教室，我服了！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497271188-efb1390a-6c2e-4a6a-bcef-37f19f8499ed.png',
      linkTo: "/instanceItem?type=technology&num=26",
      details: {
        top: {
          title: '【低成本、高水准】这个智慧教室，我服了！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497271301-4ba894f7-fe1d-423a-8545-b37272f49297.png?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ['虚拟显视空间、4K曲屏更清晰、全自动式录播、空间环境一键式控制、<strong>沉浸式、多维度、多场景……科技+艺术</strong>完美融合。', '在这个暑假，悄然出现在往日熟悉的教室里，进一步为教育客户带来了<strong>跨设备无感连接、自然人机交互、信息无缝流转</strong>的全场景智慧教室体验！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257259-1b63879e-7acf-4694-9562-ab0ceacaf235.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257294-2ccd7c45-17fa-4898-9bed-216a6b76d07f.png?x-oss-process=image%2Fresize%2Cw_296%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257266-92d5d964-87a8-456d-a45f-bd53f70b230e.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257332-6ebc1383-3fd5-4ab9-8125-4250d6fe8cff.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661497257593-a9301522-3937-4944-959b-6a9e8543dc0b.png'
          ]
        },
        bottom: {
          title: '',
          img: []
        }
      }
    },
    {// 近期活动 2022-8-2，阮弘宇
      time: '2022-08-02',
      title: '【叁始善成 昶赢未来】叁昶五岁啦！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845670695-4777b046-3dd0-4290-bf5a-5920f7d1f2e3.png',
      linkTo: "/instanceItem?type=activity&num=7",
      details: {
        top: {
          title: '【叁始善成 昶赢未来】叁昶五岁啦！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845670859-3918dac3-628d-4d46-81b0-4acdd75e01fa.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['嘿，亲爱的伙伴们，叁昶已经迎来了<strong>五周年</strong>的生日，<strong>因“五”而起，携手并进</strong>。', '<strong>上海叁昶文化科技有限公司</strong>是一家有着<strong>核心引领、成熟团队</strong>，可提供<strong>多元化服务</strong>的公司。公司围绕<strong>科技、教育、文化、咨询、服务</strong>等领域，提供多样化的产品和服务，在这快速发展的五年里，我们硕果累累，请欣赏我们的经典案例吧！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845647742-3d46ac08-c814-440d-ba83-17768d6495b1.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845647718-68f3448e-13dd-4099-9267-90275f4b27a0.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845647727-78f60ee4-fe77-4818-893d-6bb974684c3d.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845647717-b2cce766-831b-41ad-85e0-0faa38be24da.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845647709-83bb6ffb-798c-4130-bba5-cdef475a5b80.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845648337-fec68d51-0d17-493f-81ff-9e3d52676708.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845648571-0381ba35-4d4c-4542-bcb0-f7d457e67b1c.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845648575-15c7c946-b080-43e4-9ff0-e0e1cab49454.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845648618-7834e93c-9629-442e-ae3a-eff9cb4f81cf.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649029-9d4f6786-f23d-4bee-9337-78367ba00989.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649191-715cf478-3372-4939-981c-3e202511f855.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649194-1e8e2121-936d-4bb0-8d20-c219a213cc45.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649255-5a9b70d3-860b-43d0-ae4c-52c68d1e512c.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649522-7f0795aa-f69e-4447-a265-48a05934dcfd.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649821-62c760d6-07ea-4bb0-bfc6-e8e4ed9cb6e1.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845649999-5316346d-1a5d-45ee-8445-3cadb04b7dc7.png'
          ]
        },
        bottom: {
          title: ['<strong>“五”与伦比——智慧校园</strong>  五年来，叁昶公司的<strong>智慧校园</strong>建设强化数据挖掘和分析，构建基于数据的<strong>教育治理新模式</strong>，结合特有文化设计特色，创造性提出了”<strong>文化+科技</strong>“，”<strong>艺术+技术</strong>“的设计建设理念，以教育信息化促进教育现代化。', '<strong>“五”艺超群——智慧教室</strong>  五年来，叁昶公司的智慧教室运用其<strong>数字化、网络化、智能化</strong>和<strong>多媒体化</strong>的技术特点，结合特有文化设计特色，创造性提出了”<strong>文化+科技</strong>“，”<strong>艺术+技术</strong>“的设计建设理念，积极探索大中小学智慧教室和智慧课堂建设。', '<strong>“五”可比拟——软件开发</strong>  五年来，叁昶公司的<strong>教育管理系统</strong>，按照 <strong>“政府指导、学校协作、资源共享、多方受益”</strong>集中建设的工作机制，经过近五年的打磨，目前已经形成了中职教育诊改、高职质量保证、高水平大学“双一流”监测管理等系统。', '<strong>“五”色斑斓——校园文化</strong>  五年来，叁昶公司凝聚校园<strong>4I（MI理念、BI行为、VI视觉、EI环境）</strong>规划方案，专注大、中、小、幼学校园文化建设、校史馆设计施工一体化服务，提出了<strong>“一校一品、以文化人”</strong>的建设理念，将文化浸润到校园的每一个角落，打造<strong>看得见、听得到、演得活、学得会、亮得出</strong>的特色校园文化。', '<strong>“五”彩纷呈——大型活动</strong>  五年来，叁昶公司秉承<strong>“创意致胜”</strong>以及<strong>“精细化运营”</strong>的活动策划理念以创造性思维打造与众不同的活动内容，将精细化理念融入项目运营管理服务的每个细节，为客户呈现<strong>“简约、安全、精彩”</strong>的每个活动。', '<strong>“五”光十色——展览展示</strong>  五年来，叁昶公司以专业的眼光和倾注全力的工作态度为您奉上创意与质量俱全的作品，我们的专业体现在<strong>创意、策划、设计、制作承建</strong>与<strong>服务</strong>的每一个环节，让您的每一次展出都将成为<strong>展会耀眼的亮点</strong>。', '<strong>“五”懈可击——调研培训</strong>  五年来，叁昶公司调研业务主要是在教育领域，运用<strong>各种调查方式</strong>系统客观的收集信息并对学生发展质量进行<strong>监测与分析</strong>，从社会需求的角度提升人才培养质量。五年来，叁昶公司的培训业务主要是针对职业院校师生，研发形成了<strong>创新创业、校园文化、学生礼仪</strong>等系列化课程，也可针对客户需求开发<strong>定制化课程</strong>，提升师生综合素养。', '未来，<strong>挑战与希望同在，希望与困难同在</strong>，摆在我们面前的任务仍然十分艰巨，我们不谈过去的艰辛，只谈对未来的无限期待，在今天，我们也掀开更好的序幕，<strong>继往开来，怀揣梦想，努力发展</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661116-35d199de-aae9-4662-945c-682c782948a0.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661498-320db401-7699-4421-9ae8-d1e2937bd093.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661054-cbdc7a42-cfe4-4de5-8f71-38f6421b8e3f.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661223-efcb24da-02a9-4bfb-8daf-6fc932e61643.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661088-5a5a4b0c-7c86-496d-bfe6-610eae2a93e1.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661861-db0a1dd9-95c2-495b-94d4-afb883017325.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845661917-4278cba9-235f-49a1-bceb-52af37e882eb.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661845662212-f79e247c-dbde-4404-a832-84254ed99985.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 近期活动 2022-6-10，阮弘宇
      time: '2022-06-10',
      title: '全力以“复”启新程，叁昶公司复工啦！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844226268-f8f5006f-1144-40a3-a9b2-c263c7ec5a6d.png',
      linkTo: "/instanceItem?type=activity&num=6",
      details: {
        top: {
          title: '全力以“复”启新程，叁昶公司复工啦！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844226253-ecd18827-f19c-4e3d-ab13-84067996a97c.png?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['6月起，上海迎来了解封，住宅小区逐步恢复正常出入、全市公共交通运营和机动车恢复通行，疫情形势趋于好转，企业逐步复工复产。叁昶公司根据政府、街道的防疫工作安排，提前研究方案，分阶段、安全、有序推进复工复产工作。', '6月2日，叁昶小伙伴们早早来到职场开展消杀清洁工作，提前营造整洁、安全的办公环境；同时，检查了机房、打印机、网络，试运转办公设备等，确保办公不受影响。', '6月6日复工日，叁昶召开了复工复产工作全员大会，指在帮助员工迅速调整工作状态以及下半年的工作重心。', '叁昶公司顾问王志卫表示，开工首日迎来“芒种”节气，寓意着种下希望，收获未来，要全力以赴复工复产，迎头赶上。并且对疫情期间全体员工团结一心、克难求进的表现给予了充分肯定，尤其对疫情期间广大年轻员工积极参与抗疫志愿服务工作给予高度评价与赞扬。就下一步的发展，会议强调，要理清思路，明确责任目标，把压力作为动力，把责任作为使命，相信自己，果断改变，果断执行，不折不扣地贯彻落实好公司各项工作要求。', '乘风破浪应有时、直挂云帆济沧海，复工号角已轰鸣吹响、军旗已猎猎飘扬！上海叁昶文化科技有限公司全体员工必将更加团结，以百倍努力、千倍信心完成公司给予的各项任务！'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844198799-efa6b56f-a7c0-4c57-9903-56eae80780eb.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844198768-884be72b-49d1-4156-ae41-35e12ada8e79.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844198767-ab0705a4-dd6a-4e02-99e8-382333062862.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844198761-3ce02ae3-8387-4c44-9705-94ab9abbc3f8.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844198770-5e281594-2ca0-41c6-86de-d0340af36e59.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844199630-988615dc-3f79-4ec2-8b6e-55308db64449.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844199615-76a8cbc7-fd0a-4920-b8fe-b24b4f0182c9.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844199692-bec50747-74bb-48c4-9daf-a1096fff33f4.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['叁昶小伙伴疫情期间，在公司顾问王志卫的鼓励和号召下，公司员工纷纷加入了抗疫志愿服务的服务中，他们有的穿起防护服穿梭在核酸检测现场，有的拿起测温枪值守在小区的门口。每个人坚守好自己这份新的岗位，为防疫工作献出一份力。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844211975-51b8a113-f414-4efd-8235-b032a7458ceb.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661844211670-959a1600-1c11-40f8-a5a1-aeb90ac7b8e9.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
          ]
        }
      }
    },
    {// 服务类 2021-12-28，阮弘宇
      time: '2021-12-28',
      title: '智·匠心，创·卓越丨由叁昶打造的世界职业教育产教融合博览会上海馆今天开展！',
      img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750650947-a1072e44-c166-4961-be63-df54c7ef7972.png',
      linkTo: "/instanceItem?type=service&num=35",
      details: {
        top: {
          title: '智·匠心，创·卓越丨由叁昶打造的世界职业教育产教融合博览会上海馆今天开展！',
          img: 'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750651047-ea92ce56-85e4-4e5b-8fdd-a09246c6cf51.png?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>首届职业教育产教融合博览会</strong>将于2022年8月19-20日在<strong>天津</strong>举行,由<strong>中国职业技术教育学会</strong>牵头举办的<strong>世界职业教育产教融合博览会</strong>(以下简称博览会)将同期举行,博览会的主题为“<strong>大力发展适应新技术和产业变革需要的职业教育</strong>”。', '博览会采用“<strong>线上+线下</strong>”相结合的方式举行，设置了“<strong>云上博览会</strong>”平台，采用最新的“<strong>3D+360°</strong>”数字展览技术，搭建中英双语实时播出的平台环境，实现全天候开放式信息流通和资源共享。大会将打造形成“<strong>一会、一赛、一展、一联盟</strong>”的职业教育国际交流合作崭新平台和范式。', '<strong>叁昶公司</strong>很荣幸参与<strong>博览会上海馆</strong>的展台策划设计制作等服务，为上海集中呈现职业教育<strong>高质量发展成就</strong>、职业教育<strong>服务发展成果</strong>和职业教育“<strong>产教融合、校企合作</strong>”办学特色的完美展示做出叁昶的力量。', '上海馆云展览链接:', 'http://ve.cool360.com/SHExhibition/index.html'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636112-6f6edf77-1ba1-463a-9fa9-0493975b50e7.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636133-a2460270-95ff-4f8b-b2fc-86491d572a1b.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636136-83ebba97-7001-444f-95ac-373e5a6af4b5.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636143-ea8ecf14-9d5a-4e8f-88c6-6943d0fb04c0.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750636140-ccb31178-17f3-43f8-889e-0b550f9027ba.png?x-oss-process=image%2Fresize%2Cw_370%2Climit_0'
          ]
        },
        bottom: {
          title: ['公司策划的上海馆围绕“<strong>智·匠心，创·卓越</strong>”主题，通过<strong>“育人之道”“数智之核”“合作之基”</strong>三大版块，将<strong>艺术与技术、文化与科技</strong>相结合，以精美生动的图片、精心制作的视频、精彩纷呈的案例，<strong>全方位、多层次</strong>展示了上海职业教育的现代职教体系构建、数字化转型优秀成果及“产教融合、校企合作”办学模式，充分彰显了<strong>上海特点、职教特色、时代特征！</strong>', '<strong>育人之道-多维度构建“技能成才”</strong>体系，上海<strong>勇立改革潮头</strong>，敢于先行先试，成功打造了具有<strong>世界水平、中国特色、上海特点</strong>的区域现代职教体系。', '<strong>数智之核-新科技打造“技能创新”</strong>高地，抢抓<strong>数字化战略</strong>机遇是职业教育增强适应性的关键，作为<strong>全国教育数字化转型试点区</strong>，上海全面推进数字化转型工作，形成职业教育现代范式。', '<strong>合作之基-全方位展现“技能报国”</strong>成效，上海秉持<strong>开放合作、互学互鉴、互利共赢</strong>的职教理念，积极提升校企协同育人成效，向全国以及海外输出<strong>上海风格职业教育</strong>，推广中国特色职教方案。', '展馆采用<strong>3D定制</strong>视频技术，通过LED透明屏呈现大飞机、卫星、火箭等上海高端制造成果，带来<strong>超惊艳、极震撼</strong>的视觉享受；实时展示以大数据为基础打造的<strong>上海职业院校诊断与改进应用平台</strong>，满足个性化、沉浸式的互动体验；综合文字、图片、视频讲述<strong>上海市教育信息化应用标杆培育校</strong>的智慧校园建设及应用实践探索，提供<strong>全方位、多层次</strong>的经验启示。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643284-8f6e9a8b-0f8c-47eb-a0e2-a52e664e1b18.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643301-dece7431-65a6-488e-bb6f-48332af26663.png',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643303-a1db4499-c573-4b56-8452-19fb44b9ec6a.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/png/25884864/1661750643304-80c13cad-ec50-4411-8725-cc2c9062823c.png?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },

    {// 服务类 2021-12-28，阮弘宇
      time: '2021-12-28',
      title: '当“博士后”遇到“叁昶”后丨我们在佛山打造“上海一条街”讲述上海博士后精彩故事！',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750886701-c412ee8d-381d-4c57-b16d-cd30128d39e5.jpeg',
      linkTo: "/instanceItem?type=service&num=34",
      details: {
        top: {
          title: '当“博士后”遇到“叁昶”后丨我们在佛山打造“上海一条街”讲述上海博士后精彩故事！',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750886793-336b1733-3c5a-4d8a-a581-6b5a7759f5ea.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['2021年12月18日，由<strong>人力资源社会保障部、广东省人民政府</strong>共同主办的<strong>第一届全国博士后创新创业大赛</strong>在广东省佛山市隆重举行！', '举办全国博士后创新创业大赛，是<strong>贯彻落实习近平总书记在中央人才工作会议上重要讲话精神、大力实施新时代人才强国战略的重要举措，旨在推动全国博士后工作创新发展，充分激发博士后创新创业潜能，促进产学研深度融合，强化国家战略人才力量，助力科技自立自强。</strong>', '本次大赛是我国博士后制度实施以来举办的<strong>规模最大、层次最高、覆盖面最广</strong>的全国性博士后创新创业赛事。大赛以<strong>“博采科技精华，创新引领未来”</strong>为主题，共设<strong>创新赛、创业赛、海外（境外）赛</strong>和<strong>揭榜领题赛</strong>等四个组别，分为新一代信息技术、高端装备制造、新材料等<strong>八个专业领域</strong>进行比赛。大赛期间，还设置了近9000平方米的博士后工作成果展示专区，各省区市和部分高校、科研院所、重点实验室、博士后创新平台参会设展，并借助VR技术手段同步线上布展。', '<strong>叁昶公司</strong>很荣幸参与第一届全国博士后创新创业大赛及工作成果展，主要负责<strong>上海地方馆、复旦大学馆，交通大学馆，同济大学馆</strong>的展台策划设计搭建及落地保障等服务，为上海人才队伍科技创新成果的完美展示做出<strong>叁昶的力量</strong>。', '为更好地讲好<strong>上海故事</strong>，上海馆的设计采用了一体化的理念，<strong>叁昶</strong>为上海市人力资源和社会保障局与上海交通大学、复旦大学、同济大学<strong>打造“1+3上海一条街”</strong>，“1”即上海地方馆，“3”为三所高校馆，通过打造上海一条街来给予观展者<strong>一站式畅通</strong>的参观体验。上海一条街的两侧顶部是黄浦江两岸建筑的剪影。同时，将会用外轮廓LED跑马灯来对建筑剪影进行装饰，效果十分酷炫。三所高校的校门也被进行了艺术化处理还原，放置于各高校馆的入口处。', '叁昶打造的上海人才队伍科技创新成果<strong>展示一条街</strong>，展台设计从提案到定稿中间经历了数次修改，中间又经历疫情的延期，但是<strong>叁昶从来都不畏艰难</strong>，我们心中的目标是<strong>用最好的理念做最好的效果</strong>。按照设计搭建方案，经过我们<strong>快速、专业，精益求精</strong>的精神完成展台的前期搭建工作以及展品展示工作。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864622-2e27c3c3-076f-45ff-8698-b6347f468919.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864628-02b6eb2a-6cbe-444c-a93e-0fd6999b250f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864631-c1c65588-4ef7-48d7-81ee-6e6359b07f0a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864638-fe5ffe7c-dd0c-463f-9cb1-2a11fb3f2ec3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750864637-4f7a27be-8d9e-411f-9ce0-2943ac750bb0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865141-c657bb2a-d400-47e3-9a06-126fd7a259ff.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865175-3629fccd-76b8-4046-aaf3-49d557769c0b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865270-d0a03c38-88b4-495f-b326-69aadc1d0f53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865472-ef027df3-7808-4457-b9a4-ff29e9392991.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865562-06c86925-b155-4207-af89-a2f37c81a84b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865733-10ab2d9d-48cd-473f-8e10-ecdf69e97ace.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750865862-b05ffe18-86ae-451f-8a18-6809b1be4738.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866136-c425d261-da42-4736-8196-0fe26c38fa6e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866218-56fa084b-5b9a-4cc9-a03a-7a4d1ea52c20.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750866256-cde0b010-2a43-4628-acf1-ad73fdf9bf6d.jpeg'
          ]
        },
        bottom: {
          title: ['<strong>人社部部长张纪南及副部长汤涛</strong>参观上海馆悉心听取上海博士后工作成果介绍，并了解参展、人才培养等情况。此次大赛经过激烈角逐，最终获得<strong>7枚金奖，5枚银奖，8枚铜奖，奖牌数位列全国第二</strong>，上海市代表团、复旦大学代表团、交通大学代表团荣获<strong>优秀组织奖</strong>。', '叁昶全体工作人员始终以最佳的精神状态、饱满的热情，专业细致的服务赢得了客户的高度认可。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877096-ee736021-6bcc-4fe0-aced-1767547bd7be.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877102-67e9a55d-776b-4e49-a0c2-ca9a3922d30a.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877118-4f808692-a7cb-4934-9007-5ef488d4da5b.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877109-608a32e2-c65a-4e6a-96cb-62fd78ab2827.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877119-ff344528-6716-4ee7-9d7d-1dd4523dfd90.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661750877967-13027b61-a2a7-4f50-a56d-d3b675ac655f.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 2021-11-8，阮弘宇，
      time: '2021-11-08',
      title: '【大战7.8.9奋战100天】叁昶公司召开公司重大项目总结会暨第四季度全员大会',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479050715-80fa1472-d4ee-4367-a8a9-376581ed06d6.jpeg',
      linkTo: "/instanceItem?type=culture&num=20",
      details: {
        top: {
          title: '【大战7.8.9奋战100天】叁昶公司召开公司重大项目总结会暨第四季度全员大会',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479050823-8694314a-3bca-4e7b-9a94-1a052cecaa9a.jpeg?x-oss-process=image%2Fresize%2Cw_600%2Climit_0'
        },
        lunbo: {
          title: ["从<strong>1921到2021</strong>,时间<strong>跨越百年</strong>, 我们党从建党之初只有<strong>50多名中共党员</strong>到如今拥有<strong>9000多万名党员</strong>的<strong>世界第一大执政党</strong>。其中的奋斗历程，值得我们不断学习、时刻铭记！会后，<strong>叁昶全体员工</strong>乘着大巴来到了<strong>中共一大会址纪念馆</strong>，我们怀着喜悦与激动的心情，在<strong>党旗前合影</strong>。在这个特别的日子里，留下了我们最特别的纪念。",

            "  <strong>中共一大会址</strong>展陈共分为序厅“<strong>历史选择 伟大起点</strong>”、第一部分“<strong>前仆后继 救亡图存</strong>”、第二部分“<strong>民众觉醒主义抉择</strong>”、第三部分“<strong>早期组织 星火初燃</strong>”、第四部分“<strong>开天辟地 日出东方</strong>”、第五部分“<strong>砥砺前行光辉历程</strong>”和尾厅“<strong>不忘初心 牢记使命 永远奋斗</strong>” 7个板块，生动展现了<strong>中国共产党的诞生、壮大历程</strong>，聚焦建党初期中国共产党在上海的革命实践。通过几个主题板块的参观，我们对<strong>中国共产党</strong>成立的艰难历程及中共一大的召开有了更加深刻的学习体会。在共产党早期成员的带领下，在工人阶级的勇敢斗争中，我们才有了今天的新中国。",

            "<strong>中国共产党</strong>的成立，是<strong>近代中国社会进步</strong>、革命发展的客观要求和必然结果，是历史的选择，是人民的选择。共产党的成立之路深深地打动了我们，指引我们在今后的工作上更加<strong>严格要求自己，不怕艰难困苦</strong>，努力向着目标奋进。",

            " 参观了<strong>一大会址纪念馆</strong>，并观看了之后，我们每个人都<strong>深受鼓舞、感触颇深</strong>。大家表示，无论面对什么挑战，无论面对什么困难，都要<strong>秉持初心</strong>，立足本职岗位，尽心尽力履职尽责，为党和国家的事业、为企业发展贡献自己的一份力量。在随后的活动中，我们各抒己见，结合当日的团建成果和公司的发展现状，表达了自己的看法并参与了分享朋友圈集赞活动。",

            " 任何前进的道路都是曲折的，需要一个团队的<strong>共同努力、坚持不懈</strong>，但是只要心在一起，力往一处使，一定会取得进步。这也是我们此次团建最大的收获。通过此次大会，我们坚定了自己的信念，在今后的工作中，我们一定秉承<strong>叁昶</strong>的“<strong>更高、更快、更强、更团结</strong>”的精神，坚持信念，团结一致，为着我们共同的目标而努力奋斗！"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009763-9eef6469-cb1f-4b10-8158-7287c97c7b24.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009771-851bc1f2-460f-41b9-a850-a70b329339a0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009775-461f94db-cfbd-4b51-b071-a7fca2b58e62.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009968-503da458-5f2e-48ca-984c-e5498752bdef.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479009767-2b627526-822c-477e-b33d-c77439e8e555.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017369-cceb29d1-1788-4343-9f7a-a31f70b6e331.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017395-4441a5b3-6186-4de1-b3ce-cc9e77fb58a1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017412-3e3e1b0b-8c30-4e38-8540-ab3269b3dd17.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479017400-c3209e12-c18f-43b8-9fd3-c64c10b92d68.jpeg'
          ]

        },
        bottom: {
          title: [
            " 秋高气爽，丹桂飘香，<strong>叁昶公司</strong>召开<strong>公司重大项目总结会暨第四季度全员大会</strong>，公司领导、各部门负责人、项目经理、项目合作伙伴及有关人员参会。会议由<strong>公司常务副总曹鸣浩</strong>主持。",

            "<strong>公司顾问王志卫</strong>就今年各项工作的圆满完成做出<strong>五点总结</strong>：一是要<strong>加强人才储备</strong>；二是要<strong>加强管理流程</strong>；三是要<strong>加强绩效考核</strong>；四是要<strong>加强质量监督</strong>；五是要<strong>加强团结合作</strong>。最后指出，在未来，我们要向着<strong>更高、更快、更强、更团结</strong>的精神全力以赴，在拼搏奋斗中实现企业、个人发展的双赢！",

            " <strong>公司常务副总曹鸣浩</strong>总结公司第三季度项目突显了<strong> “高、大、广” </strong>的特点，即<strong>层次高、规模大、涉及广</strong>。公司5个业务部门，5个综合保障部门，第三季度合计完成工作任务<strong>178项</strong>，其中业务部门完成90项，综合保障部门完成88项，确保了第三季度工作的顺利完成。",

            " <strong>公司副总吴小波</strong>说大战“789”、奋战“100天”各项计划工作，在各部门的密切配合下，顺利完成阶段性目标；要做到“<strong>有计划、有组织、有落实</strong>”的整体规划，以完成各项目顺利“<strong>闭环</strong>”交付为目的，做好“第四季度”完美收官。",

            " <strong>设计总监林晟</strong>通过今年各项目锻炼，对自己有了更深次发展，对设计思路有了更明确的方向，在今后的工作中做到<strong>加强专业学习，提高设计水平与服务质量</strong>，做到有效沟通，积极配合，共同协作完成设计任务。"],
          img: ['https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031724-93226f1a-eb7b-4217-86d9-5e918447a19d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031753-7c15ded4-4639-448a-a325-a5ebb7e56c25.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479031763-0ec7c566-140d-4712-96e3-f99fe26c9268.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035863-e980589d-a5b0-4dba-9de1-fca19c9c616f.jpeg?x-oss-process=image%2Fresize%2Cw_448%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035901-35208230-5060-49ce-952b-72070751ea06.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661479035870-7364c487-df28-4045-bef9-a44706452478.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-10-22，阮弘宇
      time: '2021-10-22',
      title: '独家策划丨进实师生璀璨东艺',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751143752-d22ee27b-3d6d-40eb-a8d2-a4f73674b4d9.jpeg',
      linkTo: "/instanceItem?type=service&num=33",
      details: {
        top: {
          title: '独家策划丨进实师生璀璨东艺',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751144047-3cc68d77-f74a-4da4-b4eb-f972bc8032db.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['10月9日下午，<strong>叁昶公司</strong>精心策划的<strong>上海市上海市进才实验中学庆祝建校20周年主题活动</strong>在<strong>东方艺术中心</strong>圆满举办！各级领导、社会各界嘉宾、家长代表、历届校友、在校师生，济济一堂，共襄盛典。此次活动结合<strong>线上</strong>与<strong>线下</strong>，视频与图片双直播的方式，凝聚国内和海外的各方关注，超过<strong>数万人</strong>关注浏览！', '<strong>校长兼党总支书记杨龙</strong>在活动中回顾了学校的办学之路，他由衷感谢各级领导在学校发展过程中给予的<strong>亲切关怀</strong>，感恩社会各界对学校发展的<strong>鼎力相助</strong>。学校将在“<strong>崇尚理性 独立思考</strong>”校训的激励下，谱写浦东教育引领区的时代新乐章。', '学校<strong>交响乐团</strong>带来的恢宏的多媒体交响合奏<strong>《红旗颂》</strong>拉开了本次主题活动的序幕。学校师生带来了他们的20周年校庆献礼——原创配乐诗朗诵<strong>《因为有你，所以有我》</strong>，表达对学校的诚挚谢意、殷殷祝福。', '来自校园各个文艺社团的同学们表演了一组校园文化的展演秀<strong>《我们都是追梦人》</strong>，其中包含铿锵激越的民鼓表演<strong>《鼓舞青春》</strong>，优雅的芭蕾舞<strong>《追光圆舞曲》</strong>，典雅婉转的昆曲<strong>《西厢记·佳期》</strong>，以及民舞<strong>《茉莉花开》</strong>和歌舞<strong>《我们都是追梦人》</strong>。', '二十年的发展之路，对于一所学校，说长却短；但是，对于一个人，二十年的光阴说短却长。二十年，是从幼年到青年，从青年到壮年，从壮年到老年。学校<strong>短短的二十年</strong>发展史却在很多师生的人生中留下了<strong>长长的回忆</strong>。今天4位师生代表就带来了他们和进实不得不说的故事——音乐情景剧<strong>《光阴的故事》</strong>。历届获得<strong>星光少年</strong>称号的学生代表们也从四面八方来到了现场，他们带着<strong>感恩的心</strong>对一直以来支持<strong>"十大特长星光少年"</strong>评选活动的<strong>科慕化学（上海）有限公司</strong>表达感谢。', '<strong>叁昶公司</strong>还精心策划了启动仪式<strong>《启程·再出发》</strong>，展现出了进才实验中学的学校师生们对于共推学校未来发展的<strong>坚定信心和决心</strong>。活动最后，<strong>校领导、教职员工代表、学生代表、家长代表</strong>等共同合唱<strong>《不忘初心》</strong>，更将现场情感推上高潮。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122029-2df1dd31-152e-4d7f-95d3-997c050a65e8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122028-e922bbcc-6085-4f89-8d8a-5027e34c3aeb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122033-f3632e36-11ff-4178-9ed2-ac7af5fadbd4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122025-f33e50f7-cca5-41b4-b429-e229e1911d00.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122050-3419f92c-77ea-4b3a-8b8e-d54565af57c8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122510-ef44d24e-382b-4092-8cce-a5c1bfe13c40.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122584-e3d67ceb-4e1c-4d1b-b8d7-7de90c1bcb83.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122594-476ff656-edf3-4e25-b38e-8fe3500fdb81.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751122703-208ce353-75d9-4e3a-b45f-62658404f0cf.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123186-41d30e4c-dd80-4dad-a755-d50ed08b6c3c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123301-c0cc05fa-7158-49bd-8554-de25fa3953dd.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123363-2dec6977-3a90-4212-bac9-af585e210c63.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123376-055da100-5d38-4f46-94f0-4aa30150aee5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123558-850465b6-c645-4cae-8ec6-6c99831f7877.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751123608-30e195cc-8869-49d5-a135-c5db866ae6f5.jpeg'
          ]
        },
        bottom: {
          title: ['公司小伙伴多次赴<strong>上海市进才实验中学</strong>汇报校庆策划方案，并在具体深化过程中多次来校汇报商讨校庆<strong>各项事宜</strong>。此次校庆舞台上的精彩演出，都是学校孩子们和老师们<strong>不厌其烦，努力排练</strong>的成果，当然也离不开<strong>公司导演团队</strong>耐心细致的指导，辛苦了，认真彩排的每个你！', '现场演出当天，学生们都早早的来到演出化妆间进行长达<strong>三个小时</strong>的化妆准备，并一直在重复回忆各个表演动作，为你们点赞！当人们还在梦中沉睡之时，叁昶小伙伴<strong>通宵搭建</strong>现场演出场地，只为了<strong>完美呈现</strong>本次校庆活动，为你们加鸡腿！', '20周年是学校发展史上的<strong>重要里程碑</strong>，更是学校深化改革强化发展的一个新起点，<strong>叁昶公司</strong>非常有幸参与其中为学校服务此次20周年大会，得到了学校方和社会各界的<strong>广泛认可，叁昶</strong>祝全体<strong>进实人</strong>在未来的日子中继续<strong>坚守初心、砥砺奋进</strong>，以昂扬的姿态走在素质教育发展的康庄大道上！ —— <strong>上海叁昶文化科技有限公司</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133561-2867d7ea-d0e7-4c9d-96ee-191b28f50762.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133574-7e60f34f-3990-44a4-b6eb-d4beccf7025c.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133589-0eaaead0-514e-4631-b5ea-21ed3171032f.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133602-88513d85-2ac9-4efa-b49e-75672f640c00.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751133599-a0b248d4-4adf-4a51-9b8b-b41d58458d41.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751134288-cced1eb1-889b-4d09-a07f-41b130453ad0.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {// 服务类 2021-09-22，阮弘宇
      time: '2021-09-22',
      title: '这个暑期叁昶注重文化育人，全新打造“看得见、听得到、亮得出”的校园文化',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751471549-33a5bff3-a883-40d9-aac6-e39d18813f66.jpeg',
      linkTo: "/instanceItem?type=service&num=32",
      details: {
        top: {
          title: '这个暑期叁昶注重文化育人，全新打造“看得见、听得到、亮得出”的校园文化',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751471552-e5cbf645-7ebc-4a9b-af42-0d7bc23e0d47.jpeg?x-oss-process=image%2Fresize%2Cw_937%2Climit_0'
        },
        lunbo: {
          title: ['<strong>习近平</strong>在<strong>清华大学建校110周年校庆</strong>考察时指出，<strong>美术、艺术、科学、技术相辅相成、相互促进、相得益彰</strong>。要发挥美术在服务经济社会发展中的重要作用，把更多<strong>美术元素、艺术元素</strong>应用到城乡规划建设中，增强城乡<strong>审美韵味、文化品位</strong>，把美术成果更好服务于人民群众的高品质生活需求。<strong>社会责任和使命担当</strong>，是艺术高校办学的方向和宗旨，在建设一流大学的同时更应担负起服务社会的重任。', '教育部下发了<strong>《关于大力加强中小学校园文化建设的通知》</strong>。通知指出，<strong>校园文化</strong>是学校教育的重要组成部分，是全面育人不可缺少的<strong>重要环节</strong>，良好的校园文化，对培养德智体全面发展的中国特色社会主义事业接班人具有重要意义，各地必须<strong>高度重视</strong>加强<strong>校园文化建设</strong>。', '<strong>叁昶公司</strong>在今年暑期对<strong>近二十所大中小各类学校</strong>进行了校园文化的<strong>量身设计</strong>、改造和施工，公司致力于打造<strong>“看得见、听得到、亮得出”</strong>校园文化特色，对每个项目的<strong>安全性、稳定性、美观性</strong>以及<strong>创新性</strong>等方面始终保持着最高要求，每个项目最终都得到了客户的一致认可和好评。', '在设计学校走廊文化时，采用抽象概括的方法对其<strong>形态、造型</strong>进行概括，色彩上在校园LOGO的基础色上提高其明度等，每一个学科处赋予该学科<strong>专属颜色和标识</strong>。在设计单体墙面和党建文化时，大胆的撞色其中一种。校园LOGO上的色彩，形成视觉的冲击，依据不同楼道分布，组成一幅文化长廊。', '在设计的<strong>“歌声里的党史”</strong>文化长廊以党在百年奋斗历程中形成的<strong>伟大精神</strong>为轴线，串联重要史实，用红色音乐文化解读精神内涵，通过<strong>手机扫码</strong>唱享红歌，激励师生从党的光辉历史中汲取红色力量，筑牢信念之基，赓续<strong>共产党人精神血脉</strong>。', '在设计<strong>党建文化馆</strong>时通过五大版块：<strong>“开天辟地”、“改天换地”、“翻天覆地”、“惊天动地”，“艺路前行”</strong>，既令展厅的展示效果有叙事、有重点、有层次;也高度契合了<strong>“紧密团结在党的周围、一切以党的领导为中心”</strong>的这一<strong>党建主旨</strong>，点燃参观者心中最炙热的红色情怀。', '在设计以<strong>恰同学少年</strong>为主题的校园文化时，紧抓<strong>青春澎湃+电子科技</strong>为主要脉络，融入工业风与未来的世界打造年轻感，适度时尚感，动感，温馨科技感非冷酷不近人情的设计风格。', '<strong>专业实训室</strong>的打造是培养学生操作能力的一个重要场地，在学生的健康成长中发挥着<strong>至关重要</strong>的作用。设计紧贴校园文化内涵与专业发展进行不断更新，让专业教学更好地<strong>服务于老师、服务于学生</strong>。', '在设计以<strong>未来</strong>为主题的校园文化时，设计思路是让每一个学生都能学好，让每一个学生都能创造成长的奇迹，创造学生的<strong>无限可能</strong>，以无限为设计符号，校徽颜色为基本色彩，着意打造在传统文化背景下<strong>蓬勃发展</strong>的现代学校形象。', '设计的<strong>初心</strong>是为了发挥学校文化传播以及助力正能量的传递作用，因此在设计上紧贴学校文化特色，端庄大气，在材质上一定要<strong>采用耐用</strong>，具有<strong>防腐蚀、抗日晒</strong>的特点，特别精心设计的灯带在晚上也能给学校带来一抹文化色彩。', '设计是以<strong>学校文化为核心</strong>展开的，对学校文化LOGO的 图形<strong>（形）</strong>、颜色<strong>（色）</strong>、理念<strong>（神）</strong>、声音<strong>（音）</strong>做了整体延展设计，将这些元素融入到<strong>校园环境</strong>中，使人们在平时的生活、学习中，潜移默化的受到学校学校文化的熏陶。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453084-968e5846-cc69-4fd5-a6a4-982414c46ae5.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453086-9a3971c4-db3c-468f-8c2d-7e833d6cfc50.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453082-2513b649-d469-4cf0-a358-3cf5d1e1279a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453085-ab8ea942-12d3-4c10-b4d6-3cadfcc9e50e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453125-3e36a4ae-9b82-4485-b944-57a527a3bc53.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453681-c8a74d87-0484-4252-9bf2-81fecfabf884.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453775-44741a12-169d-4abc-ae65-e26374eb9d16.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453803-f54b750e-e8bd-48be-abbb-6df07e4ca472.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751453998-9fb66a3f-964f-4adb-a106-8215719991fb.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454232-a8c0358c-80c9-4d9a-9e99-997ca2354a5b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454480-445b3763-7904-4344-9ffb-0d2c576a454a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454474-5e8b2f9b-945d-46cf-a189-4c34ac512d3e.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454523-7a08a55d-1be4-413a-8d44-779593f4bc13.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454547-053fba98-5be4-40f8-a6ae-9d13e4f76a95.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751454858-cb0c1d72-347d-4fab-bb58-c5041c5b8b81.jpeg'
          ]
        },
        bottom: {
          title: ['本次设计整体富有<strong>活力与动感</strong> ，大气简约，与孩子们联系紧密。简约的设计风格使得标志不宜过时，可以长久使用，便于孩子们记忆与辨识，增强标志的视觉感受。', '让<strong>墙壁“说话”</strong>，它是利用学校所有墙壁因素去<strong>陶冶感染学生</strong>，是一幅有<strong>“主体的画”</strong>，是一首<strong>“无声的诗”</strong>，但情深意切，融知识性、教育性、艺术性于一体，达到<strong>“润物无声”</strong>的教育目的。', '<strong>校园文化设计</strong>不仅是视觉上<strong>美的享受</strong>，更是一场<strong>心灵的洗涤</strong>，它与学生之间产生的<strong>互动性、参与性</strong>和<strong>展示性</strong>，就体现了学生的心理和精神的成长，我们可从不同视角来看墙壁传达的不同语意。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751463619-25dd743c-b253-4232-b434-100c78c522b6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751463657-07f3e15b-ddfe-4f81-83a1-0a8f1a9263ac.jpeg?x-oss-process=image%2Fresize%2Cw_560%2Climit_0'
          ]
        }
      }
    },
    {//2021-8-24，阮宏宇
      time: '2021-08-24',
      title: '夏日炎炎，叁昶人撸起袖子加油干！奋力冲刺，打好暑期信息化项目收尾战',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497406135-3e2e246b-24cf-4109-89c6-150043df0fa4.jpeg',
      linkTo: "/instanceItem?type=technology&num=25",
      details: {
        top: {
          title: '夏日炎炎，叁昶人撸起袖子加油干！奋力冲刺，打好暑期信息化项目收尾战',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497406096-e0593a75-0e85-4f05-acd3-9f18712143c5.jpeg'
        },
        lunbo: {
          title: ['足蒸暑土气，背灼炎无光，力尽不知热，但惜夏日长。在八月酷暑的施工现场，有这样一群人，<strong>身披烈日，分秒必争，抢节点，保进度</strong>，今夏，因你们而精彩。', ' 骄阳似火，盛夏已至。转眼间已到8月中旬，暑期即将<strong>接近尾声，叁昶公司</strong>在今年暑期的<strong>三十多所学校的项目</strong>在紧锣密鼓中进行，在和夏日的炎热和台风带来的风雨对抗中，各项目的<strong>进度没有落下</strong>，每个项目的<strong>安全性、稳定性、美观性</strong>以及<strong>创新性</strong>等方面也仍然保持着<strong>最高要求</strong>。在和时间赛跑中，争取在开学前为每位学生和老师创造一个<strong>安全、实用、舒适</strong>的学习环境。', '<strong>叁昶公司</strong>信息技术部牵头及公司多部门、多工种全力以赴<strong>坚守施工第一线</strong>，顶着滚滚热浪和嘈杂的外环境，严格落实计划目标、抢抓节点施工进度，为项目收尾<strong>全力冲刺</strong>，在项目建成的过程中，我们用图片记录其中的点点滴滴，这个暑假，他们是<strong>最可爱的人</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390412-f83a9135-a3bc-4b8b-965d-96538aad6dab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390412-f83a9135-a3bc-4b8b-965d-96538aad6dab.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390338-f124c5fb-9bf3-4a8c-a1f3-71164c17d657.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390328-69874288-fde6-4422-8297-f9ee41940729.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390325-c7e5f590-1b5c-4455-8da5-f56b9ca7ecd3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390712-5d151ba4-c744-4a71-8996-2604d32998f0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390838-13291c75-d4ef-46ab-9b24-69fa49cf4555.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497390928-6f1c1672-2d6c-47c8-81c8-0412577b41c9.jpeg'
          ]
        },
        bottom: {
          title: ['原有装修拆除，这个过程既脏又累，伙伴们严格按照设计图纸进行<strong>文明施工拆除</strong>，只能撸起袖子加油干，为了后面施工做好<strong>基础保障准备</strong>。施工之前，<strong>安全技术交底</strong>是第一步，这个时候，大家都很<strong>注意听、用心讲，安全无小事</strong>，施工细节也同要重要。布线需登高作业由于没有安全绳的挂点，都是2人协调配合，虽操作不易，但<strong>工艺不会打折</strong>。整体线路、设备安装做到<strong>横平竖直、美观大方</strong>。施工后的垃圾清运及成品防护亦是要做到<strong>完美收尾</strong>。', '雄关漫道真如铁，而今迈步从头越。时间越近，任务越紧，越催人奋进，<strong>叁昶公司</strong>全体人员将<strong>鼓足干劲</strong>，继续保持大干热潮，以<strong>高昂的斗志，饱满的热情</strong>，全力以赴投入到施工建设中，为确保<strong>按期交工</strong>，开启最后顽强的拼搏和努力。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399029-74f203e1-8a3e-45b5-8627-bda4f7a7c84d.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399060-30889e3c-50cc-460f-9d9c-f0c514f45f47.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399152-68a9f200-893f-4087-b6eb-792f95690cf4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661497399077-ba9ae658-a264-4b9e-8a17-7b7d9d49c115.jpeg'
          ]
        }
      }
    },
    {// 服务类 2021-07-23，阮弘宇
      time: '2021-07-23',
      title: '叁昶携手互促共赢 助力轨道交通高技能人才培养',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751812954-80460579-76a4-408e-a406-1a42bd7c075a.jpeg',
      linkTo: "/instanceItem?type=service&num=31",
      details: {
        top: {
          title: '叁昶携手互促共赢 助力轨道交通高技能人才培养',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751813388-5f27d449-b858-456b-afc3-dc91ae8e7e40.jpeg'
        },
        lunbo: {
          title: ['6月9日，<strong>世界技能组织全球行业合作伙伴签约仪式</strong>在京举行，<strong>郑州捷安高科股份有限公司</strong>正式成为世界技能组织“<strong>全球行业合作伙伴</strong>”。世界技能组织<strong>首席执行官大卫·霍伊和赞助事务部主任亚历山大·阿米里</strong>，人力资源社会保障部相关单位负责同志，郑州捷安高科股份有限公司负责人，上海第 46 届世界技能大赛事务执行局赛事部负责同志以及有关院校和专家代表参加了签约仪式。<strong>上海叁昶文化科技有限公司顾问王志卫</strong>主持本场签约仪式。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799497-b0ff4138-2725-473b-83d5-2f3d6dbb0ec1.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799482-f8c0edda-283d-4a21-ae17-7b79174b7b4a.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799511-ef9b30d3-9091-46ff-bc07-92d039134851.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751799495-6d19c549-3750-439a-a6d7-e205e115b854.jpeg'
          ]
        },
        bottom: {
          title: ['7月14日，<strong>上海叁昶文化科技有限公司</strong>（以下简称上海叁昶）与<strong>上海申通地铁集团有限公司</strong>（以下简称申通地铁）、<strong>郑州捷安高科股份有限公司</strong>（以下简称捷安高科）三方在上海共同签署<strong>战略合作框架协议</strong>。我们将携手合作，为<strong>全球轨道交通教育培训基地（中心）设计、设备、课程</strong>提供全面解决方案。', '<strong>上海叁昶顾问王志卫、申通地铁培训中心主任叶华平、捷安高科总经理高志生</strong>代表三方签署协议。', '叁方强强联合，优势互补，紧紧围绕服务<strong>轨道交通创新发展</strong>的目标，通过<strong>实训基地建设</strong>及<strong>项目咨询、装备技术研发</strong>及<strong>成果推广、培训服务、X证书</strong>等领域<strong>全方位、多层次、多形式</strong>的合作，加快提升三方在轨道交通高技能人才培训服务领域中的地位和服务水平，为培训效率和质量的提升持续赋能，为<strong>“交通强国”“一带一路”</strong>国家战略、为国内外轨道交通行业发展培养更多<strong>高端技术技能型人才。</strong>'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751806449-e2e77325-ac3e-4a00-b56b-ee62b65d72c0.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661751806456-29b536d8-cce5-4946-9194-fc4716ffad51.jpeg'
          ]
        }
      }
    },
  ],



  // 福利---团建类
  welfareTeamBuildingList: [
    {
      title: '团建类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446490-b4370ea5-8592-47f4-83fe-21718b80154b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=7",
      details: {
        top: {
          title: '团建类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446512-2ad83ec0-196a-444b-8a31-13b35f8b6e8b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为更好地做好<strong>上海市中职生发展调研工作</strong>，叁昶公司于2021年1月15日邀请<strong>上海市学生事务中心就业服务部副部长杨彦辰，国家督学、上海市职业教育协会副会长鲍贤俊，中华职校校长黄玉璟，上海科技管理学校副校长周卫民，叁昶公司顾问王志卫开展上海市中职生发展调研工作研讨会。</strong>出席会议的还有<strong>上海市学生事务中心就业服务部周文济、尼平、鲍茜倩，叁昶公司常务副总曹鸣浩</strong>以及调研培训部相关人员。', '为了更好的开展<strong>中职校学生实习管理和就业服务工作</strong>，市学生事务中心于2020年11月26-27日召开了<strong>2020年上海中职校就业工作培训会</strong>，来自<strong>全市中职校就业办主任、数据员</strong>等<strong>共120余人</strong>参加。', '2021年1月13日，<strong>叁昶为上海市高级技工学校党政班子及中层干部、班主任近百名教师</strong>进行2018-2020届毕业生就业质量调查报告解读。', '2021年1月6日，<strong>叁昶</strong>为<strong>沪遵职业教育联盟部分成员学校领导</strong>进行“2017-2019届遵义在沪毕业生及上海市工程技术管理学校2019-2020届毕业生职后发展调研工作汇报”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426509-52d4d876-cb07-43ac-8271-72d9d7570455.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426493-77124c46-9cca-49b7-b1ea-59de39d71628.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426507-7cb80158-38e6-4709-a91d-5c3daee30a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426525-a4aff0b4-a547-49ec-867c-739ca8d8b741.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426511-9d0d5e78-bccd-4b47-8ad3-42035d2eee4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827427103-8a062a09-6165-4def-8067-c1a2d425f0e8.jpeg'
          ]
        },
        bottom: {
          title: ['工作培训会期间，<strong>上海叁昶文化科技有限公司常务副总曹鸣浩</strong>就2020年上海市中职毕业生职后发展调查报告<strong>“诞生记”</strong>，<strong>用数据说职教故事</strong>给<strong>全市中职就业办老师</strong>上了<strong>“一堂课”</strong>。', '<strong>上海叁昶文化科技有限公司</strong>作为<strong>业内知名</strong>的<strong>第三方数据咨询机构</strong>，自2017年开始<strong>连续撰写发布《上海市中职毕业生职后发展调查报告》</strong>，为上海市中等职业教育人才培养<strong>提供数据支持</strong>。在2020年新冠疫情影响下，<strong>叁昶</strong>撰写的2020年<strong>《上海市中职毕业生职后发展调查报告》</strong>为<strong>上海市教委</strong>在中职生就业方面采取应对措施提供数据支撑。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439806-52c7febb-ef29-46b1-9c6e-75e4abe2669f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439984-37be7a0c-ad86-4b1e-b370-2a66ffea8cb0.jpeg'
          ]
        }
      }
    },
    {
      title: '团建类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585097-32c84074-e590-4833-9084-73418bb45d54.jpeg',
      linkTo: "/instanceItem?type=consultation&num=6",
      details: {
        top: {
          title: '团建类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585126-3daed20c-22c1-4e50-8824-01c3b86defd0.jpeg'
        },
        lunbo: {
          title: ['2020年9月8日（周二）下午2点在<strong>上海市学生事务中心</strong>召开了<strong>2020届上海市中职生职后发展跟踪调查项目启动工作研讨会</strong>，参加会议领导有上海市教委副处长<strong>谢俊</strong>、上海市学生事务中心副主任<strong>周红星</strong>、就业服务部部长<strong>周璐璐</strong>、就业服务部副部长<strong>杨彦辰</strong>、就业服务部<strong>周文济</strong>、<strong>尼平</strong>，参加会议的专家有上海市第二轻工业学校校长<strong>滕琴</strong>、上海电子工业学校副校长<strong>张贯彻</strong>、上海市环境学校副校长<strong>王亚彬</strong>、上海科技管理学校副校长周卫民、上海市城市建设工程学校（上海市园林学校）招生就业办主任<strong>章春泉</strong>以及上海叁昶文化科技有限公司<strong>调研团队部分成员</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567574-a5b343a6-0f5a-46f7-92ee-63cd6c6f6170.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567516-a43df773-dd64-4de9-adff-56bad3707d64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567485-b7dbd9c2-b9ce-4854-91c5-f0d990d88b85.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567643-511a26dc-0db5-4a71-b266-19469d3afc8b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567486-1bf77693-2eba-4ea0-ae65-4f3d18d2cd82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567905-c5e3c1fe-b3e9-4304-ab13-9eb229198bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568014-b90ec268-0732-4094-b17c-832bf4bb13d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568160-ecf5b61b-5c2b-45ae-abcb-0c03ba32abc8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568190-91d39f5a-038c-47cc-854e-0153c9cf6fc6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568251-5ed880c1-c073-45a2-973e-52f6d9309480.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568568-6e1661da-2e15-4a0a-9343-c8ac745bc104.jpeg'
          ]
        },
        bottom: {
          title: ['会议上，叁昶文化科技<strong>常务副总曹鸣浩</strong>就2020年全市中职生职后发展调研工作思路和具体安排做了<strong>工作汇报</strong>。期间，<strong>谢俊副处长</strong>频频与各位专家<strong>互动</strong>，对报告的细节展开研讨，认为做好中职生职后发展跟踪调查是<strong>非常有必要</strong>的，将为教委提供很好的<strong>政策决策依据</strong>。<strong>周红星副主任</strong>要求，要“<strong>不忘初心</strong>”，紧紧围绕职教工作需求，做好调研工作，为上海教育<strong>做好数据分析工作</strong>。期间，与会领导、专家还围绕调研工作进一步增设部分专业、关注“<strong>对口</strong>”支援群体等的话题展开了深入探讨。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576223-1060acb1-bbdd-4317-b86c-13a1750e5051.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576244-ab981bf4-57c6-40b6-a503-9f1b9bd8bc30.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576237-72b9ab30-b19e-4fff-954a-7b8d734c55d2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576252-0a058c48-fd81-49d4-89ef-8f60a98d1b92.jpeg'
          ]
        }
      }
    }
  ],
  // 福利---节庆类
  welfareFestivalList: [
    {
      title: '节庆类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446490-b4370ea5-8592-47f4-83fe-21718b80154b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=7",
      details: {
        top: {
          title: '节庆类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446512-2ad83ec0-196a-444b-8a31-13b35f8b6e8b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为更好地做好<strong>上海市中职生发展调研工作</strong>，叁昶公司于2021年1月15日邀请<strong>上海市学生事务中心就业服务部副部长杨彦辰，国家督学、上海市职业教育协会副会长鲍贤俊，中华职校校长黄玉璟，上海科技管理学校副校长周卫民，叁昶公司顾问王志卫开展上海市中职生发展调研工作研讨会。</strong>出席会议的还有<strong>上海市学生事务中心就业服务部周文济、尼平、鲍茜倩，叁昶公司常务副总曹鸣浩</strong>以及调研培训部相关人员。', '为了更好的开展<strong>中职校学生实习管理和就业服务工作</strong>，市学生事务中心于2020年11月26-27日召开了<strong>2020年上海中职校就业工作培训会</strong>，来自<strong>全市中职校就业办主任、数据员</strong>等<strong>共120余人</strong>参加。', '2021年1月13日，<strong>叁昶为上海市高级技工学校党政班子及中层干部、班主任近百名教师</strong>进行2018-2020届毕业生就业质量调查报告解读。', '2021年1月6日，<strong>叁昶</strong>为<strong>沪遵职业教育联盟部分成员学校领导</strong>进行“2017-2019届遵义在沪毕业生及上海市工程技术管理学校2019-2020届毕业生职后发展调研工作汇报”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426509-52d4d876-cb07-43ac-8271-72d9d7570455.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426493-77124c46-9cca-49b7-b1ea-59de39d71628.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426507-7cb80158-38e6-4709-a91d-5c3daee30a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426525-a4aff0b4-a547-49ec-867c-739ca8d8b741.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426511-9d0d5e78-bccd-4b47-8ad3-42035d2eee4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827427103-8a062a09-6165-4def-8067-c1a2d425f0e8.jpeg'
          ]
        },
        bottom: {
          title: ['工作培训会期间，<strong>上海叁昶文化科技有限公司常务副总曹鸣浩</strong>就2020年上海市中职毕业生职后发展调查报告<strong>“诞生记”</strong>，<strong>用数据说职教故事</strong>给<strong>全市中职就业办老师</strong>上了<strong>“一堂课”</strong>。', '<strong>上海叁昶文化科技有限公司</strong>作为<strong>业内知名</strong>的<strong>第三方数据咨询机构</strong>，自2017年开始<strong>连续撰写发布《上海市中职毕业生职后发展调查报告》</strong>，为上海市中等职业教育人才培养<strong>提供数据支持</strong>。在2020年新冠疫情影响下，<strong>叁昶</strong>撰写的2020年<strong>《上海市中职毕业生职后发展调查报告》</strong>为<strong>上海市教委</strong>在中职生就业方面采取应对措施提供数据支撑。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439806-52c7febb-ef29-46b1-9c6e-75e4abe2669f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439984-37be7a0c-ad86-4b1e-b370-2a66ffea8cb0.jpeg'
          ]
        }
      }
    },
    {
      title: '节庆类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585097-32c84074-e590-4833-9084-73418bb45d54.jpeg',
      linkTo: "/instanceItem?type=consultation&num=6",
      details: {
        top: {
          title: '节庆类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585126-3daed20c-22c1-4e50-8824-01c3b86defd0.jpeg'
        },
        lunbo: {
          title: ['2020年9月8日（周二）下午2点在<strong>上海市学生事务中心</strong>召开了<strong>2020届上海市中职生职后发展跟踪调查项目启动工作研讨会</strong>，参加会议领导有上海市教委副处长<strong>谢俊</strong>、上海市学生事务中心副主任<strong>周红星</strong>、就业服务部部长<strong>周璐璐</strong>、就业服务部副部长<strong>杨彦辰</strong>、就业服务部<strong>周文济</strong>、<strong>尼平</strong>，参加会议的专家有上海市第二轻工业学校校长<strong>滕琴</strong>、上海电子工业学校副校长<strong>张贯彻</strong>、上海市环境学校副校长<strong>王亚彬</strong>、上海科技管理学校副校长周卫民、上海市城市建设工程学校（上海市园林学校）招生就业办主任<strong>章春泉</strong>以及上海叁昶文化科技有限公司<strong>调研团队部分成员</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567574-a5b343a6-0f5a-46f7-92ee-63cd6c6f6170.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567516-a43df773-dd64-4de9-adff-56bad3707d64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567485-b7dbd9c2-b9ce-4854-91c5-f0d990d88b85.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567643-511a26dc-0db5-4a71-b266-19469d3afc8b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567486-1bf77693-2eba-4ea0-ae65-4f3d18d2cd82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567905-c5e3c1fe-b3e9-4304-ab13-9eb229198bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568014-b90ec268-0732-4094-b17c-832bf4bb13d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568160-ecf5b61b-5c2b-45ae-abcb-0c03ba32abc8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568190-91d39f5a-038c-47cc-854e-0153c9cf6fc6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568251-5ed880c1-c073-45a2-973e-52f6d9309480.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568568-6e1661da-2e15-4a0a-9343-c8ac745bc104.jpeg'
          ]
        },
        bottom: {
          title: ['会议上，叁昶文化科技<strong>常务副总曹鸣浩</strong>就2020年全市中职生职后发展调研工作思路和具体安排做了<strong>工作汇报</strong>。期间，<strong>谢俊副处长</strong>频频与各位专家<strong>互动</strong>，对报告的细节展开研讨，认为做好中职生职后发展跟踪调查是<strong>非常有必要</strong>的，将为教委提供很好的<strong>政策决策依据</strong>。<strong>周红星副主任</strong>要求，要“<strong>不忘初心</strong>”，紧紧围绕职教工作需求，做好调研工作，为上海教育<strong>做好数据分析工作</strong>。期间，与会领导、专家还围绕调研工作进一步增设部分专业、关注“<strong>对口</strong>”支援群体等的话题展开了深入探讨。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576223-1060acb1-bbdd-4317-b86c-13a1750e5051.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576244-ab981bf4-57c6-40b6-a503-9f1b9bd8bc30.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576237-72b9ab30-b19e-4fff-954a-7b8d734c55d2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576252-0a058c48-fd81-49d4-89ef-8f60a98d1b92.jpeg'
          ]
        }
      }
    }
  ],
  // 福利---年会类
  welfareAnnualMeetingList: [
    {
      title: '年会类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446490-b4370ea5-8592-47f4-83fe-21718b80154b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=7",
      details: {
        top: {
          title: '年会类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446512-2ad83ec0-196a-444b-8a31-13b35f8b6e8b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为更好地做好<strong>上海市中职生发展调研工作</strong>，叁昶公司于2021年1月15日邀请<strong>上海市学生事务中心就业服务部副部长杨彦辰，国家督学、上海市职业教育协会副会长鲍贤俊，中华职校校长黄玉璟，上海科技管理学校副校长周卫民，叁昶公司顾问王志卫开展上海市中职生发展调研工作研讨会。</strong>出席会议的还有<strong>上海市学生事务中心就业服务部周文济、尼平、鲍茜倩，叁昶公司常务副总曹鸣浩</strong>以及调研培训部相关人员。', '为了更好的开展<strong>中职校学生实习管理和就业服务工作</strong>，市学生事务中心于2020年11月26-27日召开了<strong>2020年上海中职校就业工作培训会</strong>，来自<strong>全市中职校就业办主任、数据员</strong>等<strong>共120余人</strong>参加。', '2021年1月13日，<strong>叁昶为上海市高级技工学校党政班子及中层干部、班主任近百名教师</strong>进行2018-2020届毕业生就业质量调查报告解读。', '2021年1月6日，<strong>叁昶</strong>为<strong>沪遵职业教育联盟部分成员学校领导</strong>进行“2017-2019届遵义在沪毕业生及上海市工程技术管理学校2019-2020届毕业生职后发展调研工作汇报”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426509-52d4d876-cb07-43ac-8271-72d9d7570455.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426493-77124c46-9cca-49b7-b1ea-59de39d71628.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426507-7cb80158-38e6-4709-a91d-5c3daee30a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426525-a4aff0b4-a547-49ec-867c-739ca8d8b741.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426511-9d0d5e78-bccd-4b47-8ad3-42035d2eee4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827427103-8a062a09-6165-4def-8067-c1a2d425f0e8.jpeg'
          ]
        },
        bottom: {
          title: ['工作培训会期间，<strong>上海叁昶文化科技有限公司常务副总曹鸣浩</strong>就2020年上海市中职毕业生职后发展调查报告<strong>“诞生记”</strong>，<strong>用数据说职教故事</strong>给<strong>全市中职就业办老师</strong>上了<strong>“一堂课”</strong>。', '<strong>上海叁昶文化科技有限公司</strong>作为<strong>业内知名</strong>的<strong>第三方数据咨询机构</strong>，自2017年开始<strong>连续撰写发布《上海市中职毕业生职后发展调查报告》</strong>，为上海市中等职业教育人才培养<strong>提供数据支持</strong>。在2020年新冠疫情影响下，<strong>叁昶</strong>撰写的2020年<strong>《上海市中职毕业生职后发展调查报告》</strong>为<strong>上海市教委</strong>在中职生就业方面采取应对措施提供数据支撑。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439806-52c7febb-ef29-46b1-9c6e-75e4abe2669f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439984-37be7a0c-ad86-4b1e-b370-2a66ffea8cb0.jpeg'
          ]
        }
      }
    },
    {
      title: '年会类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585097-32c84074-e590-4833-9084-73418bb45d54.jpeg',
      linkTo: "/instanceItem?type=consultation&num=6",
      details: {
        top: {
          title: '年会类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585126-3daed20c-22c1-4e50-8824-01c3b86defd0.jpeg'
        },
        lunbo: {
          title: ['2020年9月8日（周二）下午2点在<strong>上海市学生事务中心</strong>召开了<strong>2020届上海市中职生职后发展跟踪调查项目启动工作研讨会</strong>，参加会议领导有上海市教委副处长<strong>谢俊</strong>、上海市学生事务中心副主任<strong>周红星</strong>、就业服务部部长<strong>周璐璐</strong>、就业服务部副部长<strong>杨彦辰</strong>、就业服务部<strong>周文济</strong>、<strong>尼平</strong>，参加会议的专家有上海市第二轻工业学校校长<strong>滕琴</strong>、上海电子工业学校副校长<strong>张贯彻</strong>、上海市环境学校副校长<strong>王亚彬</strong>、上海科技管理学校副校长周卫民、上海市城市建设工程学校（上海市园林学校）招生就业办主任<strong>章春泉</strong>以及上海叁昶文化科技有限公司<strong>调研团队部分成员</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567574-a5b343a6-0f5a-46f7-92ee-63cd6c6f6170.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567516-a43df773-dd64-4de9-adff-56bad3707d64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567485-b7dbd9c2-b9ce-4854-91c5-f0d990d88b85.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567643-511a26dc-0db5-4a71-b266-19469d3afc8b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567486-1bf77693-2eba-4ea0-ae65-4f3d18d2cd82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567905-c5e3c1fe-b3e9-4304-ab13-9eb229198bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568014-b90ec268-0732-4094-b17c-832bf4bb13d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568160-ecf5b61b-5c2b-45ae-abcb-0c03ba32abc8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568190-91d39f5a-038c-47cc-854e-0153c9cf6fc6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568251-5ed880c1-c073-45a2-973e-52f6d9309480.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568568-6e1661da-2e15-4a0a-9343-c8ac745bc104.jpeg'
          ]
        },
        bottom: {
          title: ['会议上，叁昶文化科技<strong>常务副总曹鸣浩</strong>就2020年全市中职生职后发展调研工作思路和具体安排做了<strong>工作汇报</strong>。期间，<strong>谢俊副处长</strong>频频与各位专家<strong>互动</strong>，对报告的细节展开研讨，认为做好中职生职后发展跟踪调查是<strong>非常有必要</strong>的，将为教委提供很好的<strong>政策决策依据</strong>。<strong>周红星副主任</strong>要求，要“<strong>不忘初心</strong>”，紧紧围绕职教工作需求，做好调研工作，为上海教育<strong>做好数据分析工作</strong>。期间，与会领导、专家还围绕调研工作进一步增设部分专业、关注“<strong>对口</strong>”支援群体等的话题展开了深入探讨。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576223-1060acb1-bbdd-4317-b86c-13a1750e5051.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576244-ab981bf4-57c6-40b6-a503-9f1b9bd8bc30.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576237-72b9ab30-b19e-4fff-954a-7b8d734c55d2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576252-0a058c48-fd81-49d4-89ef-8f60a98d1b92.jpeg'
          ]
        }
      }
    }
  ],
  // 福利---体检类
  welfareExaminationList: [
    {
      title: '体检类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446490-b4370ea5-8592-47f4-83fe-21718b80154b.jpeg',
      linkTo: "/instanceItem?type=consultation&num=7",
      details: {
        top: {
          title: '体检类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827446512-2ad83ec0-196a-444b-8a31-13b35f8b6e8b.jpeg?x-oss-process=image%2Fresize%2Cw_750%2Climit_0'
        },
        lunbo: {
          title: ['为更好地做好<strong>上海市中职生发展调研工作</strong>，叁昶公司于2021年1月15日邀请<strong>上海市学生事务中心就业服务部副部长杨彦辰，国家督学、上海市职业教育协会副会长鲍贤俊，中华职校校长黄玉璟，上海科技管理学校副校长周卫民，叁昶公司顾问王志卫开展上海市中职生发展调研工作研讨会。</strong>出席会议的还有<strong>上海市学生事务中心就业服务部周文济、尼平、鲍茜倩，叁昶公司常务副总曹鸣浩</strong>以及调研培训部相关人员。', '为了更好的开展<strong>中职校学生实习管理和就业服务工作</strong>，市学生事务中心于2020年11月26-27日召开了<strong>2020年上海中职校就业工作培训会</strong>，来自<strong>全市中职校就业办主任、数据员</strong>等<strong>共120余人</strong>参加。', '2021年1月13日，<strong>叁昶为上海市高级技工学校党政班子及中层干部、班主任近百名教师</strong>进行2018-2020届毕业生就业质量调查报告解读。', '2021年1月6日，<strong>叁昶</strong>为<strong>沪遵职业教育联盟部分成员学校领导</strong>进行“2017-2019届遵义在沪毕业生及上海市工程技术管理学校2019-2020届毕业生职后发展调研工作汇报”。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426509-52d4d876-cb07-43ac-8271-72d9d7570455.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426493-77124c46-9cca-49b7-b1ea-59de39d71628.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426507-7cb80158-38e6-4709-a91d-5c3daee30a4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426525-a4aff0b4-a547-49ec-867c-739ca8d8b741.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827426511-9d0d5e78-bccd-4b47-8ad3-42035d2eee4f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827427103-8a062a09-6165-4def-8067-c1a2d425f0e8.jpeg'
          ]
        },
        bottom: {
          title: ['工作培训会期间，<strong>上海叁昶文化科技有限公司常务副总曹鸣浩</strong>就2020年上海市中职毕业生职后发展调查报告<strong>“诞生记”</strong>，<strong>用数据说职教故事</strong>给<strong>全市中职就业办老师</strong>上了<strong>“一堂课”</strong>。', '<strong>上海叁昶文化科技有限公司</strong>作为<strong>业内知名</strong>的<strong>第三方数据咨询机构</strong>，自2017年开始<strong>连续撰写发布《上海市中职毕业生职后发展调查报告》</strong>，为上海市中等职业教育人才培养<strong>提供数据支持</strong>。在2020年新冠疫情影响下，<strong>叁昶</strong>撰写的2020年<strong>《上海市中职毕业生职后发展调查报告》</strong>为<strong>上海市教委</strong>在中职生就业方面采取应对措施提供数据支撑。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439806-52c7febb-ef29-46b1-9c6e-75e4abe2669f.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827439984-37be7a0c-ad86-4b1e-b370-2a66ffea8cb0.jpeg'
          ]
        }
      }
    },
    {
      title: '体检类',
      img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585097-32c84074-e590-4833-9084-73418bb45d54.jpeg',
      linkTo: "/instanceItem?type=consultation&num=6",
      details: {
        top: {
          title: '体检类',
          img: 'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827585126-3daed20c-22c1-4e50-8824-01c3b86defd0.jpeg'
        },
        lunbo: {
          title: ['2020年9月8日（周二）下午2点在<strong>上海市学生事务中心</strong>召开了<strong>2020届上海市中职生职后发展跟踪调查项目启动工作研讨会</strong>，参加会议领导有上海市教委副处长<strong>谢俊</strong>、上海市学生事务中心副主任<strong>周红星</strong>、就业服务部部长<strong>周璐璐</strong>、就业服务部副部长<strong>杨彦辰</strong>、就业服务部<strong>周文济</strong>、<strong>尼平</strong>，参加会议的专家有上海市第二轻工业学校校长<strong>滕琴</strong>、上海电子工业学校副校长<strong>张贯彻</strong>、上海市环境学校副校长<strong>王亚彬</strong>、上海科技管理学校副校长周卫民、上海市城市建设工程学校（上海市园林学校）招生就业办主任<strong>章春泉</strong>以及上海叁昶文化科技有限公司<strong>调研团队部分成员</strong>。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567574-a5b343a6-0f5a-46f7-92ee-63cd6c6f6170.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567516-a43df773-dd64-4de9-adff-56bad3707d64.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567485-b7dbd9c2-b9ce-4854-91c5-f0d990d88b85.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567643-511a26dc-0db5-4a71-b266-19469d3afc8b.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567486-1bf77693-2eba-4ea0-ae65-4f3d18d2cd82.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827567905-c5e3c1fe-b3e9-4304-ab13-9eb229198bb3.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568014-b90ec268-0732-4094-b17c-832bf4bb13d4.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568160-ecf5b61b-5c2b-45ae-abcb-0c03ba32abc8.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568190-91d39f5a-038c-47cc-854e-0153c9cf6fc6.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568251-5ed880c1-c073-45a2-973e-52f6d9309480.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827568568-6e1661da-2e15-4a0a-9343-c8ac745bc104.jpeg'
          ]
        },
        bottom: {
          title: ['会议上，叁昶文化科技<strong>常务副总曹鸣浩</strong>就2020年全市中职生职后发展调研工作思路和具体安排做了<strong>工作汇报</strong>。期间，<strong>谢俊副处长</strong>频频与各位专家<strong>互动</strong>，对报告的细节展开研讨，认为做好中职生职后发展跟踪调查是<strong>非常有必要</strong>的，将为教委提供很好的<strong>政策决策依据</strong>。<strong>周红星副主任</strong>要求，要“<strong>不忘初心</strong>”，紧紧围绕职教工作需求，做好调研工作，为上海教育<strong>做好数据分析工作</strong>。期间，与会领导、专家还围绕调研工作进一步增设部分专业、关注“<strong>对口</strong>”支援群体等的话题展开了深入探讨。'],
          img: [
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576223-1060acb1-bbdd-4317-b86c-13a1750e5051.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576244-ab981bf4-57c6-40b6-a503-9f1b9bd8bc30.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576237-72b9ab30-b19e-4fff-954a-7b8d734c55d2.jpeg',
            'https://cdn.nlark.com/yuque/0/2022/jpeg/25884864/1661827576252-0a058c48-fd81-49d4-89ef-8f60a98d1b92.jpeg'
          ]
        }
      }
    }
  ],
}